/* DS price grids effective 2026-10-14. Native cart amounts, in cents. */
(function(w){
 'use strict';
 var exactOptions={"crating:20000":"42834643812434","door_fit:22500":"42834643845202","draft_control:3700":"42834643877970","feet:20000":"42834643910738","finish:4500":"42834643943506","finish:10000":"42834643976274","finish:20000":"42834644009042","finish:24500":"42834644041810","finish:40000":"42834644074578","finish:44000":"42834644107346","fireplace_type:14500":"42834644140114","fit_type:22500":"42834644172882","glass:20000":"42834644205650","glass:25000":"42834644238418","mesh:17500":"42834644271186","mesh:50000":"42834644303954","pattern:17500":"42834644336722","pattern:27500":"42834644369490","simple_height:2000":"42834644402258","simple_height:3000":"42834644435026","simple_height:4000":"42834644467794","simple_height:6000":"42834644500562","simple_width:3000":"42834644533330","simple_width:5500":"42834644566098","simple_width:6000":"42834644598866","simple_width:8000":"42834644631634","size:1500":"42834644664402","size:4000":"42834644697170","size:4500":"42834644729938","size:5000":"42834644762706","size:5500":"42834644795474","size:7500":"42834644828242","size:8000":"42834644861010","size:9500":"42834644893778","size:10000":"42834644926546","size:11000":"42834644959314","size:11500":"42834644992082","size:12000":"42834645024850","size:13000":"42834645057618","size:13500":"42834645090386","size:14000":"42834645123154","size:15000":"42834645155922","size:16000":"42834645188690","size:16500":"42834645221458","size:20000":"42834645254226","size:20500":"42834645286994","size:22500":"42834645319762","size:24000":"42834645352530","size:26000":"42834645385298","size:27500":"42834645418066","size:28500":"42834645450834","size:30000":"42834645483602","size:30500":"42834645516370","size:33000":"42834645549138","size:38500":"42834645581906","size:40000":"42834645614674","size:43000":"42834645647442","size:44000":"42834645680210","size:45000":"42834645712978","size:47500":"42834645745746","size:50000":"42834645778514","size:51500":"42834645811282","size:54500":"42834645844050","size:59000":"42834645876818","size:60000":"42834645909586","size:70000":"42834645942354","size:70500":"42834645975122","size:74000":"42834646007890","size:86500":"42834646040658","size:89000":"42834646073426","size:99500":"42834646106194","size:120000":"42834646138962","size:140000":"42834646171730","glass:2500":"42843026030674","mesh:19900":"42843026063442","draft_control:8500":"42843026096210","draft_control:7500":"41150318051410"};
 function grid(source,ui,tier){
  if(source.maxUI&&ui>source.maxUI)return null;
  var row=source.rows[tier];if(!row)return null;
  if(!Number.isFinite(ui)||ui<source.bounds[0])return row[0]*100;
  for(var i=1;i<source.bounds.length;i++)if(ui<=source.bounds[i])return row[i]===null?null:row[i]*100;
  return source.perUI&&row[row.length-1]!==null?Math.round(ui*row[row.length-1]*100):null;
 }
 function finishTier(label,group,source){
  if(!label)return 'Powder Coat';
  var f=(group.finish||[]).find(function(x){return x.label===label;});
  if(f&&f.cat==='powder_coat')return 'Powder Coat';
  if(/^(Antique Iron|Burnished Bronze|Burnished Copper|Forged Iron|Red ?Wood|Rustic Copper|Silver Birch)$/i.test(label))return 'Handcrafted';
  if(/^(Candlelight Brass|Copper Fire|Old World Bronze|Shark Skin|Slate Grey|Sterling|Venetian Bronze|Vintage Brass)$/i.test(label))return 'Artisan';
  if(/satin nickel/i.test(label)&&source.rows.Anodized)return 'Anodized';
  if(/satin nickel/i.test(label)&&source.rows.Metallic)return 'Metallic';
  if(/stainless/i.test(label)&&source.rows['Stainless Steel'])return 'Stainless Steel';
  // Unmatched finishes retain their existing charge; no invented mapping.
  return null;
 }
 function ownerBand(ui,bounds){
  if(!Number.isFinite(ui)||ui<bounds[0])return 0;
  for(var i=1;i<bounds.length;i++)if(ui<=bounds[i])return i;
  return -1;
 }
 function ownerLabel(index,bounds){return index===0?'Under '+bounds[0]+' UI':(index===1?'':'Over ')+bounds[index-1]+'–'+bounds[index]+' UI';}
 function quote(rule,width,height,finish,group,masonry){
  if(rule.ownerSizeOnly){var sum=width+height,idx=ownerBand(sum,rule.ownerBounds);
   if(idx<0)return {error:'Sizes above 120 UI require an individual quote.'};
   return {ui:sum,sizeCents:rule.ownerDeltas[idx]*100,label:Number.isFinite(sum)?ownerLabel(idx,rule.ownerBounds):'Enter width and height',confirmationRequired:sum>rule.confirmationAbove};
  }
  var source=masonry&&rule.masonry?rule.masonry:rule.source,ui=width+height;
  /* Daniel 2026-11-03: Carolina screens have no dimension-based checkout cap; use the existing UI/finish brackets and crating rules. */
  var powder=grid(source,ui,'Powder Coat'),tier=finishTier(finish,group,source),finished=tier?grid(source,ui,tier):null;
  if(rule.aspect){powder=!Number.isFinite(ui)?71900:width<42&&height<32?71900:width<50&&height<40?75900:null;finished=tier?powder:null;}
  if(powder===null||(tier&&finished===null))return {error:'This size or finish requires a quote from our team.'};
  var ownerLabelText=null;
  if(rule.ownerPowderSeven&&tier==='Powder Coat'){
   var ownerBounds=[60,70,80,90,100,110,120],ownerIndex=ownerBand(ui,ownerBounds);
   if(ownerIndex<0)return {error:'Sizes above 120 UI require an individual quote.'};
   powder=rule.ownerPowderSeven[masonry?'masonry':'prefab'][ownerIndex]*100;finished=powder;
   if(Number.isFinite(ui))ownerLabelText=ownerLabel(ownerIndex,ownerBounds);
  }
  var typeCents=(source.rows['Powder Coat'][0]+rule.included-rule.base)*100;
  return {ui:ui,typeCents:typeCents,sizeCents:powder-source.rows['Powder Coat'][0]*100,finishCents:tier?finished-powder:null,cratingCents:Number.isFinite(ui)&&ui>80?source.crating*100:0,label:ownerLabelText?ownerLabelText:!Number.isFinite(ui)?'Enter width and height':ui<source.bounds[0]?'Under '+source.bounds[0]+' UI':ui<=source.bounds[1]?source.bounds[0]+'–'+source.bounds[1]+' UI':ui<=source.bounds[2]?'Over '+source.bounds[1]+'–'+source.bounds[2]+' UI':'Over '+source.bounds[2]+' UI'};
 }
 function assign(s,key,cents,label,ids){
  Object.keys(s).forEach(function(k){if(k===key||k.indexOf(key+'_balance_')===0)delete s[k];});
  if(!cents)return;
  if(!Number.isSafeInteger(cents)||cents<0)throw Error('Invalid MSRP charge');
  // Exact native option prices keep checkout quantities at one; retain precise fallback for variable amounts.
  var exactId=exactOptions[key+':'+cents];
  if(exactId){s[key]={amount:cents,label:label,variantId:exactId,qty:1};return;}
  var emitted=false;
  [10000,100,1].forEach(function(unit,index){var qty=Math.floor(cents/unit);cents-=qty*unit;if(qty){s[key+(emitted?'_balance_'+index:'')]={amount:qty*unit,label:label,variantId:ids[unit],qty:qty};emitted=true;}});
 }
 function option(rule,field,label){
  var o=rule.options||{},s=(label||'').toLowerCase();
  if(field==='feet'&&/flat/.test(s))return o.flatFeet;
  if(field==='glass'){
   if(/ceramic/.test(s))return null;
   if(/solar/.test(s))return /bronze/.test(s)?o.solarBronze:o.solarGrey;
   if(/bevel/.test(s))return /1\/2|½/.test(s)?o.halfBevel:o.oneBevel;
   if(/black/.test(s))return o.blackGlass;
   if(/bronze/.test(s))return o.bronze;if(/grey|gray/.test(s))return o.grey;
  }
  if(field==='mesh'){
   if(/stainless/.test(s))return o.stainlessMesh;
   if(/twin/.test(s))return o.twinMesh;if(/single/.test(s))return o.singleMesh;
   if(/curtain|black mesh/.test(s))return o.meshCurtain;
  }
  if(field==='draft_control'&&/^yes/.test(s))return o.draft;
  if((field==='door_fit'||field==='fit_type')&&/flush fit/.test(s))return o.flush;
  if(field==='pattern'&&o.pattern!==undefined){
   if(/center bars/.test(s))return o.vertical;
   if(/arch.*window|window.*arch/.test(s))return 275;
   if(/pane|arch/.test(s))return o.pattern;
  }
  return null;
 }
 function prepare(rule,group){
  if(!rule||!rule.stockDeltas)return;
  if(group.simple_width&&group.simple_width[1])group.simple_width[1].price=rule.stockDeltas[2];
  if(group.simple_height&&group.simple_height[0]&&group.simple_height[0][1])group.simple_height[0][1].price=rule.stockDeltas[1];
 }
 function sync(rule,root,sel,surch,parse,group,ids){
  if(!rule)return null;
  if(rule.ownerSizeOnly){
   var sq=quote(rule,parse(sel._width||''),parse(sel._height||''),sel.finish,group,false),sd=root.ownerDocument;
   var sb=sd.getElementById('efCfgSizeBadge'),sp=sd.getElementById('efCfgSizeSurcharge');
   if(sq.error){if(sb)sb.textContent=sq.error;return sq.error;}
   assign(surch,'size',sq.sizeCents,sq.label,ids);
   if(Number.isFinite(sq.ui))sel.size=sq.label;
   if(sb)sb.textContent=sq.label+(sq.confirmationRequired?' — confirmation required':'');
   if(sp)sp.textContent=sq.sizeCents?'+$'+(sq.sizeCents/100).toFixed(2):'Base price';
   return sq.confirmationRequired?'This size requires confirmation and a quote from our team.':null;
  }
  if(rule.stockDeltas){
   var large=/^36/.test(sel.simple_width||''),medium=/^25/.test(sel.simple_height||'');
   assign(surch,'simple_width',large?rule.stockDeltas[2]*100:0,sel.simple_width,ids);
   assign(surch,'simple_height',!large&&medium?rule.stockDeltas[1]*100:0,sel.simple_height,ids);return null;
  }
  var width=sel._width||'',height=sel._height||'';
  if(rule.deluxe){width=(root.ownerDocument.getElementById('efCfgDeluxeOverallW')||{}).value||'';height=(root.ownerDocument.getElementById('efCfgDeluxeOverallH')||{}).value||'';}
  var q=quote(rule,parse(width),parse(height),sel.finish,group,sel.fireplace_type==='Masonry');
  var doc=root.ownerDocument,badge=doc.getElementById('efCfgSizeBadge'),price=doc.getElementById('efCfgSizeSurcharge');
  if(q.error){if(badge)badge.textContent=q.error;return q.error;}
  assign(surch,'size',q.sizeCents,q.label,ids);
  assign(surch,'fireplace_type',q.typeCents,sel.fireplace_type,ids);
  if(q.finishCents!==null)assign(surch,'finish',q.finishCents,sel.finish,ids);
  assign(surch,'crating',q.cratingCents,'Required above 80 UI',ids);
  if(Number.isFinite(q.ui))sel.size=q.label;
  if(badge)badge.textContent=q.label;if(price)price.textContent=q.sizeCents?'+$'+(q.sizeCents/100).toFixed(2):'Base price';
  ['glass','mesh','draft_control','door_fit','fit_type','pattern','feet'].forEach(function(field){
   (group[field]||[]).forEach(function(item){var n=option(rule,field,item.label);if(n!==null&&n!==undefined)item.price=n;});
   var amount=option(rule,field,sel[field]);if(amount!==null&&amount!==undefined)assign(surch,field,Math.round(amount*100),sel[field],ids);
   root.querySelectorAll('[data-field="'+field+'"]').forEach(function(card){var n=option(rule,field,card.dataset.value);if(n===null||n===undefined)return;card.dataset.surcharge=n;var tag=card.querySelector('.ef-cfg-card__price');if(tag)tag.textContent=n?'+$'+n:'Included';});
  });
  root.querySelectorAll('#efCfgSwatchGrid [data-label]').forEach(function(card){var f=quote(rule,parse(width),parse(height),card.dataset.label,group,sel.fireplace_type==='Masonry');if(f.error||f.finishCents===null)return;card.dataset.surcharge=f.finishCents/100;card.setAttribute('aria-label',card.dataset.label+(f.finishCents?', +$'+(f.finishCents/100).toFixed(2):', included'));var tag=card.querySelector('.ef-cfg-swatch__tooltip');if(tag)tag.textContent=card.dataset.label+(f.finishCents?' +$'+(f.finishCents/100).toFixed(2):'');});
  return null;
 }
 w.EFDoorMSRP={grid:grid,quote:quote,assign:assign,option:option,prepare:prepare,sync:sync};
})(window);

window.EF_DOOR_MSRP_RULES={"grande-flat-black-masonry-fireplace-door-standard-sizes":{"page":167,"base":750,"included":0,"source":{"bounds":[60,70,80,90],"rows":{"Powder Coat":[750,825,900,975]},"perUI":false,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"draft":37,"bronze":0,"grey":0}},"reflection-flat-black-masonry-fireplace-door-standard-sizes":{"page":165,"base":749,"included":0,"source":{"bounds":[60,70,80,90],"rows":{"Powder Coat":[749,849,1049,1249,null],"Anodized":[794,894,1094,1294,null],"Artisan":[994,1094,1294,1494,null]},"perUI":false,"crating":200},"options":{"meshCurtain":199,"twinMesh":199,"draft":75,"bronze":25,"grey":25}},"medio-flat-black-masonry-fireplace-door-standard-sizes":{"page":167,"base":750,"included":0,"source":{"bounds":[60,70,80,90],"rows":{"Powder Coat":[750,825,900,975]},"perUI":false,"crating":200},"options":{"meshCurtain":199,"twinMesh":199,"draft":37,"bronze":25,"grey":25}},"design-specialties-brookfield-custom-fireplace-doors":{"page":113,"base":910,"included":0,"source":{"bounds":[60,70,80],"rows":{"Powder Coat":[910,925,1030,15],"Anodized":[955,970,1075,16],"Artisan":[1110,1125,1230,17]},"perUI":true,"crating":200},"masonry":{"bounds":[60,70,80],"rows":{"Powder Coat":[1055,1110,1190,16],"Anodized":[1100,1155,1235,17],"Artisan":[1255,1310,1390,18]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175,"draft":85},"ownerPowderSeven":{"prefab":[910,925,1030,1350,1500,1650,1800],"masonry":[1055,1110,1190,1440,1600,1760,1920]}},"cabot-fireplace-glass-door-for-masonry":{"page":127,"base":719,"included":0,"source":{"bounds":[60,70,80],"rows":{"Powder Coat":[719,719,719,null],"Anodized":[719,719,719,null]},"perUI":false,"crating":200},"aspect":true,"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"pattern":175}},"black-rock-arch-masonry-fireplace-glass-doors":{"page":27,"base":2800,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2800,3025,3250,38],"Handcrafted":[3200,3425,3650,40]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-buckingham-arch-custom-fireplace-doors-masonry":{"page":29,"base":2395,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2395,2510,2680,31],"Handcrafted":[2795,2910,3080,34]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-legend-arch-custom-fireplace-doors-masonry":{"page":25,"base":2205,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2205,2335,2535,30],"Artisan":[2405,2535,2735,32],"Handcrafted":[2605,2735,2935,34],"Metallic":[2605,2735,2935,34]},"perUI":true,"crating":200},"options":{"meshCurtain":500,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-stiletto-custom-fireplace-doors":{"page":109,"base":910,"included":0,"source":{"bounds":[60,70,80],"rows":{"Powder Coat":[910,925,1030,15],"Anodized":[955,970,1075,16],"Artisan":[1110,1125,1230,17]},"perUI":true,"crating":200},"masonry":{"bounds":[60,70,80],"rows":{"Powder Coat":[1055,1110,1190,16],"Anodized":[1100,1155,1235,17],"Artisan":[1255,1310,1390,18]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175,"draft":85},"ownerPowderSeven":{"prefab":[910,925,1030,1350,1500,1650,1800],"masonry":[1055,1110,1190,1440,1600,1760,1920]}},"design-specialties-bungalow-custom-fireplace-doors":{"page":123,"base":1055,"included":0,"source":{"bounds":[60,70,80],"rows":{"Powder Coat":[1055,1110,1190,16],"Anodized":[1100,1155,1235,17],"Artisan":[1255,1310,1390,18]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"design-specialties-carolina-standard-custom-fireplace-doors-1":{"page":17,"base":1760,"included":175,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[1585,1685,1785,24],"Artisan":[1785,1885,1985,26],"Handcrafted":[1985,2085,2185,28]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"flush":225,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"design-specialties-carolina-arched-and-window-pane-custom-fireplace-doors":{"page":17,"base":1860,"included":275,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[1585,1685,1785,24],"Artisan":[1785,1885,1985,26],"Handcrafted":[1985,2085,2185,28]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"flush":225,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"design-specialties-carolina-arched-custom-fireplace-doors-2":{"page":17,"base":1760,"included":175,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[1585,1685,1785,24],"Artisan":[1785,1885,1985,26],"Handcrafted":[1985,2085,2185,28]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"flush":225,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"design-specialties-carolina-sunrise-custom-fireplace-doors":{"page":17,"base":1760,"included":175,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[1585,1685,1785,24],"Artisan":[1785,1885,1985,26],"Handcrafted":[1985,2085,2185,28]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"flush":225,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"design-specialties-oak-tree-custom-fireplace-doors":{"page":63,"base":2365,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2365,2505,2625,33],"Handcrafted":[2765,2905,3025,37]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-mantel-custom-fireplace-doors":{"page":71,"base":2365,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2365,2505,2625,34]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-legend-odyssey-custom-fireplace-doors":{"page":41,"base":2035,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2035,2235,2435,32]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"stainlessMesh":500}},"design-specialties-original-moderne-custom-fireplace-doors-2":{"page":37,"base":2060,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2060,2225,2365,34],"Artisan":[2260,2425,2565,36],"Handcrafted":[2460,2625,2765,38],"Metallic":[2460,2625,2765,38]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-slim-moderne-custom-fireplace-doors-3":{"page":37,"base":2060,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2060,2225,2365,34],"Artisan":[2260,2425,2565,36],"Handcrafted":[2460,2625,2765,38],"Metallic":[2460,2625,2765,38]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-legend-standard-custom-fireplace-doors":{"page":21,"base":1935,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[1935,2135,2235,28],"Artisan":[2135,2335,2435,30],"Handcrafted":[2335,2535,2635,32],"Metallic":[2335,2535,2635,32]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"banded-scroll-masonry-prefab-fireplace-glass-doors":{"page":67,"base":2630,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2630,2855,3080,40]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-craftsman-custom-fireplace-doors-1":{"page":59,"base":2650,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2650,2855,3080,39],"Artisan":[2850,3055,3280,41],"Handcrafted":[3050,3255,3480,43]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-madrid-custom-fireplace-doors-2":{"page":51,"base":2950,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2950,3175,3400,46],"Handcrafted":[3350,3575,3800,50]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-hammered-edge-standard-custom-fireplace-doors":{"page":45,"base":2645,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2645,2885,3120,42],"Handcrafted":[3045,3285,3520,46]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-black-rock-custom-fireplace-doors":{"page":55,"base":2825,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2825,3050,3275,41],"Handcrafted":[3225,3450,3675,45]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500}},"design-specialties-apex-custom-fireplace-doors":{"page":121,"base":1055,"included":0,"source":{"bounds":[60,70,80],"rows":{"Powder Coat":[1055,1110,1190,16],"Anodized":[1100,1155,1235,17],"Artisan":[1255,1310,1390,18]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"design-specialties-reflection-custom-fireplace-doors":{"page":165,"base":749,"included":0,"source":{"bounds":[60,70,80,90],"rows":{"Powder Coat":[749,849,1049,1249,null],"Anodized":[794,894,1094,1294,null],"Artisan":[994,1094,1294,1494,null]},"perUI":false,"crating":200},"options":{"meshCurtain":199,"twinMesh":199,"draft":75,"bronze":25,"grey":25}},"design-specialties-piccolo-custom-fireplace-doors":{"page":167,"base":750,"included":0,"source":{"bounds":[60,70,80,90],"rows":{"Powder Coat":[750,825,900,975]},"perUI":false,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"draft":37,"bronze":0,"grey":0}},"design-specialties-stiletto-cutback-custom-fireplace-doors":{"page":107,"base":1190,"included":0,"source":{"bounds":[60,70,80],"rows":{"Powder Coat":[1190,1300,1350,18],"Anodized":[1235,1345,1395,19],"Artisan":[1390,1500,1550,22]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"stainless-steel-masonry-fireplace-door":{"page":137,"base":2900,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2900,3500,4100,null],"Stainless Steel":[2900,3500,4100,null]},"perUI":false,"crating":200},"options":{"meshCurtain":500,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175,"draft":85}},"design-specialties-carolina-standard-custom-fireplace-doors-2":{"page":17,"base":1585,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[1585,1685,1785,24],"Artisan":[1785,1885,1985,26],"Handcrafted":[1985,2085,2185,28]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"flush":225,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"design-specialties-legend-odyssey-custom-fireplace-doors-1":{"page":41,"base":2035,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2035,2235,2435,32]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"stainlessMesh":500}},"brookfield-deluxe-magnetic-prefab-fireplace-glass-doors":{"page":115,"base":1315,"included":0,"source":{"bounds":[60,70,80],"rows":{"Powder Coat":[1315,1360,1410,18],"Artisan":[1515,1560,1610,19]},"perUI":true,"crating":200},"deluxe":true,"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"medio-flat-black-masonry-fireplace-door-custom-size":{"page":167,"base":750,"included":0,"source":{"bounds":[60,70,80,90],"rows":{"Powder Coat":[750,825,900,975]},"perUI":false,"crating":200},"options":{"meshCurtain":199,"twinMesh":199,"draft":37,"bronze":25,"grey":25}},"carolina-traditional-steel-fireplace-glass-doors-masonry-prefab":{"page":17,"base":1585,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[1585,1685,1785,24],"Artisan":[1785,1885,1985,26],"Handcrafted":[1985,2085,2185,28]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"flush":225,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"vertical":175,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"milwaukee-forged-iron-masonry-prefab-fireplace-glass-doors":{"page":97,"base":3660,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[3660,3935,4175,54],"Handcrafted":[4060,4375,4575,58]},"perUI":true,"crating":200,"maxUI":98},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"bronze":0,"grey":0,"stainlessMesh":500}},"savannah-masonry-prefab-fireplace-glass-doors":{"page":125,"base":1055,"included":0,"source":{"bounds":[60,70,80],"rows":{"Powder Coat":[1055,1110,1190,16],"Anodized":[1100,1155,1235,17],"Artisan":[1255,1310,1390,18]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"halfBevel":200,"oneBevel":250,"bronze":0,"grey":0,"stainlessMesh":500,"pattern":175}},"all-glass-steel-fireplace-glass-doors-masonry-prefab":{"page":75,"base":2035,"included":0,"source":{"bounds":[60,74,84],"rows":{"Powder Coat":[2035,2235,2435,31],"Artisan":[2135,2335,2535,33],"Handcrafted":[2235,2435,2635,35],"Metallic":[2235,2435,2635,35]},"perUI":true,"crating":200},"options":{"meshCurtain":175,"twinMesh":175,"singleMesh":175,"draft":85,"blackGlass":250,"solarBronze":200,"solarGrey":200,"bronze":0,"grey":0,"stainlessMesh":500}},"ardmore-flat-black-masonry-fireplace-door-sleek-modern-durable-design":{"page":169,"base":395,"stockDeltas":[0,30,55]},"armitage-flat-black-masonry-fireplace-door-sleek-modern-durable-design":{"page":171,"base":455,"stockDeltas":[0,20,30]},"finley-flat-black-masonry-fireplace-door-standard-sizes":{"page":175,"base":600,"stockDeltas":[0,60,80]},"farnsworth-oil-rubbed-bronze-masonry-fireplace-door-standard-sizes":{"page":173,"base":600,"stockDeltas":[0,40,60]},"steel-custom-single-panel-fireplace-screen-carolina-window-pane":{"page":151,"base":750,"included":200,"screen":true,"operable":false,"source":{"bounds":[68,74,80],"rows":{"Powder Coat":[550,590,630,10],"Artisan":[650,690,730,12],"Handcrafted":[750,790,830,14]},"perUI":true,"crating":200},"options":{"flatFeet":200}},"design-specialties-carolina-custom-fireplace-screen":{"page":151,"base":550,"included":0,"screen":true,"operable":false,"source":{"bounds":[68,74,80],"rows":{"Powder Coat":[550,590,630,10],"Artisan":[650,690,730,12],"Handcrafted":[750,790,830,14]},"perUI":true,"crating":200},"options":{"flatFeet":200}},"custom-steel-arch-free-standing-fireplace-screen-carolina":{"page":151,"base":750,"included":200,"screen":true,"operable":false,"source":{"bounds":[68,74,80],"rows":{"Powder Coat":[550,590,630,10],"Artisan":[650,690,730,12],"Handcrafted":[750,790,830,14]},"perUI":true,"crating":200},"options":{"flatFeet":200}},"steel-custom-single-panel-fireplace-screen-carolina-sunrise-window-pane":{"page":151,"base":750,"included":200,"screen":true,"operable":false,"source":{"bounds":[68,74,80],"rows":{"Powder Coat":[550,590,630,10],"Artisan":[650,690,730,12],"Handcrafted":[750,790,830,14]},"perUI":true,"crating":200},"options":{"flatFeet":200}},"fireplace-screen-with-operable-doors-custom-size-21-finishes-carolina":{"page":151,"base":750,"included":200,"screen":true,"operable":true,"source":{"bounds":[68,74,80],"rows":{"Powder Coat":[550,590,630,10],"Artisan":[650,690,730,12],"Handcrafted":[750,790,830,14]},"perUI":true,"crating":200},"options":{"flatFeet":200}},"custom-steel-custom-free-standing-folding-screens-21-finishes-carolina":{"page":151,"base":750,"included":200,"screen":true,"operable":false,"source":{"bounds":[68,74,80],"rows":{"Powder Coat":[550,590,630,10],"Artisan":[650,690,730,12],"Handcrafted":[750,790,830,14]},"perUI":true,"crating":200},"options":{"flatFeet":200}},"design-specialties-carolina-standard-custom-fireplace-screen-8":{"page":151,"base":950,"included":400,"screen":true,"operable":false,"source":{"bounds":[68,74,80],"rows":{"Powder Coat":[550,590,630,10],"Artisan":[650,690,730,12],"Handcrafted":[750,790,830,14]},"perUI":true,"crating":200},"options":{"flatFeet":200}},"design-specialties-carolina-free-standing-screen-door-4":{"page":151,"base":950,"included":400,"screen":true,"operable":false,"source":{"bounds":[68,74,80],"rows":{"Powder Coat":[550,590,630,10],"Artisan":[650,690,730,12],"Handcrafted":[750,790,830,14]},"perUI":true,"crating":200},"options":{"flatFeet":200}},"fireplace-arch-screen-with-operable-doors-custom-size-21-finishes-carolina":{"page":151,"base":950,"included":400,"screen":true,"operable":true,"source":{"bounds":[68,74,80],"rows":{"Powder Coat":[550,590,630,10],"Artisan":[650,690,730,12],"Handcrafted":[750,790,830,14]},"perUI":true,"crating":200},"options":{"flatFeet":200}},"design-specialties-rainbow-custom-fireplace-doors":{"base":679,"ownerSizeOnly":true,"ownerBounds":[60,70,74,85,96,110,120],"ownerDeltas":[0,50,140,400,700,995,1400],"confirmationAbove":80},"cavestone-fireplace-glass-doors-custom-masonry-fit":{"base":789,"ownerSizeOnly":true,"ownerBounds":[60,70,74,85,96,110,120],"ownerDeltas":[0,50,140,400,700,995,1400],"confirmationAbove":80}};
/* EF ceramic glass: owner-confirmed opening area, 2026-10-20. */
(function(w){
  'use strict';
  function quote(width,height){
    if(!Number.isFinite(width)||!Number.isFinite(height)||width<=0||height<=0)return null;
    return Math.round(width*height*25000/144);
  }
  function charges(cents,ids){
    if(!Number.isSafeInteger(cents)||cents<0)throw new Error('Invalid ceramic charge');
    var out={};
    [10000,100,1].forEach(function(unit,index){var qty=Math.floor(cents/unit);cents-=qty*unit;if(qty)out[Object.keys(out).length?'glass_balance_'+index:'glass']={amount:qty*unit,label:'Ceramic glass · $250/sq ft of opening',variantId:ids[unit],qty:qty};});
    return out;
  }
  w.EFCeramicGlass={quote:quote,charges:charges};
})(window);

/* EF_TRIFOLD_POLICY_20261005 — local draft; exact public models only. */
(function(host){
 var rules={"custom-steel-custom-free-standing-folding-screens-21-finishes-carolina":{"family":"ds","feet":[],"handles":["No Handle","Simplicity"]},"design-specialties-carolina-standard-custom-fireplace-screen-8":{"family":"ds","feet":[],"handles":["No Handle","Simplicity"]},"design-specialties-carolina-free-standing-screen-door-8":{"family":"ds","feet":[],"handles":["No Handle","Simplicity"]},"design-specialties-carolina-free-standing-screen-door-6":{"family":"ds","feet":[],"handles":["No Handle","Simplicity"]},"design-specialties-carolina-free-standing-screen-door-4":{"family":"ds","feet":[],"handles":["No Handle","Simplicity"]}};
 function rule(handle,type){return type==='cfg-screen'?rules[handle]||null:null;}
 function allowed(r,field,label){return !r || (field!=='feet'&&field!=='handle') || (field==='feet'?r.feet:r.handles).indexOf(label)!==-1;}
 function data(r,group){if(!r||!group)return group;var next=Object.assign({},group);['feet','handle'].forEach(function(k){next[k]=(group[k]||[]).filter(function(o){return allowed(r,k,o.label)&&o.label!=='None (Tri-Fold)';});if(r.family==='ds'&&k==='handle'&&r.handles.length)next[k]=[{"label":"No Handle","price":0,"variantId":null,"img":"https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-screen-no-handle.png?v=1781679646","desc":"Screen without handles"},{"label":"Simplicity","price":0,"variantId":null,"img":"https://cdn.shopify.com/s/files/1/0070/9502/5746/files/getimg_ai_img-zo7ykzl2nryzrtrwiqag3-_1__1763967698271x300_bf1c3e2d-a449-4de8-b62c-d9692e26f8f7.png?v=1775269955"}].map(function(o){return Object.assign({},o);});if(!next[k].length)delete next[k];});return next;}
 function sanitize(r,group,selections,surcharges){if(!r)return;['feet','handle'].forEach(function(k){var opt=(group&&group[k]||[]).find(function(o){return o.label===selections[k]&&allowed(r,k,o.label);});if(!opt){delete selections[k];delete surcharges[k];}else if(surcharges[k]){surcharges[k]={label:opt.label,amount:(opt.price||0)*100,variantId:opt.variantId||null};}});}
 host.EFTrifoldPolicy={rule:rule,allowed:allowed,data:data,sanitize:sanitize};
})(typeof window!=='undefined'?window:globalThis);

/* ─── Block 0 (was line ~54) ─── */

/* Lazy-load heavy configurator scripts on demand */
function efLoadScript(url, flag) {
  if (window[flag]) return;
  var s = document.createElement('script');
  s.src = url;
  document.head.appendChild(s);
  window[flag] = true;
}
if (!window.EF_CFG_DATA) {
  console.error('[EF-CFG] EF_CFG_DATA failed to load!');
} else {
  console.log('[EF-CFG] Data loaded:', Object.keys(window.EF_CFG_DATA).length, 'groups');
}


/* ─── Block 1 (was line ~964) ─── */

(function() {
  'use strict';

  /* ────────────────────────────────────
     CONSTANTS & CONFIG
     ──────────────────────────────────── */
  var CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  /* EF_STOLL_1TO1_20260829 — "+$135 per 2″ height increase over dimensions on sizing chart"
     (every Stoll door order form). One shared hidden variant, added with quantity = steps. */
  var STOLL_HEIGHT_STEP_PRICE = 135;
  var STOLL_HEIGHT_STEP_VARIANT = '42659520446546';

  var CAT_LABELS = {
    /* Stoll pricebook categories (page 79) — used by all Stoll groups */
    powdercoat:       'Powder Coat',
    premium:          'Premium',
    plated_stainless: 'Stainless',
    plated:           'Plated',
    overlay:          'Overlay',
    /* Legacy categories — kept for non-Stoll groups (Avalon, Legend, Carolina, etc.).
       2026-05-06 — `boutique` category removed per user request. Oil Rubbed Bronze
       (the only boutique finish) moved into `handcrafted` via data-file rewrites. */
    powder_coat:      'Powder Coat',
    standard:         'Powder Coat',
    stainless:        'Plated & Stainless',
    handcrafted:      'Hand Crafted'
  };

  /* 2026-06-01 — Normalize finish categories. The deprecated `boutique` category
     (its lone finish, Oil Rubbed Bronze, belongs under Hand Crafted) still lingers
     in some group data (e.g. DS Custom screens), producing a stray 4th "BOUTIQUE"
     tab. Fold it into `handcrafted` at read-time so it merges into that tab. */
  /* REVIEW-12 §2.5 / T-CFG8 2026-09-01 — display-only. NEVER use the result as a key:
     dataset.label, selections.finish, the cart property and the surcharge lookup all
     keep the raw string, because the raw string is what ef-cfg-surcharges.js and the
     Shopify variant option value are matched on. */
  var EF_FINISH_TYPO = { 'Old World Bronzez': 'Old World Bronze' };
  function efFinishDisplay(label) {
    var t = String(label == null ? '' : label);
    if (EF_FINISH_TYPO[t]) return EF_FINISH_TYPO[t];
    return t.replace(/_/g, ' ')
            .replace(/(\S)\(/g, '$1 (')
            .replace(/(\w)-\s+/g, '$1 \u2014 ')
            .replace(/\s+/g, ' ')
            .trim();
  }

  function normCat(c) {
    c = c || 'powder_coat';
    if (c === 'boutique') return 'handcrafted';
    return c;
  }

  var SKIP_WORDS = ['all', 'mid', 'old', 'new', 'hand', 'arch', 'the', 'and', 'for'];

  /* Step definitions by cfg type */
  var STEP_DEFS = {
    'cfg-custom':         ['Fireplace', 'Measurements', 'Style', 'Finish', 'Glass', 'Review'],
    'cfg-custom-full':    ['Fireplace', 'Measurements', 'Style', 'Finish', 'Glass', 'Review'],
    'cfg-custom-premium': ['Fireplace', 'Measurements', 'Style', 'Finish', 'Glass', 'Review'],
    'cfg-standard':       ['Order'],  /* single page — variant + optional photo/notes + ATC */
    'cfg-simple':         ['Order'],  /* single page — W/H ranges + optional photo/notes + ATC */
    'cfg-screen':         ['Fireplace', 'Measurements', 'Style', 'Finish', 'Glass', 'Review']  /* step 0 + step 4 auto-skipped */
  };

  /* cfg-screen skip helpers — Fireplace (0), Style (2) + Glass (4) hidden.
     Step 2 (Style: feet/handle) is skipped for frameless full-glass screens — the
     panel has no decorative style options; the flow is Measurements → Finish → Glass. */
  var _skipStep0 = false;
  function _isSkippedStep(i) { return (_skipStep0 && i === 0) || (_skipStep2 && i === 2) || (_skipStep4 && i === 4); }
  function _skippedBefore(i) { var n=0; if(_skipStep0 && i>0) n++; if(_skipStep2 && i>2) n++; if(_skipStep4 && i>4) n++; return n; }
  function _totalSkipped() { return (_skipStep0?1:0) + (_skipStep2?1:0) + (_skipStep4?1:0); }

  /* ────────────────────────────────────
     DOM REFS
     ──────────────────────────────────── */
  var root = document.getElementById('efCfg');
  if (!root) return;

  var cfgType   = root.dataset.cfgType;
  var isArch    = root.dataset.arch === 'true';
  var isMeshOnly= root.dataset.meshOnly === 'true';
  var basePrice = parseInt(root.dataset.basePrice, 10) || 0; // in cents
  var variantId = root.dataset.variantId;
  var prodTitle = root.dataset.productTitle;
  var prodHandle= root.dataset.productHandle;
  var msrpRule=window.EF_DOOR_MSRP_RULES[prodHandle]||null;
  var msrpError=null;
  var prodVendor= root.dataset.vendor || '';
  /* EF_OLDWORLD_SCREEN_NOHANDLE_20261010: owner-scoped exception; shared data stays intact. */
  var isOldWorldSlim = root.dataset.productId === '7673852133458' && prodHandle === 'old-world-slim-fireplace-screen';
  var isOldWorldScreen = cfgType === 'cfg-screen' && prodHandle === 'fireplace-screen-with-operable-doors-custom-size-21-finishes-old-world';
  /* Per-product flags — read from product title to drive option-set overrides
     without needing dedicated EF_CFG_DATA groups. */
  var isOdyssey  = /odyssey/i.test(prodTitle);
  var isAllGlass = /all\s*glass/i.test(prodTitle);
  /* Hammered Edge single-panel SCREEN: no handle choices on the order form (owner, 2026-09-17).
     Title match + cfg-screen only — the Hammered Edge DOORS product keeps its handles. EF_HAMMERED_NOHANDLE_20260917 */
  var isHammeredEdgeScreen = /hammered\s*edge/i.test(prodTitle) && cfgType === 'cfg-screen';
  /* Forged Iron Arch (Conversion): shares DS Arch data group but ships with
     restricted options — Cabinet/Bi-Fold only, no handles, no decorative pattern. */
  var isForgedIronArch = /forged\s*iron.*arch|forged-iron-arch/i.test(prodTitle);
  /* EdgeLine = Stoll Inline Hinge variant of DeepSet (shared "Fireplace Doors - Inset / Inline"
     option group). Inline cannot use: decorative pattern (Inset-only), Inside Fit, or
     Pyro Ceramic glass. DeepSet (Inset Hinge) is the default — no flag needed. */
  var isEdgeline = /edgeline|edge-line|edge\s*line/i.test(prodTitle);
  var stepNames = (STEP_DEFS[cfgType] || STEP_DEFS['cfg-custom']).slice();
  /* Mesh-only doors (Stoll Mesh, DS Legend Mesh): step 4 still selects mesh +
     draft control, just no glass — relabel from "Glass" to "Mesh" so the
     progress strip reflects what the user actually picks. */
  if (isMeshOnly) {
    var glassIdx = stepNames.indexOf('Glass');
    if (glassIdx !== -1) stepNames[glassIdx] = 'Mesh';
  }
  if(isOldWorldSlim){stepNames[3]='Finish';stepNames[4]='Mesh';}
  var totalSteps= stepNames.length;
  var curStep   = 0;

  /* ── EF FUNNEL ANALYTICS (P-007, 2026-07-27) ─────────────────────────────
     Pure dataLayer emissions for GA4/GTM funnel measurement. ZERO configurator
     logic touched — every call site is additive and fully guarded; any failure
     is silently swallowed and can never affect the money path. */
  function efTrack(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = params || {};
      p.event = eventName;
      if (!p.product_handle) p.product_handle = prodHandle || '';
      window.dataLayer.push(p);
      /* gtag.js (ef-analytics) ignores GTM-style pushes — forward explicitly
         so the funnel reaches GA4 (G-LJCQPD1VSH) through the same consent gate. */
      if (typeof window.gtag === 'function') {
        var g = {};
        for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k) && k !== 'event') g[k] = p[k];
        window.gtag('event', eventName, g);
      }
    } catch (e) {}
  }

  /* State — also exposed on window for Express Checkout (worker path).
     Same object identity so live mutations are visible to external readers. */
  var selections  = {};
  var surcharges  = {};
  var _skipStep4  = false;
  var _skipStep2  = false;
  var sizeData    = [];
  var sizeGrid    = false;   /* EF_STOLL_SIZE_GRID_20260829 */
  var matchedGroup= null;
  var groupData   = null;
  /* Read current product overrides as well as catalog data; used only to validate photo suggestions. */
  window.efCfgPhotoOptions = function(field) {
    if (['finish','glass','glass_color','glass_type','mesh','mesh_screen','mesh_type','draft_control','draft'].indexOf(field) < 0) return [];
    return groupData && Array.isArray(groupData[field]) ? groupData[field].map(function(option) { return String(option.label || ''); }).filter(Boolean) : [];
  };
  var uploadedFile= null;
  window._efCfgState = {
    isOldWorldSlim: isOldWorldSlim,
    owsRestore: owsRestore,
    get curStep() { return curStep; },
    owsBuildCart: owsBuildCart,
    trifoldDimensionsReady: trifoldDimensionsReady,
    trifoldWingsReady: trifoldWingsReady,
    sanitizeTrifold: sanitizeTrifold,
    syncGlassProtection: syncGlassProtection,
    msrpReady: function(){return !syncDoorMSRP();},
    ceramicAreaReady: function(){return !ceramicAreaSelected() || ceramicAreaCents()!==null;},
    setGlassProtection: function(enabled) { setGlassProtection(enabled); updatePrice(); },
    selections: selections,
    surcharges: surcharges,
    get photoURL() { return photoURL; },
    get photoURLs() { return photoURLs.slice(); },
    get photoNames() { return photoNames.slice(); },
    get photoErrors() { return photoErrors.slice(); },
    get photoVersions() { return photoVersions.slice(); },
    get photoUploading() { return _photoUploading; },
    get photoError() { return photoErrors.some(Boolean); },
    photoProperties: efPhotoProperties,
    validateMainPhoto: efValidateMainPhoto,
    uploadPhoto: uploadPhoto,
    removePhoto: removePhoto,
    get matchedGroup() { return matchedGroup; },
    get cfgType() { return cfgType; },
    get isArch() { return isArch; },
    get variantId() { return variantId; },
    get prodTitle() { return prodTitle; },
    calcTotal: function () { return calcTotal(); },
    formatFieldLabel: function (k) { return formatFieldLabel(k); }
  };

  // EF_OWS_NATIVE_WIZARD_20261010: exact product only; manufacturer's two-axis size grid.
  function owsInput() {
    var notes=document.getElementById('efCfgNotes');
    return {width:selections._width||'',height:selections._height||'',finish:selections.finish||'',mesh:selections.mesh||'',notes:notes?notes.value:''};
  }
  function owsMeasure() {
    if(!window.EFOldWorldSlim)return {error:'Configuration unavailable. Please contact us.'};
    var input=owsInput();input.finish='Matte Black';input.mesh='Perforated Mesh';
    return window.EFOldWorldSlim.quote(input);
  }
  function owsBuildCart() {
    if(!window.EFOldWorldSlim)return {error:'Configuration unavailable. Please contact us.'};
    var node=document.getElementById('efOwsNativeData'),data;
    try{data=JSON.parse(node.textContent);}catch(e){return {error:'Configuration unavailable. Please contact us.'};}
    var payload=window.EFOldWorldSlim.cart(owsInput(),data);
    if(!payload.error)Object.assign(payload.items[0].properties,efPhotoProperties());
    return payload;
  }
  function owsSync() {
    if(!isOldWorldSlim)return;
    var q=owsMeasure();
    Object.keys(surcharges).forEach(function(k){delete surcharges[k];});
    ['handle','feet','fireplace_type','firebox_type','fit_type','door_type','glass','draft_control','hardware_finish','pattern','door_finish'].forEach(function(k){delete selections[k];});
    if(q.error){delete selections.size;}else{
      var t=window.EFOldWorldSlim.tiers[q.tier];selections.size='Up to '+t.w+' × '+t.h+' in';
      surcharges.size={amount:q.sizeDeltaCents,label:selections.size,variantId:null};
    }
    if(!q.error && window.EFOldWorldSlim&&window.EFOldWorldSlim.premium.indexOf(selections.finish)>=0)surcharges.finish={amount:41000,label:selections.finish,variantId:null};
    var info=document.getElementById('efOwsSizeMessage');
    if(info){info.textContent=q.error||('Finished screen '+q.width+' × '+q.height+' in · '+selections.size);info.hidden=!selections._width&&!selections._height;}
    var support=document.getElementById('efOwsMeshSupport');if(support)support.hidden=!(selections.mesh==='Wire Mesh'&&!q.error&&q.width>40&&q.height>40);
  }
  function owsRestore(data) {
    var s=window.EFOldWorldSlim.normalizeSelections(data.selections||{});delete selections.door_finish;
    ['_width','_height'].forEach(function(k){var el=document.getElementById(k==='_width'?'efCfgWidth':'efCfgHeight');if(el){el.value=s[k]||'';selections[k]=el.value;el.dispatchEvent(new Event('input',{bubbles:true}));}});
    ['finish','mesh'].forEach(function(k){var list=groupData[k]||[],f=list.find(function(o){return o.label===s[k];});if(f)selections[k]=f.label;else delete selections[k];});
    renderFinishes();
    var restoredFrame=(groupData.finish||[]).find(function(f){return f.label===selections.finish;});
    if(restoredFrame){var tab=root.querySelector('#efCfgFinishTabs [data-cat="'+normCat(restoredFrame.cat)+'"]');if(tab)tab.click();var fp=document.getElementById('efCfgFinishPreview');if(fp)fp.classList.add('is-visible');document.getElementById('efCfgFinishPreviewSwatch').style.backgroundImage=restoredFrame.img?'url('+encodeURI(restoredFrame.img)+')':'';document.getElementById('efCfgFinishPreviewName').textContent=restoredFrame.label;document.getElementById('efCfgFinishPreviewPrice').textContent=restoredFrame.price?'+'+money(restoredFrame.price*100):'Included';}
    if(restoredFrame){var rb=root.querySelector('#efCfgSwatchGrid [data-label="'+CSS.escape(restoredFrame.label)+'"]');if(rb){rb.setAttribute('aria-checked','false');rb.classList.remove('is-selected');selectSwatch(rb,restoredFrame);}}
    var mg=root.querySelector('[data-group="mesh"] .ef-cfg-group__grid');if(mg){renderCards('mesh',mg);var mb=mg.querySelector('[data-value="'+CSS.escape(selections.mesh||'')+'"]');if(mb)mb.click();}
    owsSync();updatePrice();var target=owsMeasure().error?1:!selections.finish?3:!selections.mesh?4:Math.max(1,Math.min(5,data.curStep||1));if(_isSkippedStep(target))target=nextVisibleStep(target,1);showStep(target);
  }

  /* ────────────────────────────────────
     PRODUCT → DATA GROUP MATCHING
     ──────────────────────────────────── */
  function matchProductToGroup() {
    var data = window.EF_CFG_DATA;
    if(isOldWorldSlim)return data && data["Fireplace Screen - Old World Slim"] ? "Fireplace Screen - Old World Slim" : null;
    if (!data) { console.warn('EF_CFG_DATA not loaded'); return null; }

    var ALIASES = {
      /* ── ARCH variants (must be matched FIRST to win over rectangular sibling) ── */
      /* Bar Iron Arch — uses the Stoll Bar Iron option set (reassigned 2026-06-16 per product owner):
         arch-specific steps 1&2 (size W+Peak, Masonry, firebox, fit) + all other options copied from
         the rectangular Stoll "Bar Iron - Masonry & Prefab" group (finish/handle/glass/mesh/door_type/
         pattern/hardware_finish). Dedicated file: ef-cfg-doors-bar-iron-arch.js (group "Fireplace Doors - Bar Iron Arch").
         Old World Arch + Smithline Arch remain on dedicated Stoll groups with Legend size brackets. */
      /* Brookfield Deluxe Magnetic — must match BEFORE the generic 'brookfield' →
         standard group fallback in pass1, otherwise the matcher routes Deluxe
         to the standard Brookfield group and the Deluxe-specific measurement
         panel + filters never trigger. */
      'brookfield deluxe': 'Fireplace Doors - Brookfield Deluxe',
      'brookfield – deluxe': 'Fireplace Doors - Brookfield Deluxe',
      'brookfield - deluxe': 'Fireplace Doors - Brookfield Deluxe',
      'bar iron arch':    'Fireplace Doors - Bar Iron Arch',
      'bar iron - arch':  'Fireplace Doors - Bar Iron Arch',
      'forgeline arch':   'Fireplace Doors - Bar Iron Arch',
      'forged iron arch': 'Fireplace Doors - Bar Iron Arch',
      'old world arch':   'Fireplace Doors - Old World Arch',
      'old world - arch': 'Fireplace Doors - Old World Arch',
      'smithline arch':   'Fireplace Doors - Smithline Arch',
      'smithline - arch': 'Fireplace Doors - Smithline Arch',
      /* Industrial Arch (Metro Arch) — REASSIGNED 2026-08-29 (owner GO) from the Blacksmith
         option set (p45) to Industrial (p47). It was standing on the Blacksmith size grid
         while its base price came from Industrial, over-charging $371–$1,426 per door.
         Arch (+$465, p47) is baked into the product base price ($2136 + $465 = $2601),
         so the data group needs no separate arch row — the p47 W×H grid applies as-is.
         EF_STOLL_INDUSTRIAL_ARCH_20260829 */
      'industrial arch':  'Fireplace Doors - Industrial',
      'industrial - arch':'Fireplace Doors - Industrial',
      'metro arch':       'Fireplace Doors - Industrial',
      /* Design Specialties arches → dedicated group "DS Arch" (cloned from DS group + Legend size brackets, 2026-04-21).
         These MUST come before the non-arch DS aliases (black rock, etc.). */
      'buckingham arch':  'Fireplace Doors - DS Arch',
      'buckingham':       'Fireplace Doors - DS Arch',
      'black rock arch':  'Fireplace Doors - DS Arch',
      'legend plain arch':'Fireplace Doors - DS Arch',
      'legend plain':     'Fireplace Doors - DS Arch',

      /* ── Non-arch (rectangular) ── */
      'forgeline': 'Fireplace Doors - Bar Iron',
      'forge line': 'Fireplace Doors - Bar Iron',
      'forge-line': 'Fireplace Doors - Bar Iron',
      'mesh masonry': 'Fireplace Doors - Mesh Doors',
      'laguna': 'Fireplace Doors - Laguna',
      /* ══════════════════════════════════════════════════════════════════
         SCREEN products — MUST match BEFORE door aliases (title often contains
         keywords like "carolina window pane" which would otherwise route to doors).
         All screens use cfg-screen flow (3 steps: Measurements → Style → Review).
         ══════════════════════════════════════════════════════════════════ */
      /* — Full Glass (frameless, no handle, no feet) — */
      'full glass':                'Fireplace Screen - Full Glass',
      'frameless clear glass':     'Fireplace Screen - Full Glass',
      'clear glass fireplace screen': 'Fireplace Screen - Full Glass',
      'fireplace glass screen':    'Fireplace Screen - Full Glass',
      /* — Modern Stainless (outdoor) — */
      'modern stainless':          'Fireplace Screen - Modern Stainless Outdoor',
      'outdoor arch':              'Fireplace Screen - Modern Stainless Outdoor',
      'outdoor rectangle':         'Fireplace Screen - Modern Stainless Outdoor',
      /* — Manhattan / Nolita / Tribeca / Madison screens (DS single-panel) — */
      'manhattan rectangle':       'Fireplace Screen - Manhattan Modern',
      'nolita rectangle':          'Fireplace Screen - Manhattan Modern',
      'nolita custom free standing': 'Fireplace Screen - Manhattan Modern',
      'tribeca rectangle':         'Fireplace Screen - Manhattan Modern',
      'madison free standing':     'Fireplace Screen - Manhattan Modern',
      /* — Stoll Traditional family (Blacksmith, Craftsman, Colonial, Old World, Industrial, Transitional, Elite, Essentials) — */
      'blacksmith triple panel':   'Fireplace Screen - Stoll Traditional',
      'blacksmith arch working':   'Fireplace Screen - Stoll Traditional',
      'blacksmith rectangle':      'Fireplace Screen - Stoll Traditional',
      'craftsman aged':            'Fireplace Screen - Stoll Traditional',
      'craftsman forged':          'Fireplace Screen - Stoll Traditional',
      'craftsman old world':       'Fireplace Screen - Stoll Traditional',
      'colonial':                  'Fireplace Screen - Stoll Traditional',
      'transitional rectangle':    'Fireplace Screen - Stoll Traditional',
      'industrial rectangle':      'Fireplace Screen - Stoll Traditional',
      'industrial triple panel':   'Fireplace Screen - Stoll Traditional',
      'elite rectangle':           'Fireplace Screen - Stoll Traditional',
      'essentials rectangle':      'Fireplace Screen - Stoll Traditional',
      'essentials triple panel':   'Fireplace Screen - Stoll Traditional',
      'traditional triple panel':  'Fireplace Screen - Stoll Traditional',
      'traditional rectangle':     'Fireplace Screen - Stoll Traditional',
      'traditional arch':          'Fireplace Screen - Stoll Traditional',
      'traditional ellipse':       'Fireplace Screen - Stoll Traditional',
      'traditional classic courtyard': 'Fireplace Screen - Stoll Traditional',
      'traditional x design':      'Fireplace Screen - Stoll Traditional',
      'old world rectangle':       'Fireplace Screen - Stoll Traditional',
      'old world arch':            'Fireplace Screen - Stoll Traditional',  /* OVERRIDES door alias since screens matched first */
      /* — DS Custom family (Scroll, Sawgrass, Black Rock, Banded Scroll, Hammered Edge) — */
      'scroll custom fireplace screen': 'Fireplace Screen - DS Custom',
      'sawgrass':                  'Fireplace Screen - DS Custom',
      'banded scroll':             'Fireplace Screen - DS Custom',
      'hammered edge':             'Fireplace Screen - DS Custom',
      'black rock':                'Fireplace Screen - DS Custom',
      /* — Carolina (single panel + all variants: arch, folding, operable, free standing) — */
      'single panel fireplace screen':            'Fireplace Screen - Carolina Single Panel',
      'single panel fireplace screen - carolina': 'Fireplace Screen - Carolina Single Panel',
      'arch fireplace screen':                    'Fireplace Screen - Carolina Single Panel',
      'carolina custom free standing':            'Fireplace Screen - Carolina Single Panel',
      'carolina free standing':                   'Fireplace Screen - Carolina Single Panel',
      'free standing fireplace screen handmade':  'Fireplace Screen - Carolina Single Panel',
      'folding screens - carolina':               'Fireplace Screen - Carolina Single Panel',
      'folding screens custom':                   'Fireplace Screen - Carolina Single Panel',
      'fireplace screen with operable doors':     'Fireplace Screen - Carolina Single Panel',
      'fireplace arch screen with operable':      'Fireplace Screen - Carolina Single Panel',
      'fireplace screen - carolina':              'Fireplace Screen - Carolina Single Panel',
      'carolina ivy':                             'Fireplace Screen - Carolina Single Panel',
      'carolina pond':                            'Fireplace Screen - Carolina Single Panel',
      'carolina coastal':                         'Fireplace Screen - Carolina Single Panel',
      'carolina plain':                           'Fireplace Screen - Carolina Single Panel',
      /* Legend — Fireplace Screen with Operable Doors (DS premium product) */
      'legend freestanding glass fireplace screen': 'Fireplace Screen - Carolina Single Panel',
      'legend fireplace screen':                    'Fireplace Screen - Carolina Single Panel',
      /* Generic catch-all screen fallback (must be LAST in screen block) */
      'fireplace screen':                         'Fireplace Screen - Carolina Single Panel',
      'carolina sunrise': 'Fireplace Doors - Carolina / Panes',
      'carolina window pane': 'Fireplace Doors - Carolina / Panes',
      'carolina steel': 'Fireplace Doors - Carolina / Panes',
      /* Odyssey — uses Carolina option set, but glass + handle hidden via per-product filter (see renderCards) */
      'odyssey':       'Fireplace Doors - Carolina',
      /* Brooklyn + SlimLinePro aliases moved below to the Stoll 2026 block (dedicated groups). */
      /* DS shared option set — Piccolo & 304 Stainless Steel use the DS catalog */
      'piccolo':       'Fireplace Doors - DS / Oak / Black / Crafts etc',
      '304 stainless': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'stainless steel': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      /* Stoll-name → our-EF_CFG_DATA-group equivalents (per owner mapping 2026-04-21) */
      'arden':    'Fireplace Doors - Avalon /Br /Ht / Ln',  /* Arden = Stoll Avalon */
      'openview': 'Fireplace Doors - Full View',            /* OpenView = Stoll Full View */
      /* Sierra family = Stoll Columbia (pricebook page 32, L2051). Standard widths
         35/39/43/47/51 with width-tier surcharge $0/$0/$240/$240/$371 over base $1086.
         All three Sierra variants share the same Columbia option set. */
      'sierra window pane': 'Fireplace Doors - Columbia',
      'sierra arch':        'Fireplace Doors - Columbia',
      'sierra':             'Fireplace Doors - Columbia',
      /* DeepSet (Inset Hinge) + EdgeLine (Inline Hinge) share Stoll's Inset/Inline
         pricebook (page 37, L2884). Same price grid; per-product flag isEdgeline
         hides decorative panes + Inside Fit (Inline restrictions). Arch handled
         via frame_width field in-group, not the global isArch flag. */
      'deepset arch conversion': 'Fireplace Doors - Inset / Inline',
      'deepset arch':            'Fireplace Doors - Inset / Inline',
      'deepset':                 'Fireplace Doors - Inset / Inline',
      'edgeline arch conversion':'Fireplace Doors - Inset / Inline',
      'edgeline arch':           'Fireplace Doors - Inset / Inline',
      'edgeline':                'Fireplace Doors - Inset / Inline',
      /* Smithline (rectangular) = Stoll Blacksmith. MUST come AFTER 'smithline arch' alias above
         so arch variants still route to the dedicated Smithline Arch group. */
      'smithline':'Fireplace Doors - Blacksmith',
      /* Stoll Heritage = "Original" in pricebook — dedicated group with 27 finishes per HearthProducts 2026. */
      'heritage': 'Fireplace Doors - Heritage',
      /* Design Specialties shared option set: Madrid, Black Rock, Craftsman, Hammered Edge, Banded Scroll, Oak Tree, Napa Valley.
         Bevel Glass options are filtered to Black Rock only (see glass-field constraint below). */
      'madrid':        'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'black rock':    'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'craftsman':     'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'hammered edge': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'banded scroll': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'oak tree':      'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'napa valley':   'Fireplace Doors - DS / Oak / Black / Crafts etc',
      /* Mantel (DS) — Masonry & Prefab Fireplace Doors. Uses Carolina Window Pane option set per owner 2026-04-22. */
      'mantel':        'Fireplace Doors - Carolina / Panes',
      /* Milwaukee Forged Iron — Design Specialties product (DS option set) with Milwaukee-specific size pricing.
         Milwaukee MUST be checked before any generic 'forged iron' alias. */
      'milwaukee': 'Fireplace Doors - Milwaukee',
      /* ── Stoll 2026 pricebook groups (owner 2026-04-22). EF renames per Stoll contract. ── */
      /* Brooklyn Hidden Main Frame — dedicated group as of 2026-08-29. It used to share the
         Design Specialties "Original / Slim / Moderne" ladder ($100/$200/$400/$600), which
         under-charged the Stoll Manhattan grid by up to $1,680 on a 68"×44½" opening.
         Cloned from Manhattan (p55) with its own EF-STOLL-BRKH-* size variants.
         MUST precede the generic 'brooklyn' alias below. EF_STOLL_BRKH_GROUP_20260829 */
      'brooklyn hidden':     'Fireplace Doors - Brooklyn Hidden Main Frame',
      'brooklyn - hidden':   'Fireplace Doors - Brooklyn Hidden Main Frame',
      'brooklyn':            'Fireplace Doors - Manhattan',           /* Brooklyn = Stoll Manhattan (L6157) */
      'manhattan':           'Fireplace Doors - Manhattan',
      'slimlinepro':         'Fireplace Doors - Elite Thinline',      /* SlimLine Pro = Stoll Elite Thinline (L6524) — Cabinet only */
      'slim line pro':       'Fireplace Doors - Elite Thinline',
      'elite thinline':      'Fireplace Doors - Elite Thinline',
      'rustic':              'Fireplace Doors - Old World',           /* Rustic = Stoll Old World (L4136) */
      'old world':           'Fireplace Doors - Old World',
      'metro':               'Fireplace Doors - Industrial',          /* Metro = Stoll Industrial (L4916) — Cabinet only */
      'industrial':          'Fireplace Doors - Industrial',
      'midway':              'Fireplace Doors - Transitional',        /* Midway = Stoll Transitional (L5254) */
      'transitional':        'Fireplace Doors - Transitional',
      'timeless flames':     'Fireplace Doors - Vintage',             /* Timeless Flames = Stoll Vintage (L5603) */
      'vintage':             'Fireplace Doors - Vintage',
      'aged iron':           'Fireplace Doors - Aged & Forged Iron',  /* Aged/Forged Iron (L3721) */
      'aged & forged iron':  'Fireplace Doors - Aged & Forged Iron',
      'aged and forged iron':'Fireplace Doors - Aged & Forged Iron',
      'forged iron':         'Fireplace Doors - Aged & Forged Iron',  /* Stoll Forged Iron — own group as of 2026-04-22 */
      /* Ashford + Edgewood — Stoll steel custom doors (~$2,263 base). No dedicated pricebook
         entry; route to Manhattan (Brooklyn) option set as closest mid-tier steel Stoll match.
         Reassign if owner provides Ashford/Edgewood-specific pricebook later. */
      'ashford':             'Fireplace Doors - Manhattan',
      'edgewood':            'Fireplace Doors - Manhattan',
      /* Plated — Stoll's premium electroplated line (page 39 of HearthProducts pricebook).
         Dedicated group cloned from Bar Iron + 5 plated finishes baked in at $0 (included
         in $6,433+ base). 10–12 week lead time, max size 60×40 due to plating-tank limits. */
      'plated':              'Fireplace Doors - Plated'
    };

    var groups = Object.keys(data);
    var title = prodTitle.toLowerCase();

    /* 2026-06-01 — FIX: Black Rock / Hammered Edge / Banded Scroll exist as BOTH a
       screen and a DS door. Their screen alias in ALIASES is declared BEFORE the
       door alias of the same key, so the JS duplicate-key rule (last wins) silently
       overwrote the screen mapping with the door group → screen products routed to a
       door option-set (empty/wrong configurator). Re-assert the screen group FIRST
       for screen products so they get the correct DS Custom screen option-set. */
    var efIsScreen = (root && root.dataset && root.dataset.cfgType === 'cfg-screen') || title.indexOf('screen') !== -1;
    if (efIsScreen) {
      var SCREEN_OVERRIDE = {
        'black rock':    'Fireplace Screen - DS Custom',
        'hammered edge': 'Fireplace Screen - DS Custom',
        'banded scroll': 'Fireplace Screen - DS Custom'
      };
      for (var sov in SCREEN_OVERRIDE) {
        if (title.indexOf(sov) !== -1 && data[SCREEN_OVERRIDE[sov]]) return SCREEN_OVERRIDE[sov];
      }
    }

    for (var alias in ALIASES) {
      if (title.indexOf(alias) !== -1 && data[ALIASES[alias]]) return ALIASES[alias];
    }

    /* Pass 1: match on product model names only (unique, unambiguous).
       These are real product names that won't collide with colors/materials. */
    var MODEL_NAMES = [
      'stiletto cutback',
      'ardmore','armitage','finley','belmont','brookfield','stiletto','silhouette',
      'cabot','rainbow','reflection','grande','medio','apex','bungalow','savannah',
      'carolina','legend','avalon','blacksmith','elite thinline','madrid',
      'hammered edge','craftsman','oak tree','black rock','bar iron',
      'original custom','old world','smithline','essex','lancaster','portland',
      'hudson','mantel','mke rail','camden','colt','farnsworth'
    ];
    var pass1 = [];
    for (var i = 0; i < groups.length; i++) {
      var gName = groups[i];
      var raw = gName.replace(/^Fireplace Doors\s*-\s*/i, '');
      var keywords = raw.split(/\s*[\/,]\s*/);
      var matchedChars = 0;
      for (var k = 0; k < keywords.length; k++) {
        var kw = keywords[k].trim().toLowerCase();
        if (MODEL_NAMES.indexOf(kw) !== -1 && title.indexOf(kw) !== -1) {
          matchedChars += kw.length;
        }
      }
      if (matchedChars > 0) pass1.push({ name: gName, score: matchedChars });
    }
    if (pass1.length === 1) return pass1[0].name;
    if (pass1.length > 1) {
      pass1.sort(function(a, b) { return b.score - a.score; });
      return pass1[0].name;
    }

    /* Pass 2: fallback keyword match (original logic) */
    groups.sort(function(a, b) { return b.length - a.length; });
    for (var j = 0; j < groups.length; j++) {
      var gName2 = groups[j];
      var raw2 = gName2.replace(/^Fireplace Doors\s*-\s*/i, '');
      var keywords2 = raw2.split(/\s*[\/,]\s*/);
      var matched = false;
      for (var m = 0; m < keywords2.length; m++) {
        var kw2 = keywords2[m].trim().toLowerCase();
        if (kw2.length < 4) continue;
        if (SKIP_WORDS.indexOf(kw2) !== -1) continue;
        if (title.indexOf(kw2) !== -1) {
          matched = true;
          break;
        }
      }
      if (matched) return gName2;
    }
    return groups.length ? groups[groups.length - 1] : null;
  }

  matchedGroup = matchProductToGroup();
  groupData = matchedGroup && window.EF_CFG_DATA ? window.EF_CFG_DATA[matchedGroup] : null;
  /* Expose for the AI Configurator Assist IIFE (separate scope) — sent to the
     worker so it knows which option-set the customer is configuring and can
     restrict finish recommendations to what's actually available. */
  window.EFDoorMSRP.prepare(msrpRule,groupData||{});
  window.efCfgMatchedGroup = matchedGroup;
  console.log('[EF-CFG] Product:', prodTitle, '| Matched group:', matchedGroup, '| Data found:', !!groupData, '| size entries:', groupData && groupData.size ? groupData.size.length : 'NONE');

  /* ────────────────────────────────────
     STOLL FINISH OVERRIDE (pricebook page 79)
     When a product is Stoll-branded (Arden, Sierra, Brooklyn, SlimLinePro,
     ForgeLine, Heritage, Odyssey, Rustic, Metro, Midway, Timeless Flames,
     Aged Iron, DeepSet, EdgeLine, OpenView), swap groupData.finish with the
     canonical 4-category Stoll list. This runs REGARDLESS of which EF group
     the product alias maps to — ensures consistent Stoll-spec finishes.
     ──────────────────────────────────── */
  (function applyStollFinishOverride() {
    if (!groupData) return;
    /* Guard: this override is for Stoll-branded products only. Some Design
       Specialties doors have titles that collide with Stoll aliases below
       (e.g. "Milwaukee Forged Iron" → /forged iron/, "Odyssey" → /odyssey/),
       which would wrongly swap their DS finishes for the Stoll set. DS products
       keep their own finishes (normalized by normalizeFinishCats). */
    var _isDsVendor = /design\s*specialties/i.test(prodVendor);
    var _pt = (prodTitle || '').toLowerCase();

    var STOLL_POWDERCOAT = ['Aspire Rust','Bronzed Iron','Champagne','Charcoal','Copper Vein','Matte Black','Oil Rubbed Bronze','Silver Vein','Textured Black','Vintage Vein','White'];
    var STOLL_PREMIUM = ['Antique Black','Antique Steel','Brushed Beige','Brushed Black','Brushed Grey','Brushed White','Burnished Bronze','Burnished Copper','Burnished Latte','Industrial Black','Natural Iron','Satin Gold'];
    /* PLATED (electroplated) — a different door build, not a coating. Stoll order book p.39:
       exactly these 5 finishes, and a flat +$4,200 retail difference over a powder-coat Bar
       Iron (set 2026-06-06). One shared $4,200 surcharge variant; per-finish swatch images. */
    var PLATED_VARIANT = '42438142361682';
    var PLATED_PRICE = 4200;
    var PLATED_IMG = {
      'Antique Brass':  'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/antique_brass_brushed_metal_seamless_swatch.jpg?v=1776897940',
      'Antique Nickel': 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-plated-antique-nickel.jpg?v=1780896016',
      'Satin Brass':    'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/satin_brushed_horizontal_brass_texture.jpg?v=1776897940',
      'Terra Cotta':    'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-plated-terra-cotta.jpg?v=1780896020',
      'Uptown Walnut':  'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-plated-uptown-walnut.jpg?v=1780896023'
    };
    var STOLL_PLATED = ['Antique Brass','Antique Nickel','Satin Brass','Terra Cotta','Uptown Walnut'];
    /* Stainless is its own thing (brushed 304 stainless), NOT a plated finish. Keep separate. */
    var STAINLESS_IMG = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/seamless_brushed_stainless_steel_surface.jpg?v=1776897940';
    var STOLL_OVERLAY = ['Antique Brass','Brushed Chrome','Pewter','Satin Brass'];
    /* OVERLAY & TRIM finishes. Stoll order forms (p29/p35/p53/p55) price these at $205 on the
       main frame, not $395. Owner GO 2026-08-29: match the pricebook. One shared surcharge
       variant (EF-STOLL-OVERLAY-205) so every style bills the same line item. */
    var OVERLAY_VARIANT = '42659289366610';
    var OVERLAY_PRICE   = 205;

    /* Per-EF-brand availability (verified against Stoll pricebook order forms).
       plated: 'all' (6 entries) | 'stainless' (1 entry) | null (none) */
    /* overlay availability verified against clean Stoll pricebook order forms (2026-06, layout
       extract). overlay=false where the form has NO overlay/trim finish column (selling those
       finishes was unfulfillable). overlay=true only where the form offers Overlay & Trim
       finishes (Original/Heritage, Full View/TotalView, Manhattan). */
    /* overlay availability VERIFIED 2026-06-08 by reading each style's FINISH SELECTION
       directly from the pricebook PDF (per-page pdftotext, no column bleed). overlay=true ONLY
       where the order form prints an "OVERLAY & TRIM FINISHES" section: Bar Iron, Original/Heritage,
       Full View/TotalView, Manhattan. All others = powdercoat+premium (+stainless) only → overlay=false
       (we were selling 4 overlay finishes the factory won't build on those frames). */
    var PRODUCT_MAP = [
      /* Arden — vendor corrected to Design Specialties 2026-08-29 (extruded aluminum frame,
         DS anodized finishes, made in South Carolina). It still shares the Stoll `doors-bar-iron`
         data group, whose raw finish list carries Plated +$4,200 / Brushed Stainless +$1,400 /
         overlay @$395 — none of which belong on an $895 aluminum door. dsOk keeps this override
         running for Arden despite the DS vendor guard, so its palette stays exactly as it was.
         TODO: Arden needs its own DS data group (audit §7.1). EF_ARDEN_DSOK_20260829 */
      {match:/arden/,                                  plated:null,        overlay:true, dsOk:true},
      /* Ashford / Edgewood — Stoll Manhattan platform (p55, base $2,167). p55 offers
         Overlay & Trim finishes and Brushed Stainless at $800, so they get the Brooklyn spec
         rather than the generic Stoll fallback (which would drop the $800 stainless). */
      {match:/ashford|edgewood/,                       plated:'stainless', overlay:true, stainlessPrice:800, stainlessVariant:'42376170373202'},
      {match:/openview/,                               plated:null,        overlay:true},  // Stoll Full View — overlay offered (p53)
      {match:/sierra/,                                 plated:null,        overlay:false}, // Stoll Columbia — no overlay (welded bullet hinges, p33)
      {match:/deepset|edgeline/,                       plated:'stainless', overlay:false, stainlessPrice:800, stainlessVariant:'42376090812498'}, // Stoll Inset/Inline — no overlay, Brushed Stainless $800 (p37)
      {match:/brooklyn/,                               plated:'stainless', overlay:true, stainlessPrice:800, stainlessVariant:'42376170373202'},  // Stoll Manhattan — overlay offered, Brushed Stainless $800 (p55)
      {match:/slimlinepro|slim\s*line\s*pro/,          plated:null,        overlay:false}, // Stoll Elite Thinline — no overlay (p57)
      /* Aged & Forged Iron (p41) FIRST: 'Forged Iron ...' titles must NOT fall through to the
         Bar Iron rule below, which would sell Plated +$4200 / Stainless / Overlay that p41
         does not offer. Audit 2026-08-29 fix #15. */
      {match:/flat\s*hammer|aged\s*iron|forged\s*iron/, plated:null,      overlay:false}, // Stoll Aged & Forged — powdercoat + premium only (p41)
      {match:/forgeline|forge[\s-]?line|bar\s*iron/,   plated:'all',       overlay:true},  // Stoll Bar Iron — overlay offered (p35)
      {match:/heritage/,                               plated:null,        overlay:true},  // Stoll Original — overlay offered (p29)
      {match:/odyssey/,                                plated:null,        overlay:true},  // Stoll Carolina-equivalent (not in audited pages, left as-is)
      {match:/rustic/,                                 plated:null,        overlay:false}, // Stoll Old World — no overlay (p43)
      {match:/metro/,                                  plated:null,        overlay:false}, // Stoll Industrial — no overlay (p47)
      {match:/midway/,                                 plated:null,        overlay:false}, // Stoll Transitional — no overlay (p49)
      {match:/timeless\s*flames?/,                     plated:null,        overlay:false}, // Stoll Vintage — no overlay (p51)
      {match:/smithline|blacksmith|industrial/,        plated:null,        overlay:false}  // Stoll Blacksmith (p45) / Industrial (p47) — powdercoat + premium only
    ];

    var spec = null;
    for (var i = 0; i < PRODUCT_MAP.length; i++) {
      if (PRODUCT_MAP[i].match.test(_pt)) { spec = PRODUCT_MAP[i]; break; }
    }
    /* Design Specialties products keep their own finishes — unless the entry is explicitly
       marked dsOk (Arden: DS product parked on a Stoll data group, see above). */
    if (_isDsVendor && !(spec && spec.dsOk)) return;

    /* EF_STOLL_DEFAULT_SPEC_20260829 — owner GO 2026-08-29: "Stoll doors must show Stoll's
       colors, not Design Specialties'". Until today a Stoll-vendor product whose title matched
       no PRODUCT_MAP row fell through with whatever finish list its data group happened to
       carry — on shared/legacy groups that meant DS names (Shark Skin, Rustic Copper,
       Satin Nickel, Root Beer, Mahogany…) and $315/$1,500 tiers with no basis in any Stoll
       order form. Now the vendor decides: Stoll vendor + no per-style spec = the canonical
       Stoll powdercoat (11 × $0) + premium (12 × $395) lists, no plated / stainless / overlay
       (those are per-style and must be opted into through PRODUCT_MAP above).
       Scoped to door groups: screens and the Plated line keep their own palettes. */
    if (!spec) {
      if (cfgType === 'cfg-screen') return;
      if (!/stoll/i.test(prodVendor)) return;
      if ((matchedGroup || '').indexOf('Fireplace Doors') !== 0) return;
      if (/plated|electroplated|stainless/.test(_pt)) return;
      spec = { match: /__stoll_default__/, plated: null, overlay: false, isDefault: true };
    }

    /* Preserve existing variantIds by normalized label match */
    var existing = {};
    (groupData.finish || []).forEach(function(f) {
      var k = (f.label || '').toLowerCase().replace(/\*/g,'').replace(/\s+(plated|overlay)$/i,'').trim();
      if (!existing[k]) existing[k] = f;
    });
    function lookupV(label) { var e = existing[label.toLowerCase().trim()]; return e ? (e.variantId || null) : null; }
    function lookupImg(label) { var e = existing[label.toLowerCase().trim()]; return (e && e.img) ? e.img : ''; }

    var out = [];
    STOLL_POWDERCOAT.forEach(function(l) { out.push({label:l, cat:'powdercoat', price:'0', variantId:lookupV(l), img:lookupImg(l)}); });
    STOLL_PREMIUM.forEach(function(l)    { out.push({label:l, cat:'premium', price:'395', variantId:lookupV(l), img:lookupImg(l)}); });
    /* PLATED finishes (+$4,200) — only when this product offers full plating ('all'). */
    if (spec.plated === 'all') {
      STOLL_PLATED.forEach(function(l) { out.push({label:l, cat:'plated', price:String(PLATED_PRICE), variantId:PLATED_VARIANT, img:PLATED_IMG[l] || lookupImg(l)}); });
    }
    /* STAINLESS (brushed 304) — offered by full-plating ('all') and stainless-only doors.
       Price matches the pricebook per style: Bar Iron/ForgeLine $1400, Inset/Inline & Manhattan $800. */
    if (spec.plated === 'all' || spec.plated === 'stainless') {
      var _stPrice = String(spec.stainlessPrice || 1400);
      /* EF_STOLL_STAINLESS_20260829 — pin the surcharge variant when the style has a
         pricebook stainless price, so the displayed price and the billed line item agree
         even when the group's own data file still carries the old $1,400 variant. */
      out.push({label:'Brushed Stainless', cat:'plated_stainless', price:_stPrice, variantId:(spec.stainlessVariant || lookupV('Brushed Stainless')), img:lookupImg('Brushed Stainless') || STAINLESS_IMG});
    }
    if (spec.overlay) STOLL_OVERLAY.forEach(function(l) { out.push({label:l, cat:'overlay', price:String(OVERLAY_PRICE), variantId:OVERLAY_VARIANT, img:lookupImg(l)}); });

    /* Shallow-clone groupData before mutating so the shared EF_CFG_DATA
       object isn't polluted across renders. */
    groupData = Object.assign({}, groupData);
    groupData.finish = out;
    console.log('[EF-CFG] Stoll finish override applied:', out.length, 'finishes for pattern', spec.match);
  })();

  /* ────────────────────────────────────
     STOLL HANDLE OVERRIDE — EF_STOLL_HANDLES_20260829
     Owner GO 2026-08-29: "Stoll doors show Design Specialties handles — must be Stoll's".
     Handle availability is per order form, NOT global:
       p23 Mesh · p29 Original · p33 Columbia · p35 Bar Iron · p37 Inset/Inline · p53 TotalView
             → Square* / Wire / Designer / Strap / Hampton / Knob   (all N/C)
       p41 Aged & Forged → Square* / Wire / Designer / Strap / Knob / Craftsman
       p45 Blacksmith    → Blacksmith* / Strap / Craftsman
       p57 Elite Thinline→ Knob handles only (listed under ELITE THINLINE FEATURES)
       p43 / p47 / p49 / p51 / p55 → no HANDLE section on the form → group left untouched
     "Contemporary" is on the Stoll forms but was discontinued store-wide 2026-06-16
     (dropDiscontinuedOptions), so it is deliberately not re-introduced here.
     "Place Handles On Center Bar $70" is priced through the Extras step, not here.
     Design Specialties products are never touched (vendor guard).
     ──────────────────────────────────── */
  (function applyStollHandleOverride() {
    if (!groupData) return;
    if (cfgType === 'cfg-screen') return;
    if (/design\s*specialties/i.test(prodVendor)) return;
    if (!/stoll/i.test(prodVendor)) return;

    var _F = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/';
    /* Stoll Industries handle artwork (*_SI.png). "Desinger" is Stoll's own file-name typo. */
    var SI_IMG = {
      'Square':   _F + 'Square_SI.png',
      'Wire':     _F + 'Wire_SI.png',
      'Designer': _F + 'Desinger_SI.png',
      'Strap':    _F + 'Strap_SI.png',
      'Hampton':  _F + 'Hampton_SI.png',
      'Knob':     _F + 'Knob_SI.png',
      /* Owner-supplied artwork 2026-08-30 (transparent PNG, same treatment as the *_SI set). */
      'Craftsman':  _F + 'ef-handle-craftsman-si.png?v=1788123201',
      /* 2026-08-30 correction: the first file the owner sent (ef-handle-blacksmith-si.png,
         riveted S-curve) is the Old World handle, not this one. Blacksmith = forged bar
         with a ring pull. The unused file stays in Files for a future Old World handle. */
      'Blacksmith': _F + 'ef-handle-blacksmith-si-v2.png?v=1788123536',
      /* Signature handles: the Industrial (p47) and Transitional (p49) order forms carry no
         handle selection — each door ships with its own handle, so we show that one card. */
      'Industrial':   _F + 'ef-handle-industrial-si.png?v=1788123903',
      'Transitional': _F + 'ef-handle-transitional-si.png?v=1788123906'
    };
    /* Recommended handle per style (owner 2026-08-30) — a merchandising hint on the card,
       it does not change the default selection or any price. Craftsman on the Aged & Forged
       (hammered iron) doors, Blacksmith on the Blacksmith / Smithline doors — that is the
       rustic "old world" handle in the Stoll book (p45 "J. Blacksmith*"). */
    var RECOMMENDED = {
      'Fireplace Doors - Aged & Forged Iron': 'Craftsman',
      'Fireplace Doors - Blacksmith':         'Blacksmith',
      'Fireplace Doors - Smithline Arch':     'Blacksmith',
      'Fireplace Doors - Industrial':         'Industrial',
      'Fireplace Doors - Transitional':       'Transitional'
    };
    var STD        = ['Square', 'Wire', 'Designer', 'Strap', 'Hampton', 'Knob'];
    var AGEDFORGED = ['Square', 'Wire', 'Designer', 'Strap', 'Knob', 'Craftsman'];
    var BLACKSMITH = ['Blacksmith', 'Strap', 'Craftsman'];
    var KNOB_ONLY  = ['Knob'];
    var INDUSTRIAL = ['Industrial'];
    var TRANSITION = ['Transitional'];
    var BY_GROUP = {
      'Fireplace Doors - Mesh Doors':          STD,
      'Fireplace Doors - Heritage':            STD,
      'Fireplace Doors - Columbia':            STD,
      'Fireplace Doors - Bar Iron':            STD,
      'Fireplace Doors - Bar Iron Arch':       STD,
      'Fireplace Doors - Inset / Inline':      STD,
      'Fireplace Doors - Full View':           STD,
      'Fireplace Doors - Aged & Forged Iron':  AGEDFORGED,
      'Fireplace Doors - Blacksmith':          BLACKSMITH,
      'Fireplace Doors - Smithline Arch':      BLACKSMITH,
      'Fireplace Doors - Elite Thinline':      KNOB_ONLY,
      'Fireplace Doors - ThinlinePro':         KNOB_ONLY,
      'Fireplace Doors - Industrial':          INDUSTRIAL,
      'Fireplace Doors - Transitional':        TRANSITION
    };
    var labels = BY_GROUP[matchedGroup];
    if (!labels) return;

    /* Preserve existing variantIds (and images we don't have SI art for) by label. */
    var existing = {};
    (groupData.handle || []).forEach(function (h) {
      var k = (h.label || '').toLowerCase().replace(/\*/g, '').trim();
      if (!existing[k]) existing[k] = h;
    });
    var _rec = RECOMMENDED[matchedGroup] || null;
    var handles = labels.map(function (l) {
      var e = existing[l.toLowerCase()];
      return {
        label: l,
        price: 0,
        variantId: (e && e.variantId) || null,
        img: SI_IMG[l] || (e && e.img) || '',
        rec: _rec === l ? 'Recommended' : null
      };
    });
    groupData = Object.assign({}, groupData);
    groupData.handle = handles;
    console.log('[EF-CFG] Stoll handle override applied:', handles.length, 'handles for', matchedGroup);
  })();

  /* ────────────────────────────────────
     DISCONTINUED OPTIONS (2026-06-16)
     Options pulled from the palette globally (no longer orderable). Removed at
     runtime so we don't have to touch the 28 code-split data files. Label match,
     case-insensitive. These are effectively DS-only (Stoll lists don't carry them):
       • finish "Black Nickel"  • handle "Contemporary"
     ──────────────────────────────────── */
  // Owner request 2026-09-22: temporarily hide Birdcage for doors and screens.
  // Keep the source option data intact so this can be reversed independently.
  (function hideBirdcageHandle() {
    if (!groupData || !Array.isArray(groupData.handle)) return;
    groupData = Object.assign({}, groupData);
    groupData.handle = groupData.handle.filter(function (option) {
      return !/^bird[\s-]*cage(?:[\s-]+handle)?$/i.test((option.label || '').trim());
    });
  })();

  (function dropDiscontinuedOptions() {
    if (!groupData) return;
    var GONE = {
      finish: { 'black nickel': 1, 'root beer': 1 },
      handle: { 'contemporary': 1 }
    };
    Object.keys(GONE).forEach(function (grp) {
      var arr = groupData[grp];
      if (!Array.isArray(arr)) return;
      var kept = arr.filter(function (o) { return !GONE[grp][(o.label || '').toLowerCase().trim()]; });
      if (kept.length !== arr.length) {
        groupData = Object.assign({}, groupData);
        groupData[grp] = kept;
        console.log('[EF-CFG] Discontinued ' + grp + ' removed; ' + kept.length + ' remain');
      }
    });
  })();

  /* ────────────────────────────────────
     NEWLY-AVAILABLE OPTIONS (2026-06-16)
     Options that are now orderable, injected at runtime (parallel to the
     discontinued filter) so we don't touch the 28 code-split data files.
     "Rugged Steel" = free handle, added only to groups that already offer the
     Design Specialties handle set (detected by a signature handle), never duped.
     ──────────────────────────────────── */
  (function addNewOptions() {
    if (!groupData || !Array.isArray(groupData.handle)) return;
    var labels = groupData.handle.map(function (h) { return (h.label || '').toLowerCase().trim(); });
    var isDSHandleSet = labels.indexOf('classic') !== -1 || labels.indexOf('simplicity') !== -1;
    if (!isDSHandleSet || labels.indexOf('rugged steel') !== -1) return;
    groupData = Object.assign({}, groupData);
    var hs = groupData.handle.slice();
    var rugged = {
      label: 'Rugged Steel', price: 0, variantId: null,
      img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/Rugged_Steel.png?v=1781639976'
    };
    /* Rugged Steel is free — place it with the free handles, BEFORE the first
       paid (+$) bar handle (Diamond/Square/Hammered Bar). */
    var firstPaid = hs.findIndex(function (h) { return (parseFloat(h.price) || 0) > 0; });
    if (firstPaid === -1) hs.push(rugged); else hs.splice(firstPaid, 0, rugged);
    groupData.handle = hs;
    console.log('[EF-CFG] Added handle: Rugged Steel (before paid handles)');
  })();

  /* ────────────────────────────────────
     STOLL HANDLE IMAGE SWAP (2026-06-16)
     New handle renders from the Stoll order form. Matched by the OLD image URL
     (the Stoll ".jpg" handle art) so the Design-Specialties "Square" (a getimg URL)
     is left untouched — only the Stoll Square.jpg is swapped. Runtime, so all
     groups update without editing the code-split data files.
     ──────────────────────────────────── */
  (function swapStollHandleImages() {
    if (!groupData || !Array.isArray(groupData.handle)) return;
    var SI = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/';
    var MAP = [
      ['/Strap.jpg',    SI + 'Strap_SI.png?v=1781647290'],
      ['/Square.jpg',   SI + 'Square_SI.png?v=1781647290'],
      ['/Designer.jpg', SI + 'Desinger_SI.png?v=1781647290'],
      ['/Wire.jpg',     SI + 'Wire_SI.png?v=1781647290'],
      ['/Hampton.jpg',  SI + 'Hampton_SI.png?v=1781647290'],
      ['/Knob.jpg',     SI + 'Knob_SI.png?v=1781647290']
    ];
    var hit = false;
    var hs = groupData.handle.map(function (h) {
      if (!h.img) return h;
      for (var i = 0; i < MAP.length; i++) {
        if (h.img.indexOf(MAP[i][0]) !== -1) { hit = true; return Object.assign({}, h, { img: MAP[i][1] }); }
      }
      return h;
    });
    if (hit) { groupData = Object.assign({}, groupData); groupData.handle = hs; console.log('[EF-CFG] Stoll handle images swapped'); }
  })();

  /* ────────────────────────────────────
     PATTERN PREVIEW IMAGE (2026-06-16, TEST)
     New preview render for the "Standard" pattern option. Runtime swap by label
     so every group's Standard pattern uses it (test scope).
     ──────────────────────────────────── */
  (function swapPatternImages() {
    /* 2026-06-25 — REVERTED per owner. The transparent "Standard" PNG was a TEST and
       made Standard look inconsistent vs the other 8 patterns (which use the original
       white-bg line-drawing images). Keep everything as it was → Standard uses its
       original image like the rest. Re-enable by removing this return. */
    return;
    if (!groupData || !Array.isArray(groupData.pattern)) return;
    var IMG = { 'standard': 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/fireplace_standard_pattern_transparent.png?v=1781647709' };
    var hit = false;
    var ps = groupData.pattern.map(function (p) {
      var key = (p.label || '').toLowerCase().trim();
      if (IMG[key]) { hit = true; return Object.assign({}, p, { img: IMG[key] }); }
      return p;
    });
    if (hit) { groupData = Object.assign({}, groupData); groupData.pattern = ps; console.log('[EF-CFG] Pattern image swapped'); }
  })();

  /* ────────────────────────────────────
     FINISH CATEGORY NORMALIZATION (2026-06-16)
     Fixes two systemic issues in the per-group finish lists that surface as
     wrong finish tabs (display-only — never touches price or variantId):
       1) PRICED finish mis-tagged into a free/powder-coat tier → it shows in the
          "Powder Coat" tab (e.g. Belmont's +$75 anodized finishes, Old World Arch
          $395 finishes). Move any finish with price > 0 out of the free tier.
       2) DS groups carry BOTH `premium` and `handcrafted` → a redundant 3rd tab.
          Where `handcrafted` exists, fold `premium` into it so the customer sees
          just Powder Coat + Hand Crafted (per spec for Design Specialties doors).
     Groups that are already correct (powdercoat + premium, no handcrafted — e.g.
     the Stoll override output, Brookfield, Cavestone) are left untouched.
     ──────────────────────────────────── */
  (function normalizeFinishCats() {
    if (!groupData || !groupData.finish || !groupData.finish.length) return;
    var FREE = { powder_coat: 1, powdercoat: 1, standard: 1 };
    var hasHandcrafted = groupData.finish.some(function (f) { return f.cat === 'handcrafted'; });
    var changed = 0;
    var out = groupData.finish.map(function (f) {
      var orig = f.cat || 'powder_coat';
      var c = orig;
      var price = parseFloat(f.price) || 0;
      if (FREE[c] && price > 0) c = hasHandcrafted ? 'handcrafted' : 'premium';
      if (c === 'premium' && hasHandcrafted) c = 'handcrafted';
      if (c !== orig) { changed++; return Object.assign({}, f, { cat: c }); }
      return f;
    });
    if (changed) {
      groupData = Object.assign({}, groupData);
      groupData.finish = out;
      console.log('[EF-CFG] Finish categories normalized:', changed, 'recategorized');
    }
  })();

  /* ────────────────────────────────────
     PREMIUM ALUMINUM FINISHES → HAND CRAFTED (2026-08-29, owner request)
     The Design Specialties aluminum-door "Premium" palette (Brookfield / Stiletto /
     Apex set) offered on selected screens as a +$175 Hand Crafted option. Per-product
     opt-in by handle (started with the Madison screen). Runs AFTER normalizeFinishCats
     so cat 'handcrafted' is final. Each finish has its own hidden surcharge variant on
     product 7492486070354 ("Finish: finish-10", $175). Finishes the product already
     lists (e.g. Shark Skin, Satin Nickel) are never duplicated or repriced.
     ──────────────────────────────────── */
  (function addPremiumAluminumFinishes() {
    if (!groupData || !Array.isArray(groupData.finish)) return;
    var HANDLES = {
      'free-standing-fireplace-screen-custom-made-tribeca-rectangle': 1   /* Madison Free Standing Screen */
    };
    if (!HANDLES[(prodHandle || '').toLowerCase()]) return;
    var AV = 'https://product-options-img.avisplus.io/7095025746/7095025746_';
    var SET = [
      { label: 'Copper Fire',       variantId: '42659188932690', img: AV + '1723952740690_RMHZkhmYjwsVXTTVksJ.jpeg' },
      { label: 'Old World Bronze',  variantId: '42659189030994', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/7095025746_1723952745034_ogVpQuHzaPsENWzxXX.jpg?v=1776732375' },
      { label: 'Vintage Brass',     variantId: '42659189063762', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-vintage-brass.jpg?v=1788030713' },
      { label: 'Venetian Bronze',   variantId: '42659189096530', img: AV + '1723952764118_bvQSPnpwkvUcnyXJkWBVx.jpeg' },
      { label: 'Candlelight Brass', variantId: '42659189162066', img: AV + '1723952766404_XFteBCRYiexLiGQYzm.jpeg' }
    ];
    var have = {};
    groupData.finish.forEach(function (f) { have[(f.label || '').toLowerCase().replace(/_/g, ' ').trim()] = 1; });
    var add = SET.filter(function (f) { return !have[f.label.toLowerCase()]; })
      .map(function (f) { return { label: f.label, cat: 'handcrafted', price: '175', variantId: f.variantId, img: f.img }; });
    if (!add.length) return;
    groupData = Object.assign({}, groupData);
    var fs = groupData.finish.slice();
    /* Place right after the last existing Hand Crafted finish so the tab reads
       existing set → premium aluminum, not scattered. */
    var lastHC = -1;
    fs.forEach(function (f, i) { if (f.cat === 'handcrafted') lastHC = i; });
    if (lastHC === -1) fs = fs.concat(add); else fs.splice.apply(fs, [lastHC + 1, 0].concat(add));
    groupData.finish = fs;
    console.log('[EF-CFG] Premium Aluminum finishes added to Hand Crafted:', add.length);
  })();

  /* EF_DS_VINTAGE_BRASS_20261017: owner-approved steel +350; existing aluminum prices retained; Cabot +75. */
  (function addDesignSpecialtiesVintageBrass() {
    var materialByHandle = {
      "design-specialties-brookfield-custom-fireplace-doors": "aluminum",
      "cabot-fireplace-glass-door-for-masonry": "aluminum",
      "black-rock-arch-masonry-fireplace-glass-doors": "steel",
      "design-specialties-buckingham-arch-custom-fireplace-doors-masonry": "steel",
      "design-specialties-legend-arch-custom-fireplace-doors-masonry": "steel",
      "design-specialties-stiletto-custom-fireplace-doors": "aluminum",
      "design-specialties-bungalow-custom-fireplace-doors": "aluminum",
      "design-specialties-carolina-standard-custom-fireplace-doors-1": "steel",
      "design-specialties-carolina-arched-and-window-pane-custom-fireplace-doors": "steel",
      "design-specialties-carolina-arched-custom-fireplace-doors-2": "steel",
      "design-specialties-carolina-sunrise-custom-fireplace-doors": "steel",
      "design-specialties-oak-tree-custom-fireplace-doors": "steel",
      "design-specialties-mantel-custom-fireplace-doors": "steel",
      "design-specialties-napa-valley-custom-fireplace-doors": "steel",
      "design-specialties-legend-odyssey-custom-fireplace-doors": "steel",
      "design-specialties-original-moderne-custom-fireplace-doors-2": "steel",
      "design-specialties-slim-moderne-custom-fireplace-doors-3": "steel",
      "design-specialties-legend-standard-custom-fireplace-doors": "steel",
      "banded-scroll-masonry-prefab-fireplace-glass-doors": "steel",
      "design-specialties-craftsman-custom-fireplace-doors-1": "steel",
      "design-specialties-madrid-custom-fireplace-doors-2": "steel",
      "design-specialties-hammered-edge-standard-custom-fireplace-doors": "steel",
      "design-specialties-black-rock-custom-fireplace-doors": "steel",
      "steel-custom-single-panel-fireplace-screen-carolina-window-pane": "steel",
      "design-specialties-carolina-custom-fireplace-screen": "steel",
      "custom-steel-arch-free-standing-fireplace-screen-carolina": "steel",
      "steel-custom-single-panel-fireplace-screen-carolina-sunrise-window-pane": "steel",
      "free-standing-fireplace-screen-custom-made-options-sawgrass": "steel",
      "design-specialties-carolina-standard-custom-fireplace-screen-6": "steel",
      "design-specialties-carolina-free-standing-screen-door": "steel",
      "fireplace-screen-with-operable-doors-custom-size-21-finishes-carolina": "steel",
      "steel-free-standing-screen-with-doors-custom-made-21-finishes-banded-scroll": "steel",
      "custom-steel-custom-free-standing-folding-screens-21-finishes-carolina": "steel",
      "design-specialties-carolina-standard-custom-fireplace-screen-8": "steel",
      "design-specialties-carolina-free-standing-screen-door-4": "steel",
      "design-specialties-carolina-free-standing-screen-door-5": "steel",
      "design-specialties-carolina-free-standing-screen-door-6": "steel",
      "design-specialties-apex-custom-fireplace-doors": "aluminum",
      "design-specialties-reflection-custom-fireplace-doors": "steel",
      "design-specialties-piccolo-custom-fireplace-doors": "steel",
      "design-specialties-rainbow-custom-fireplace-doors": "steel",
      "steel-custom-free-standing-screen-door-carolina-mesh-curtain": "steel",
      "design-specialties-carolina-standard-custom-fireplace-screen-9": "steel",
      "design-specialties-carolina-free-standing-screen-door-8": "steel",
      "design-specialties-stiletto-cutback-custom-fireplace-doors": "aluminum",
      "design-specialties-full-glass-screen": "steel",
      "design-specialties-full-glass-screen-1": "steel",
      "design-specialties-carolina-standard-custom-fireplace-screen-3": "steel",
      "design-specialties-carolina-standard-custom-fireplace-screen-7": "steel",
      "design-specialties-carolina-standard-custom-fireplace-screen-10": "steel",
      "design-specialties-scroll-custom-fireplace-screen": "steel",
      "fireplace-screen-custom-made-21-finishes-by-design-specialties-black-rock": "steel",
      "stainless-steel-masonry-fireplace-door": "steel",
      "design-specialties-carolina-standard-custom-fireplace-doors-2": "steel",
      "design-specialties-legend-odyssey-custom-fireplace-doors-1": "steel",
      "brookfield-deluxe-magnetic-prefab-fireplace-glass-doors": "aluminum",
      "carolina-traditional-steel-fireplace-glass-doors-masonry-prefab": "steel",
      "legend-custom-masonry-prefab-fireplace-mesh-doors": "steel",
      "legend-freestanding-glass-fireplace-screen-with-operable-doors-custom-size-21-finishes": "steel",
      "milwaukee-forged-iron-masonry-prefab-fireplace-glass-doors": "steel",
      "clear-glass-fireplace-screen-with-front-feet-custom-made": "steel",
      "laguna-arch-pane-masonry-prefab-fireplace-glass-doors": "steel",
      "cavestone-fireplace-glass-doors-custom-masonry-fit": "steel",
      "fireplace-screen-with-operable-doors-custom-size-21-finishes-old-world": "steel",
      "free-standing-fireplace-screen-handmade-to-fit-axis": "steel",
      "fireplace-arch-screen-with-operable-doors-custom-size-21-finishes-carolina": "steel",
      "savannah-masonry-prefab-fireplace-glass-doors": "aluminum",
      "all-glass-steel-fireplace-glass-doors-masonry-prefab": "steel"
    };
    var material = materialByHandle[(prodHandle || '').toLowerCase()];
    if (!material || !/design\s*specialties/i.test(prodVendor || '')) return;
    if (!groupData || !Array.isArray(groupData.finish)) return;
    var found = false;
    var finishes = groupData.finish.map(function (finish) {
      if (!/^vintage[ _]+brass(?: finish)?$/i.test(finish.label || '')) return finish;
      found = true;
      var next = Object.assign({}, finish, { cat: 'handcrafted', img: 'https://product-options-img.avisplus.io/dea3576e-57ee-4c55-9762-cd856a5bf704/vintage-brass_1771282016758x300.jpg' });
      if (material === 'steel') { next.price = 350; next.variantId = '42820671963218'; }
      return next;
    });
    if (!found) finishes.push({
      label: 'Vintage Brass Finish', cat: 'handcrafted', price: material === 'steel' ? 350 : 75,
      variantId: material === 'steel' ? '42820671963218' : '41150263394386', img: 'https://product-options-img.avisplus.io/dea3576e-57ee-4c55-9762-cd856a5bf704/vintage-brass_1771282016758x300.jpg'
    });
    groupData = Object.assign({}, groupData, { finish: finishes });
  })();

  /* EF_POLISHED_BRASS_20261017: owner-requested two-model finish and illustrative previews. */
  (function addPolishedBrass() {
    var previews = {"design-specialties-rainbow-custom-fireplace-doors":"https://cdn.shopify.com/s/files/1/0070/9502/5746/t/272/assets/ef-rainbow-polished-brass-20261017.png?v=1792265587","cavestone-fireplace-glass-doors-custom-masonry-fit":"https://cdn.shopify.com/s/files/1/0070/9502/5746/t/272/assets/ef-cavestone-polished-brass-20261017.png?v=1792265591"};
    var preview = previews[(prodHandle || '').toLowerCase()];
    if (!preview || !groupData || !Array.isArray(groupData.finish)) return;
    if (groupData.finish.some(function(f) { return f.label === 'Polished Brass'; })) return;
    groupData = Object.assign({}, groupData, { finish: groupData.finish.concat([{
      label: 'Polished Brass', cat: 'handcrafted', price: 350, variantId: '42820682743890',
      img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/t/272/assets/ef-polished-brass-swatch-20261017.jpg?v=1792265585', previewImg: preview
    }]) });
  })();

  /* ────────────────────────────────────
     SIZE CATEGORIES (parsed from data)
     ──────────────────────────────────── */
  function parseSizeCategories() {
    if (!groupData || !groupData.size) return;
    sizeData = [];
    sizeGrid = false;
    groupData.size.forEach(function(s) {
      // Parse: "Medium: 60-70 (W+H)" or "Small: under 60 (W+H)" or "XXL: 90+ (W+H)"
      var m;
      var entry = { label: s.label, price: s.price || 0, variantId: s.variantId, maxTotal: Infinity, minTotal: 0,
                    maxW: (s.maxW === undefined || s.maxW === null) ? null : parseFloat(s.maxW),
                    maxH: (s.maxH === undefined || s.maxH === null) ? null : parseFloat(s.maxH) };
      /* EF_STOLL_SIZE_GRID_20260829 - Stoll order forms price by a Width x Height grid
         (row = max opening width AND max opening height), not by united inches. Rows that
         carry maxW/maxH switch this group to grid selection; every other group (all Design
         Specialties data) keeps the legacy W+H behaviour untouched. */
      if (entry.maxW !== null && entry.maxH !== null && !isNaN(entry.maxW) && !isNaN(entry.maxH)) sizeGrid = true;

      m = s.label.match(/under\s+(\d+)/i);
      if (m) { entry.maxTotal = parseInt(m[1], 10) - 0.01; entry.minTotal = 0; }

      m = s.label.match(/(\d+)\s*[-–]\s*(\d+)/);
      if (m) { entry.minTotal = parseInt(m[1], 10); entry.maxTotal = parseInt(m[2], 10) + 0.999; }

      m = s.label.match(/(\d+)\s*\+/);
      if (m) { entry.minTotal = parseInt(m[1], 10); entry.maxTotal = Infinity; }

      // Clean label for display (strip "(W+H)")
      entry.displayLabel = s.label.replace(/\s*\(W\s*\+\s*(?:H|Peak)\)\s*/gi, '').trim();
      /* EF_STOLL_1TO1_20260829 — Stoll rows display exactly as the order form ("Up to 38″ W × 36½″ H"). */
      if (s.gridLabel) entry.displayLabel = s.gridLabel;

      sizeData.push(entry);
    });
  }
  parseSizeCategories();

  /* ────────────────────────────────────
     PARSE FRACTION INPUT ("36 1/16" → 36.0625)
     ──────────────────────────────────── */
  function parseMeasurement(val) {
    if (!val) return NaN;
    val = val.trim().replace(/[""″]/g, '');
    // Match "36 1/16" or "36.5" or "36"
    var m = val.match(/^(\d+(?:\.\d+)?)\s+(\d+)\/(\d+)$/);
    if (m) return parseFloat(m[1]) + parseInt(m[2], 10) / parseInt(m[3], 10);
    m = val.match(/^(\d+(?:\.\d+)?)$/);
    if (m) return parseFloat(m[1]);
    // Try fraction only "1/2"
    m = val.match(/^(\d+)\/(\d+)$/);
    if (m) return parseInt(m[1], 10) / parseInt(m[2], 10);
    return NaN;
  }

  /* ────────────────────────────────────
     MONEY FORMATTER
     ──────────────────────────────────── */
  function money(cents) {
    var neg = cents < 0;
    cents = Math.abs(cents);
    var d = Math.floor(cents / 100);
    var c = cents % 100;
    return (neg ? '-' : '') + '$' + d.toLocaleString('en-US') + (c ? '.' + (c < 10 ? '0' : '') + c : '');
  }

  /* ────────────────────────────────────
     BUILD PROGRESS BAR
     ──────────────────────────────────── */
  var checkSvg = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6l3 3 5-5"/></svg>';

  function buildProgress() {
    /* Luxury strip — thin sticky bar under header. One segment per visible step.
       JS-driven so segment count matches visibleSteps. */
    var strip = document.getElementById('efCfgStrip');
    if (strip) {
      var visStepCount = 0;
      for (var vi = 0; vi < stepNames.length; vi++) {
        if (!_isSkippedStep(vi)) visStepCount++;
      }
      if (!visStepCount) visStepCount = stepNames.length || 6;
      var stripHtml = '';
      for (var si = 0; si < visStepCount; si++) {
        stripHtml += '<div class="ef-cfg-strip__seg" data-vis-step="' + si + '"></div>';
      }
      strip.innerHTML = stripHtml;

      /* ROUND 5 (2026-04-29) — also build segmented bar for the in-flow stepbar
         (mirrors the strip's segment count + premium bronze treatment). */
      var sbTrack = document.getElementById('efPd2StepBarTrack');
      if (sbTrack) {
        var sbHtml = '';
        for (var sbi = 0; sbi < visStepCount; sbi++) {
          sbHtml += '<div class="ef-pd2-stepbar__seg" data-vis-step="' + sbi + '"></div>';
        }
        sbTrack.innerHTML = sbHtml;
      }

      /* Detect header height once on init + on resize (NOT on scroll —
         reading getBoundingClientRect on every scroll caused forced reflows
         that interacted badly with iOS gallery video scroll-into-view). */
      function syncStripOffset() {
        var hdr = document.querySelector('header.shopify-section, #shopify-section-header, header[role="banner"], .header, header');
        var h = 0;
        if (hdr) h = Math.round(hdr.getBoundingClientRect().height);
        if (!h || h < 30) h = 64; /* sane default */
        document.documentElement.style.setProperty('--ef-cfg-strip-offset', h + 'px');
      }
      syncStripOffset();
      window.addEventListener('resize', syncStripOffset, { passive: true });
      /* Run once after window load — header may not be fully sized at script execution */
      window.addEventListener('load', syncStripOffset, { once: true });
      requestAnimationFrame(function() { strip.classList.add('is-ready'); });
    }

    var el = document.getElementById('efCfgProgress');
    /* "Configure your door" label removed 2026-05-03 — duplicate of the
       new section header above. Progress strip just shows step fraction. */
    var html =
      '<div class="ef-cfg-progress__header ef-cfg-progress__header--frac-only">' +
        '<span class="ef-cfg-progress__header-fraction">Step <span id="efCfgStepNum">1</span> of <span id="efCfgStepTotal">' + stepNames.length + '</span></span>' +
      '</div>' +
      '<div class="ef-cfg-progress__nodes">' +
        '<div class="ef-cfg-progress__track-line"></div>' +
        '<div class="ef-cfg-progress__track-fill" id="efCfgTrackFill"></div>';
    /* Mobile-shorter step labels — desktop sees full names, mobile gets
       truncated where helpful. User feedback 2026-05-03 — "Measurements" was
       truncating on 375px viewport but reads fine on desktop. */
    var MOBILE_STEP_SHORT = { 'Measurements': 'Measure' };
    stepNames.forEach(function(name, i) {
      var mobileShort = MOBILE_STEP_SHORT[name];
      var labelHtml = mobileShort
        ? '<span class="ef-desktop-only">' + name + '</span><span class="ef-mobile-only">' + mobileShort + '</span>'
        : name;
      html +=
        '<div class="ef-cfg-progress__node" data-step="' + i + '"' + (i === 0 ? ' aria-current="step"' : '') + '>' +
          '<div class="ef-cfg-progress__circle" id="efCfgCircle' + i + '">' + (i + 1) + '</div>' +
          '<div class="ef-cfg-progress__node-label">' + labelHtml + '</div>' +
          '<div class="ef-cfg-progress__node-summary" id="efCfgSummary' + i + '"></div>' +
        '</div>';
    });
    html +=
      '</div>' +
      '<div class="ef-cfg-progress__pill">' +
        '<div class="ef-cfg-progress__pill-fill" id="efCfgPillFill"></div>' +
      '</div>';
    el.innerHTML = html;

    el.querySelectorAll('.ef-cfg-progress__node').forEach(function(node) {
      node.addEventListener('click', function() {
        var idx = parseInt(node.dataset.step, 10);
        if (idx < curStep) { goToStep(idx); }
        else if (idx > curStep) {
          for (var s = curStep; s < idx; s++) {
            if (_isSkippedStep(s)) continue;
            if (!validateStep(s)) {
              var failNode = el.querySelector('[data-step="' + s + '"]');
              if (failNode) {
                failNode.classList.add('is-error');
                setTimeout(function() { failNode.classList.remove('is-error'); }, 2000);
              }
              return;
            }
          }
          goToStep(idx);
        }
      });
    });

    updateProgress();
  }

  function getStepSummary(stepIndex) {
    /* Return a short label for completed steps based on user selections */
    switch(stepIndex) {
      case 0: return selections.fireplace_type || selections.firebox_type || '';
      case 1:
        var w = selections._width || '';
        var h = selections._height || '';
        if (w && h) return w + '"×' + h + '"';
        return '';
      case 2: return selections.door_type || selections.fit_type || selections.frame_width || '';
      case 3: return selections.finish || '';
      case 4: return selections.glass || selections.mesh || '';
      default: return '';
    }
  }

  function updateProgress() {
    var total = stepNames.length;
    var progEl = document.getElementById('efCfgProgress');
    if (!progEl) return;
    var displayNum = 0;
    for (var i = 0; i < total; i++) {
      var node = progEl.querySelector('[data-step="' + i + '"]');
      var circle = progEl.querySelector('#efCfgCircle' + i);
      var summary = progEl.querySelector('#efCfgSummary' + i);
      if (!node) continue;
      if (_isSkippedStep(i)) { node.style.display = 'none'; continue; }
      node.style.display = '';
      displayNum++;
      node.classList.remove('is-done', 'is-active');
      node.removeAttribute('aria-current');
      var dn = displayNum;
      if (i < curStep) {
        node.classList.add('is-done');
        node.style.cursor = 'pointer';
        circle.innerHTML = checkSvg;
        if (summary) summary.textContent = getStepSummary(i);
      } else if (i === curStep) {
        node.classList.add('is-active');
        node.setAttribute('aria-current', 'step');
        node.style.cursor = 'default';
        circle.textContent = dn;
        if (summary) summary.textContent = '';
      } else {
        node.style.cursor = 'default';
        circle.textContent = dn;
        if (summary) summary.textContent = '';
      }
    }
    var visTotal = total - _totalSkipped();
    var visCur = curStep - _skippedBefore(curStep);
    /* Track line + fill — clip to half-slot offset on each side so line starts
       AT circle 1 center and ends AT circle N center. Track-line has no ID
       (only class) — query by class. User feedback 2026-05-03. */
    var halfSlotPct = (50 / visTotal) + '%';
    var trackLineEls = progEl.querySelectorAll('.ef-cfg-progress__track-line');
    trackLineEls.forEach(function(el) {
      el.style.setProperty('left', halfSlotPct, 'important');
      el.style.setProperty('right', halfSlotPct, 'important');
    });
    /* Track fill: line between nodes */
    var trackFill = document.getElementById('efCfgTrackFill');
    if (trackFill) {
      trackFill.style.setProperty('left', halfSlotPct, 'important');
      var pct = visCur > 0 ? (visCur / (visTotal - 1)) * 100 : 0;
      /* fill width must be capped to (100% - 2*halfSlot) so the bronze fill
         doesn't extend past the last circle. */
      var fillWidth = ((visTotal - 1) / visTotal) * pct + '%';
      trackFill.style.setProperty('width', fillWidth, 'important');
    }
    /* Pill fill */
    var pillFill = document.getElementById('efCfgPillFill');
    if (pillFill) {
      pillFill.style.width = (((visCur + 1) / visTotal) * 100) + '%';
    }
    /* Step number */
    var stepNum = document.getElementById('efCfgStepNum');
    if (stepNum) stepNum.textContent = visCur + 1;
    var stepTotalEl = document.getElementById('efCfgStepTotal');
    if (stepTotalEl) stepTotalEl.textContent = visTotal;

    if (window.innerWidth <= 599) {
      var nodesEl = progEl.querySelector('.ef-cfg-progress__nodes');
      var activeNode = progEl.querySelector('[data-step="' + curStep + '"]');
      if (nodesEl && activeNode) {
        var scrollPos = activeNode.offsetLeft - (nodesEl.offsetWidth / 2) + (activeNode.offsetWidth / 2);
        nodesEl.scrollTo({ left: scrollPos, behavior: 'smooth' });
      }
    }

    /* Sync luxury strip — visCur is current visible-step index, visTotal is total visible steps */
    var stripEl = document.getElementById('efCfgStrip');
    if (stripEl) {
      var segs = stripEl.querySelectorAll('.ef-cfg-strip__seg');
      /* Segment count was built in buildProgress() BEFORE populateSteps() decided which steps
         are skipped (_skipStep2 etc.) — rebuild segments when the visible count changes. (2026-07-01) */
      if (segs.length !== visTotal && visTotal > 0) {
        var _sh = '';
        for (var _si = 0; _si < visTotal; _si++) _sh += '<div class="ef-cfg-strip__seg" data-vis-step="' + _si + '"></div>';
        stripEl.innerHTML = _sh;
        var _sbT = document.getElementById('efPd2StepBarTrack');
        if (_sbT) {
          var _sbh = '';
          for (var _sj = 0; _sj < visTotal; _sj++) _sbh += '<div class="ef-pd2-stepbar__seg" data-vis-step="' + _sj + '"></div>';
          _sbT.innerHTML = _sbh;
        }
        segs = stripEl.querySelectorAll('.ef-cfg-strip__seg');
      }
      segs.forEach(function(seg, idx) {
        seg.classList.remove('is-done', 'is-active');
        if (idx < visCur) seg.classList.add('is-done');
        else if (idx === visCur) seg.classList.add('is-active');
      });
    }
  }

  /* ────────────────────────────────────
     RENDER OPTION CARDS
     ──────────────────────────────────── */
  function renderCards(field, container) {
    if (trifoldRule && (field === 'feet' || field === 'handle')) {
      groupData = window.EFTrifoldPolicy.data(trifoldRule, groupData);
      sanitizeTrifold();
    }
    if (!groupData || !groupData[field]) {
      // Hide the group if no data
      var grp = container.closest('.ef-cfg-group');
      if (grp) grp.style.display = 'none';
      return;
    }
    /* Odyssey: uses Carolina option set but ships without:
         - glass / handle choices (per owner)
         - pattern (decorative panes — Odyssey is plain)
         - non-overlap fit types (Odyssey is Overlap Fit only)
       Glass/handle/pattern groups are hidden entirely. fit_type still renders
       but is filtered down to Overlap Fit only (handled in the fit_type filter
       block below — see _fitOverlapOnly). */
    if (isOdyssey && (field === 'glass' || field === 'handle' || field === 'pattern')) {
      var _ogrp = container.closest('.ef-cfg-group');
      if (_ogrp) _ogrp.style.display = 'none';
      delete selections[field];
      delete surcharges[field];
      return;
    }
    /* All Glass: frameless steel doors — no handles (door operates via glass edge).
       Hide handle field entirely. */
    if (isHammeredEdgeScreen && field === 'handle') { var _hegrp = container.closest('.ef-cfg-group'); if (_hegrp) _hegrp.style.display = 'none'; delete selections[field]; delete surcharges[field]; return; } /* EF_HAMMERED_NOHANDLE_20260917 */
    if (isAllGlass && field === 'handle') {
      var _aggrp = container.closest('.ef-cfg-group');
      if (_aggrp) _aggrp.style.display = 'none';
      delete selections[field];
      delete surcharges[field];
      return;
    }
    /* Forged Iron Arch: hide handle + pattern entirely (per owner spec) */
    if (isForgedIronArch && (field === 'handle' || field === 'pattern')) {
      var _figrp = container.closest('.ef-cfg-group');
      if (_figrp) _figrp.style.display = 'none';
      delete selections[field];
      delete surcharges[field];
      return;
    }
    /* EdgeLine (Inline Hinge): hide decorative pattern entirely (Inset-only per pricebook) */
    if (isEdgeline && field === 'pattern') {
      var _elgrp = container.closest('.ef-cfg-group');
      if (_elgrp) _elgrp.style.display = 'none';
      delete selections[field];
      delete surcharges[field];
      return;
    }
    container.innerHTML = '';
    var _seen = {};
    var _pn = (matchedGroup || '').toLowerCase();

    /* ═══════════════════════════════════════════════════════════════
       FIT TYPE RULES (from Design Specialties Pricebook 2024)
       ─────────────────────────────────────────────────────────────
       overlap_only:  Met, Mantel/All Glass, Hudson, MKE Rail, Brookfield ZC
       inside_only:   Stiletto ZC, Silhouette ZC
       has_flush:     Carolina (all variants) — Masonry Only, +$175
       has_tight:     All steel doors (Carolina, Legend, Hammered Edge,
                      Madrid, Black Rock, Craftsman, Oak Tree, etc.)
       default:       Overlap + Inside (most aluminum & steel masonry)
       ═══════════════════════════════════════════════════════════════ */
    var _fitOverlapOnly = _pn.indexOf('met,') !== -1 || _pn === 'the met' ||
      (_pn.indexOf('met') !== -1 && _pn.indexOf('moderne') === -1 && _pn.indexOf('metro') === -1) ||
      _pn.indexOf('mantel') !== -1 || _pn.indexOf('hudson') !== -1 ||
      _pn.indexOf('mke rail') !== -1 ||
      (_pn.indexOf('brookfield') !== -1 && _pn.indexOf('zc') !== -1) ||
      _pn.indexOf('brookfield deluxe') !== -1 ||
      _pn.indexOf('cutback') !== -1;
    /* Odyssey: allows Overlap Fit + Inside Fit — handled by _fitInsideAndOverlapOnly below */
    var _fitInsideAndOverlapOnly = isOdyssey;
    var _fitInsideOnly = (_pn.indexOf('stiletto') !== -1 && _pn.indexOf('zc') !== -1) ||
      (_pn.indexOf('silhouette') !== -1 && _pn.indexOf('zc') !== -1);
    var _isCarolina = _pn.indexOf('carolina') !== -1;
    var _isAluminum = _pn.indexOf('stiletto') !== -1 || _pn.indexOf('silhouette') !== -1 ||
      _pn.indexOf('brookfield') !== -1 || _pn.indexOf('apex') !== -1 ||
      _pn.indexOf('bungalow') !== -1 || _pn.indexOf('savannah') !== -1 ||
      _pn.indexOf('cabot') !== -1 || _pn.indexOf('reflection') !== -1 ||
      _pn.indexOf('grande') !== -1 || _pn.indexOf('medio') !== -1;

    /* Brookfield Deluxe Magnetic = Factory Built only (magnetic mount installs
       inside ZC opening — no masonry application per pricebook). */
    var _isBrookfieldDeluxe = _pn.indexOf('brookfield deluxe') !== -1;

    var items = groupData[field].filter(function(opt) {
      if (field === 'fireplace_type' && _isBrookfieldDeluxe) {
        var ftlbl = opt.label.toLowerCase().trim();
        if (ftlbl.indexOf('masonry') !== -1) return false;
      }
      if (field === 'glass') {
        var lbl = opt.label.toLowerCase().trim();
        /* Ceramic Glass: only masonry (hide/show handled in selectCard fireplace_type) */
        /* Bevel Glass: DS shared option set — available ONLY for Black Rock.
           Madrid, Craftsman, Hammered Edge, Banded Scroll, Oak Tree, Napa Valley → hide bevel options. */
        if (lbl.indexOf('bevel') !== -1 && prodTitle.toLowerCase().indexOf('black rock') === -1) return false;
        /* EdgeLine (Inline Hinge): Pyro Ceramic not available (pricebook: Cabinet w/ Center Bar masonry only, NOT Inline) */
        if (isEdgeline && lbl.indexOf('pyro') !== -1) return false;
        /* Piccolo (DS shared option set): Black Glass not offered — hidden per owner 2026-07-15 */
        if (lbl.indexOf('black glass') !== -1 && /picc?ol+o/.test(prodTitle.toLowerCase())) return false;
      }
      /* Inside Fit available for BOTH DeepSet and EdgeLine (owner 2026-04-22) */
      if (field === 'mesh' && isArch && !groupData.heaPriceIds) {
        /* Arch products: only Pull-Curtain mesh available (Black Mesh and Stainless Steel
           cannot be installed on a curved opening — their tracks are straight). */
        var mlbl = opt.label.toLowerCase().trim();
        if (mlbl.indexOf('black mesh') !== -1) return false;
        if (mlbl.indexOf('stainless') !== -1) return false;
      }
      if (field === 'door_type' && (isArch || isForgedIronArch)) {
        /* Arch products + Forged Iron Arch: only Clear-View Cabinet and Bi-Fold
           fit a curved opening. Hide Center Bar, AirSeal, Total View, Single
           Hinge, Fixed Door (rectangular-only constructs).
           Handles both legacy EF labels ('Cabinet', 'Bi-Fold') and Stoll-spec
           labels ('Cabinet Clear View', 'Bi-Fold Clear View'). */
        var dtlbl = opt.label.toLowerCase().trim();
        if (/airseal|center\s*bar|total\s*view|single\s*hinge|fixed/i.test(dtlbl)) return false;
        var _startsCabinet = /^cabinet\b/.test(dtlbl);
        var _startsBifold  = /^bi-?fold\b/.test(dtlbl) || dtlbl === 'trackless bi-fold';
        if (!_startsCabinet && !_startsBifold) return false;
      }
      if (field === 'fit_type') {
        var lbl = opt.label.toLowerCase().trim();
        /* Skip "Overlap Fit Only" label variant */
        if (lbl.indexOf('overlap fit only') !== -1) return false;
        /* Overlap-only products: hide Inside, Flush, Tight, Regular */
        if (_fitOverlapOnly && lbl.indexOf('overlap') === -1) return false;
        /* Inside-only products: hide Overlap, Flush, Tight, Regular */
        if (_fitInsideOnly && lbl.indexOf('inside') === -1) return false;
        /* Odyssey-style products: only Overlap Fit + Inside Fit (hide Flush, Tight, Regular) */
        if (_fitInsideAndOverlapOnly && lbl.indexOf('overlap') === -1 && lbl.indexOf('inside') === -1) return false;
        /* Flush Fit & Regular Fit: move to door_fit group for premium products */
        if (cfgType === 'cfg-custom-premium' && (lbl.indexOf('flush') !== -1 || lbl.indexOf('regular') !== -1)) return false;
        /* Flush Fit: only Carolina (non-premium) */
        if (lbl.indexOf('flush') !== -1 && !_isCarolina) return false;
        /* Regular Fit: only Carolina (non-premium) */
        if (lbl.indexOf('regular') !== -1 && !_isCarolina) return false;
        /* Tight Fitting: only steel doors (not aluminum) */
        if (lbl.indexOf('tight') !== -1 && _isAluminum) return false;
      }
      /* Deduplicate by label (Avis data has duplicates for some products) */
      var key = opt.label.toLowerCase().trim();
      if (_seen[key]) return false;
      _seen[key] = true;
      return true;
    });
    /* Arch products: ensure Fireplace Ceramic Glass is offered (Smithline/Old World groups
       lack it in source data — inject the shared DS surcharge variant). */
    if (field === 'glass' && isArch && !groupData.heaPriceIds) {
      var _hasCeramic = items.some(function(it){ return (it.label || '').toLowerCase().indexOf('ceramic') !== -1; });
      if (!_hasCeramic) {
        items.push({
          label: 'Fireplace Ceramic Glass',
          price: 1785,
          variantId: '42373276565586',
          img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/beveled_amber_glass_with_zoom_magnifier.jpg?v=1776733306',
          desc: 'High-temperature ceramic glass. Follow your fireplace and door instructions for use.'
        });
      }
    }

    if (!items.length) {
      var grp2 = container.closest('.ef-cfg-group');
      if (grp2) grp2.style.display = 'none';
      return;
    }
    // Show group and set grid columns based on count
    var grp3 = container.closest('.ef-cfg-group');
    if (grp3) grp3.style.display = '';
    container.className = 'ef-cfg-group__grid';
    /* Moderne (Slim/Original) Door Type: force 2-col layout — 4 large door illustrations
       look cramped at 3-col (3+1 layout). Other groups keep default 3-col for door_type. */
    var _isModerneDoorType = field === 'door_type' && matchedGroup === 'Fireplace Doors - Original Slim / Moderne';
    if (_isModerneDoorType) {
      /* default 2-col grid, no extra class needed */
    } else if (items.length === 3) container.classList.add('ef-cfg-group__grid--3');
    else if (items.length >= 4) container.classList.add('ef-cfg-group__grid--3');

    // Copy only: preserve canonical Masonry values used by pricing, photo suggestions and orders.
    var masonryOnly = field === 'fireplace_type' && items.length === 1 && /masonry/i.test(items[0].label) && !/prefab|factory|zero.clearance/i.test(items[0].label);
    if (masonryOnly && grp3) {
      var compatibilityTitle = grp3.querySelector('.ef-cfg-group__label');
      if (compatibilityTitle) compatibilityTitle.textContent = 'Fireplace Compatibility';
      var compatibilityHelp = grp3.querySelector('.ef-cfg-group__help');
      if (compatibilityHelp) compatibilityHelp.textContent = 'Designed for traditional brick or stone fireplaces. Not for factory-built (prefab) fireplaces.';
      var fireplaceIntro = root.querySelector('#efCfgStep0 > .ef-cfg-step__subtitle');
      if (fireplaceIntro) fireplaceIntro.textContent = 'This door is designed for masonry fireplaces. Choose your firebox type below.';
      container.setAttribute('aria-label', 'Fireplace compatibility: masonry only');
    }

    /* Fallback descriptions for options without desc */
    var fallbackDescs = {
      'Trackless Bi-Fold': 'Fully swing Bi-fold doors',
      'Bi-Fold': 'Fully swing Bi-fold doors',
      'Cabinet': 'Traditional hinged double doors',
      'Simplicity': 'Clean vertical bar',
      'Modern': 'Rectangular pull',
      'Birdcage': 'Ornate twisted design',
      'Infinity': 'Continuous loop handle',
      'Square': 'Angular modern pull',
      'Classic': 'Traditional curved handle',
      'Foundation': 'Solid minimal bar',
      'Contour': 'Ergonomic curved grip',
      'Rugged Steel': 'Hand-forged iron bar',
      'Contemporary': 'Sleek modern design',
      'Designer': 'Premium decorative handle',
      'Masonry': 'Traditional brick or stone fireplace',
      'Overlap Fit': 'Frame overlaps the opening edges',
      'Inside Fit': 'Frame sits inside the opening',
      'Regular Fit': 'Doors overlap the fireplace frame',
      'Flush Fit': 'Doors sit inside the fireplace frame',
      'Clear Glass': 'Standard clear tempered',
      'Grey': 'Tinted grey tempered',
      'Bronze': 'Tinted bronze tempered',
      'Black Glass': 'Tinted black tempered',
      'Wire Mesh Instead': 'Replaces glass with wire mesh',
      'Wire Mesh': 'Replaces glass with wire mesh',
      'Bevel Glass 1/2': 'Beveled edge tempered',
      'Bevel Glass 1': 'Wide beveled edge tempered',
      'No Mesh': 'Just glass doors',
      'Black Mesh': 'Pull-chain mesh',
      'Twin Gate': 'Two mesh doors',
      'Single Panel': 'Single mesh panel',
      'Stainless Steel': 'Premium stainless steel',
      'No Thank You': 'No draft control',
      'Yes': 'Add bottom draft control'
    };

    items.forEach(function(opt) {
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-card' + (!opt.img ? ' ef-cfg-card--no-img' : '');
      btn.setAttribute('type', 'button');
      if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-checked', 'false'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
      btn.setAttribute('tabindex', '0');
      btn.dataset.field = field;
      /* Clean label: remove trailing periods, shorten long mesh/glass names */
      var cleanLabel = opt.label.replace(/\.\s*$/, '');
      /* Shorten labels: take only part before " - " */
      if (field === 'mesh' || field === 'glass') {
        cleanLabel = cleanLabel.split(' - ')[0].replace(/\[.*\]/, '').trim();
      }
      btn.dataset.value = cleanLabel;
      btn.dataset.surcharge = opt.price || 0;
      if (opt.variantId) btn.dataset.variantId = opt.variantId;

      /* Find description: prefer fallback if exists (shorter/cleaner), then data desc */
      var desc = '';
      for (var key in fallbackDescs) {
        if (cleanLabel.toLowerCase().indexOf(key.toLowerCase()) !== -1) {
          desc = fallbackDescs[key];
          break;
        }
      }
      if (!desc) desc = opt.desc || '';
      if(isOldWorldSlim && field==='mesh')desc=cleanLabel==='Wire Mesh'?'Woven wire mesh':'Perforated metal mesh';

      /* Arch products: override images with arch-specific illustrations.
         Covers: firebox_type (flush/hole), fit_type (overlap/inside),
         door_type (bi-fold/cabinet), mesh (depends on door_type selection). */
      var _imgSrc = opt.img;
      if (cfgType === 'cfg-screen' && field === 'feet') {
        var footKey = {'Classic Foot':'footClassic', 'Flat Foot':'footFlat', 'Contemporary Foot':'footContemporary'}[cleanLabel];
        if (footKey && root.dataset[footKey]) _imgSrc = root.dataset[footKey];
        if (cleanLabel === 'Classic Foot') desc = 'Traditional curved foot';
      }
      if (isArch) {
        var _ll = cleanLabel.toLowerCase();
        if (field === 'firebox_type') {
          if (_ll.indexOf('flush') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/arch_-_flush_hearth_1.png?v=1776817368';
          } else if (_ll.indexOf('hole') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/arch_-_hole_in_the_wall_2.png?v=1776817415';
          }
        } else if (field === 'fit_type') {
          if (_ll.indexOf('overlap') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/arch_-_overlap.png?v=1776817368';
          } else if (_ll.indexOf('inside') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/arch_-_inside.png?v=1776817368';
          }
        } else if (field === 'door_type') {
          if (_ll.indexOf('bi-fold') !== -1 || _ll.indexOf('bifold') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/glass_bi-fold_1.png?v=1776814923';
          } else if (_ll.indexOf('cabinet') !== -1) {
            _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/glass_cabinet_1.png?v=1776814923';
          }
        } else if (field === 'mesh') {
          var _dp  = (selections.door_type || '').toLowerCase();
          var _bi  = _dp.indexOf('bi-fold') !== -1 || _dp.indexOf('bifold') !== -1;
          var _cab = _dp.indexOf('cabinet') !== -1;
          var _tw  = _ll.indexOf('twin gate') !== -1;
          var _one = _ll.indexOf('single panel') !== -1 || _ll.indexOf('one panel') !== -1;
          if (_bi && _tw)        _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/bi-fold_twin_gate_mesh_1.png?v=1776814923';
          else if (_bi && _one)  _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/bi-fold_one_panel_1.png?v=1776814923';
          else if (_cab && _tw)  _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/cabinet_twin_gate_mesh_1.png?v=1776814923';
          else if (_cab && _one) _imgSrc = 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/cabinet_one_panel_1.png?v=1776814923';
        }
      }

      if (_imgSrc) {
        btn.classList.remove('ef-cfg-card--no-img');
        btn.classList.add('ef-cfg-card--has-preview');
      }

      var html = '<span class="ef-cfg-card__check">' + CHECK_SVG + '</span>';

      if (_imgSrc) {
        /* Zoom button — mobile tap-to-zoom. data-cfg-zoom attr matched by global click delegate */
        /* Span (not button) — nested <button> breaks the parent card's DOM tree.
           Click delegation matches data-cfg-zoom regardless of element type. */
        html += '<span class="ef-cfg-card__zoom" role="button" tabindex="0" aria-label="View larger image" data-cfg-zoom>'
              + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>'
              + '</span>';
        html += '<span class="ef-cfg-card__img"><img src="' + _imgSrc.replace(/ /g, '%20') + '" alt="' + escHtml(cleanLabel) + '" loading="lazy" onerror="this.style.display=\'none\';this.parentNode.classList.add(\'ef-cfg-img-broken\')"></span>';
        html += '<span class="ef-cfg-card__preview">'
              + '<img src="' + _imgSrc.replace(/ /g, '%20') + '" alt="' + escHtml(cleanLabel) + '">'
              + '<span class="ef-cfg-card__preview-label">' + escHtml(cleanLabel) + '</span>'
              + '</span>';
      }

      html += '<span class="ef-cfg-card__body">';
      /* EF_REC_BADGE_20260830 — merchandising hint ("Recommended") on an option card.
         Set by the Stoll handle override; never affects price or default selection. */
      if (opt.rec) {
        html += '<span class="ef-cfg-card__rec">' + escHtml(String(opt.rec)) + '</span>';
      }
      html += '<span class="ef-cfg-card__title">' + escHtml(masonryOnly ? 'For Masonry Only' : cleanLabel) + '</span>';
      if (desc) {
        html += '<span class="ef-cfg-card__desc">' + escHtml(desc) + '</span>';
      }
      if (opt.price && opt.price > 0) {
        html += '<span class="ef-cfg-card__price">+$' + opt.price + '</span>';
      }
      html += '</span>';

      btn.innerHTML = html;
      /* Modal will read these from data attrs */
      if (_imgSrc) btn.dataset.imgFull = _imgSrc;
      btn.dataset.fullDesc = desc || '';
      btn.addEventListener('click', function(e) {
        /* Don't trigger card select when user tapped the zoom icon */
        if (e.target && e.target.closest && e.target.closest('[data-cfg-zoom]')) return;
        selectCard(btn, field);
      });
      btn.addEventListener('keydown', function(e) {
        /* T-CFG5 2026-09-01 (review-12 §3.6) — same guard the click sibling above has.
           The zoom delegate calls preventDefault() but not stopPropagation(), and this
           listener is bound on the card itself, so without this line Enter on the
           magnifier BOTH changed the selection and opened the modal. Latent until now
           only because the magnifier was hidden on most desktop grids; §3.2 shows it
           everywhere, which would have made that the default keyboard experience. */
        if (e.target && e.target.closest && e.target.closest('[data-cfg-zoom]')) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(btn, field);
        }
      });
      appendChoiceCard(container, btn);
    });
  }

  /* Kontrolka wyboru i powiększenie są rodzeństwem, bez zagnieżdżonych przycisków. */
  function appendChoiceCard(container, btn) {
    var oldZoom = btn.querySelector('[data-cfg-zoom]');
    container.setAttribute('role', 'radiogroup');
    if (!container.getAttribute('aria-label')) {
      var group = container.closest('.ef-cfg-group');
      var heading = group && group.querySelector('h3, h4, .ef-cfg-group__title');
      container.setAttribute('aria-label', heading ? heading.textContent.trim() : 'Choose an option');
    }
    if (!oldZoom) { container.appendChild(btn); return; }
    var wrap = document.createElement('div');
    wrap.className = 'ef-cfg-card-wrap ef-cfg-card--has-preview';
    var zoom = document.createElement('button');
    zoom.type = 'button';
    zoom.className = 'ef-cfg-card__zoom';
    zoom.setAttribute('data-cfg-zoom', '');
    zoom.setAttribute('aria-label', 'View larger image: ' + (btn.dataset.value || 'option'));
    zoom.innerHTML = oldZoom.innerHTML;
    oldZoom.remove();
    wrap.appendChild(btn);
    wrap.appendChild(zoom);
    container.appendChild(wrap);
  }

  // Published Recessed Depth is an OVERLAP measurement, never Frame Depth.
  function resolveRecessDepth(data, selected) {
    var variants = data && data.variants || [];
    var type = /masonry/i.test(selected.fireplace_type || '') ? 'masonry' : /prefab|factory|zero/i.test(selected.fireplace_type || '') ? 'prefab' : '';
    var variant = variants.filter(function(v) { return v.fireplace_type === type; })[0] || variants.filter(function(v) { return v.fireplace_type === 'all'; })[0];
    if (!variant && !type && variants.length === 1) variant = variants[0];
    var inside = /inside|recessed|flush fit/i.test(selected.fit_type || '');
    var gate = /gate|twin/i.test((selected.mesh || '') + ' ' + (selected.glass || ''));
    var numeric = variant && variant.status === 'verified' && typeof variant.inches === 'number' && isFinite(variant.inches);
    var mesh = String(selected.mesh || '');
    var cabinetMesh = !/no mesh|just glass|none/i.test(mesh) && /cabinet|gate|twin/i.test(mesh);
    var customReturn = Object.keys(selected).some(function(k) { return /return|flange|cutback/i.test(k + ' ' + String(selected[k] || '')) && !/no thank|none|no return/i.test(String(selected[k] || '')); });
    var depth = numeric ? (variant.screen_mesh && cabinetMesh ? variant.screen_mesh : gate && variant.gate_mesh ? variant.gate_mesh : variant) : null;
    var rearDatum = variant && variant.basis === 'rear_frame';
    var isStoll = data && data.manufacturer === 'Stoll';
    var headline = depth ? 'Recessed depth: ' + depth.label : variant && variant.status === 'not_applicable' ? 'Recessed depth: N/A for this model' : 'Recessed depth: confirm for your frame';
    var description = depth ? 'For overlap mounting, this door extends ' + depth.label + ' into the opening.' : 'Our team can confirm the clearance needed for your selected frame and mounting. Follow this model’s measuring guide.';
    if (isStoll && !depth && !(variant && variant.status === 'not_applicable')) {
      headline = 'Frame clearance checked with your order';
      description = 'Enter your smallest opening dimensions and include a photo looking up inside the top edge. Our team checks the frame clearance before production.';
    }
    if (rearDatum && depth) {
      headline = 'Rear frame projection: ' + depth.label;
      description = 'The rear flange extends ' + depth.label + ' behind the main frame. Factory-built airflow spacing changes how far it enters the opening. Keep the fireplace’s required airflow clearances.';
    }
    if (variant && variant.standard_only && depth) description += ' Standard frame, without custom returns.';
    if (variant && variant.screen_mesh) description += ' With Twin Gate Mesh: ' + variant.screen_mesh.label + ' inside the opening; without mesh: ' + variant.label + '.';
    if (variant && variant.gate_mesh) description += ' With Gate Mesh, allow ' + variant.gate_mesh.label + ' inside the opening; without it, ' + variant.label + '.';
    if (inside && depth) description += ' You selected inside fit: use the full frame and mounting dimensions in this model’s guide, rather than this overlap depth, to check clearance.';
    if (!variant && variants.length > 1 && !type) {
      headline = 'Recessed depth by fireplace type';
      description = variants.map(function(v) { return (v.fireplace_type === 'prefab' ? 'Factory-built' : 'Masonry') + ': ' + (v.label || 'confirm with our team'); }).join(' · ') + '. Choose your fireplace type to see the matching guidance.';
    }
    var masonry = type === 'masonry' || (!type && variant && variant.fireplace_type === 'masonry');
    var compare = !!(depth && masonry && !inside && !customReturn && variant.basis === 'overlap' && depth.inches > 0);
    if (customReturn && variant && variant.standard_only) {
      headline = 'Custom frame clearance';
      description = 'Your custom return or flange changes the standard depth. Include your opening measurements and top-edge photo; our team checks the final frame clearance before production.';
    }
    var help = compare ? 'For overlap mounting, this door extends ' + depth.label + ' into the opening. Measure from the front face of the opening back to the steel bar and compare that distance below.' : description;
    if (variant && variant.standard_only && compare) help += ' This is the standard frame without custom returns.';
    if (variant && variant.screen_mesh && compare) help += ' With Twin Gate Mesh, the required depth is ' + variant.screen_mesh.label + '.';
    if (variant && variant.gate_mesh && compare) help += ' Gate Mesh changes the required depth to ' + variant.gate_mesh.label + '.';
    return {headline:headline,description:description,help:help,compare:compare,label:depth ? depth.label : '',conditional:!!(variant && (variant.gate_mesh || variant.screen_mesh))};
  }
  function refreshRecessDepthGuidance() {
    if (cfgType === 'cfg-screen') return;
    var el = document.getElementById('efCfgRecessDepthData');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.textContent); } catch (_) { return; }
    if (!data || data.schema_version !== 1) return;
    var view = resolveRecessDepth(data, selections);
    var meshGroup = root.querySelector('[data-group="mesh"]');
    if (view.conditional && meshGroup && !root.querySelector('[data-depth-mesh]')) {
      var notice = document.createElement('aside');notice.className = 'ef-model-depth';notice.setAttribute('data-depth-mesh','');notice.setAttribute('data-model-depth','');
      var title = document.createElement('strong');title.setAttribute('data-depth-title','');notice.appendChild(title);
      var copy = document.createElement('p');copy.setAttribute('data-depth-description','');notice.appendChild(copy);
      meshGroup.parentNode.insertBefore(notice,meshGroup.nextSibling);
    }
    root.querySelectorAll('[data-model-depth]').forEach(function(panel) {
      panel.hidden = false;panel.querySelector('[data-depth-title]').textContent = view.headline;panel.querySelector('[data-depth-description]').textContent = view.description;
    });
    var help = root.querySelector('[data-depth-help]');if (help) help.textContent = view.help;
    root.querySelectorAll('[data-depth-examples], [data-depth-caption]').forEach(function(n) { n.hidden = !view.compare; });
    root.querySelectorAll('[data-depth-dimension]').forEach(function(n) { n.textContent = view.label; });
    var before = root.querySelector('[data-depth-before]');if (before) before.textContent = 'Bar is more than ' + view.label + ' behind the front';
    var under = root.querySelector('[data-depth-under]');if (under) under.textContent = 'Bar is less than ' + view.label + ' behind the front';
    var caption = root.querySelector('[data-depth-caption]');if (caption) caption.textContent = 'Side views · overlap mounting · not to scale. If the bar is exactly ' + view.label + ' back, or clearance is tight, include a close-up photo with your order so our team can confirm the measuring point.';
  }

  function selectCard(btn, field) {
    if (trifoldRule && !window.EFTrifoldPolicy.allowed(trifoldRule, field, btn.dataset.value || btn.dataset.label)) { sanitizeTrifold(); return; }
    var grid = btn.closest('.ef-cfg-group__grid') || btn.parentElement;
    /* Toggle off — second click on the already-selected card deselects.
       Useful for cosmetic options (finish, handle, draft control, mesh, pattern).
       For required fields (fit_type, door_type) the validateStep on Next will
       block advance until something is re-selected. */
    if (btn.getAttribute('aria-checked') === 'true') {
      btn.setAttribute('aria-checked', 'false'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
      if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', 'false');
      delete selections[field];
      delete surcharges[field];
      /* Restore gallery ONLY for glass-screens that actually have a per-product glass
         preview for this label — never clobber a doors finish-preview swap. */
      if (field === 'glass') {
        try {
          var _gphX = (root && root.dataset && root.dataset.productHandle) || '';
          var _gmX  = (window.EF_SCREEN_FINISH_PREVIEWS && window.EF_SCREEN_FINISH_PREVIEWS[_gphX]) || null;
          if (_gmX && (_gmX['Grey'] || _gmX['Bronze'] || _gmX['Clear'])) efRestoreMainImage();
        } catch(e) {}
      }
      refreshRecessDepthGuidance();
      try { updatePrice(); } catch(e) {}
      return;
    }

    grid.querySelectorAll('.ef-cfg-card').forEach(function(c) {
      c.setAttribute('aria-checked', 'false'); c.setAttribute('role', c.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); c.removeAttribute('aria-pressed');
      if (!c.hasAttribute('aria-checked')) c.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-checked', 'true'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
    if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', 'true');

    selections[field] = btn.dataset.value;
    var surcharge = parseInt(btn.dataset.surcharge, 10) || 0;
    surcharges[field] = { amount: surcharge * 100, label: btn.dataset.value, variantId: btn.dataset.variantId || null };

    /* EF FUNNEL: option select (P-007) — additive emission only */
    try {
      efTrack('ef_cfg_option_select', {
        step_name: stepNames[curStep] || '',
        option_type: field,
        option_label: btn.dataset.value || '',
        price_delta: surcharge || 0
      });
    } catch (e) {}

    /* Glass color → swap the gallery main image to the per-product tint preview
       (frameless full-glass screens). Keyed by product handle in EF_SCREEN_FINISH_PREVIEWS,
       same map used by finish swatches. Restores to the base photo if no preview exists
       (e.g. Black before its render is generated). */
    if (field === 'glass') {
      try {
        var _gph  = (root && root.dataset && root.dataset.productHandle) || '';
        var _gmap = (window.EF_SCREEN_FINISH_PREVIEWS && window.EF_SCREEN_FINISH_PREVIEWS[_gph]) || null;
        var _gp   = _gmap && _gmap[btn.dataset.value];
        /* A glass SCREEN is identified by glass-color keys in its per-product map
           (doors finish-preview maps never contain Clear/Grey/Bronze). Swap when the
           picked color has a render; for a glass screen color WITHOUT a render (Black,
           until generated) restore to the clear base — but NEVER touch the gallery on
           doors, where that would undo the finish-swatch preview swap. */
        var _isGlassScreenMap = _gmap && (_gmap['Grey'] || _gmap['Bronze'] || _gmap['Clear']);
        if (_gp) efSwapMainImage(_gp);
        else if (_isGlassScreenMap) efRestoreMainImage();
      } catch(e) {}
    }

    /* Update opening diagram when fireplace/firebox type changes */
    if (field === 'fireplace_type') { _openType.fp = btn.dataset.value; drawOpening(_openDims.w, _openDims.h); }
    if (field === 'firebox_type')   {
      _openType.fb = btn.dataset.value;
      drawOpening(_openDims.w, _openDims.h);
      /* Arch SVG dynamic hearth toggle:
         - Flush: hearth slab visible, floor at y=260 (level with hearth surface)
         - Hole-in-wall: hearth hidden, brick wall extends below firebox down to floor at y=292 */
      if (isArch) {
        var _isFlushArch = btn.dataset.value.toLowerCase().indexOf('flush') !== -1 ||
                           btn.dataset.value.toLowerCase().indexOf('hearth') !== -1;
        var _ah1 = document.getElementById('efArchHearthTop');
        var _ah2 = document.getElementById('efArchHearthEdge');
        var _afl = document.getElementById('efArchFloorLine');
        var _awb = document.getElementById('efArchWallBelow');
        if (_ah1) _ah1.setAttribute('opacity', _isFlushArch ? '1' : '0');
        if (_ah2) _ah2.setAttribute('opacity', _isFlushArch ? '1' : '0');
        if (_awb) _awb.setAttribute('opacity', _isFlushArch ? '0' : '1');
        if (_afl) {
          _afl.setAttribute('y1', _isFlushArch ? '260' : '292');
          _afl.setAttribute('y2', _isFlushArch ? '260' : '292');
        }
      }
    }

    /* Conditional logic: Fireplace Type affects Fit Type & Draft Control */
    if (field === 'fireplace_type') {
      var isFactory = btn.dataset.value.toLowerCase().indexOf('factory') !== -1 ||
                      btn.dataset.value.toLowerCase().indexOf('prefab') !== -1;

      /* Factory-Built → hide Inside Fit ONLY for DS aluminum products
         that are documented as Overlap Only in ZC/Factory-Built mode.
         Products not in this list keep both fit types for Factory-Built. */
      var _pnFit = (matchedGroup || '').toLowerCase();
      var _factoryOverlapOnly = ['brookfield'];
      var _shouldHideInside = _factoryOverlapOnly.some(function(n) { return _pnFit.indexOf(n) !== -1; });
      var _factoryInsideOnly = _pnFit.indexOf('stiletto') !== -1 && _pnFit.indexOf('cutback') === -1;
      var hideInsideFit = isFactory && _shouldHideInside;
      var hideOverlapFit = isFactory && _factoryInsideOnly;
      var fitCards = root.querySelectorAll('[data-field="fit_type"]');
      fitCards.forEach(function(c) {
        var cv = c.dataset.value.toLowerCase();
        var isInside = cv.indexOf('inside') !== -1;
        var isOverlap = cv.indexOf('overlap') !== -1;
        var shouldHide = (isInside && hideInsideFit) || (isOverlap && hideOverlapFit);
        c.style.display = shouldHide ? 'none' : '';
        if (shouldHide && c.getAttribute('aria-checked') === 'true') {
          c.setAttribute('aria-checked', 'false'); c.setAttribute('role', c.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); c.removeAttribute('aria-pressed'); c.setAttribute('role', c.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); c.removeAttribute('aria-pressed'); c.setAttribute('role', c.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); c.removeAttribute('aria-pressed');
          if (!c.hasAttribute('aria-checked')) c.setAttribute('aria-pressed', 'false');
          delete selections.fit_type;
          delete surcharges.fit_type;
        }
        if (hideInsideFit && isOverlap) {
          c.setAttribute('aria-checked', 'true'); c.setAttribute('role', c.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); c.removeAttribute('aria-pressed');
          selections.fit_type = c.dataset.value;
          surcharges.fit_type = { amount: (parseInt(c.dataset.surcharge,10)||0)*100, label: c.dataset.value, variantId: c.dataset.variantId || null };
        }
        if (hideOverlapFit && isInside) {
          c.setAttribute('aria-checked', 'true'); c.setAttribute('role', c.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); c.removeAttribute('aria-pressed');
          selections.fit_type = c.dataset.value;
          surcharges.fit_type = { amount: (parseInt(c.dataset.surcharge,10)||0)*100, label: c.dataset.value, variantId: c.dataset.variantId || null };
        }
      });
      /* Draft Control: masonry only — hide for factory-built/prefab */
      var draftGroup = root.querySelector('[data-group="draft_control"]');
      if (draftGroup && draftGroup.dataset.hasDraftControl === '1') {
        var showDC = !isFactory;
        draftGroup.style.display = showDC ? '' : 'none';
        if (!showDC) { delete selections.draft_control; delete surcharges.draft_control; }
      }

      /* Extras: Z-Tab is prefab/ZC only — re-evaluate now that we know the fireplace type. */
      try { updateExtrasVisibility(); } catch (e) {}

      /* Ceramic Glass: masonry only */
      var ceramicCards = root.querySelectorAll('[data-field="glass"]');
      ceramicCards.forEach(function(gc) {
        if (gc.dataset.value.toLowerCase().indexOf('ceramic') !== -1) {
          gc.style.display = isFactory ? 'none' : '';
          if (isFactory && gc.getAttribute('aria-checked') === 'true') {
            gc.setAttribute('aria-checked', 'false'); gc.setAttribute('role', gc.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); gc.removeAttribute('aria-pressed');
            if (!gc.hasAttribute('aria-checked')) gc.setAttribute('aria-pressed', 'false');
            delete selections.glass;
            delete surcharges.glass;
          }
        }
      });
    }

    /* Glass = Wire Mesh / Replace with Mesh → dim Mesh Screen group (mesh replaces glass, no extra screen needed).
       Cards stay visible but greyed out and non-interactive. Selection cleared. */
    if (field === 'glass') {
      var _glv = btn.dataset.value.toLowerCase();
      var _isWireMesh = _glv.indexOf('wire mesh') !== -1 ||
                        _glv.indexOf('replace with mesh') !== -1 ||
                        _glv.indexOf('replace glass') !== -1 ||
                        _glv.indexOf('mesh instead') !== -1;
      var meshGroup = root.querySelector('[data-group="mesh"]');
      if (meshGroup) {
        meshGroup.classList.toggle('ef-cfg-group--disabled', _isWireMesh);
        if (_isWireMesh) {
          meshGroup.querySelectorAll('.ef-cfg-card').forEach(function(mc) {
            mc.setAttribute('aria-checked', 'false'); mc.setAttribute('role', mc.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); mc.removeAttribute('aria-pressed');
            if (!mc.hasAttribute('aria-checked')) mc.setAttribute('aria-pressed', 'false');
          });
          delete selections.mesh;
          delete surcharges.mesh;
        }
      }
    }

    /* Arch: when door_type changes, re-render mesh cards so images switch
       between bi-fold and cabinet variants (renderCards reads selections.door_type). */
    if (field === 'door_type' && isArch) {
      var _archMeshGroup = root.querySelector('[data-group="mesh"]');
      var _archMeshGrid  = _archMeshGroup ? _archMeshGroup.querySelector('.ef-cfg-group__grid') : null;
      if (_archMeshGrid) {
        var _prevMesh = selections.mesh;
        renderCards('mesh', _archMeshGrid);
        if (_prevMesh) {
          _archMeshGrid.querySelectorAll('.ef-cfg-card').forEach(function(mc) {
            if (mc.dataset.value === _prevMesh) {
              mc.setAttribute('aria-checked', 'true'); mc.setAttribute('role', mc.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); mc.removeAttribute('aria-pressed');
              if (!mc.hasAttribute('aria-checked')) mc.setAttribute('aria-pressed', 'true');
            }
          });
        }
      }
    }

    /* Door type → mirror selected door image onto the "No Mesh" card
       (No Mesh = just glass doors, so its preview should match the chosen door style).
       For arch, runs after re-render so fresh cards get the mirror treatment too. */
    if (field === 'door_type') {
      var _dtImg = btn.querySelector('img');
      var _dtSrc = _dtImg ? _dtImg.getAttribute('src') : null;
      if (_dtSrc) {
        var _meshCards = root.querySelectorAll('[data-field="mesh"]');
        _meshCards.forEach(function(mc) {
          var _v = (mc.dataset.value || '').toLowerCase();
          if (_v.indexOf('no mesh') !== -1) {
            mc.querySelectorAll('img').forEach(function(im) { im.src = _dtSrc; });
          }
        });
      }
    }

    refreshRecessDepthGuidance();
    updatePrice();
  }

  /* ────────────────────────────────────
     RENDER FINISH SWATCHES
     ──────────────────────────────────── */
  function renderFinishes() {
    if (!groupData || !groupData.finish) return;

    var tabs = {};
    groupData.finish.forEach(function(f) {
      var cat = normCat(f.cat);
      if (!tabs[cat]) tabs[cat] = [];
      tabs[cat].push(f);
    });

    var tabEl = document.getElementById('efCfgFinishTabs');
    var gridEl = document.getElementById('efCfgSwatchGrid');
    tabEl.innerHTML = '';
    gridEl.innerHTML = '';

    var catKeys = Object.keys(tabs);
    if (!catKeys.length) return;

    var activeTab = catKeys[0];

    catKeys.forEach(function(cat) {
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-tab' + (cat === activeTab ? ' is-active' : '');
      btn.textContent = CAT_LABELS[cat] || cat;
      btn.dataset.cat = cat;
      btn.setAttribute('role', 'tab');
      btn.addEventListener('click', function() {
        hideSwatchPopup();
        tabEl.querySelectorAll('.ef-cfg-tab').forEach(function(t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        showSwatchesForCat(cat, gridEl);
      });
      tabEl.appendChild(btn);
    });

    showSwatchesForCat(activeTab, gridEl);
  }

  function showSwatchesForCat(cat, gridEl) {
    hideSwatchPopup();
    gridEl.innerHTML = '';
    /* Premium "why it costs more" reveal — only on the Premium tab. */
    var _pi = document.getElementById('efCfgPremiumInfo');
    if (_pi) { _pi.style.display = (cat === 'premium') ? 'block' : 'none'; }
    /* Plated "why it costs more" reveal — only on the Plated tab. */
    var _pl = document.getElementById('efCfgPlatedInfo');
    if (_pl) { _pl.style.display = (cat === 'plated') ? 'block' : 'none'; }
    if (!groupData || !groupData.finish) return;

    groupData.finish.forEach(function(f) {
      if (normCat(f.cat) !== cat) return;

      var btn = document.createElement('button');
      btn.className = 'ef-cfg-swatch';
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-checked', selections.finish === f.label ? 'true' : 'false'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
      if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', selections.finish === f.label ? 'true' : 'false');
      btn.setAttribute('aria-label', efFinishDisplay(f.label) + (f.price > 0 ? ', plus $' + f.price : ', included'));
      btn.setAttribute('tabindex', '0');
      btn.dataset.label = f.label;
      btn.dataset.surcharge = f.price || 0;
      btn.dataset.cat = f.cat || 'powder_coat';
      if (f.variantId) btn.dataset.variantId = f.variantId;

      var circle = document.createElement('span');
      circle.className = 'ef-cfg-swatch__circle';
      if (f.img) circle.style.backgroundImage = 'url(' + f.img.replace(/ /g, '%20') + ')';
      else circle.style.background = '#333';

      var tooltip = document.createElement('span');
      tooltip.className = 'ef-cfg-swatch__tooltip';
      tooltip.innerHTML = escHtml(efFinishDisplay(f.label)) + '<br>' + (f.price > 0 ? '+' + money(f.price * 100) : 'Included');

      btn.appendChild(circle);
      btn.appendChild(tooltip);

      btn.addEventListener('click', function() { selectSwatch(btn, f); });
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectSwatch(btn, f); }
      });
      /* mouseenter / mouseleave only meaningful on hover-capable devices.
         On touch devices iOS Safari fires simulated mouseenter on tap → click,
         then mouseleave when finger lifts — which would auto-hide the popup
         we just showed via selectSwatch. Gate by (hover: hover). */
      btn.addEventListener('mouseenter', function(e) {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
          showSwatchPopup(btn, f);
        }
      });
      btn.addEventListener('mouseleave', function() {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
          hideSwatchPopup();
        }
      });

      gridEl.appendChild(btn);
    });
  }

  /* ────────────────────────────────────
     FINISH SAMPLES — multi-select grid + ATC ($10 each, $10 promo per sample)
     Backend: requires Shopify product "Door Finish Sample" at $10.
     Replace DOOR_SAMPLE_VARIANT_ID below with the real variant ID.
     ──────────────────────────────────── */
  function renderSamples() {
    if(isOldWorldSlim)return;
    var grid = document.getElementById('efCfgSamplesGrid');
    if (!grid) return;
    if (!groupData || !groupData.finish || !groupData.finish.length) return;

    var DOOR_SAMPLE_VARIANT_ID = '42380268535890'; /* Fireplace Door Finish Sample — handle: fireplace-door-finish-sample */
    var SAMPLE_PRICE = 10;
    var selectedSamples = {}; /* { label: { label, img } } */

    /* REVIEW-12 §2.2 / T-CFG8 2026-09-01 — group by f.cat, the field renderFinishes()
       already uses for this step's tabs. Free tier first, then premium: that is the
       data order, the tab order, and the order the price argument needs. */
    function efSampleCard(f) {
      var bgStyle = f.img
        ? 'background-image:url(' + f.img.replace(/ /g, '%20') + ');'
        : 'background-color:#888;';
      /* data-label carries the RAW label — it is the join key into swatchByLabel,
         the cart line-item property and the surcharge lookup. Only the visible name
         goes through efFinishDisplay(). */
      var safeLabel = (f.label || '').replace(/"/g, '&quot;');
      return '<button type="button" class="ef-cfg-samples-card" data-label="' + safeLabel + '" aria-pressed="false">' +
        '<span class="ef-cfg-samples-card__swatch" style="' + bgStyle + '"></span>' +
        '<span class="ef-cfg-samples-card__name">' + escHtml(efFinishDisplay(f.label || '')) + '</span>' +
      '</button>';
    }

    /* The price phrase is computed from the group's own prices and never literal —
       the premium tier is +$150 on Cavestone, +$175 on the Madison screen set and
       +$395 on the Stoll groups, and some groups are mixed. Four shapes, one rule. */
    function efSamplePrice(list) {
      var ps = list.map(function (f) { return parseFloat(f.price) || 0; });
      var min = Math.min.apply(null, ps), max = Math.max.apply(null, ps);
      if (max === 0) return 'included in your price';
      if (min === max) return '+$' + max.toLocaleString('en-US') + ' on your door';
      if (min === 0) return 'included to +$' + max.toLocaleString('en-US') + ' on your door';
      return 'from +$' + min.toLocaleString('en-US') + ' on your door';
    }

    var efCatOrder = [], efByCat = {};
    groupData.finish.forEach(function (f) {
      var c = normCat(f.cat);
      if (!efByCat[c]) { efByCat[c] = []; efCatOrder.push(c); }
      efByCat[c].push(f);
    });

    grid.innerHTML = efCatOrder.map(function (cat) {
      var list = efByCat[cat];
      /* One group only (most screen sets): the caption would be a heading over the
         whole panel, which is what the summary title already is. Emit bare cards. */
      var cap = efCatOrder.length < 2 ? '' :
        '<p class="ef-cfg-samples__cap">' +
          '<span>' + escHtml(CAT_LABELS[cat] || cat) + ' &middot; ' + list.length +
            (list.length === 1 ? ' finish' : ' finishes') + '</span>' +
          '<span>' + escHtml(efSamplePrice(list)) + '</span>' +
        '</p>';
      return cap + list.map(efSampleCard).join('');
    }).join('');

    var countEl = document.getElementById('efCfgSamplesCount');
    var totalEl = document.getElementById('efCfgSamplesTotal');
    var atcBtn = document.getElementById('efCfgSamplesAtc');
    if (!countEl || !totalEl || !atcBtn) return;

    function updateBar() {
      var n = Object.keys(selectedSamples).length;
      /* UX/a11y rec 2026-05-03 — never start the CTA disabled at $0 (reads as
         broken, no SR explanation). Stays enabled; if user taps with 0 selected
         we focus the grid + show inline nudge. Count copy adapts so the bar
         doesn't read "0 selected · $0" (dead-end energy). */
      if (n === 0) {
        countEl.textContent = 'Tap a swatch to start';
        totalEl.textContent = '';
      } else {
        countEl.textContent = n + ' selected';
        totalEl.textContent = '$' + (n * SAMPLE_PRICE).toLocaleString('en-US');
      }
      atcBtn.disabled = false;
      atcBtn.removeAttribute('disabled');
    }

    /* Build a label → swatch-url lookup so we can pass the swatch image as a
       hidden line-item property — cart drawer reads it to render the actual
       finish color instead of the generic sample-product image. */
    var swatchByLabel = {};
    groupData.finish.forEach(function (f) {
      if (f && f.label) swatchByLabel[f.label] = f.img || '';
    });

    grid.addEventListener('click', function(e) {
      var card = e.target.closest('.ef-cfg-samples-card');
      if (!card) return;
      var label = card.getAttribute('data-label');
      if (selectedSamples[label]) {
        delete selectedSamples[label];
        card.classList.remove('is-selected');
        if (!card.hasAttribute('aria-checked')) card.setAttribute('aria-pressed', 'false');
      } else {
        selectedSamples[label] = { label: label, img: swatchByLabel[label] || '' };
        card.classList.add('is-selected');
        if (!card.hasAttribute('aria-checked')) card.setAttribute('aria-pressed', 'true');
      }
      updateBar();
    });

    var atcDefaultHTML = 'Add Samples <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>';

    atcBtn.addEventListener('click', function() {
      var labels = Object.keys(selectedSamples);
      if (!labels.length) {
        /* Inline nudge instead of silent disabled state — focus grid + flash hint. */
        countEl.textContent = 'Tap a swatch above to add';
        countEl.style.color = '#8A6A43';
        countEl.style.fontWeight = '600';
        var firstCard = grid.querySelector('.ef-cfg-samples-card');
        if (firstCard) firstCard.focus();
        setTimeout(function () {
          countEl.style.color = '';
          countEl.style.fontWeight = '';
          updateBar();
        }, 1800);
        return;
      }

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      /* Each sample = its own line item with finish-name property so the order
         shows "Finish: Bronze Burst" etc. for fulfillment to ship the right swatch. */
      var sampleConfigId = 'sample-' + Date.now().toString(36);
      var items = labels.map(function(n) {
        var props = {
          'Finish': n,
          '_sample_set_id': sampleConfigId
        };
        /* Property name matches what ef-cart-drawer.js expects (line 113). */
        var swatchUrl = (selectedSamples[n] && selectedSamples[n].img) || swatchByLabel[n];
        if (swatchUrl) props._finish_image = swatchUrl;
        return {
          id: parseInt(DOOR_SAMPLE_VARIANT_ID),
          quantity: 1,
          properties: props
        };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { if (!r.ok) throw new Error('cart error'); return r.json(); })
      .then(function() {
        atcBtn.style.background = '#8A6A43';
        atcBtn.innerHTML = 'Added &#10003;';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        /* Open EF custom cart drawer (same as main ATC) — never Prestige's <cart-drawer>,
           which has different fonts/styling and was causing visual inconsistency. */
        if (window.EFCartDrawer && typeof window.EFCartDrawer.open === 'function') {
          window.EFCartDrawer.open();
        }
        setTimeout(function() {
          atcBtn.disabled = true;
          atcBtn.style.background = '';
          atcBtn.innerHTML = atcDefaultHTML;
          selectedSamples = {};
          grid.querySelectorAll('.ef-cfg-samples-card.is-selected').forEach(function(c) {
            c.classList.remove('is-selected');
            if (!c.hasAttribute('aria-checked')) c.setAttribute('aria-pressed', 'false');
          });
          updateBar();
        }, 1200);
      })
      .catch(function() {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Error — try again';
        setTimeout(function() {
          atcBtn.innerHTML = atcDefaultHTML;
        }, 2000);
      });
    });

    updateBar();
  }

  /* ────────────────────────────────────
     EF FINISH PREVIEW — main gallery image swap on swatch click.
     Helpers swap #efGallerySwiper's first slide image to finish.previewImg
     and restore on deselect. Defensive — wrapped in try/catch so absence
     of gallery never breaks configurator.
     ──────────────────────────────────── */
  function efGalleryFirstImg() {
    try { return document.querySelector('#efGallerySwiper .swiper-slide:first-child picture img, #efGallerySwiper .swiper-slide:first-child img'); }
    catch(e) { return null; }
  }
  function efSwapMainImage(previewUrl) {
    var img = efGalleryFirstImg();
    if (!img || !previewUrl) return;
    if (!img.dataset.efOriginalSrc) {
      img.dataset.efOriginalSrc = img.getAttribute('src') || '';
      img.dataset.efOriginalSrcset = img.getAttribute('srcset') || '';
    }
    /* 2026-06-05 — serve an optimized image via Shopify CDN transform (width cap → ~80KB,
       webp auto-negotiated) instead of the full-size original (the finish previews were
       uploaded at full res). Skip if the URL already carries a width/height transform. */
    var _opt = previewUrl;
    if (_opt && !/[?&](width|height)=/.test(_opt)) _opt += (_opt.indexOf('?') > -1 ? '&' : '?') + 'width=1100';
    img.setAttribute('src', _opt);
    img.setAttribute('srcset', _opt);
    /* 2026-06-05 — jump the gallery to slide 1 so the customer SEES the finish swap even
       if they're currently viewing another photo (the swap only touches the first slide). */
    try { var _sw = document.getElementById('efGallerySwiper'); if (_sw && _sw.swiper && _sw.swiper.activeIndex !== 0) _sw.swiper.slideTo(0); } catch(e) {}
  }
  function efRestoreMainImage() {
    var img = efGalleryFirstImg();
    if (!img || !img.dataset.efOriginalSrc) return;
    img.setAttribute('src', img.dataset.efOriginalSrc);
    if (img.dataset.efOriginalSrcset) img.setAttribute('srcset', img.dataset.efOriginalSrcset);
    else img.removeAttribute('srcset');
  }

  /* Mobile inline live finish preview — cross-fade the door-in-this-finish image right at the
     swatches (the gallery swap is off-screen on phones/tablets). Only ~60% of door lines have a
     finish render, so this is shown ONLY when a preview URL exists; otherwise it's hidden (no
     broken image). Stateless A/B layer via the .is-shown class. 2026-06-25. */
  function efCfgLivePreview(src, name) {
    var lp = document.getElementById('efCfgFinishLivePreview');
    if (!lp) return;
    if (!src) { lp.hidden = true; return; }
    var imgA = document.getElementById('efCfgFinishLiveImgA');
    var imgB = document.getElementById('efCfgFinishLiveImgB');
    var tag = document.getElementById('efCfgFinishLiveTag');
    var opt = src;
    if (opt && !/[?&](width|height)=/.test(opt)) opt += (opt.indexOf('?') > -1 ? '&' : '?') + 'width=900';
    lp.hidden = false;
    var aShown = imgA.classList.contains('is-shown');
    var next = aShown ? imgB : imgA, cur = aShown ? imgA : imgB;
    function reveal() { next.classList.add('is-shown'); cur.classList.remove('is-shown'); }
    if (next.getAttribute('src') === opt) { reveal(); }
    else { next.onload = reveal; next.src = opt; }
    if (tag) tag.textContent = name || '';
  }

  function selectSwatch(btn, finishData) {
    /* Toggle off — second click on already-selected swatch deselects.
       Same UX as selectCard. validateStep on Next blocks advance if finish
       is required and nothing's selected. */
    if (btn.getAttribute('aria-checked') === 'true') {
      btn.setAttribute('aria-checked', 'false'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
      if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', 'false');
      delete selections.finish;
      delete surcharges.finish;
      try { recomputeHardwareSurcharge(); } catch (e) {}
      try { var _efRo = document.getElementById('efCfg'); if (_efRo) { _efRo.dataset.finishChip = ''; } } catch (e) {}
      var prevHide = document.getElementById('efCfgFinishPreview');
      if (prevHide) prevHide.classList.remove('is-visible');
      try { hideSwatchPopup(); } catch(e) {}
      try { updatePrice(); } catch(e) {}
      /* T-CFG5 2026-09-01 — the finish path no longer writes to the PDP media gallery.
         Owner: "na glownym zdjeciu nie zmieniaj koloru w galeri tylko w zdjeciu kolo
         konfiguratora." efRestoreMainImage() removed here for the same reason as the
         swap at the selection branch below: with the finish path out of the gallery,
         a restore on deselect could only ever undo a GLASS-colour swap made on a
         frameless glass screen (selectCard, :1551), which is not this handler's to undo. */
      try { efCfgLivePreview(null); } catch(e) {}
      return;
    }

    var finishGrid = document.getElementById('efCfgSwatchGrid');
    finishGrid.querySelectorAll('.ef-cfg-swatch').forEach(function(s) {
      s.setAttribute('aria-checked', 'false'); s.setAttribute('role', s.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); s.removeAttribute('aria-pressed');
      if (!s.hasAttribute('aria-checked')) s.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-checked', 'true'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
    if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', 'true');

    selections.finish = finishData.label;
    /* Capture the selected finish's appearance for the Review chip (robust against grid
       re-renders). url('...') for textured finishes, flat #333 for color-only ones. */
    try { var _efR = document.getElementById('efCfg'); if (_efR) { _efR.dataset.finishChip = finishData.img ? ("url('" + finishData.img.replace(/ /g, '%20').replace(/'/g, '%27') + "')") : '#333'; } } catch (e) {}
    surcharges.finish = {
      amount: (finishData.price || 0) * 100,
      label: finishData.label,
      variantId: finishData.variantId || null
    };

    /* EF FUNNEL: finish select (P-007) — additive emission only */
    try {
      efTrack('ef_cfg_option_select', {
        step_name: stepNames[curStep] || '',
        option_type: 'finish',
        option_label: finishData.label || '',
        price_delta: finishData.price || 0
      });
    } catch (e) {}

    // Update preview
    var prev = document.getElementById('efCfgFinishPreview');
    prev.classList.add('is-visible');
    document.getElementById('efCfgFinishPreviewSwatch').style.backgroundImage = finishData.img ? 'url(' + finishData.img.replace(/ /g, '%20') + ')' : '';
    document.getElementById('efCfgFinishPreviewName').textContent = finishData.label;
    document.getElementById('efCfgFinishPreviewPrice').textContent = finishData.price > 0 ? '+' + money(finishData.price * 100) : 'Included';

    // EF FINISH PREVIEW — swap gallery main image if previewImg available
    try {
      /* 2026-06-04 — PER-PRODUCT finish previews. Multiple screen products share one cfg
         data file (e.g. 4 Carolina screens share screen-carolina-single-panel), but each has
         a different base photo, so the swap image must be per product. window.EF_SCREEN_FINISH_PREVIEWS
         is keyed by product handle -> { finishLabel: url } and overrides the data file's previewImg. */
      var _ph = (root && root.dataset && root.dataset.productHandle) || '';
      var _pmap = (window.EF_SCREEN_FINISH_PREVIEWS && window.EF_SCREEN_FINISH_PREVIEWS[_ph]) || null;
      /* Tri-fold screens have no per-product finish renders; the shared data-file previewImg points at
         a single-panel Carolina photo, which is wrong here. Only swap when a REAL per-product override
         exists — otherwise keep the product's own gallery (the 3D preview already recolors). (2026-07-01) */
      var _isTF = !!(groupData && groupData.side_panel && groupData.side_panel.length);
      var _preview = (_pmap && _pmap[finishData.label]) || (_isTF ? null : finishData.previewImg);
      /* T-CFG5 2026-09-01 — GALLERY SWAP REMOVED FROM THE FINISH PATH.
         Owner, with two screenshots to disambiguate: "na glownym zdjeciu nie zmieniaj
         koloru w galeri tylko w zdjeciu kolo konfiguratora" — the PDP media gallery at
         the top of the page keeps the product's own media; only the configurator's
         companion preview shows the finish. Measured before the change (Rainbow, 1440,
         logs/tcfg5-before.json): clicking "Textured Black" moved the gallery's first
         slide from img-T8phvnNEaKutwM3pfSN44.jpg?width=800 to
         ef-finish-rainbow-final-800-motc4e5j.png?width=1100 AND slid the swiper back to
         slide 0 under the buyer. That is what he is asking us to stop.
         The companion preview is NOT fed from here: efCfgLivePreview() below writes
         #efCfgFinishLiveImgA/B, and efx-studio-companion.js mirrors that src mutation
         into .efx-studio__photo img. Removing the gallery write leaves it untouched.
         efSwapMainImage / efRestoreMainImage are deliberately KEPT — selectCard() still
         uses them for glass-colour tints on frameless glass screens (:1551), which have
         no companion mirror and would otherwise lose their only live preview. */
      /* Mobile inline live preview — shows ONLY when this finish has a render (~60% of lines) */
      try { efCfgLivePreview(_preview || null, finishData.label); } catch(e) {}
    } catch(e) {}

    // Frame color changed → re-evaluate two-tone hardware surcharge (auto-clears if now equal).
    try { recomputeHardwareSurcharge(); } catch(e) {}

    updatePrice();

    /* Re-position popup AFTER price updates — Artisan/Premium surcharges
       change the price-section height above the grid, which shifts swatch
       position. Calculating popup before layout settles puts it off-screen. */
    requestAnimationFrame(function() {
      try { showSwatchPopup(btn, finishData); } catch(e) {}
    });
  }

  /* ── Style Finish (same swatches, all free, in Style step) ── */
  function renderStyleFinishes() {
    if (!groupData || !groupData.style_finish) return;
    var sfGrp = root.querySelector('[data-group="style_finish"]');
    if (!sfGrp) return;
    sfGrp.style.display = '';
    var ffLabel = document.getElementById('efCfgFrameFinishLabel');
    if (ffLabel) ffLabel.style.display = '';

    var tabs = {};
    groupData.style_finish.forEach(function(f) {
      var cat = normCat(f.cat);
      if (!tabs[cat]) tabs[cat] = [];
      tabs[cat].push(f);
    });

    var tabEl = document.getElementById('efCfgStyleFinishTabs');
    var gridEl = document.getElementById('efCfgStyleFinishGrid');
    tabEl.innerHTML = '';
    gridEl.innerHTML = '';

    var catKeys = Object.keys(tabs);
    if (!catKeys.length) return;
    var activeTab = catKeys[0];

    catKeys.forEach(function(cat) {
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-tab' + (cat === activeTab ? ' is-active' : '');
      btn.textContent = CAT_LABELS[cat] || cat;
      btn.dataset.cat = cat;
      btn.setAttribute('role', 'tab');
      btn.addEventListener('click', function() {
        hideSwatchPopup();
        tabEl.querySelectorAll('.ef-cfg-tab').forEach(function(t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        showStyleSwatchesForCat(cat, gridEl);
      });
      tabEl.appendChild(btn);
    });
    showStyleSwatchesForCat(activeTab, gridEl);
  }

  function showStyleSwatchesForCat(cat, gridEl) {
    hideSwatchPopup();
    gridEl.innerHTML = '';
    if (!groupData || !groupData.style_finish) return;
    groupData.style_finish.forEach(function(f) {
      if (normCat(f.cat) !== cat) return;
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-swatch';
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-checked', selections.style_finish === f.label ? 'true' : 'false'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
      if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', selections.style_finish === f.label ? 'true' : 'false');
      btn.setAttribute('aria-label', f.label + ', included');
      btn.setAttribute('tabindex', '0');
      btn.dataset.label = f.label;
      btn.dataset.surcharge = 0;
      btn.dataset.cat = f.cat || 'powder_coat';

      var circle = document.createElement('span');
      circle.className = 'ef-cfg-swatch__circle';
      if (f.img) circle.style.backgroundImage = 'url(' + f.img.replace(/ /g, '%20') + ')';
      else circle.style.background = '#333';

      var tooltip = document.createElement('span');
      tooltip.className = 'ef-cfg-swatch__tooltip';
      tooltip.innerHTML = escHtml(f.label) + '<br>Included';

      btn.appendChild(circle);
      btn.appendChild(tooltip);
      btn.addEventListener('click', function() { selectStyleSwatch(btn, f); });
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectStyleSwatch(btn, f); }
      });
      btn.addEventListener('mouseenter', function(e) {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
          showSwatchPopup(btn, f);
        }
      });
      btn.addEventListener('mouseleave', function() {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
          hideSwatchPopup();
        }
      });
      gridEl.appendChild(btn);
    });
  }

  function selectStyleSwatch(btn, finishData) {
    /* Toggle off — second click on already-selected swatch deselects */
    if (btn.getAttribute('aria-checked') === 'true') {
      btn.setAttribute('aria-checked', 'false'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
      if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', 'false');
      delete selections.style_finish;
      delete surcharges.style_finish;
      var prevHide = document.getElementById('efCfgStyleFinishPreview');
      if (prevHide) prevHide.classList.remove('is-visible');
      try { hideSwatchPopup(); } catch(e) {}
      try { updatePrice(); } catch(e) {}
      return;
    }

    var gridEl = document.getElementById('efCfgStyleFinishGrid');
    gridEl.querySelectorAll('.ef-cfg-swatch').forEach(function(s) {
      s.setAttribute('aria-checked', 'false'); s.setAttribute('role', s.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); s.removeAttribute('aria-pressed');
      if (!s.hasAttribute('aria-checked')) s.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-checked', 'true'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
    if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', 'true');
    selections.style_finish = finishData.label;
    surcharges.style_finish = { amount: 0, label: finishData.label, variantId: null };

    var prev = document.getElementById('efCfgStyleFinishPreview');
    if (prev) {
      prev.style.display = '';
      prev.classList.add('is-visible');
      document.getElementById('efCfgStyleFinishPreviewSwatch').style.backgroundImage = finishData.img ? 'url(' + finishData.img.replace(/ /g, '%20') + ')' : '';
      document.getElementById('efCfgStyleFinishPreviewName').textContent = finishData.label;
      document.getElementById('efCfgStyleFinishPreviewPrice').textContent = 'Included';
    }
    updatePrice();
    /* Re-position popup AFTER price updates — same fix as selectSwatch. */
    requestAnimationFrame(function() {
      try { showSwatchPopup(btn, finishData); } catch(e) {}
    });
  }

  /* ── HARDWARE FINISH (two-tone) — 2026-06-06 ───────────────────────────────
     Forge Iron only. Customer can give hinges/handles a different color than the
     frame. "Match Frame" = included; any other color = +$75 two-tone surcharge
     (real hidden variant so the cart subtotal stays honest). The surcharge is
     recomputed whenever EITHER the hardware OR the frame finish changes, so it
     auto-clears if the two colors end up equal. */
  var HW_TWOTONE_VARIANT_ID = '42437260771410';
  var HW_TWOTONE_PRICE = 75; // dollars — edit here + on the Shopify variant to change

  function recomputeHardwareSurcharge() {
    var hw = selections.hardware_finish;
    // Not chosen, or explicitly matching the frame → included, no line item.
    if (!hw || hw === '__match__' || hw === selections.finish) {
      delete surcharges.hardware_finish;
    } else {
      surcharges.hardware_finish = {
        amount: HW_TWOTONE_PRICE * 100,
        label: 'Hardware: ' + hw + ' (two-tone)',
        variantId: HW_TWOTONE_VARIANT_ID
      };
    }
    var prev = document.getElementById('efCfgHardwarePreview');
    var priceEl = document.getElementById('efCfgHardwarePreviewPrice');
    if (priceEl) {
      priceEl.textContent = surcharges.hardware_finish ? '+' + money(HW_TWOTONE_PRICE * 100) : 'Included';
    }
    if (prev && hw) { prev.style.display = ''; prev.classList.add('is-visible'); }
  }

  function renderHardwareFinishes() {
    if (!groupData || !groupData.hardware_finish || !groupData.hardware_finish.length) return;
    var grp = document.getElementById('efCfgHardwareGroup');
    var gridEl = document.getElementById('efCfgHardwareGrid');
    if (!grp || !gridEl) return;
    grp.style.display = '';
    gridEl.innerHTML = '';

    function addSwatch(label, img, isMatch) {
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-swatch' + (isMatch ? ' ef-cfg-swatch--match' : '');
      btn.setAttribute('type', 'button');
      var checked = isMatch ? (!selections.hardware_finish || selections.hardware_finish === '__match__')
                            : (selections.hardware_finish === label);
      btn.setAttribute('aria-checked', checked ? 'true' : 'false'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
      if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', checked ? 'true' : 'false');
      btn.setAttribute('aria-label', label + (isMatch ? ', included' : ', +' + money(HW_TWOTONE_PRICE * 100)));
      btn.setAttribute('tabindex', '0');
      btn.dataset.label = isMatch ? '__match__' : label;

      var circle = document.createElement('span');
      circle.className = 'ef-cfg-swatch__circle';
      if (isMatch) {
        circle.style.background = 'linear-gradient(135deg,#1E1E1B 0 50%,#C9C9C9 50% 100%)';
      } else if (img) {
        circle.style.backgroundImage = 'url(' + img.replace(/ /g, '%20') + ')';
      } else {
        circle.style.background = '#333';
      }

      var tooltip = document.createElement('span');
      tooltip.className = 'ef-cfg-swatch__tooltip';
      tooltip.innerHTML = escHtml(label) + '<br>' + (isMatch ? 'Included' : '+' + money(HW_TWOTONE_PRICE * 100));

      btn.appendChild(circle);
      btn.appendChild(tooltip);
      var data = { label: isMatch ? '__match__' : label, img: img, isMatch: !!isMatch, displayLabel: label };
      /* Popup-data shape matches showSwatchPopup (label/img/price). Match Frame = $0/Included. */
      var popData = { label: label, img: img, price: isMatch ? 0 : HW_TWOTONE_PRICE };
      btn.addEventListener('click', function() { selectHardwareSwatch(btn, data); });
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectHardwareSwatch(btn, data); }
      });
      btn.addEventListener('mouseenter', function() {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) { try { showSwatchPopup(btn, popData); } catch(e) {} }
      });
      btn.addEventListener('mouseleave', function() {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) { try { hideSwatchPopup(); } catch(e) {} }
      });
      gridEl.appendChild(btn);
    }

    addSwatch('Match Frame', null, true);
    groupData.hardware_finish.forEach(function(f) { addSwatch(f.label, f.img, false); });

    // Default to Match Frame (included) so the state is always defined.
    if (!selections.hardware_finish) selections.hardware_finish = '__match__';
    recomputeHardwareSurcharge();
  }

  function selectHardwareSwatch(btn, data) {
    var gridEl = document.getElementById('efCfgHardwareGrid');
    if (gridEl) gridEl.querySelectorAll('.ef-cfg-swatch').forEach(function(s) {
      s.setAttribute('aria-checked', 'false'); s.setAttribute('role', s.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); s.removeAttribute('aria-pressed'); if (!s.hasAttribute('aria-checked')) s.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-checked', 'true'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
    if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', 'true');

    selections.hardware_finish = data.isMatch ? '__match__' : data.label;

    var prev = document.getElementById('efCfgHardwarePreview');
    if (prev) {
      prev.style.display = '';
      prev.classList.add('is-visible');
      var sw = document.getElementById('efCfgHardwarePreviewSwatch');
      if (sw) {
        if (data.isMatch) sw.style.backgroundImage = '', sw.style.background = 'linear-gradient(135deg,#1E1E1B 0 50%,#C9C9C9 50% 100%)';
        else sw.style.background = '', sw.style.backgroundImage = data.img ? 'url(' + data.img.replace(/ /g, '%20') + ')' : '';
      }
      var nm = document.getElementById('efCfgHardwarePreviewName');
      if (nm) nm.textContent = data.isMatch ? 'Match Frame' : data.label;
    }
    recomputeHardwareSurcharge();
    try { updatePrice(); } catch(e) {}

    /* Show the same 1:1 swatch popup as Frame Finish (after price/layout settles). */
    var popData = { label: data.isMatch ? 'Match Frame' : data.label, img: data.img, price: data.isMatch ? 0 : HW_TWOTONE_PRICE };
    requestAnimationFrame(function() { try { showSwatchPopup(btn, popData); } catch(e) {} });
  }

  /* ── Swatch Popup ── */
  /* Top-3 popular finishes (by % of orders, derived from sales data). */
  var EF_POPULAR_FINISHES = {
    'matte black':       { rank: 1, pct: 47 },
    'textured black':    { rank: 2, pct: 18 },
    'charcoal':          { rank: 3, pct: 11 }
  };
  function showSwatchPopup(btn, f) {
    var popup = document.getElementById('efCfgSwatchPopup');
    var img = popup.querySelector('.ef-cfg-swatch-popup__img');
    var name = popup.querySelector('.ef-cfg-swatch-popup__name');
    var price = popup.querySelector('.ef-cfg-swatch-popup__price');
    var badge = document.getElementById('efCfgSwatchPopupBadge');
    var stat  = document.getElementById('efCfgSwatchPopupStat');

    if (f.img) {
      img.src = f.img.replace(/ /g, '%20');
      img.alt = f.label;
      img.style.display = '';
    } else {
      img.style.display = 'none';
    }
    name.textContent = f.label;
    price.textContent = f.price > 0 ? '+' + money(f.price * 100) : 'Included';

    /* Populate badge + stat for popular finishes */
    var key = (f.label || '').toLowerCase().trim();
    var pop = EF_POPULAR_FINISHES[key];
    if (badge && stat) {
      if (pop) {
        badge.hidden = false;
        stat.hidden = false;
        stat.textContent = 'Used in ' + pop.pct + '% of orders';
      } else {
        badge.hidden = true;
        stat.hidden = true;
      }
    }

    // Position popup near the swatch (absolute positioning relative to root).
    // Popup scrolls with the page; low z-index lets it slide under the header
    // and sticky ATC bar when scrolled past them.
    // 2026-05-06 fix: was using hardcoded popupW=220, popupH=300 — but actual
    // popup is 150px wide and ~200px tall. With H=300 the popup floated 300px
    // above the swatch instead of "right above the circle". Now measure live
    // dimensions after content + visibility paint, so close-positioning
    // works regardless of popup content height (badge / stat optional rows).
    popup.style.visibility = 'hidden';
    popup.classList.add('is-visible');
    var popupW = popup.offsetWidth || 150;
    var popupH = popup.offsetHeight || 200;
    var rect = btn.getBoundingClientRect();
    var rootRect = root.getBoundingClientRect();
    var left = rect.left - rootRect.left + rect.width / 2 - popupW / 2;
    left = Math.max(8, Math.min(left, rootRect.width - popupW - 8));
    var top = rect.top - rootRect.top - popupH - 10;
    // If not enough space above, show below the swatch
    if (top < 8) top = rect.bottom - rootRect.top + 10;

    popup.style.left = left + 'px';
    popup.style.top = top + 'px';
    popup.style.bottom = 'auto';
    popup.style.visibility = '';

    /* 2026-06-02 — TOUCH auto-dismiss. Touch devices never fire mouseleave, so the
       swatch popup used to stay on screen after a finish tap and block the rest of the
       order form. On touch we dismiss it on the next scroll, on a tap outside a swatch,
       and after a short timeout — informs briefly, never covers the form. */
    var isTouch = !(window.matchMedia && window.matchMedia('(hover: hover)').matches);
    if (isTouch) {
      clearTimeout(_swatchPopupTimer);
      _swatchPopupTimer = setTimeout(hideSwatchPopup, 1900);
      var dismiss = function (e) {
        if (e && e.type === 'touchstart' && e.target && e.target.closest && e.target.closest('.ef-cfg-swatch')) return;
        hideSwatchPopup();
      };
      window.addEventListener('scroll', dismiss, { capture: true, once: true, passive: true });
      document.addEventListener('touchstart', dismiss, { capture: true, once: true, passive: true });
    }
  }

  var _swatchPopupTimer = null;
  function hideSwatchPopup() {
    clearTimeout(_swatchPopupTimer);
    document.getElementById('efCfgSwatchPopup').classList.remove('is-visible');
  }

  /* ────────────────────────────────────
     POPULATE ALL STEPS
     ──────────────────────────────────── */
  function renderDoorFitCards(items, container) {
    if (!container) return;
    container.innerHTML = '';
    var descs = {
      'Regular Fit': 'Doors overlap the fireplace frame',
      'Flush Fit': 'Doors sit inside the fireplace frame'
    };
    items.forEach(function(opt) {
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-card' + (!opt.img ? ' ef-cfg-card--no-img' : '');
      btn.setAttribute('type', 'button');
      if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-checked', 'false'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
      btn.setAttribute('tabindex', '0');
      btn.dataset.field = 'door_fit';
      var cleanLabel = opt.label.replace(/\.\s*$/, '');
      btn.dataset.value = cleanLabel;
      btn.dataset.surcharge = opt.price || 0;
      if (opt.variantId) btn.dataset.variantId = opt.variantId;
      var desc = descs[cleanLabel] || opt.desc || '';
      if (opt.img) btn.classList.add('ef-cfg-card--has-preview');
      var html = '<span class="ef-cfg-card__check">' + CHECK_SVG + '</span>';
      if (opt.img) {
        /* Span (not button) — nested <button> breaks the parent card's DOM tree.
           Click delegation matches data-cfg-zoom regardless of element type. */
        html += '<span class="ef-cfg-card__zoom" role="button" tabindex="0" aria-label="View larger image" data-cfg-zoom>'
              + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>'
              + '</span>';
        html += '<span class="ef-cfg-card__img"><img src="' + opt.img.replace(/ /g, '%20') + '" alt="' + escHtml(cleanLabel) + '" loading="lazy" onerror="this.style.display=\'none\';this.parentNode.classList.add(\'ef-cfg-img-broken\')"></span>';
        html += '<span class="ef-cfg-card__preview">'
              + '<img src="' + opt.img.replace(/ /g, '%20') + '" alt="' + escHtml(cleanLabel) + '">'
              + '<span class="ef-cfg-card__preview-label">' + escHtml(cleanLabel) + '</span>'
              + '</span>';
      }
      html += '<span class="ef-cfg-card__body">';
      html += '<span class="ef-cfg-card__title">' + escHtml(cleanLabel) + '</span>';
      if (desc) html += '<span class="ef-cfg-card__desc">' + escHtml(desc) + '</span>';
      if (opt.price && opt.price > 0) html += '<span class="ef-cfg-card__price">+$' + opt.price + '</span>';
      html += '</span>';
      btn.innerHTML = html;
      if (opt.img) btn.dataset.imgFull = opt.img;
      btn.dataset.fullDesc = desc || '';
      btn.addEventListener('click', function(e) {
        if (e.target && e.target.closest && e.target.closest('[data-cfg-zoom]')) return;
        selectCard(btn, 'door_fit');
      });
      btn.addEventListener('keydown', function(e) {
        /* T-CFG5 2026-09-01 (review-12 §3.6) — see the identical guard in renderCards. */
        if (e.target && e.target.closest && e.target.closest('[data-cfg-zoom]')) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(btn, 'door_fit'); }
      });
      appendChoiceCard(container, btn);
    });
    container.className = 'ef-cfg-group__grid';
    if (items.length <= 2) container.classList.add('ef-cfg-group__grid--2col');
  }

  /* ════════════════════════════════════════════════════════════════════════
     EXTRAS — optional multi-select add-ons (EF_STOLL_EXTRAS_20260829)

     Stoll order forms carry a block of per-order add-ons that were not sellable
     on the site: Key Lock $205, Z-Tab $70, Flange up to 3" $135 / over 3" $275,
     Place Handles on Center Bar $70, Extra Insulation Roll (10 ft.) $14.
     Availability is per order form, so the list lives in each data group as an
     optional `extras` array — groups without one render nothing (all Design
     Specialties groups, plus the shared Plated group, are untouched).

     Unlike every other field these are MULTI-select, so instead of a single
     `selections[field]` scalar each ticked extra gets its own key,
     `extra_<slug>`, in the same `selections` / `surcharges` maps. That makes it
     ride the existing money path unchanged: calcTotal(), updatePrice(), the
     /cart/add.js surcharge batch (one line item per extra with _parent_product /
     _option_type / _config_id) and the Express Checkout snapshot all iterate
     Object.keys(surcharges) and pick them up for free.
     ════════════════════════════════════════════════════════════════════════ */
  function extraKey(label) {
    return 'extra_' + String(label).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+/, '').replace(/_+$/, '');
  }

  function efExtrasList() {
    if (!groupData || !groupData.extras || !groupData.extras.length) return [];
    /* Design Specialties products never see Stoll extras, even when they sit on a
       data group that carries them (shared groups). */
    if (/design\s*specialties/i.test(prodVendor)) return [];
    if (cfgType === 'cfg-screen') return [];
    return groupData.extras;
  }

  function toggleExtra(btn) {
    var key = btn.dataset.extraKey;
    var on = btn.getAttribute('aria-checked') !== 'true';
    btn.setAttribute('aria-checked', on ? 'true' : 'false'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
    if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (on) {
      selections[key] = btn.dataset.value;
      surcharges[key] = {
        amount: (parseInt(btn.dataset.surcharge, 10) || 0) * 100,
        label: btn.dataset.value,
        variantId: btn.dataset.variantId || null
      };
    } else {
      delete selections[key];
      delete surcharges[key];
    }
    updatePrice();
  }

  function renderExtras() {
    var grp = root.querySelector('[data-group="extras"]');
    if (!grp) return;
    var grid = grp.querySelector('.ef-cfg-group__grid');
    var list = efExtrasList();
    if (!grid || !list.length) { grp.style.display = 'none'; return; }
    grp.style.display = '';
    grid.innerHTML = '';
    list.forEach(function (opt) {
      var key = extraKey(opt.label);
      var btn = document.createElement('button');
      btn.className = 'ef-cfg-card ef-cfg-card--extra';
      btn.setAttribute('type', 'button');
      btn.setAttribute('role', 'checkbox');
      btn.setAttribute('aria-checked', selections[key] ? 'true' : 'false'); btn.setAttribute('role', btn.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); btn.removeAttribute('aria-pressed');
      if (!btn.hasAttribute('aria-checked')) btn.setAttribute('aria-pressed', selections[key] ? 'true' : 'false');
      btn.setAttribute('tabindex', '0');
      btn.dataset.field = 'extras';
      btn.dataset.extraKey = key;
      btn.dataset.value = opt.label;
      btn.dataset.surcharge = opt.price || 0;
      if (opt.variantId) btn.dataset.variantId = opt.variantId;
      if (opt.zcOnly) btn.dataset.zcOnly = '1';
      var html = '<span class="ef-cfg-card__check">' + CHECK_SVG + '</span>';
      html += '<span class="ef-cfg-card__body">';
      html += '<span class="ef-cfg-card__title">' + escHtml(opt.label) + '</span>';
      if (opt.desc) html += '<span class="ef-cfg-card__desc">' + escHtml(opt.desc) + '</span>';
      if (opt.price && opt.price > 0) html += '<span class="ef-cfg-card__price">+$' + opt.price + '</span>';
      html += '</span>';
      btn.innerHTML = html;
      btn.addEventListener('click', function () { toggleExtra(btn); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleExtra(btn); }
      });
      grid.appendChild(btn);
    });
    updateExtrasVisibility();
  }

  /* Z-Tabs are a prefab / zero-clearance mounting part — hide them once the customer
     has told us the fireplace is masonry. Called on every fireplace_type change. */
  function updateExtrasVisibility() {
    var grp = root.querySelector('[data-group="extras"]');
    if (!grp) return;
    var cards = grp.querySelectorAll('.ef-cfg-card--extra');
    if (!cards.length) { grp.style.display = 'none'; return; }
    var ft = String(selections.fireplace_type || '').toLowerCase();
    var known = ft !== '';
    var isFactory = /factory|prefab|zero|\bzc\b/.test(ft);
    var visible = 0;
    var dropped = false;
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var hide = c.dataset.zcOnly === '1' && known && !isFactory;
      c.style.display = hide ? 'none' : '';
      if (!hide) visible++;
      if (hide && c.getAttribute('aria-checked') === 'true') {
        c.setAttribute('aria-checked', 'false'); c.setAttribute('role', c.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); c.removeAttribute('aria-pressed'); c.setAttribute('role', c.classList.contains('ef-cfg-card--extra') ? 'checkbox' : 'radio'); c.removeAttribute('aria-pressed');
        if (!c.hasAttribute('aria-checked')) c.setAttribute('aria-pressed', 'false');
        delete selections[c.dataset.extraKey];
        delete surcharges[c.dataset.extraKey];
        dropped = true;
      }
    }
    grp.style.display = visible ? '' : 'none';
    if (dropped) updatePrice();
  }

  /* [{key,label,amount}] for the review summary + cart line item properties. */
  function efSelectedExtras() {
    var out = [];
    Object.keys(selections).forEach(function (k) {
      if (k.indexOf('extra_') !== 0) return;
      var s = surcharges[k];
      out.push({ key: k, label: selections[k], amount: s ? s.amount : 0 });
    });
    return out;
  }

  function populateSteps() {
    if (cfgType === 'cfg-standard' || cfgType === 'cfg-simple') return;
    if (!groupData) {
      console.warn('No EF_CFG_DATA group matched for:', prodTitle);
      return;
    }

    // Step 1: Fireplace Type
    var fields0 = ['fireplace_type', 'firebox_type'];
    fields0.forEach(function(f) {
      var grp = root.querySelector('[data-group="' + f + '"]');
      if (grp) renderCards(f, grp.querySelector('.ef-cfg-group__grid'));
    });

    /* Auto-select single-option fields (e.g. Masonry Only products) */
    fields0.forEach(function(f) {
      if (groupData[f] && groupData[f].length === 1) {
        var card = root.querySelector('[data-field="' + f + '"]');
        if (card && card.getAttribute('aria-checked') !== 'true') {
          selectCard(card, f);
        }
      }
    });

    // Step 3: Style (includes fit_type now)
    var fields2 = ['fit_type', 'frame_width', 'door_type', 'side_panel', 'feet', 'handle', 'pattern'];
    fields2.forEach(function(f) {
      var grp = root.querySelector('[data-group="' + f + '"]');
      if (grp) renderCards(f, grp.querySelector('.ef-cfg-group__grid'));
    });

    /* Single-handle styles (Stoll Elite Thinline / ThinlinePro ship with Knob handles only,
       p57) would otherwise present a one-card "Pick 1" the customer has to click to get past.
       Auto-select it. No group has a single handle option other than those, so this is inert
       everywhere else — Design Specialties included. EF_STOLL_HANDLES_20260829 */
    if (groupData.handle && groupData.handle.length === 1) {
      var _h1 = root.querySelector('[data-group="handle"] [data-field="handle"]');
      if (_h1 && _h1.getAttribute('aria-checked') !== 'true') selectCard(_h1, 'handle');
    }

    // ── Tri-Fold screens: show the side-panel selector only when the product has side_panel data.
    //    (2026-06-29) Non-trifold products never have this group → it stays hidden. ──
    var _spGrp = root.querySelector('[data-group="side_panel"]');
    if (_spGrp) _spGrp.style.display = (groupData.side_panel && groupData.side_panel.length) ? '' : 'none';

    // ── Screens only: "Feet Style" group visibility (2026-06-16) ──
    // Hide the feet selector when the screen comes with a fixed foot:
    //   • screens WITH operable doors → Classic Foot only (default = first option in data)
    //   • single-option feet (e.g. Full Glass "Front Feet Only")
    // Keep it shown for free-standing screens that feature selectable front feet,
    // and surface the 8–10" forward-protrusion note there. Doors configs are untouched.
    if (cfgType === 'cfg-screen') {
      var _feetGrp = root.querySelector('[data-group="feet"]');
      if (_feetGrp) {
        var _feetN     = (groupData.feet || []).length;
        var _t         = (prodTitle || '').toLowerCase();
        var _hasDoors  = /operable door|with door|w\/ ?door|screen door|folding/.test(_t) || root.dataset.screenHasDoors === 'true';
        var _frontFeet = /front feet/.test(_t);
        _feetGrp.style.display = trifoldRule ? (_feetN ? '' : 'none') : ((_hasDoors || (_feetN <= 1 && !_frontFeet)) ? 'none' : '');
        var _note = _feetGrp.querySelector('[data-feet-protrude]');
        if (_note) _note.style.display = (_frontFeet && _feetGrp.style.display !== 'none') ? '' : 'none';
      }
    }

    // Door Fit Type: extract Regular/Flush from fit_type data for premium products
    if (cfgType === 'cfg-custom-premium') {
      var doorFitGrp = root.querySelector('[data-group="door_fit"]');
      if (doorFitGrp) {
        var doorFitGrid = doorFitGrp.querySelector('.ef-cfg-group__grid');
        var doorFitItems = (groupData.fit_type || []).filter(function(opt) {
          var lbl = (opt.label || '').toLowerCase().trim();
          return lbl.indexOf('regular') !== -1 || lbl.indexOf('flush') !== -1;
        });
        /* Only show the Door Fit Type group when the group actually offers
           Regular/Flush fits. Otherwise hide it (no empty "PICK 1" section even
           when fit_type is undefined — e.g. groups mis-tagged as premium). */
        if (doorFitItems.length > 0) {
          renderDoorFitCards(doorFitItems, doorFitGrid);
          doorFitGrp.style.display = '';
        } else {
          doorFitGrp.style.display = 'none';
        }
      }
    }

    // Custom Frame Width: Legend only
    var _isLegend = (matchedGroup || '').toLowerCase().indexOf('legend') !== -1;
    var cfwEl = document.getElementById('efCfgCustomFrame');
    if (cfwEl) {
      cfwEl.style.display = _isLegend ? '' : 'none';
      if (_isLegend) {
        var fInputs = ['efCfgFrameLeft','efCfgFrameRight','efCfgFrameTop','efCfgFrameBottom'];
        var fLabels = { efCfgFrameLeft:'A', efCfgFrameRight:'B', efCfgFrameTop:'C', efCfgFrameBottom:'D' };
        var fKeys = { efCfgFrameLeft:'_frame_left', efCfgFrameRight:'_frame_right', efCfgFrameTop:'_frame_top', efCfgFrameBottom:'_frame_bottom' };
        window._efUpdateFrameSvg = updateFrameSvg;
        function updateFrameSvg() {
          var svg = document.getElementById('efCfgFrameSvg');
          if (!svg) return;
          var l = Math.min(12, Math.max(1, parseFloat(document.getElementById('efCfgFrameLeft').value) || 2));
          var r = Math.min(12, Math.max(1, parseFloat(document.getElementById('efCfgFrameRight').value) || 2));
          var t = Math.min(12, Math.max(1, parseFloat(document.getElementById('efCfgFrameTop').value) || 2));
          var b = Math.min(12, Math.max(1, parseFloat(document.getElementById('efCfgFrameBottom').value) || 2));

          var widthInput = document.getElementById('efCfgWidth');
          var heightInput = document.getElementById('efCfgHeight');
          var ow = (widthInput && parseFloat(widthInput.value)) || 36;
          var oh = (heightInput && parseFloat(heightInput.value)) || 28;
          /* Scale uses MAX possible frame (12" each side) so glass stays the
             same visual size while A/B/C/D change — frame grows outward. */
          var MAX_F = 12;
          var scaleW = 320 / (ow + 2 * MAX_F);
          var scaleH = 260 / (oh + 2 * MAX_F);
          var scale = Math.min(scaleW, scaleH);
          var gw = ow * scale, gh = oh * scale;
          var lPx = l * scale, rPx = r * scale, tPx = t * scale, bPx = b * scale;

          /* Anchor glass/opening at centre; frame extends outward by A/B/C/D. */
          var cx = 200, cy = 170;
          var ix = cx - gw / 2, iy = cy - gh / 2;
          var ox = ix - lPx, oy = iy - tPx;
          var totalW = gw + lPx + rPx, totalH = gh + tPx + bPx;
          var barW = 3, gap = 3, halfGlass = (gw - barW) / 2;

          function s(id, a) { var e = svg.getElementById(id); if (!e) return; for (var k in a) e.setAttribute(k, a[k]); }
          function txt(id, v) { var e = svg.getElementById(id); if (e) e.textContent = v; }

          s('efFrameOuter', { x:ox, y:oy, width:totalW, height:totalH });

          s('efGlassL', { x:ix+gap, y:iy+gap, width:halfGlass-gap*2, height:gh-gap*2 });
          s('efGlassR', { x:cx+barW/2+gap, y:iy+gap, width:halfGlass-gap*2, height:gh-gap*2 });

          var lGx = ix+gap, lGy = iy+gap, lGw = halfGlass-gap*2, lGh = gh-gap*2;
          s('efRefl1', { x1:lGx+6, y1:lGy+6, x2:lGx+lGw*0.25, y2:lGy+lGh*0.25 });
          s('efRefl2', { x1:lGx+12, y1:lGy+6, x2:lGx+lGw*0.3, y2:lGy+lGh*0.25 });
          var rGx = cx+barW/2+gap;
          s('efRefl3', { x1:rGx+6, y1:lGy+6, x2:rGx+lGw*0.25, y2:lGy+lGh*0.25 });
          s('efRefl4', { x1:rGx+12, y1:lGy+6, x2:rGx+lGw*0.3, y2:lGy+lGh*0.25 });

          s('efDivider', { x:cx-barW/2, y:iy, width:barW, height:gh });

          var hSize = Math.min(12, gh*0.08);
          s('efHandleL', { x:cx-barW/2-hSize-4, y:cy-hSize/2, width:hSize, height:hSize });
          s('efHandleR', { x:cx+barW/2+4, y:cy-hSize/2, width:hSize, height:hSize });

          var hingeW = 4, hingeH = Math.min(8, gh*0.06);
          var hx1 = ix-hingeW+1, hx2 = ix+gw-1;
          s('efHingeL1', { x:hx1, y:iy+gh*0.15, width:hingeW, height:hingeH });
          s('efHingeL2', { x:hx1, y:cy-hingeH/2, width:hingeW, height:hingeH });
          s('efHingeL3', { x:hx1, y:iy+gh*0.85-hingeH, width:hingeW, height:hingeH });
          s('efHingeR1', { x:hx2, y:iy+gh*0.15, width:hingeW, height:hingeH });
          s('efHingeR2', { x:hx2, y:cy-hingeH/2, width:hingeW, height:hingeH });
          s('efHingeR3', { x:hx2, y:iy+gh*0.85-hingeH, width:hingeW, height:hingeH });

          var margin = 24;
          s('efDimA', { x1:ox, y1:cy, x2:ix, y2:cy });
          s('efLabelA', { x:ox-margin, y:cy-7 }); txt('efLabelA', 'A');
          s('efValA', { x:ox-margin, y:cy+8 }); txt('efValA', l + '"');

          s('efDimB', { x1:ix+gw, y1:cy, x2:ox+totalW, y2:cy });
          s('efLabelB', { x:ox+totalW+margin, y:cy-7 }); txt('efLabelB', 'B');
          s('efValB', { x:ox+totalW+margin, y:cy+8 }); txt('efValB', r + '"');

          var cDimX = ox - margin;
          s('efDimC', { x1:cDimX, y1:oy, x2:cDimX, y2:iy });
          s('efLabelC', { x:cDimX, y:oy-14 }); txt('efLabelC', 'C  ' + t + '"');

          var dDimX = ox + totalW + margin;
          s('efDimD', { x1:dDimX, y1:iy+gh, x2:dDimX, y2:oy+totalH });
          s('efLabelD', { x:dDimX, y:oy+totalH+16 }); txt('efLabelD', 'D  ' + b + '"');

          selections._frame_left = l + '"';
          selections._frame_right = r + '"';
          selections._frame_top = t + '"';
          selections._frame_bottom = b + '"';
        }
        fInputs.forEach(function(id) {
          var inp = document.getElementById(id);
          if (inp) {
            inp.addEventListener('input', updateFrameSvg);
            selections[fKeys[id]] = inp.value + '"';
          }
        });
        updateFrameSvg();
      }
    }

    // Step 4: Finish
    renderFinishes();

    renderStyleFinishes();
    renderHardwareFinishes();
    renderSamples();

    // Step 5: Glass & Accessories
    var fields3 = ['glass', 'mesh', 'draft_control'];
    fields3.forEach(function(f) {
      var grp = root.querySelector('[data-group="' + f + '"]');
      if (grp) renderCards(f, grp.querySelector('.ef-cfg-group__grid'));
    });

    /* Draft control: render cards but keep hidden until masonry is selected.
       selectCard(fireplace_type) handles show/hide based on masonry vs factory-built. */
    var _dcGrp = root.querySelector('[data-group="draft_control"]');
    if (_dcGrp) {
      var _hasDC = groupData && groupData.draft_control && groupData.draft_control.length > 0;
      _dcGrp.dataset.hasDraftControl = _hasDC ? '1' : '0';
      _dcGrp.style.display = 'none';
    }

    /* Extras (optional multi-select) — EF_STOLL_EXTRAS_20260829 */
    renderExtras();

    /* Skip Step 5 entirely if no glass, mesh, or draft_control data,
       OR if product is a mesh-doors variant (title ends in "Mesh Doors"). */
    var _hasGlass = groupData.glass && groupData.glass.length > 0;
    var _hasMesh = groupData.mesh && groupData.mesh.length > 0;
    var _hasDraftControl = groupData.draft_control && groupData.draft_control.length > 0;
    /* Mesh-only flag from Liquid (data-mesh-only) catches Stoll Mesh / DS Mesh
       where the title is "Mesh Masonry & Prefab Doors" — regex below misses it
       because "Mesh" isn't immediately followed by "doors". */
    var _isMeshOnly = isMeshOnly || /\bmesh\s+doors?\b/i.test(prodTitle);
    if ((!_hasGlass && !_hasMesh && !_hasDraftControl) || _isMeshOnly) {
      _skipStep4 = true;
      var step4El = document.getElementById('efCfgStep4');
      /* Extras live inside step 5 (Glass & Accessories). When that step is skipped —
         mesh-only doors (Stoll Mesh p23) — move the extras group into the Review step so
         the add-ons stay sellable instead of disappearing with the step. */
      var _exGrp = root.querySelector('[data-group="extras"]');
      var _revStep = document.getElementById('efCfgStepReview');
      var _revGrid = document.getElementById('efCfgReviewGrid');
      if (_exGrp && _revStep && _revGrid && _exGrp.style.display !== 'none') {
        _revGrid.parentNode.insertBefore(_exGrp, _revGrid);
      }
      if (step4El) step4El.style.display = 'none';
    }
    /* Frameless FULL-GLASS screens: hide the Style step (2 — feet/handle). The frameless
       glass panel has no decorative style options. Flow = Measurements → Finish → Glass →
       Review. Finish (frame/base color) and Glass Color both stay. */
    var _isGlassScreenCfg = /clear glass|full glass|frameless/i.test(prodTitle || '')
                          || /full glass/i.test(matchedGroup || '');
    if (cfgType === 'cfg-screen' && (_isGlassScreenCfg || isOldWorldScreen || isOldWorldSlim)) {
      _skipStep2 = true;
      var step2El = document.getElementById('efCfgStep2');
      if (step2El) step2El.style.display = 'none';
    }
    /* cfg-screen: skip Fireplace step (0) — screens are universal. Swap door→screen text. */
    if (cfgType === 'cfg-screen') {
      _skipStep0 = true;
      var step0El = document.getElementById('efCfgStep0');
      if (step0El) step0El.style.display = 'none';
      var SWAP = [
        [/configure your door/gi, 'Configure Your Screen'],
        [/your door/gi,           'Your Screen'],
        [/\bdoor style\b/gi,      'Screen Style'],
        [/choose your door type, fit, and handle style/gi,
         'Choose your screen style and handle.'],
        [/fireplace door/gi,      'fireplace screen'],
        [/door frame/gi,          'screen frame'],
        [/fireplace opening/gi,   'screen'],
        [/your measurements/gi,   'Your Screen Size'],
        [/width and height of your fireplace/gi, 'finished width and height of your screen'],
        [/opening in inches/gi,   'in inches'],
        [/bottom to top of the opening/gi, 'Floor to the top'],
        [/how to measure your fireplace/gi, 'Screen Sizing Tips'],
        [/frame finish/gi,        'Screen Finish'],
        [/narrowest point of the opening/gi, 'Side to side, at the widest point'],
        [/floor to top of opening or lintel bar/gi, 'Finished screen height'],
        [/narrowest point of the arch opening, base to base/gi, 'Finished screen width at the base (widest point)'],
        [/floor to where arch starts curving \(straight side\)/gi, 'Finished screen height at the straight side (where the arch starts)'],
        [/floor to highest point of the arch \(peak\)/gi, 'Finished screen height at the center peak (tallest point)'],
        [/\bopening width\b/gi, 'Screen Width'],
        [/\bside height\b/gi, 'Side Height'],
        [/\bcenter height \(at peak\)/gi, 'Center Peak Height'],
        [/handle finish automatically matches the frame color you select in step 4/gi,
         'Handles are included in the frame finish color, and mount vertically on each side.'],
      ];
      var textWalker = document.createTreeWalker(document.querySelector('.ef-cfg'), NodeFilter.SHOW_TEXT);
      var node;
      while (node = textWalker.nextNode()) {
        var t = node.textContent;
        var changed = false;
        for (var i=0; i<SWAP.length; i++) {
          if (SWAP[i][0].test(t)) { t = t.replace(SWAP[i][0], SWAP[i][1]); changed = true; }
        }
        if (changed) node.textContent = t;
      }
      /* Screens are ordered to finished dimensions; never imply opening-size deductions. */
      var screenCopy = {
        '.ef-cfg-size-header__label':'Screen size',
        '#efCfgStep3 .ef-cfg-step__subtitle':'Find a finish that complements your room. Select a color to preview it.',
        '#efCfgStep1 .ef-cfg-step__title.ef-cfg-arch-hide':'Your finished screen size',
        '#efCfgStep1 .ef-cfg-step__subtitle.ef-cfg-arch-hide':'Enter the final outside width and height of the screen you want us to build.',
        '#efCfgStep1 .ef-cfg-step__title.ef-cfg-arch-show':'Your finished arch screen size',
        '#efCfgStep1 .ef-cfg-step__subtitle.ef-cfg-arch-show':'Enter the outside dimensions of the screen you want us to build. The template confirms your arch shape.',
        'label[for="efCfgWidth"] .ef-cfg-arch-hide':'Finished screen width',
        'label[for="efCfgWidth"] .ef-cfg-arch-show':'Finished screen width',
        'label[for="efCfgHeight"] .ef-cfg-arch-hide':'Finished screen height',
        '#efCfgWidthDesc':'Outside edge to outside edge',
        '#efCfgHeightDesc':'Resting surface to the top of the screen',
        '#efCfgWidthDescArch':'Finished outside width at the base',
        '#efCfgSideHeightDesc':'Resting surface to where the screen arch starts',
        '#efCfgHeightDescArch':'Resting surface to the screen’s highest point'
      };
      Object.keys(screenCopy).forEach(function (selector) { var el=root.querySelector(selector); if(el) el.textContent=screenCopy[selector]; });
      /* Tri-fold: the two wings (side panels) are already chosen above, so the width the customer types
         is the CENTER panel only — relabel so they don't wonder "center panel or whole screen?".
         Arch trifolds have their own arch-show label/desc elements (the arch-hide ones are display:none),
         so BOTH variants get the trifold copy — same language, arch just adds Side/Peak heights. (2026-07-01) */
      if (groupData && groupData.side_panel && groupData.side_panel.length) {
        var _tfWL = document.querySelector('label[for="efCfgWidth"] span.ef-cfg-arch-hide') || document.querySelector('label[for="efCfgWidth"] span');
        if (_tfWL) _tfWL.textContent = 'Center Panel Width';
        var _tfWLA = document.querySelector('label[for="efCfgWidth"] span.ef-cfg-arch-show');
        if (_tfWLA) _tfWLA.textContent = 'Center Panel Width';
        var _tfWD = document.getElementById('efCfgWidthDesc');
        if (_tfWD) _tfWD.textContent = 'Just the flat center panel — your two wings add on each side';
        var _tfWDA = document.getElementById('efCfgWidthDescArch');
        if (_tfWDA) _tfWDA.textContent = 'Just the flat center panel, at the base — your two wings add on each side';
        var _tfSHD = document.getElementById('efCfgSideHeightDesc');
        if (_tfSHD) _tfSHD.textContent = 'Screen height at the panel edges, floor to where the arch starts curving';
        var _tfHDA = document.getElementById('efCfgHeightDescArch');
        if (_tfHDA) _tfHDA.textContent = 'Screen height at the center, floor to the highest point of the arch';
      }
      if (curStep === 0) curStep = 1;
      /* 2026-06-16 — keep the screen tip box HIDDEN. Free-standing screens have no
         inside/overlap fit, so coverage advice ("+2\" wider") was misleading and
         repeated "finished size" three times. Step 1 stays minimal: title + one-line
         subtitle + inputs + the precision/verify line below. */
      var tipEl = document.getElementById('efCfgScreenTip');
      if (tipEl) tipEl.style.display = 'none';
      /* Show the compact screen-only overlap sizing hint (same pill format as the
         precision line). Optional guidance — both width AND height. */
      var sizeHint = document.getElementById('efCfgScreenSizeHint');
      if (sizeHint) {
        sizeHint.style.display = '';
        /* Tri-fold is FREE-STANDING — "overlap the opening" doesn't apply. Instead, tell the customer
           to mark the size on the floor with painter's tape to confirm the footprint fits. (2026-07-01) */
        if (groupData && groupData.side_panel && groupData.side_panel.length) {
          sizeHint.innerHTML = '<svg class="ef-cfg-measure-precision__ic" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> ' +
            'Tip: mark the <strong>width</strong> on your floor with <strong>painter&rsquo;s tape</strong> first &mdash; the easiest way to see how the screen&rsquo;s footprint sits in front of your fireplace before you order.';
        }
      }
      /* Hide door-centric "How to Measure" collapsible — tip box above handles it for screens */
      var htm = document.querySelector('.ef-cfg-htmeasure');
      if (htm) htm.style.display = 'none';
      /* T-CFG8 — with row 1 hidden the panel offers one route, so the title has to
         stop promising two. CSS picks which of the two authored spans paints. */
      var _hp = document.getElementById('efCfgHelpPanel');
      if (_hp) _hp.classList.add('is-one-route');
      /* Hide AI Fireplace Expert CTA — AI not tuned for screens */
      var aiBtn = document.getElementById('efCfgAiBtn');
      if (aiBtn) aiBtn.style.display = 'none';
      /* Hide AI advice box */
      var aiAdvice = document.getElementById('efCfgAiAdvice');
      if (aiAdvice) aiAdvice.style.display = 'none';
      /* Tri-fold: Step 2 (Style) ends up EMPTY — side panels moved into Step 1, and fit/feet/
         handle/pattern groups all have no data → renderCards hid every group. Drop the step
         from the flow (dynamic check so a future trifold WITH feet/handle data keeps it). (2026-07-01) */
      if (groupData && groupData.side_panel && groupData.side_panel.length && !_skipStep2) {
        var _tfS2 = document.getElementById('efCfgStep2');
        var _tfS2Visible = _tfS2 && Array.prototype.some.call(_tfS2.querySelectorAll('.ef-cfg-group'), function (g) { return g.style.display !== 'none'; });
        if (_tfS2 && !_tfS2Visible) { _skipStep2 = true; _tfS2.style.display = 'none'; }
      }
    }
  }

  /* ────────────────────────────────────
     OPENING DIAGRAM — live SVG preview
     Always visible, true proportions.
     Adapts to fireplace_type + firebox_type.
     ──────────────────────────────────── */
  var _openDims = { w: 36, h: 28 }; /* default = placeholder values */
  var _openType = { fp: '', fb: '' }; /* fireplace_type, firebox_type */

  /* ────────────────────────────────────
     SCREEN SVG — free-standing fireplace screen
     Frame: 1-1/4" · fine mesh · curved feet extending down+out
     Scales to finished W×H entered by customer.
     ──────────────────────────────────── */
  function drawScreen(wInch, hInch, svg) {
    var W = (wInch && wInch > 0) ? wInch : 40;
    var H = (hInch && hInch > 0) ? hInch : 32;
    _openDims.w = W;
    _openDims.h = H;

    var maxW = 320, maxH = 230;
    var scale = Math.min(maxW / W, maxH / H);
    var sW = Math.round(W * scale);
    var sH = Math.round(H * scale);

    /* Full-glass screens (e.g. "Modern Clear Glass Fireplace Screen with Steel Base"):
       frameless clear glass panel on a steel base with a forward-protruding foot —
       NOT a mesh panel. Bespoke render, then bail out of the mesh path. */
    var _isGlassScreen = /clear glass|full glass|frameless/i.test(prodTitle || '')
                      || /full glass/i.test(matchedGroup || '');
    if (_isGlassScreen) { drawGlassScreen(W, H, scale, sW, sH, svg); return; }

    var frameT = Math.max(3, Math.round(1.25 * scale));
    var footReach = Math.round(sW * 0.1);
    var footDrop  = Math.max(frameT * 3, Math.round(scale * 3));
    var footInset = Math.round(sW * 0.04);

    var padX = Math.max(50, footReach + 15), padTop = 32, padBot = Math.max(30, footDrop + 14);
    var cW = sW + padX * 2;
    var cH = sH + padTop + padBot;

    var x0 = padX, y0 = padTop;
    var ix = x0 + frameT, iy = y0 + frameT;
    var iw = sW - frameT * 2, ih = sH - frameT * 2;

    /* Curved feet — Bezier curves that swoop down and outward */
    var fLbase = x0 + footInset;
    var fLtip  = x0 + footInset - footReach;
    var footBot = y0 + sH + footDrop;
    var footL = 'M ' + fLbase + ' ' + (y0 + sH)
              + ' C ' + fLbase + ' ' + (y0 + sH + footDrop * 0.55)
              + ', ' + (fLtip + footReach * 0.25) + ' ' + (footBot - footDrop * 0.15)
              + ', ' + fLtip + ' ' + footBot;
    var fRbase = x0 + sW - footInset;
    var fRtip  = x0 + sW - footInset + footReach;
    var footR = 'M ' + fRbase + ' ' + (y0 + sH)
              + ' C ' + fRbase + ' ' + (y0 + sH + footDrop * 0.55)
              + ', ' + (fRtip - footReach * 0.25) + ' ' + (footBot - footDrop * 0.15)
              + ', ' + fRtip + ' ' + footBot;

    var meshS = Math.max(2, Math.round(scale * 0.4));
    padBot = 40;
    cH = sH + padTop + padBot;

    /* Arch shape: curved top half-ellipse from center peak to side base */
    var archRiseInch = 0;
    if (isArch && selections._side_height) {
      archRiseInch = Math.max(0, H - parseFloat(selections._side_height));
    } else if (isArch) {
      archRiseInch = Math.max(2, H * 0.25); /* default arch rise if side height not set */
    }
    var archRise = Math.round(archRiseInch * scale);

    /* Frame path — either rect or arch */
    var framePath, innerPath;
    if (isArch && archRise > 0) {
      /* Outer: bottom-left up, over arc to top-right, down to bottom-right */
      framePath = 'M ' + x0 + ' ' + (y0 + sH) +
                  ' L ' + x0 + ' ' + (y0 + archRise) +
                  ' A ' + (sW/2) + ' ' + archRise + ' 0 0 1 ' + (x0 + sW) + ' ' + (y0 + archRise) +
                  ' L ' + (x0 + sW) + ' ' + (y0 + sH) + ' Z';
      /* Inner cavity (arch shape, frameT inset) */
      var iArchRise = Math.max(0, archRise - frameT);
      innerPath = 'M ' + ix + ' ' + (y0 + sH - frameT) +
                  ' L ' + ix + ' ' + (y0 + frameT + iArchRise) +
                  ' A ' + (iw/2) + ' ' + iArchRise + ' 0 0 1 ' + (ix + iw) + ' ' + (y0 + frameT + iArchRise) +
                  ' L ' + (ix + iw) + ' ' + (y0 + sH - frameT) + ' Z';
    } else {
      framePath = 'M ' + x0 + ' ' + y0 + ' h ' + sW + ' v ' + sH + ' h -' + sW + ' Z';
      innerPath = 'M ' + ix + ' ' + iy + ' v ' + ih + ' h ' + iw + ' v -' + ih + ' Z';
    }

    svg.setAttribute('viewBox', '0 0 ' + cW + ' ' + cH);
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', 'auto');

    /* Mesh clip path for arch — uses same inner path as clip region */
    var clipDef = isArch && archRise > 0
      ? '<clipPath id="efScreenClip"><path d="' + innerPath + '"/></clipPath>'
      : '';
    var meshRect = isArch && archRise > 0
      ? '<rect x="' + ix + '" y="' + (y0 + frameT) + '" width="' + iw + '" height="' + (sH - frameT * 2) + '" fill="url(#efScreenMesh)" clip-path="url(#efScreenClip)"/>'
      : '<rect x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih + '" fill="url(#efScreenMesh)"/>';

    svg.innerHTML =
      '<defs>' +
        '<pattern id="efScreenMesh" x="0" y="0" width="' + meshS + '" height="' + meshS + '" patternUnits="userSpaceOnUse">' +
          '<rect width="' + meshS + '" height="' + meshS + '" fill="#2A2724"/>' +
          '<circle cx="' + (meshS/2) + '" cy="' + (meshS/2) + '" r="0.4" fill="#8A8579" opacity="0.55"/>' +
        '</pattern>' +
        '<linearGradient id="efFrameGrad" x1="0%" y1="0%" x2="0%" y2="100%">' +
          '<stop offset="0%" stop-color="#2B2722"/>' +
          '<stop offset="50%" stop-color="#141210"/>' +
          '<stop offset="100%" stop-color="#2B2722"/>' +
        '</linearGradient>' +
        clipDef +
      '</defs>' +
      meshRect +
      /* Frame (hollow — outer minus inner, even-odd fill) */
      '<path d="' + framePath + ' ' + innerPath + '" fill="url(#efFrameGrad)" fill-rule="evenodd"/>' +
      /* Width dimension */
      '<text x="' + (x0 + sW / 2) + '" y="' + (y0 - 12) + '" text-anchor="middle" font-family="Inter,sans-serif" font-size="12" font-weight="600" fill="#1E1E1B">' + W + '" W</text>' +
      '<line x1="' + x0 + '" y1="' + (y0 - 5) + '" x2="' + (x0 + sW) + '" y2="' + (y0 - 5) + '" stroke="#8A6A43" stroke-width="1"/>' +
      /* Height dimension */
      '<text x="' + (x0 + sW + 16) + '" y="' + (y0 + sH / 2) + '" text-anchor="start" font-family="Inter,sans-serif" font-size="12" font-weight="600" fill="#1E1E1B" dominant-baseline="middle">' + H + (isArch ? '" Peak' : '" H') + '</text>' +
      '<line x1="' + (x0 + sW + 8) + '" y1="' + y0 + '" x2="' + (x0 + sW + 8) + '" y2="' + (y0 + sH) + '" stroke="#8A6A43" stroke-width="1"/>' +
      '<text x="' + (cW / 2) + '" y="' + (y0 + sH + 22) + '" text-anchor="middle" font-family="Inter,sans-serif" font-size="10" fill="#8A8579" letter-spacing="1">' + (isArch ? 'FINISHED ARCH SCREEN SIZE' : 'FINISHED SCREEN SIZE') + '</text>';
  }

  /* ────────────────────────────────────
     GLASS SCREEN SVG — frameless clear glass panel sitting in a steel
     base with a forward-protruding foot plate (shown in perspective).
     Used for the "Full Glass" screen group (no mesh, no top/side frame).
     ──────────────────────────────────── */
  function drawGlassScreen(W, H, scale, sW, sH, svg) {
    var padX = 66, padTop = 34, padBot = 86;
    var cW = sW + padX * 2;
    var cH = sH + padTop + padBot;

    var gx = padX, gy = padTop;                        /* glass top-left */
    var baseH   = Math.max(16, Math.round(sH * 0.15)); /* steel base front-face height */
    var by      = gy + sH;                             /* base bottom / front-face baseline */
    var baseTop = by - baseH;                          /* base front-face top */
    var glassH  = sH - Math.round(baseH * 0.5);        /* glass dips into the base channel */

    /* forward foot plate (perspective): horizontal steel plate jutting toward viewer */
    var footDepth = Math.max(16, Math.round(baseH * 1.2));
    var footOut   = Math.max(10, Math.round(sW * 0.06)); /* near (front) edge wider = closer */
    var ffl = gx - footOut, ffr = gx + sW + footOut;     /* front edge x */
    var fby = by + footDepth;                            /* front edge y */
    var footPlate = 'M ' + gx + ' ' + by + ' L ' + (gx + sW) + ' ' + by +
                    ' L ' + ffr + ' ' + fby + ' L ' + ffl + ' ' + fby + ' Z';

    svg.setAttribute('viewBox', '0 0 ' + cW + ' ' + cH);
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', 'auto');

    svg.innerHTML =
      '<defs>' +
        '<linearGradient id="efGlassGrad" x1="0%" y1="0%" x2="100%" y2="100%">' +
          '<stop offset="0%" stop-color="#DCE6E8" stop-opacity="0.55"/>' +
          '<stop offset="45%" stop-color="#EAF0F1" stop-opacity="0.20"/>' +
          '<stop offset="100%" stop-color="#C7D2D4" stop-opacity="0.5"/>' +
        '</linearGradient>' +
        '<linearGradient id="efBaseGrad" x1="0%" y1="0%" x2="0%" y2="100%">' +
          '<stop offset="0%" stop-color="#3A3631"/>' +
          '<stop offset="55%" stop-color="#1C1A17"/>' +
          '<stop offset="100%" stop-color="#0F0E0C"/>' +
        '</linearGradient>' +
        '<linearGradient id="efFootGrad" x1="0%" y1="0%" x2="0%" y2="100%">' +
          '<stop offset="0%" stop-color="#4A453E"/>' +
          '<stop offset="100%" stop-color="#23211D"/>' +
        '</linearGradient>' +
      '</defs>' +
      /* clear glass panel (frameless) */
      '<rect x="' + gx + '" y="' + gy + '" width="' + sW + '" height="' + glassH + '" fill="url(#efGlassGrad)"/>' +
      /* diagonal reflection streak */
      '<polygon points="' + (gx + sW * 0.16) + ',' + gy + ' ' + (gx + sW * 0.34) + ',' + gy + ' ' + (gx + sW * 0.16) + ',' + (gy + glassH) + ' ' + (gx + sW * 0.02) + ',' + (gy + glassH) + '" fill="#FFFFFF" opacity="0.12"/>' +
      /* glass edge highlight */
      '<rect x="' + gx + '" y="' + gy + '" width="' + sW + '" height="' + glassH + '" fill="none" stroke="#AEBFC2" stroke-width="1.5" stroke-opacity="0.7"/>' +
      /* forward foot plate (drawn before base so the base front face overlaps its back edge) */
      '<path d="' + footPlate + '" fill="url(#efFootGrad)" stroke="#000" stroke-opacity="0.25" stroke-width="1"/>' +
      /* steel base front face */
      '<rect x="' + gx + '" y="' + baseTop + '" width="' + sW + '" height="' + baseH + '" rx="2" fill="url(#efBaseGrad)"/>' +
      '<rect x="' + gx + '" y="' + baseTop + '" width="' + sW + '" height="2" fill="#5A554C" opacity="0.6"/>' +
      /* width dimension */
      '<text x="' + (gx + sW / 2) + '" y="' + (gy - 12) + '" text-anchor="middle" font-family="Inter,sans-serif" font-size="12" font-weight="600" fill="#1E1E1B">' + W + '" W</text>' +
      '<line x1="' + gx + '" y1="' + (gy - 5) + '" x2="' + (gx + sW) + '" y2="' + (gy - 5) + '" stroke="#8A6A43" stroke-width="1"/>' +
      /* height dimension (glass + base) */
      '<text x="' + (gx + sW + 16) + '" y="' + (gy + sH / 2) + '" text-anchor="start" font-family="Inter,sans-serif" font-size="12" font-weight="600" fill="#1E1E1B" dominant-baseline="middle">' + H + '" H</text>' +
      '<line x1="' + (gx + sW + 8) + '" y1="' + gy + '" x2="' + (gx + sW + 8) + '" y2="' + by + '" stroke="#8A6A43" stroke-width="1"/>' +
      /* caption */
      '<text x="' + (cW / 2) + '" y="' + (fby + 18) + '" text-anchor="middle" font-family="Inter,sans-serif" font-size="10" fill="#8A8579" letter-spacing="1">CLEAR GLASS · STEEL BASE</text>';
  }

  function drawOpening(wInch, hInch) {
    var svg = document.getElementById('efCfgOpeningSvg');
    if (!svg) return;

    /* cfg-screen: render a free-standing fireplace screen (frame + mesh + feet)
       instead of a fireplace opening. 1-1/4" frame, square feet at bottom. */
    if (cfgType === 'cfg-screen') {
      drawScreen(wInch, hInch, svg);
      return;
    }
    /* Arch doors use their own three-dimension illustration. The rectangular
       opening SVG is hidden there; avoid redrawing it and waking its observers. */
    if (isArch) return;

    var W = (wInch && wInch > 0) ? wInch : _openDims.w;
    var H = (hInch && hInch > 0) ? hInch : _openDims.h;
    _openDims.w = W;
    _openDims.h = H;

    /* Detect construction type from selections */
    var isMasonry = true;  /* default */
    var isFlush   = true;  /* default */
    if (_openType.fp) {
      isMasonry = _openType.fp.toLowerCase().indexOf('masonry') !== -1;
    }
    if (_openType.fb) {
      isFlush = _openType.fb.toLowerCase().indexOf('flush') !== -1 ||
                _openType.fb.toLowerCase().indexOf('hearth') !== -1;
    }

    /*
     * True-proportion scaling:
     * The opening fits into max 220×180 px, W:H ratio exact.
     */
    var maxOW = 220, maxOH = 180;
    var scale = Math.min(maxOW / W, maxOH / H);
    var oW = Math.round(W * scale);
    var oH = Math.round(H * scale);

    /* Surround padding around opening */
    var surPadX = Math.max(28, Math.round(oW * 0.18));

    /*
     * Flush Hearth: opening sits on the hearth floor.
     *   → bigger top padding, small bottom (opening bottom = surround bottom = hearth top)
     * Hole in Wall: opening is vertically centered.
     *   → equal top and bottom padding
     */
    var surPadTop, surPadBot;
    if (isFlush) {
      surPadTop = Math.max(32, Math.round(oH * 0.25));
      surPadBot = 0; /* opening bottom flush with surround bottom / hearth top */
    } else {
      /* Hole in wall: equal padding top and bottom → centered */
      var surPadV = Math.max(28, Math.round(oH * 0.18));
      surPadTop = surPadV;
      surPadBot = surPadV;
    }

    var sW = oW + surPadX * 2;
    var sH = oH + surPadTop + surPadBot;

    /* Mantel/hearth geometry */
    var mantelH = 14;
    var mantelOver = 10;
    var hearthH = 16;
    var hearthEdgeH = 6;
    var hearthOver = 15;
    var showHearth = isFlush;

    /* Dimension lines */
    var dimLeft = 28;
    var dimBot = 28;
    var arrowLen = 6;
    var hLblOffset = 6; /* extra space for height label text */

    /* Positions */
    var svgPadL = dimLeft + hLblOffset + 12;
    var svgPadT = 10;
    var sX = svgPadL;
    var sY = svgPadT + mantelH + 4; /* always room for mantel area */
    var oX = sX + surPadX;
    var oY = sY + surPadTop;

    var hearthY = sY + sH;
    var hearthX = sX - hearthOver;
    var hearthTotalW = sW + hearthOver * 2;

    var mantelX = sX - mantelOver;
    var mantelY = sY - mantelH - 2;
    var mantelW = sW + mantelOver * 2;

    /* Total SVG size */
    var totalW = svgPadL + sW + 20;
    var bottomExtra = showHearth ? hearthH + hearthEdgeH : 4;
    var totalH = mantelY + mantelH + 4 + sH + bottomExtra + dimBot + 18;

    svg.setAttribute('viewBox', '0 0 ' + totalW + ' ' + totalH);

    /* ─ Helper ─ */
    function setAttr(id, attrs) {
      var el = document.getElementById(id);
      if (!el) return;
      for (var k in attrs) el.setAttribute(k, attrs[k]);
    }

    /* ── Surround ── */
    if (isMasonry) {
      /* Brick surround */
      setAttr('efCfgSurroundRect', { x: sX, y: sY, width: sW, height: sH, fill: 'url(#efBrickPat)', stroke: '#B5A898', 'stroke-width': '1', rx: '2' });
      /* Show mantel */
      setAttr('efCfgMantel', { x: mantelX, y: mantelY, width: mantelW, height: mantelH, opacity: '1' });
      setAttr('efCfgMantelFace', { x: mantelX, y: mantelY + mantelH, width: mantelW, height: 4, opacity: '1' });
      setAttr('efCfgMantelShadow', { x: sX, y: sY, width: sW, height: 10, opacity: '1' });
      /* Hide prefab frame */
      setAttr('efCfgPrefabOuter', { opacity: '0', 'stroke-width': '0' });
      setAttr('efCfgPrefabInner', { opacity: '0', 'stroke-width': '0' });
    } else {
      /* Prefab: dark metal housing */
      setAttr('efCfgSurroundRect', { x: sX, y: sY, width: sW, height: sH, fill: '#2C2C2C', stroke: '#4A4A4A', 'stroke-width': '1.5', rx: '3' });
      /* Show prefab double-frame */
      setAttr('efCfgPrefabOuter', { x: sX - 2, y: sY - 2, width: sW + 4, height: sH + 4, rx: 4, opacity: '1', stroke: '#555', 'stroke-width': '1.5' });
      setAttr('efCfgPrefabInner', { x: sX + 4, y: sY + 4, width: sW - 8, height: sH - 8, rx: 2, opacity: '0.5', stroke: '#3A3A3A', 'stroke-width': '0.8' });
      /* Hide masonry mantel */
      setAttr('efCfgMantel', { opacity: '0' });
      setAttr('efCfgMantelFace', { opacity: '0' });
      setAttr('efCfgMantelShadow', { opacity: '0' });
    }

    /* ── Firebox opening ── */
    setAttr('efCfgOpeningRect', { x: oX, y: oY, width: oW, height: oH });

    /* Soot */
    setAttr('efCfgSoot', { x: oX + 1, y: oY + 1, width: oW - 2, height: Math.min(30, oH * 0.18) });

    /* Back wall hint */
    var bwInset = Math.max(12, Math.round(oW * 0.1));
    var bwInsetV = Math.max(14, Math.round(oH * 0.1));
    setAttr('efCfgBackWall', {
      x: oX + bwInset, y: oY + bwInsetV,
      width: oW - bwInset * 2, height: oH - bwInsetV * 2
    });

    /* ── Hearth / floor ── */
    if (showHearth) {
      /* Flush Hearth: hearth slab below surround, opening sits on it */
      setAttr('efCfgHearth', { x: hearthX, y: hearthY, width: hearthTotalW, height: hearthH, opacity: '1' });
      setAttr('efCfgHearthEdge', { x: hearthX, y: hearthY + hearthH - 2, width: hearthTotalW, height: hearthEdgeH, opacity: '1' });
      setAttr('efCfgFloorLine', { x1: hearthX - 10, y1: hearthY + hearthH + hearthEdgeH - 2, x2: hearthX + hearthTotalW + 10, y2: hearthY + hearthH + hearthEdgeH - 2, opacity: '1' });
    } else {
      /* Hole in wall: no hearth, just floor line below surround */
      setAttr('efCfgHearth', { opacity: '0' });
      setAttr('efCfgHearthEdge', { opacity: '0' });
      setAttr('efCfgFloorLine', { x1: sX - 10, y1: sY + sH + 2, x2: sX + sW + 10, y2: sY + sH + 2, opacity: '1' });
    }

    /* ── Width dimension ── */
    var wDimBase = showHearth ? (hearthY + hearthH + hearthEdgeH) : (sY + sH);
    var wDimY = wDimBase + 12;
    setAttr('efCfgDimWLine', { x1: oX, y1: wDimY, x2: oX + oW, y2: wDimY });
    var wAL = oX, wAR = oX + oW;
    setAttr('efCfgDimWArwL', { points: wAL+','+wDimY+' '+(wAL+arrowLen)+','+(wDimY-3)+' '+(wAL+arrowLen)+','+(wDimY+3) });
    setAttr('efCfgDimWArwR', { points: wAR+','+wDimY+' '+(wAR-arrowLen)+','+(wDimY-3)+' '+(wAR-arrowLen)+','+(wDimY+3) });
    setAttr('efCfgDimWCapL', { x1: oX, y1: wDimY - 6, x2: oX, y2: wDimY + 6 });
    setAttr('efCfgDimWCapR', { x1: oX + oW, y1: wDimY - 6, x2: oX + oW, y2: wDimY + 6 });
    var wLbl = document.getElementById('efCfgDimWLabel');
    if (wLbl) {
      wLbl.setAttribute('x', oX + oW / 2);
      wLbl.setAttribute('y', wDimY + 16);
      wLbl.textContent = W + '\u2033';
    }

    /* ── Height dimension ── */
    var hDimX = sX - dimLeft;
    var hLblX = hDimX - 6; /* label offset from line — matches width label gap */
    setAttr('efCfgDimHLine', { x1: hDimX, y1: oY, x2: hDimX, y2: oY + oH });
    setAttr('efCfgDimHArwT', { points: hDimX+','+oY+' '+(hDimX-3)+','+(oY+arrowLen)+' '+(hDimX+3)+','+(oY+arrowLen) });
    setAttr('efCfgDimHArwB', { points: hDimX+','+(oY+oH)+' '+(hDimX-3)+','+(oY+oH-arrowLen)+' '+(hDimX+3)+','+(oY+oH-arrowLen) });
    setAttr('efCfgDimHCapT', { x1: hDimX - 6, y1: oY, x2: hDimX + 6, y2: oY });
    setAttr('efCfgDimHCapB', { x1: hDimX - 6, y1: oY + oH, x2: hDimX + 6, y2: oY + oH });
    var hLbl = document.getElementById('efCfgDimHLabel');
    if (hLbl) {
      var hMid = oY + oH / 2;
      hLbl.setAttribute('x', hLblX);
      hLbl.setAttribute('y', hMid);
      hLbl.setAttribute('transform', 'rotate(-90 ' + hLblX + ' ' + hMid + ')');
      hLbl.textContent = H + '\u2033';
    }
  }

  /* Initial draw with defaults (matches placeholders e.g. 36 / e.g. 28) */
  drawOpening(36, 28);

  /* ────────────────────────────────────
     MEASUREMENTS → SIZE CATEGORY
     ──────────────────────────────────── */
  function handleMeasurements() {
    var wEl = document.getElementById('efCfgWidth');
    var hEl = document.getElementById('efCfgHeight');
    var sEl = document.getElementById('efCfgSideHeight'); /* arch only */
    if (!wEl || !hEl) return;

    /* Debounce SVG diagram updates so it doesn't jump on every keystroke.
       User typing "40" sees the diagram update after they pause, not after "4". */
    var _drawTimer = null;
    function debouncedDraw(w, h) {
      clearTimeout(_drawTimer);
      _drawTimer = setTimeout(function() { drawOpening(w, h); }, 500);
    }

    /* Light the field + show a green check once a realistic measurement is in,
       so the customer gets a live "got it" confirmation. 2026-05-31. */
    function _efSetDimValid(el, ok) {
      var wrap = el && el.closest ? el.closest('.ef-cfg-input-suffix') : null;
      if (wrap && wrap.classList.contains('is-valid') !== !!ok) wrap.classList.toggle('is-valid', !!ok);
    }

    function calc() {
      if(isOldWorldSlim){
        selections._width=wEl.value.trim();selections._height=hEl.value.trim();owsSync();
        var oq=owsMeasure();_efSetDimValid(wEl,!oq.error);_efSetDimValid(hEl,!oq.error);
        if(!oq.error)debouncedDraw(oq.width,oq.height);
        var result=document.getElementById('efCfgSizeResult');if(result)result.classList.remove('is-visible');
        var section=document.getElementById('efCfgSizeSection');if(section)section.style.display='none';
        updatePrice(true);updateATCState();return;
      }
      var w = parseMeasurement(wEl.value);
      var h = parseMeasurement(hEl.value);
      var wValid = !isNaN(w) && w > 0;
      var hValid = !isNaN(h) && h > 0;
      var wRealistic = wValid && w >= 10;
      var hRealistic = hValid && h >= 10;

      _efSetDimValid(wEl, wRealistic);
      _efSetDimValid(hEl, hRealistic);
      if (sEl) { var sv = parseMeasurement(sEl.value); _efSetDimValid(sEl, !isNaN(sv) && sv >= 10); }

      /* Update SVG diagram only when value looks like a real measurement (>=10")
         so typing the first digit of "36" doesn't redraw at 3" */
      if (wRealistic || hRealistic) {
        debouncedDraw(wRealistic ? Math.round(w) : 36, hRealistic ? Math.round(h) : 28);
      }

      if (!wValid || !hValid) {
        var emptyResult = document.getElementById('efCfgSizeResult');
        if (emptyResult.classList.contains('is-visible')) emptyResult.classList.remove('is-visible');
        var sizeSection = document.getElementById('efCfgSizeSection');
        if (sizeSection && sizeSection.style.display !== 'none') sizeSection.style.display = 'none';
        delete selections._width;
        delete selections._height;
        delete selections._side_height;
        delete selections.size;
        delete surcharges.size; delete surcharges.size_height;
        updatePrice(true);
        return;
      }

      selections._width = wEl.value.trim();
      selections._height = hEl.value.trim();
      /* Arch: capture Side Height (no impact on pricing — just for manufacturer reference) */
      if (isArch && sEl) {
        var sideRaw = sEl.value.trim();
        if (sideRaw) selections._side_height = sideRaw;
        else delete selections._side_height;
      }
      /* Pricing total: Width + Height (rectangle) OR Width + Peak (arch — same field, just relabeled) */
      var total = Math.round((w + h) * 100) / 100;
      var totalDisplay = prodHandle === 'design-specialties-rainbow-custom-fireplace-doors'
        ? Math.round((w + h) * 10000) / 10000
        : Math.round(total);

      // Find matching size category
      var cat = null;
      if (sizeGrid) {
        /* EF_STOLL_SIZE_GRID_20260829 - first row whose max width AND max height both fit.
           Height here is the peak height on arch products (same input field). If nothing
           fits, fall back to the last (largest) row so we never under-charge. */
        /* EF_STOLL_1TO1_20260829 — exact Stoll order-form rule (owner decision 2026-08-29):
           the row is chosen by WIDTH only ("Fireplace Opening Size Up To … wide"); any height
           over the row's max height is charged "+$135 per 2″ height increase over dimensions
           on sizing chart" (each started 2″ = one $135 unit, added as a multiplied line item). */
        for (var gi = 0; gi < sizeData.length; gi++) {
          var ge = sizeData[gi];
          if (ge.maxW === null || ge.maxH === null) continue;
          if (w <= ge.maxW) { cat = ge; break; }
        }
        if (!cat && sizeData.length) cat = sizeData[sizeData.length - 1];
        delete surcharges.size_height;
        if (cat && h > cat.maxH) {
          var _over = h - cat.maxH;
          var _steps = Math.ceil(_over / 2 - 1e-9);
          surcharges.size_height = {
            amount: _steps * STOLL_HEIGHT_STEP_PRICE * 100,
            label: '+' + (Math.round(_over * 100) / 100) + '″ over ' + cat.maxH + '″ (' + _steps + ' × $' + STOLL_HEIGHT_STEP_PRICE + ')',
            variantId: STOLL_HEIGHT_STEP_VARIANT,
            qty: _steps
          };
        }
        console.log('[EF-CFG] size-grid W=' + w + ' H=' + h + ' rows=' + sizeData.length + ' matched=' + (cat ? cat.label : 'NONE') + (surcharges.size_height ? ' | height ' + surcharges.size_height.label : ''));
      } else {
        delete surcharges.size_height;
      }
      for (var i = 0; !sizeGrid && i < sizeData.length; i++) {
        if (total >= sizeData[i].minTotal && total <= sizeData[i].maxTotal) {
          cat = sizeData[i];
          break;
        }
      }

      /* ────────────────────────────────────
         EF_STOLL_UI_BRACKETS_20260830 — owner decision: Stoll doors sell in the same
         united-inch brackets as every other EF door (one "Size" line, no per-2-inch
         multiplier, which read like a miscalculation to customers). Bracket prices are
         set above the Stoll list for realistic openings, but a very wide-and-short
         opening (linear fireplaces) can still list higher than its bracket, so we move
         it up to the first bracket that covers the list price. Never below Stoll list,
         still exactly one size line. `stoll_grid` = the order-form rows for this style.
         ──────────────────────────────────── */
      if (cat && groupData && Array.isArray(groupData.stoll_grid) && groupData.stoll_grid.length) {
        var _grid = groupData.stoll_grid, _row = null;
        for (var _gi = 0; _gi < _grid.length; _gi++) {
          if (w <= parseFloat(_grid[_gi].maxW)) { _row = _grid[_gi]; break; }
        }
        if (!_row) _row = _grid[_grid.length - 1];
        var _over = Math.max(0, h - parseFloat(_row.maxH));
        var _listPrice = (parseFloat(_row.price) || 0) + STOLL_HEIGHT_STEP_PRICE * Math.ceil(_over / 2 - 1e-9);
        if (_listPrice > cat.price) {
          var _bumped = null;
          for (var _bi = 0; _bi < sizeData.length; _bi++) {
            if (sizeData[_bi].price >= _listPrice) { _bumped = sizeData[_bi]; break; }
          }
          cat = _bumped || sizeData[sizeData.length - 1];
          console.log('[EF-CFG] stoll-guard: list $' + _listPrice + ' > bracket — moved up to ' + cat.label);
        }
      }

      console.log('[EF-CFG] calc: W=' + w + ' H=' + h + ' total=' + total + ' | sizeData=' + sizeData.length + ' entries | matched=' + (cat ? cat.label : 'NONE'));

      var resEl = document.getElementById('efCfgSizeResult');
      var sizeSection = document.getElementById('efCfgSizeSection');
      if (sizeSection && sizeSection.style.display !== '') sizeSection.style.display = '';
      var sizeTotalText = sizeGrid
        ? ((isArch ? 'W \u00D7 Peak = ' : 'W \u00D7 H = ') + w + '\u2033 \u00D7 ' + h + '\u2033')
        : ((isArch ? 'W + Peak = ' : 'W + H = ') + totalDisplay + '\u2033');
      var sizeTotalEl = document.getElementById('efCfgSizeTotal');
      if (sizeTotalEl.textContent !== sizeTotalText) sizeTotalEl.textContent = sizeTotalText;

      if (cat) {
        var sizeBadge = document.getElementById('efCfgSizeBadge');
        if (sizeBadge.textContent !== cat.displayLabel) sizeBadge.textContent = cat.displayLabel;
        var sizeCharge = document.getElementById('efCfgSizeSurcharge'), sizeChargeText = cat.price > 0 ? '+$' + cat.price : 'Base price';
        if (sizeCharge.textContent !== sizeChargeText) sizeCharge.textContent = sizeChargeText;
        selections.size = cat.displayLabel;
        surcharges.size = { amount: cat.price * 100, label: cat.displayLabel, variantId: cat.variantId };
      } else {
        var customBadge = document.getElementById('efCfgSizeBadge');
        if (customBadge.textContent !== 'Custom') customBadge.textContent = 'Custom';
        var customCharge = document.getElementById('efCfgSizeSurcharge');
        if (customCharge.textContent !== '') customCharge.textContent = '';
        selections.size = 'Custom';
        surcharges.size = { amount: 0, label: 'Custom', variantId: null };
      }

      if (!resEl.classList.contains('is-visible')) resEl.classList.add('is-visible');
      updatePrice(true);
    }

    wEl.addEventListener('input', calc);
    hEl.addEventListener('input', calc);
    /* Side height is optional manufacturer information, never a price input.
       Capture it when entered last, without re-running the width/peak price path. */
    if (isArch && sEl) sEl.addEventListener('input', function () {
      var sideRaw = sEl.value.trim(), side = parseMeasurement(sideRaw);
      _efSetDimValid(sEl, !isNaN(side) && side >= 10);
      if (sideRaw) selections._side_height = sideRaw;
      else delete selections._side_height;
    });
  }

  /* ────────────────────────────────────
     HOW TO MEASURE ACCORDION
     ──────────────────────────────────── */
  (function() {
    var toggle = document.getElementById('efCfgHtmToggle');
    var body = document.getElementById('efCfgHtmBody');
    if (!toggle || !body) return;
    toggle.addEventListener('click', function() {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !open);
      body.setAttribute('aria-hidden', open);
    });
  })();

  /* ────────────────────────────────────
     VARIANT SELECT (cfg-standard)
     ──────────────────────────────────── */
  function handleVariantSelect() {
    var sel = document.getElementById('efCfgVariantSelect');
    if (!sel) return;
    sel.addEventListener('change', function() {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.value) {
        variantId = opt.value;
        var vPrice = parseInt(opt.dataset.price, 10) || 0;
        basePrice = vPrice;
        selections.variant = opt.textContent.trim();
      } else {
        selections.variant = null;
      }
      updatePrice();
    });

    /* Preselect first available variant so ATC is click-ready on page load.
       Skips the placeholder "" option and any disabled (sold-out) variants. */
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (o.value && !o.disabled) {
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change'));
        break;
      }
    }
  }

  /* ────────────────────────────────────
     STANDARD SIZE DROPDOWNS (Stoll Columbia, etc.)
     Replaces W/H text inputs with two cascading dropdowns when the matched
     group has standard_size === true. Width tier carries the size surcharge
     (since Columbia prices by finished width, not W+H sum); height range is
     informational only.
     ──────────────────────────────────── */
  /* Brookfield Deluxe Magnetic — replaces standard width/height inputs with the
     6-input measurement panel (per Avis/DS spec). Also hides:
       - W+H size badge section
       - The big rectangular opening diagram SVG (#efCfgOpeningDiagram) — that
         28"×36" fireplace illustration was showing above the inputs and looks
         out of place next to the magnetic-mount real-photo image we now use. */
  function handleBrookfieldDeluxe() {
    if (matchedGroup !== 'Fireplace Doors - Brookfield Deluxe') return;
    var measureBox = document.getElementById('efCfgMeasure');
    var deluxeBox  = document.getElementById('efCfgDeluxeMeasure');
    if (!measureBox || !deluxeBox) return;
    measureBox.style.display = 'none';
    deluxeBox.style.display = '';
    deluxeBox.querySelectorAll('input').forEach(function(input){input.addEventListener('input',function(){updatePrice();});});
    var sizeSection = document.getElementById('efCfgSizeSection');
    if (sizeSection) sizeSection.style.display = 'none';
    var openingDiagram = document.getElementById('efCfgOpeningDiagram');
    if (openingDiagram) openingDiagram.style.display = 'none';
  }

  function handleStandardSize() {
    if (!groupData || !groupData.standard_size) return;
    var measureBox = document.getElementById('efCfgMeasure');
    var stdBox     = document.getElementById('efCfgStdSize');
    var wSel       = document.getElementById('efCfgStdWidth');
    var hSel       = document.getElementById('efCfgStdHeight');
    if (!measureBox || !stdBox || !wSel || !hSel) return;

    measureBox.style.display = 'none';
    stdBox.style.display = '';
    /* Hide the W+H size badge section — it doesn't apply to width-tier pricing */
    var sizeSection = document.getElementById('efCfgSizeSection');
    if (sizeSection) sizeSection.style.display = 'none';

    var widths  = groupData.size || [];
    var heights = groupData.size_height || [];

    widths.forEach(function(w, i) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.textContent = w.label + (w.price > 0 ? '  (+$' + w.price + ')' : '');
      wSel.appendChild(opt);
    });
    heights.forEach(function(h, i) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.textContent = h.label;
      hSel.appendChild(opt);
    });

    function applySelections() {
      var wIdx = wSel.value;
      var hIdx = hSel.value;
      if (wIdx === '' || hIdx === '') {
        delete selections._width;
        delete selections._height;
        delete selections.size;
        delete surcharges.size; delete surcharges.size_height;
        updatePrice();
        return;
      }
      var w = widths[parseInt(wIdx, 10)];
      var h = heights[parseInt(hIdx, 10)];
      selections._width  = w.label;
      selections._height = h.label;
      selections.size    = w.label;
      surcharges.size = {
        amount:    (w.price || 0) * 100,
        label:     w.label,
        variantId: w.variantId || null
      };
      updatePrice();
    }

    wSel.addEventListener('change', function() {
      hSel.disabled = (wSel.value === '');
      if (wSel.value === '') {
        hSel.value = '';
      }
      applySelections();
    });
    hSel.addEventListener('change', applySelections);
  }

  /* ────────────────────────────────────
     SIMPLE RANGE SELECTS (cfg-simple)
     ──────────────────────────────────── */
  function handleSimpleRanges() {
    if (cfgType !== 'cfg-simple') return;
    if (!groupData || !groupData.simple_width) {
      console.warn('[EF-CFG] cfg-simple: no range data found for product "' + prodTitle + '". Matched group:', matchedGroup);
      return;
    }
    var wSel = document.getElementById('efCfgSimpleWidth');
    var hSel = document.getElementById('efCfgSimpleHeight');
    if (!wSel || !hSel) return;

    var widthData = groupData.simple_width || [];
    var heightSets = groupData.simple_height || [];
    var modelSets = groupData.simple_models || [];
    var dimsEl = document.getElementById('efCfgSimpleDims');
    var dimsValEl = document.getElementById('efCfgSimpleDimsValue');

    function showModelDims(wIdx, hIdx) {
      if (!dimsEl || !dimsValEl) return;
      var models = modelSets[wIdx];
      if (models && models[hIdx]) {
        var m = models[hIdx];
        dimsValEl.innerHTML = '<strong>' + m.name + '</strong><br>Overall: ' + m.overall;
        dimsEl.style.display = '';
      } else {
        dimsEl.style.display = 'none';
      }
    }

    widthData.forEach(function(w, i) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.textContent = w.label + (w.price > 0 ? ' (+$' + w.price + ')' : '');
      opt.dataset.price = w.price || 0;
      opt.dataset.variantId = w.variantId || '';
      wSel.appendChild(opt);
    });

    function populateHeight(widthIdx) {
      hSel.innerHTML = '<option value="">Select height range...</option>';
      var heights = heightSets[widthIdx] || [];
      heights.forEach(function(h, i) {
        var opt = document.createElement('option');
        opt.value = i;
        opt.textContent = h.label + (h.price > 0 ? ' (+$' + h.price + ')' : '');
        opt.dataset.price = h.price || 0;
        opt.dataset.variantId = h.variantId || '';
        hSel.appendChild(opt);
      });
      hSel.disabled = false;
      delete selections.simple_height;
      delete surcharges.simple_height;
      if (dimsEl) dimsEl.style.display = 'none';
      updatePrice();
    }

    wSel.addEventListener('change', function() {
      wSel.style.borderColor = '';
      if (wSel.value === '') {
        hSel.innerHTML = '<option value="">Select width first...</option>';
        hSel.disabled = true;
        delete selections.simple_width;
        delete surcharges.simple_width;
        delete selections.simple_height;
        delete surcharges.simple_height;
        updatePrice();
        return;
      }
      var idx = parseInt(wSel.value, 10);
      var w = widthData[idx];
      selections.simple_width = w.label;
      surcharges.simple_width = { amount: (w.price || 0) * 100, label: w.label, variantId: w.variantId || null };
      populateHeight(idx);
    });

    hSel.addEventListener('change', function() {
      hSel.style.borderColor = '';
      if (hSel.value === '') {
        delete selections.simple_height;
        delete surcharges.simple_height;
        updatePrice();
        return;
      }
      var wIdx = parseInt(wSel.value, 10);
      var hIdx = parseInt(hSel.value, 10);
      var h = (heightSets[wIdx] || [])[hIdx];
      if (h) {
        selections.simple_height = h.label;
        surcharges.simple_height = { amount: (h.price || 0) * 100, label: h.label, variantId: h.variantId || null };
        showModelDims(wIdx, hIdx);
      }
      updatePrice();
    });

    /* Preselect first available width + first matching height so ATC is
       click-ready on page load. Buyer changes the dropdowns if their fireplace
       falls outside the default range — but for the most common purchase path
       we remove the friction of forcing two selections before checkout. */
    if (widthData.length > 0) {
      wSel.value = '0';
      wSel.dispatchEvent(new Event('change'));
      var firstHeights = heightSets[0] || [];
      if (firstHeights.length > 0) {
        hSel.value = '0';
        hSel.dispatchEvent(new Event('change'));
      }
    }
  }

  /* ────────────────────────────────────
     PRICE CALCULATION & DISPLAY
     ──────────────────────────────────── */
  var lastPriceSignal = null;

  /* EF_GLASS_PROTECTION_20261017 */
  function glassProtectionEligible() {
    return ["design-specialties-brookfield-custom-fireplace-doors","cabot-fireplace-glass-door-for-masonry","black-rock-arch-masonry-fireplace-glass-doors","design-specialties-buckingham-arch-custom-fireplace-doors-masonry","design-specialties-legend-arch-custom-fireplace-doors-masonry","design-specialties-stiletto-custom-fireplace-doors","design-specialties-bungalow-custom-fireplace-doors","design-specialties-carolina-standard-custom-fireplace-doors-1","design-specialties-carolina-arched-and-window-pane-custom-fireplace-doors","design-specialties-carolina-arched-custom-fireplace-doors-2","design-specialties-carolina-sunrise-custom-fireplace-doors","design-specialties-oak-tree-custom-fireplace-doors","design-specialties-mantel-custom-fireplace-doors","design-specialties-napa-valley-custom-fireplace-doors","design-specialties-legend-odyssey-custom-fireplace-doors","design-specialties-original-moderne-custom-fireplace-doors-2","design-specialties-slim-moderne-custom-fireplace-doors-3","design-specialties-legend-standard-custom-fireplace-doors","banded-scroll-masonry-prefab-fireplace-glass-doors","design-specialties-craftsman-custom-fireplace-doors-1","design-specialties-madrid-custom-fireplace-doors-2","design-specialties-hammered-edge-standard-custom-fireplace-doors","design-specialties-black-rock-custom-fireplace-doors","design-specialties-apex-custom-fireplace-doors","design-specialties-reflection-custom-fireplace-doors","design-specialties-piccolo-custom-fireplace-doors","design-specialties-rainbow-custom-fireplace-doors","design-specialties-stiletto-cutback-custom-fireplace-doors","stainless-steel-masonry-fireplace-door","design-specialties-carolina-standard-custom-fireplace-doors-2","design-specialties-legend-odyssey-custom-fireplace-doors-1","thinlinepro-custom-fireplace-doors","mission-custom-fireplace-doors","design-specialties-original-moderne-custom-fireplace-doors-5","madison-custom-fireplace-doors","innovative-custom-fireplace-doors","masonry-prefab-fireplace-glass-doors","iron-crafted-custom-fireplace-doors","aged-world-fireplace-glass-doors-exceptional-fire","smithline-masonry-and-prefab-fireplace-glass-doors","metro-custom-fireplace-doors","midway-flames-custom-fireplace-doors","timeless-flames-custom-fireplace-doors","bar-iron-masonry-prefab-fireplace-doors","edgeline-custom-fireplace-doors","deepset-custom-fireplace-doors-2","sierra-custom-steel-masonry-prefab-fireplace-doors","sierra-arch-pane-custom-steel-masonry-prefab-fireplace-doors","sierra-windows-pane-custom-steel-masonry-prefab-fireplace-doors","bar-crafts-custom-fireplace-doors-6","belmont-custom-masonry-fireplace-glass-doors","wheatland-custom-masonry-fireplace-glass-doors","seaside-standard-glass-doors-designed-for-all-prefabricated-fireplaces","monterey-standard-glass-doors-designed-for-all-prefabricated-fireplaces","openview-masonry-prefab-fireplace-doors","edgewood-masonry-fireplace-door","ashford-masonry-fireplace-door","blacksmith-arch-masonry-and-prefab-fireplace-glass-doors","forged-iron-arch-conversion-masonry-and-prefab-fireplace-glass-doors","old-world-arch-masonry-distressed-steel-fireplace-glass-doors","bar-iron-arch-masonry-steel-fireplace-glass-doors","industrial-arch-masonry-steel-fireplace-glass-doors","smithline-arch-conversion-masonry-and-prefab-fireplace-glass-doors","ardmore-flat-black-masonry-fireplace-door-sleek-modern-durable-design","armitage-flat-black-masonry-fireplace-door-sleek-modern-durable-design","grande-flat-black-masonry-fireplace-door-standard-sizes","reflection-flat-black-masonry-fireplace-door-standard-sizes","medio-flat-black-masonry-fireplace-door-standard-sizes","finley-flat-black-masonry-fireplace-door-standard-sizes","farnsworth-oil-rubbed-bronze-masonry-fireplace-door-standard-sizes","colt-flat-black-masonry-fireplace-door-standard-sizes","colt-gun-metal-masonry-fireplace-door-standard-sizes","alexander-natural-iron-masonry-fireplace-door-standard-sizes","brookfield-deluxe-magnetic-prefab-fireplace-glass-doors","medio-flat-black-masonry-fireplace-door-custom-size","carolina-traditional-steel-fireplace-glass-doors-masonry-prefab","milwaukee-forged-iron-masonry-prefab-fireplace-glass-doors","laguna-arch-pane-masonry-prefab-fireplace-glass-doors","cavestone-fireplace-glass-doors-custom-masonry-fit","savannah-masonry-prefab-fireplace-glass-doors","all-glass-steel-fireplace-glass-doors-masonry-prefab"].indexOf(prodHandle) !== -1 && cfgType !== 'cfg-screen' && !isMeshOnly && !/mesh|no glass|without glass/i.test(selections.glass || '');
  }
  function setGlassProtection(enabled) {
    if (enabled && glassProtectionEligible()) {
      selections.glass_protection = 'Lifetime Glass Protection by ExceptionalFire — $99';
      surcharges.glass_protection = {amount:9900,label:'Lifetime coverage',variantId:'42820684677202'};
    } else { delete selections.glass_protection; delete surcharges.glass_protection; }
    syncGlassProtection();
  }
  function syncGlassProtection() {
    var eligible = glassProtectionEligible();
    if (!eligible) { delete selections.glass_protection; delete surcharges.glass_protection; }
    var card = document.getElementById('efGlassProtection');
    if (!card && eligible) card = createGlassProtectionCard(document.getElementById('efCfgReviewGrid') || document.getElementById('efCfgStep0'), function(checked) {
      setGlassProtection(checked); updatePrice();
      window.dispatchEvent(new CustomEvent('ef-cfg:state-changed'));
    });
    if (card) { card.hidden = !eligible; card.querySelector('input').checked = !!selections.glass_protection; }
  }
  /* EF_GLASS_PROTECTION_CARD_20261017 — explicit opt-in; compact beside order add-ons. */
  function createGlassProtectionCard(anchor, onChange) {
    var existing = document.getElementById('efGlassProtection');
    if (existing || !anchor) return existing;
    var card = document.createElement('section');
    card.id = 'efGlassProtection';
    card.setAttribute('aria-labelledby', 'efGlassProtectionTitle');
    card.innerHTML = "<style>#efGlassProtection{box-sizing:border-box;background:#fbf8f2;border:1px solid #c7ad7b;border-radius:8px;padding:14px 16px;margin:16px 0;width:100%;font-family:inherit;color:#242424}#efGlassProtection .ef-gp-choice{display:flex;align-items:center;gap:11px;min-height:44px;padding:0;margin:0;cursor:pointer;font-family:inherit;font-size:15px;font-weight:600;line-height:1.35;text-transform:none;letter-spacing:0}#efGlassProtection input{appearance:auto;position:static;opacity:1;flex:0 0 20px;width:20px;height:20px;margin:0;accent-color:#86652f;cursor:pointer}#efGlassProtection input:focus-visible,#efGlassProtection summary:focus-visible{outline:2px solid #86652f;outline-offset:4px}#efGlassProtection .ef-gp-price{margin-left:auto;flex:0 0 auto;text-align:right;white-space:nowrap;font-size:16px;line-height:1.25}#efGlassProtection .ef-gp-price small{display:block;font-size:11px;font-weight:400;margin-top:3px}#efGlassProtection .ef-gp-benefit{font-size:13px;line-height:1.5;margin:5px 0 3px 31px;color:#555}#efGlassProtection details{margin-left:31px;font-size:12px;line-height:1.5}#efGlassProtection summary{display:list-item;width:fit-content;max-width:100%;cursor:pointer;text-decoration:underline;text-underline-offset:2px;min-height:36px;box-sizing:border-box;padding:8px 0;font-size:12px;line-height:20px}#efGlassProtection details p{font-size:13px;line-height:1.5;margin:8px 0}#efGlassProtection[hidden]{display:none!important}@media(max-width:480px){#efGlassProtection{padding:12px}#efGlassProtection .ef-gp-choice{gap:9px;font-size:14px}#efGlassProtection .ef-gp-benefit,#efGlassProtection details{margin-left:29px}#efGlassProtection .ef-gp-price{font-size:15px}}</style><label class=\"ef-gp-choice\" for=\"efGlassProtectionCheck\"><input type=\"checkbox\" id=\"efGlassProtectionCheck\" aria-describedby=\"efGlassProtectionBenefit\"><span id=\"efGlassProtectionTitle\">Add Lifetime Glass Protection</span><span class=\"ef-gp-price\">+$99<small>one-time</small></span></label><p class=\"ef-gp-benefit\" id=\"efGlassProtectionBenefit\">Optional protection by ExceptionalFire for accidental and heat-related glass breakage during proper use. Replacement shipping included.</p><details><summary>Coverage details</summary><p>Your manufacturer’s warranty remains included whether or not you add this plan.</p><p>This ExceptionalFire plan covers replacement glass for accidental breakage and heat-related breakage during proper use, for the original purchaser for as long as they own the covered doors. Replacement shipping and claim handling are included. Frames, finishes and installation labor are not covered.</p><p>Always follow the manufacturer’s operating instructions, including whether doors must remain open while a fire is burning. This plan does not authorize use contrary to those instructions.</p><p>ExceptionalFire is responsible for this plan and any coverage beyond the manufacturer’s warranty. To request replacement glass, contact ExceptionalFire with your order number and photos of the damage. This plan supplements your existing manufacturer warranty.</p></details>";
    var notes = document.getElementById('efCfgNotes');
    var noteGroup = notes && notes.closest('.ef-cfg-group');
    if (noteGroup && noteGroup.parentNode === anchor.parentNode) {
      noteGroup.parentNode.insertBefore(card, noteGroup.nextSibling);
    } else {
      anchor.parentNode.insertBefore(card, anchor.nextSibling);
    }
    card.querySelector('input').addEventListener('change', function(e) { onChange(e.target.checked); });
    return card;
  }

  function heaDisplayAmount(key) {
    return Object.keys(surcharges).reduce(function(sum,k){return sum+((k===key || k.indexOf(key+'_balance_')===0)?surcharges[k].amount:0);},0);
  }

  /* EF_CERAMIC_AREA_20261020: opening dimensions, not estimated panel area. */
  function syncDoorMSRP(){msrpError=window.EFDoorMSRP.sync(msrpRule,root,selections,surcharges,parseMeasurement,groupData||{},{"1":"42831347941458","100":"42831347908690","10000":"42831347875922"});return msrpError;}
  function ceramicAreaEligible(){return ["design-specialties-brookfield-custom-fireplace-doors","cabot-fireplace-glass-door-for-masonry","black-rock-arch-masonry-fireplace-glass-doors","design-specialties-buckingham-arch-custom-fireplace-doors-masonry","design-specialties-legend-arch-custom-fireplace-doors-masonry","design-specialties-stiletto-custom-fireplace-doors","design-specialties-bungalow-custom-fireplace-doors","design-specialties-carolina-standard-custom-fireplace-doors-1","design-specialties-carolina-arched-and-window-pane-custom-fireplace-doors","design-specialties-carolina-arched-custom-fireplace-doors-2","design-specialties-carolina-sunrise-custom-fireplace-doors","design-specialties-oak-tree-custom-fireplace-doors","design-specialties-mantel-custom-fireplace-doors","design-specialties-napa-valley-custom-fireplace-doors","design-specialties-legend-odyssey-custom-fireplace-doors","design-specialties-original-moderne-custom-fireplace-doors-2","design-specialties-slim-moderne-custom-fireplace-doors-3","design-specialties-legend-standard-custom-fireplace-doors","banded-scroll-masonry-prefab-fireplace-glass-doors","design-specialties-craftsman-custom-fireplace-doors-1","design-specialties-madrid-custom-fireplace-doors-2","design-specialties-hammered-edge-standard-custom-fireplace-doors","design-specialties-black-rock-custom-fireplace-doors","design-specialties-apex-custom-fireplace-doors","design-specialties-reflection-custom-fireplace-doors","design-specialties-piccolo-custom-fireplace-doors","design-specialties-stiletto-cutback-custom-fireplace-doors","stainless-steel-masonry-fireplace-door","design-specialties-carolina-standard-custom-fireplace-doors-2","design-specialties-legend-odyssey-custom-fireplace-doors-1","bar-crafts-custom-fireplace-doors-6","old-world-arch-masonry-distressed-steel-fireplace-glass-doors","ardmore-flat-black-masonry-fireplace-door-sleek-modern-durable-design","armitage-flat-black-masonry-fireplace-door-sleek-modern-durable-design","grande-flat-black-masonry-fireplace-door-standard-sizes","reflection-flat-black-masonry-fireplace-door-standard-sizes","medio-flat-black-masonry-fireplace-door-standard-sizes","finley-flat-black-masonry-fireplace-door-standard-sizes","farnsworth-oil-rubbed-bronze-masonry-fireplace-door-standard-sizes","colt-flat-black-masonry-fireplace-door-standard-sizes","colt-gun-metal-masonry-fireplace-door-standard-sizes","alexander-natural-iron-masonry-fireplace-door-standard-sizes","brookfield-deluxe-magnetic-prefab-fireplace-glass-doors","medio-flat-black-masonry-fireplace-door-custom-size","carolina-traditional-steel-fireplace-glass-doors-masonry-prefab","legend-custom-masonry-prefab-fireplace-mesh-doors","milwaukee-forged-iron-masonry-prefab-fireplace-glass-doors","laguna-arch-pane-masonry-prefab-fireplace-glass-doors","savannah-masonry-prefab-fireplace-glass-doors","all-glass-steel-fireplace-glass-doors-masonry-prefab","design-specialties-hammered-edge-arch-custom-fireplace-doors-masonry"].indexOf(prodHandle)!==-1;}
  function ceramicAreaSelected(){return ceramicAreaEligible() && /ceramic/i.test(selections.glass||'');}
  function ceramicAreaCents(){return window.EFCeramicGlass.quote(parseMeasurement(selections._width||''),parseMeasurement(selections._height||''));}
  function syncCeramicArea(){
    if(!ceramicAreaEligible())return;
    Object.keys(surcharges).forEach(function(k){if(k.indexOf('glass_balance_')===0)delete surcharges[k];});
    var cents=ceramicAreaCents();
    if(ceramicAreaSelected()){
      delete surcharges.glass;
      if(cents!==null)Object.assign(surcharges,window.EFCeramicGlass.charges(cents,{"1":"42831346958418","100":"42831346925650","10000":"42831346892882"}));
    }
    root.querySelectorAll('[data-field="glass"]').forEach(function(card){
      if(!/ceramic/i.test(card.dataset.value||''))return;
      card.dataset.surcharge=cents===null?0:cents/100;
      var price=card.querySelector('.ef-cfg-card__price');
      if(price)price.textContent=cents===null?'$250/sq ft of opening':'+'+money(cents);
      card.setAttribute('aria-label','Ceramic glass, '+(cents===null?'$250 per square foot of opening':money(cents)));
    });
  }

  function updatePrice(measurementOnly) {
    syncDoorMSRP();
    syncCeramicArea();
    if (window.EFHammeredArch && groupData && groupData.heaPriceIds) window.EFHammeredArch.sync(root,selections,surcharges,parseMeasurement,groupData.heaPriceIds,groupData);

    syncGlassProtection();
    if(isOldWorldSlim){owsSync();updateATCState();}
    sanitizeTrifold();
    var linesEl = document.getElementById('efCfgPriceLines');
    /* Build the same receipt off-document. Measurement keystrokes usually stay
       in one price bracket; unchanged output must not replace live DOM nodes. */
    var nextLines = document.createElement('div');

    var total = basePrice;
    var displayBase = money(basePrice);

    // Base price line
    addPriceLine(nextLines, 'Base Price', displayBase, false);

    // Surcharges
    var keys = Object.keys(surcharges);
    if(ceramicAreaSelected())keys=keys.filter(function(k){return k.indexOf('glass_balance_')!==0;});
    if(msrpRule || groupData && groupData.heaPriceIds)keys=keys.filter(function(k){return k.indexOf('_balance_')<0;});
    keys.forEach(function(k) {
      var s = surcharges[k];
      if(ceramicAreaSelected() && k==='glass')s=Object.assign({},s,{amount:heaDisplayAmount(k)});
      if(msrpRule || groupData && groupData.heaPriceIds)s=Object.assign({},s,{amount:heaDisplayAmount(k)});
      if (s.amount > 0) {
        total += s.amount;
        var fieldLabel = formatFieldLabel(k);
        addPriceLine(nextLines, '+ ' + fieldLabel + ' (' + s.label + ')', '+' + money(s.amount), true);
      }
    });

    var receiptHTML = nextLines.innerHTML;
    if (linesEl.innerHTML !== receiptHTML) linesEl.innerHTML = receiptHTML;
    var totalText = money(total), _tpop = document.getElementById('efCfgTotalPrice');
    var priceChanged = _tpop && _tpop.textContent !== totalText;
    if (priceChanged) _tpop.textContent = totalText;

    /* Pulse only for an actual price change; never force layout per keystroke. */
    if (priceChanged && !measurementOnly && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      _tpop.classList.remove('ef-price-pop'); void _tpop.offsetWidth; _tpop.classList.add('ef-price-pop');
    }

    // Update main product price display on page
    var mainPrice = document.getElementById('ef-price-display');
    if (mainPrice && mainPrice.textContent !== totalText) mainPrice.textContent = totalText;

    // Update compare-at price — scale proportionally or hide if total exceeds it
    var compareEl = document.querySelector('.ef-pd-price-compare');
    var saveEl = document.querySelector('.ef-pd-price-save');
    if (compareEl) {
      var origCompare = (parseInt(document.getElementById('efCfg').dataset.comparePrice, 10) || 0);
      var origBase = basePrice;
      if (origCompare > 0 && origBase > 0) {
        // Scale compare-at proportionally: compare_ratio * total
        var ratio = origCompare / origBase;
        var glassPlanCents = surcharges.glass_protection ? surcharges.glass_protection.amount : 0;
        var scaledCompare = Math.round((total - glassPlanCents) * ratio / 100) * 100 + glassPlanCents;
        if (scaledCompare > total) {
          if (compareEl.textContent !== money(scaledCompare)) compareEl.textContent = money(scaledCompare);
          if (compareEl.style.display !== '') compareEl.style.display = '';
          /* 2026-05-11 — SAVE badge was static from Liquid (only base savings).
             Now sync with scaledCompare so badge = displayed_compare - total. */
          if (saveEl) {
            var saveText = 'Save ' + money(scaledCompare - total);
            if (saveEl.textContent !== saveText) saveEl.textContent = saveText;
            if (saveEl.style.display !== '') saveEl.style.display = '';
          }
        } else {
          // Compare would be less than total — hide it
          if (compareEl.style.display !== 'none') compareEl.style.display = 'none';
          if (saveEl && saveEl.style.display !== 'none') saveEl.style.display = 'none';
        }
      }
    }

    // Update ATC button text
    var atc = document.getElementById('efCfgATC');
    var atcText = 'Add to Cart \u2014 ' + totalText;
    if (atc && atc.textContent !== atcText) atc.textContent = atcText;

    // Review step price breakdown
    var reviewPB = document.getElementById('efCfgPriceBreakdownReview');
    if (reviewPB && reviewPB.innerHTML !== receiptHTML) reviewPB.innerHTML = receiptHTML;

    updateStepCTA();

    /* CRO 2026-04-29 \u2014 broadcast live price for ef-pd2-sticky-atc.js */
    try {
      var complete = _allSelectionsMade();
      /* Typing within one bracket carries no new price/completeness signal.
         Keep synchronous state and all non-measurement broadcasts unchanged. */
      if (!measurementOnly || !lastPriceSignal || lastPriceSignal.total !== total || lastPriceSignal.complete !== complete) {
        lastPriceSignal = { total: total, complete: complete };
        window.dispatchEvent(new CustomEvent('ef-cfg:price-changed', {
          detail: { totalCents: total, allSelectionsMade: complete }
        }));
      }
    } catch (_) {}

    /* EF FUNNEL: price ping (P-007) \u2014 throttled to max 1/s, additive only */
    try {
      var _efNowTs = Date.now();
      if (!window._efCfgPriceTs || (_efNowTs - window._efCfgPriceTs) >= 1000) {
        window._efCfgPriceTs = _efNowTs;
        efTrack('ef_cfg_price', { total: Math.round(total) / 100 });
      }
    } catch (e) {}

    /* Quick Ship single-page flow (cfg-standard + cfg-simple) \u2014 no showStep
       advance to re-enable the ATC after a selection, so refresh disabled
       state from here. Custom flows always allow ATC, so this is a no-op
       for them. */
    updateATCState();
  }

  function addPriceLine(container, label, value, isSurcharge) {
    var div = document.createElement('div');
    div.className = 'ef-cfg-price-line' + (isSurcharge ? ' ef-cfg-price-line--surcharge' : '');
    div.innerHTML = '<span>' + escHtml(label) + '</span><span class="ef-cfg-price-line__value">' + escHtml(value) + '</span>';
    container.appendChild(div);
  }

  function formatFieldLabel(key) {
    if(isOldWorldSlim && key==='finish')return 'Screen Finish';
    if(isOldWorldSlim && key==='size')return 'Finished Size';
    var map = {
      glass_protection: 'Glass Protection',
      size: 'Size',
      size_height: 'Height Increase',
      finish: 'Finish',
      fireplace_type: 'Fireplace Type',
      firebox_type: 'Firebox Type',
      fit_type: 'Fit Type',
      frame_width: 'Frame Width',
      door_fit: 'Door Fit Type',
      style_finish: 'Style Finish',
      hardware_finish: 'Hardware Finish',
      door_type: 'Door Type',
      side_panel: 'Tri-Fold Side Panels',
      handle: 'Handle',
      glass: 'Glass',
      mesh: 'Mesh Screen',
      draft_control: 'Draft Control',
      pattern: 'Pattern'
    };
    /* Extras are keyed extra_<slug> (multi-select). They all report as "Extra" so the price
       breakdown reads "+ Extra (Key Lock)" and the cart line item carries
       _option_type: "Extra". EF_STOLL_EXTRAS_20260829 */
    if (key.indexOf('extra_') === 0) return 'Extra';
    return map[key] || key.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
  }

  /* Human-readable selection value (e.g. hardware "__match__" → "Match Frame"). */
  function selValDisplay(field, v) {
    if (field === 'hardware_finish' && v === '__match__') return 'Match Frame';
    return v;
  }

  /* ────────────────────────────────────
     REVIEW STEP
     ──────────────────────────────────── */
  function buildReview() {
    syncDoorMSRP();
    syncCeramicArea();
    if (window.EFHammeredArch && groupData && groupData.heaPriceIds) window.EFHammeredArch.sync(root,selections,surcharges,parseMeasurement,groupData.heaPriceIds,groupData);

    syncGlassProtection();
    sanitizeTrifold();
    var grid = document.getElementById('efCfgReviewGrid');
    grid.innerHTML = '';

    // Fireplace Type (Step 1)
    if (selections.fireplace_type) {
      var sFP = surcharges.fireplace_type;
      addReviewItem(grid, 'Fireplace Type', selections.fireplace_type, msrpRule ? heaDisplayAmount('fireplace_type') : (sFP ? sFP.amount : 0));
    }
    if (selections.firebox_type) {
      var sFB = surcharges.firebox_type;
      addReviewItem(grid, 'Firebox Type', selections.firebox_type, sFB ? sFB.amount : 0);
    }

    // Measurements (Step 2)
    if (selections._width) {
      addReviewItem(grid, 'Width', selections._width + '"');
    }
    if (selections._height) {
      addReviewItem(grid, isArch ? 'Center Peak Height' : 'Height', selections._height + '"');
    }
    if (isArch && selections._side_height) {
      addReviewItem(grid, 'Side Height', selections._side_height + '"');
    }
    if (selections._frame_left) {
      addReviewItem(grid, 'Custom Frame Width', 'L:' + selections._frame_left + ' R:' + selections._frame_right + ' T:' + selections._frame_top + ' B:' + selections._frame_bottom);
    }
    if (selections.size) {
      var sPrice = (msrpRule || groupData && groupData.heaPriceIds) ? heaDisplayAmount("size") : (surcharges.size ? surcharges.size.amount : 0);
      addReviewItem(grid, 'Opening Size', selections.size, sPrice);
    }
    if (selections.simple_width) {
      var sW = surcharges.simple_width;
      addReviewItem(grid, 'Opening Width', selections.simple_width, msrpRule ? heaDisplayAmount('simple_width') : (sW ? sW.amount : 0));
    }
    if (selections.simple_height) {
      var sH = surcharges.simple_height;
      addReviewItem(grid, 'Opening Height', selections.simple_height, msrpRule ? heaDisplayAmount('simple_height') : (sH ? sH.amount : 0));
    }
    if (selections.variant) {
      addReviewItem(grid, 'Selected Variant', selections.variant);
    }

    // Remaining selections (Style, Finish, Glass)
    var order = ['fit_type','frame_width','door_fit','door_type','side_panel','feet','handle','pattern','style_finish','finish','door_finish','hardware_finish','glass','mesh','draft_control'];
    order.forEach(function(field) {
      if (!selections[field]) return;
      /* Hardware finish: show "Match Frame" for the included default, real color otherwise. */
      var val = (field === 'hardware_finish' && selections[field] === '__match__') ? 'Match Frame' : selections[field];
      var s = surcharges[field];
      addReviewItem(grid, formatFieldLabel(field), val, (msrpRule || groupData && groupData.heaPriceIds || ceramicAreaSelected() && field==='glass') ? heaDisplayAmount(field) : (s ? s.amount : 0));
    });

    /* Extras (EF_STOLL_EXTRAS_20260829) — one summary row listing every ticked add-on
       with their combined surcharge. */
    var _revExtras = efSelectedExtras();
    if (_revExtras.length) {
      var _exTotal = 0;
      _revExtras.forEach(function (e) { _exTotal += e.amount; });
      addReviewItem(grid, 'Extras', _revExtras.map(function (e) { return e.label; }).join(', '), _exTotal);
    }

    // Price breakdown
    updatePrice();
  }

  /* Map review labels to step indices for "Edit" links — varies by cfgType */
  var reviewStepMap;
  if (cfgType === 'cfg-standard') {
    reviewStepMap = { 'Selected Variant': 0, 'Size': 0, 'Opening Size': 0 };
  } else if (cfgType === 'cfg-simple') {
    reviewStepMap = { 'Opening Width': 0, 'Opening Height': 0 };
  } else {
    reviewStepMap = {
      'Fireplace Type': 0, 'Firebox Type': 0,
      'Width': 1, 'Height': 1, 'Opening Size': 1, 'Selected Variant': 1, 'Size': 1,
      'Fit Type': 2, 'Frame Width': 2, 'Door Fit Type': 2, 'Door Type': 2, 'Handle': 2, 'Pattern': 2,
      'Finish': 3, 'Screen Finish': 3, 'Frame Finish': 3, 'Working Door Finish': 3, 'Style Finish': 3, 'Hardware Finish': 3,
      'Glass': 4, 'Mesh': 4, 'Mesh Screen': 4, 'Draft Control': 4, 'Extras': 4
    };
  }

  /* Strip verbose descriptions — keep only the short label before separators */
  function shortenValue(val) {
    if (!val) return '';
    /* Remove everything after common separators: " — ", " – ", " - ", " · " */
    val = val.split(/\s[—–\-]\s/)[0];
    /* Trim "Only" suffix */
    val = val.replace(/\s+Only$/i, '');
    return val.trim();
  }

  function addReviewItem(container, label, value, surchargeAmount) {
    if(trifoldRule){var names={'Width':'Center panel width','Height':'Screen height','Opening Size':'Size tier','Tri-Fold Side Panels':'Each side panel'};if(names[label]){label=names[label];reviewStepMap[label]=1;}if(label==='Each side panel')value=value+' each';}
    var div = document.createElement('div');
    div.className = 'ef-cfg-review-item';
    var shortVal = shortenValue(value);
    /* Visual chip (2026-05-30): show the selected option's image / finish swatch next to
       each row — turns the text summary into a luxury spec sheet. Fully defensive: if no
       image is found the row renders exactly as before. Reads from the rendered (possibly
       hidden) option cards/swatches via their aria-checked state. */
    var THUMB_SEL = {'Fireplace Type':'[data-group="fireplace_type"]','Firebox Type':'[data-group="firebox_type"]','Fit Type':'[data-group="fit_type"]','Door Type':'[data-group="door_type"]','Handle':'[data-group="handle"]','Hardware Finish':'#efCfgHardwareGrid','Glass':'[data-group="glass"]','Mesh':'[data-group="mesh"]','Mesh Screen':'[data-group="mesh"]','Draft Control':'[data-group="draft_control"]'};
    var thumbHtml = '';
    function _efChip(bgImg, bgColor){
      /* style.backgroundImage returns url("...") with DOUBLE quotes — swap to single so it
         doesn't break the double-quoted style="" attribute (this was the empty-chip bug). */
      if (bgImg && bgImg !== 'none') return '<span class="ef-cfg-review-item__thumb" style="background-image:' + bgImg.replace(/"/g, "'") + '"></span>';
      if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') return '<span class="ef-cfg-review-item__thumb ef-cfg-review-item__thumb--color" style="background:' + bgColor + '"></span>';
      return '';
    }
    try {
      if (label === 'Finish' || label === 'Style Finish') {
        /* Primary source: the appearance captured at selection time onto #efCfg[data-finish-chip]
           (robust against grid re-renders / image-less finishes). */
        var _fc = ''; try { var _efRt = document.getElementById('efCfg'); _fc = (label === 'Finish' && _efRt) ? (_efRt.dataset.finishChip || '') : ''; } catch (e) {}
        if (_fc) { thumbHtml = (_fc.indexOf('url(') === 0) ? _efChip(_fc, '') : _efChip('', _fc); }
        /* Fallback: preview swatch mirrors the selected finish image; then grid swatch + computed. */
        var _pv = thumbHtml ? null : document.getElementById(label === 'Style Finish' ? 'efCfgStyleFinishPreviewSwatch' : 'efCfgFinishPreviewSwatch');
        var _gc = document.querySelector((label === 'Style Finish' ? '#efCfgStyleFinishGrid' : '#efCfgSwatchGrid') + ' .ef-cfg-swatch[aria-checked="true"] .ef-cfg-swatch__circle');
        var _bgi = (_pv && _pv.style.backgroundImage) || (_gc && _gc.style.backgroundImage) || '';
        var _bgc = '';
        if (!_bgi || _bgi === 'none') {
          var _src = _gc || _pv;
          if (_src) { var _cs = getComputedStyle(_src); _bgi = _cs.backgroundImage; _bgc = _cs.backgroundColor; }
        }
        if (!thumbHtml) thumbHtml = _efChip(_bgi, _bgc);
      } else {
        var _csel = THUMB_SEL[label];
        if (_csel) {
          var _grp = document.querySelector(_csel);
          var _sel = _grp && _grp.querySelector('.ef-cfg-card[aria-checked="true"], .ef-cfg-swatch[aria-checked="true"]');
          if (_sel) {
            var _im = _sel.querySelector('img');
            if (_im && _im.getAttribute('src')) {
              thumbHtml = '<span class="ef-cfg-review-item__thumb" style="background-image:url(\'' + _im.getAttribute('src').replace(/'/g, '%27') + '\')"></span>';
            } else {
              var _c = _sel.querySelector('.ef-cfg-swatch__circle');
              if (_c) { var _cs2 = getComputedStyle(_c); thumbHtml = _efChip(_c.style.backgroundImage || _cs2.backgroundImage, _c.style.backgroundColor || _cs2.backgroundColor); }
            }
          }
        }
      }
    } catch (e) {}
    if (!thumbHtml) thumbHtml = '<span class="ef-cfg-review-item__thumb ef-cfg-review-item__thumb--spacer" aria-hidden="true"></span>';
    var html = thumbHtml + '<span class="ef-cfg-review-item__label">' + escHtml(label) + '</span>';
    html += '<span class="ef-cfg-review-item__value">' + escHtml(shortVal) + '</span>';
    if (surchargeAmount && surchargeAmount > 0) {
      html += '<span class="ef-cfg-review-item__price">+' + money(surchargeAmount) + '</span>';
    }
    var stepIdx = reviewStepMap[label];
    if (stepIdx !== undefined) {
      /* Bronze sentence-case "Edit" text link (typography-spec rec). aria-label
         disambiguates 10 identical links for SR users (a11y rec). */
      var ariaLabel = 'Edit ' + label.toLowerCase();
      html += '<a href="#" class="ef-cfg-review-item__edit" data-edit-step="' + stepIdx + '" aria-label="' + escHtml(ariaLabel) + '">Edit</a>';
    }
    div.innerHTML = html;
    container.appendChild(div);
  }

  /* ────────────────────────────────────
     NAVIGATION
     ──────────────────────────────────── */
  function goToStep(idx) { showStep(idx); }

  /* 2026-05-06 — Expose validate-and-advance helper for sticky ATC.
     Sticky ATC click in locked state should:
       1. Validate current step (highlights missing required fields w/ red outline + msg)
       2. If valid → advance to next step
       3. If invalid → user sees red borders + "Please make a selection" (no advance)
     Returns: 'advanced' | 'highlighted' | 'unlocked' (when on last step + valid). */
  window.efCfgValidateAndAdvance = function() {
    if (!validateStep(curStep)) return 'highlighted';
    /* Find next visible step */
    var next = curStep + 1;
    while (next < stepNames.length && _isSkippedStep(next)) next++;
    if (next >= stepNames.length) return 'unlocked';
    goToStep(next);
    return 'advanced';
  };

  function showStep(idx, opts) {
    curStep = idx;
    refreshRecessDepthGuidance();
    /* EF FUNNEL: step view (P-007) — additive emission only */
    try {
      efTrack('ef_cfg_step_view', {
        step_index: idx,
        step_name: stepNames[idx] || ('step-' + idx)
      });
    } catch (e) {}
    // Hide all steps
    root.querySelectorAll('.ef-cfg-step').forEach(function(s) { s.classList.remove('is-visible'); });
    // Hide swatch popup left over from finish selection — without this, the
    // selected-finish popup persists onto next step (Glass / Review etc) on
    // every device, looking like a stuck overlay. Bug reported 2026-04-28.
    var _swatchPopup = document.getElementById('efCfgSwatchPopup');
    if (_swatchPopup) _swatchPopup.classList.remove('is-visible');

    // Lazy-load heavy scripts as needed
    if (idx >= 1 && typeof efLoadScript === 'function') {
      efLoadScript(document.getElementById('efCfg').dataset.imagesUrl, 'efCfgImagesLoaded');
    }
    if (idx === totalSteps - 1 && typeof efLoadScript === 'function') {
      efLoadScript(document.getElementById('efCfg').dataset.surchargesUrl, 'efCfgSurchargesLoaded');
    }

    // Show current.
    // Single-page types (cfg-standard + cfg-simple) collapsed step 0 + review
    // into one view — no efCfgStepReview exists for them, render step 0 always.
    var stepEl;
    var _isSinglePage = (cfgType === 'cfg-standard' || cfgType === 'cfg-simple');
    if (idx === totalSteps - 1 && !_isSinglePage) {
      stepEl = document.getElementById('efCfgStepReview');
      buildReview();
    } else {
      stepEl = document.getElementById('efCfgStep' + idx);
    }
    if (stepEl) stepEl.classList.add('is-visible');

    if (typeof window._efUpdateFrameSvg === 'function') window._efUpdateFrameSvg();

    // Update eyebrow text "STEP X OF Y" (adjust for skipped steps)
    var _displayTotal = totalSteps - _totalSkipped();
    var _displayIdx = idx + 1 - _skippedBefore(idx);
    var eyebrow = stepEl ? stepEl.querySelector('.ef-cfg-step__eyebrow') : null;
    if (eyebrow) eyebrow.textContent = 'Step ' + _displayIdx + ' of ' + _displayTotal;

    updateProgress();

    // Update progressbar aria-valuenow
    var progNav = document.getElementById('efCfgProgress');
    if (progNav) progNav.setAttribute('aria-valuenow', _displayIdx);

    // Announce step change to screen readers
    var announcement = document.getElementById('ef-step-announcement');
    if (announcement) announcement.textContent = 'Step ' + _displayIdx + ' of ' + _displayTotal + ': ' + (stepNames[idx] || '');

    // Nav buttons
    var backBtn = document.getElementById('efCfgBack');
    var nextBtn = document.getElementById('efCfgNext');
    var quoteBtn = document.getElementById('ef-quote-trigger');
    var prevVisIdx = idx - 1;
    while (prevVisIdx >= 0 && _isSkippedStep(prevVisIdx)) prevVisIdx--;
    backBtn.style.display = (prevVisIdx < 0) ? 'none' : '';

    var atcBtn = document.getElementById('efCfgATC');
    var navWrap = document.getElementById('efCfgNav');
    /* Review-step extras: A2 More Payment Options + A3 Express Checkout +
       A1 money-back guarantee. Hidden via [hidden] attr on non-review steps. */
    var reviewExtras = document.getElementById('efCfgReviewExtras');
    if (idx === totalSteps - 1) {
      nextBtn.style.display = 'none';
      if (quoteBtn) quoteBtn.style.display = 'none';
      if (atcBtn) { atcBtn.style.display = ''; atcBtn.textContent = 'Add to Cart \u2014 ' + money(calcTotal()); }
      if (navWrap) navWrap.classList.add('is-review-step');
      if (reviewExtras) reviewExtras.hidden = false;
    } else {
      nextBtn.style.display = '';
      if (quoteBtn) quoteBtn.style.display = '';
      var nextVisIdx = idx + 1;
      while (nextVisIdx < totalSteps && _isSkippedStep(nextVisIdx)) nextVisIdx++;
      var nextStepName = stepNames[nextVisIdx] || '';
      /* Desktop: full "Next: Measurements" label. Mobile: just step name + arrow
         (was truncating on 375px viewport). 2026-05-03 — dual span swap. */
      nextBtn.innerHTML = '<span class="ef-desktop-only">Next: ' + nextStepName + '</span><span class="ef-mobile-only">' + nextStepName + '</span> <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>';
      if (atcBtn) atcBtn.style.display = 'none';
      if (navWrap) navWrap.classList.remove('is-review-step');
      if (reviewExtras) reviewExtras.hidden = true;
    }

    /* Helper line rotation \u2014 copy specialist consensus 2026-05-03 (technical
       + CRO copywriters both rejected poetic Cormorant italic in favor of
       sentence-case Inter as "system hint" register the technical buyer trusts).
       Each line addresses a specific anxiety/signal for that step's decision. */
    var helperEl = document.getElementById('efCfgNavHelper');
    if (helperEl) {
      /* REVIEW-9 §4 / T-CFG4 2026-08-31 — copy only, no behaviour. Four of the six beats
         printed a claim that was already on the same screen, or was not true as written:

           beat 1 (Measurements)  verbatim duplicate of the precision strip ~300 px above
                                  it; "Expert review before building." was measured
                                  painting TWICE on this step (census expertReviewCount:2).
                                  Both facts now appear once, above the fields.
           beat 2 (Door Style)    PROMOTED into the fit group, above the two cards it
                                  decides, instead of under the Next button where it was
                                  printed after the choice had been made.
           beat 4 (Glass)         glass spec + lead time are already stated twice in the
                                  buy column (T-CFG3B §5).
           beat 5 (Review)        "A real person reviews every order before production."
                                  asserts a universal pre-production check. The Perfect Fit
                                  Guarantee page promises it only where EF has verified the
                                  measurements. Deleted rather than re-worded — the one
                                  surviving claim is the gate-phrased line on step 2.

         Beat 0 stays: it is a contract about length and reversibility, stated before the
         buyer commits. Beat 3 stays: free samples before we cut metal is a fact.
         An empty beat paints nothing — #efCfgNavHelper:empty in efx-configurator.css. */
      var helperBeats = [
        '3 min \u00b7 6 steps \u00b7 save anytime',                              /* attribution + reversibility */
        '',
        '',
        'Compare finish samples in your room before choosing.',                          /* color-confidence proof */
        '',
        ''
      ];
      /* '|| helperBeats[0]' would have re-printed beat 0 into every emptied slot, so an
         empty beat now has to be told apart from a missing one. */
      var _hb = helperBeats[Math.min(idx, helperBeats.length - 1)];
      helperEl.textContent = (typeof _hb === 'string') ? _hb : helperBeats[0];
    }

    /* ROUND 5 (2026-04-29) \u2014 Update simple stepbar (Step X of Y \u2014 Name + Next + segmented bar).
       Reuses _displayIdx / _displayTotal / stepNames already computed above (~line 2730).
       Bar uses segmented bronze treatment matching .ef-cfg-strip \u2014 premium, tactile,
       buyer counts progress without reading text. */
    var sbPos  = document.getElementById('efPd2StepPos');
    var sbName = document.getElementById('efPd2StepName');
    var sbNext = document.getElementById('efPd2StepNext');
    var sbBar  = document.getElementById('efPd2Stepbar');
    if (sbPos)  sbPos.textContent  = 'Step ' + _displayIdx + ' of ' + _displayTotal;
    if (sbName) sbName.textContent = stepNames[idx] || '';
    if (sbNext) {
      if (idx === totalSteps - 1) {
        sbNext.innerHTML = '<span class="ef-pd2-stepbar__ready">\u2713 Ready to checkout</span>';
      } else {
        var _nbVisIdx = idx + 1;
        while (_nbVisIdx < totalSteps && _isSkippedStep(_nbVisIdx)) _nbVisIdx++;
        sbNext.textContent = 'Next: ' + (stepNames[_nbVisIdx] || '');
      }
    }
    /* Sync segmented bar \u2014 same logic as luxury strip:
       segments before _displayIdx-1 = .is-done, segment at _displayIdx-1 = .is-active. */
    var sbSegs = document.querySelectorAll('#efPd2StepBarTrack .ef-pd2-stepbar__seg');
    sbSegs.forEach(function(seg, sIdx) {
      seg.classList.remove('is-done', 'is-active');
      if (sIdx < _displayIdx - 1) seg.classList.add('is-done');
      else if (sIdx === _displayIdx - 1) seg.classList.add('is-active');
    });
    if (sbBar) sbBar.classList.toggle('is-final', idx === totalSteps - 1);

    // Enable/disable ATC
    updateATCState();
    updateStepCTA();

    /* Old sticky bar toggling (#efStickyATC + #ef-sticky-atc) removed 2026-04-29.
       Both legacy bars only showed on the last step; replaced by the new always-visible
       dark 3-state sticky bar (#efPd2Sticky). The new bar reads state via the
       'ef-cfg:state-changed' / 'ef-cfg:price-changed' events dispatched below. */

    // Scroll to top of configurator (skip on initial page load — keep user at gallery)
    if (!opts || !opts.skipScroll) {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* CRO 2026-04-29 — broadcast state for ef-pd2-sticky-atc.js (read-only listener).
       NOTE: do NOT call validateStep() here — it has side effects (scrolls, sets
       red outlines, injects "Please make a selection" error UI). Sticky bar uses
       realAtc.disabled instead. */
    try {
      window.dispatchEvent(new CustomEvent('ef-cfg:state-changed', {
        detail: {
          curStep: idx,
          totalSteps: totalSteps,
          totalSkipped: _totalSkipped(),
          isLast: (idx === totalSteps - 1),
          totalCents: calcTotal(),
          cfgType: cfgType,
          /* 2026-05-06 — sticky ATC unlocks on this flag, not on review-step position. */
          allSelectionsMade: _allSelectionsMade()
        }
      }));
    } catch (_) {}
  }

  function updateATCState() {
    if(msrpRule && syncDoorMSRP()){var quoteAtc=document.getElementById('efCfgATC');if(quoteAtc){quoteAtc.disabled=true;quoteAtc.textContent='Contact us for a quote';}return;}
    if(isOldWorldSlim){var slimAtc=document.getElementById('efCfgATC');if(slimAtc)slimAtc.disabled=!!owsBuildCart().error;return;}
    var atc = document.getElementById('efCfgATC');
    if (!atc) return;
    if (cfgType === 'cfg-standard') {
      atc.disabled = !selections.variant;
    } else if (cfgType === 'cfg-simple') {
      atc.disabled = !selections.simple_width || !selections.simple_height;
    } else {
      // For custom types, always allow (user chose what they wanted)
      atc.disabled = false;
    }
  }

  function nextVisibleStep(from, dir) {
    var s = from + dir;
    while (s >= 0 && s < totalSteps) {
      if (_isSkippedStep(s)) { s += dir; continue; }
      return s;
    }
    return from;
  }

  document.getElementById('efCfgNext').addEventListener('click', function() {
    if (curStep < totalSteps - 1) {
      if (validateStep(curStep)) {
        showStep(nextVisibleStep(curStep, 1));
      }
    }
  });

  /* ────────────────────────────────────
     PASSIVE COMPLETENESS CHECK (2026-05-06)
     Returns true when every required selection has been made — regardless of
     which step the user is currently viewing. Used by the sticky ATC bar so it
     unlocks based on selections rather than navigation position. NO side effects
     (no scrolls, no red outlines, no DOM mutations).
     ──────────────────────────────────── */
  function _allSelectionsMade() {
    if(syncDoorMSRP())return false;
    if(ceramicAreaSelected() && ceramicAreaCents()===null)return false;
    if(isOldWorldSlim)return !owsBuildCart().error;
    if (trifoldRule) return !!(trifoldDimensionsReady() && selections.finish && trifoldWingsReady());
    if (cfgType === 'cfg-standard') return !!selections.variant;
    if (cfgType === 'cfg-simple')   return !!(selections.simple_width && selections.simple_height);
    /* cfg-custom* / cfg-arch flow */
    /* Measurements: standard-size dropdowns OR W/H inputs OR Brookfield Deluxe 6 inputs */
    if (groupData && groupData.standard_size) {
      var stdW = document.getElementById('efCfgStdWidth');
      var stdH = document.getElementById('efCfgStdHeight');
      if (!stdW || !stdW.value || !stdH || !stdH.value) return false;
    } else if (matchedGroup === 'Fireplace Doors - Brookfield Deluxe') {
      var ids = ['efCfgDeluxeOverallW','efCfgDeluxeOverallH','efCfgDeluxeOpeningW',
                 'efCfgDeluxeOpeningH','efCfgDeluxeTopOffset','efCfgDeluxeBottomOffset'];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (!el || !String(el.value || '').trim()) return false;
      }
    } else {
      if (!selections._width || !selections._height) return false;
    }
    if (!(selections.door_type || selections.fit_type)) return false;
    if (!selections.finish) return false;
    if (!(selections.glass || selections.mesh)) return false;
    if (cfgType === 'cfg-custom-full' || cfgType === 'cfg-custom-premium') {
      if (!selections.draft_control) return false;
    }
    if (cfgType === 'cfg-custom-premium') {
      if (!selections.frame_width) return false;
    }
    return true;
  }

  /* ────────────────────────────────────
     VALIDATION
     ──────────────────────────────────── */
  /* Presentation only: mirror validateStep's existing requirements without its
     error, focus or navigation side effects. Optional extras remain optional. */
  function missingStepLabel(stepIdx) {
    if(isOldWorldSlim){if(stepIdx===1)return owsMeasure().error?'Enter a valid published screen size':'';if(stepIdx===3)return !selections.finish?'Choose screen finish':'';if(stepIdx===4)return !selections.mesh?'Choose mesh':'';}
    function empty(id) { var field = document.getElementById(id); return field && !String(field.value || '').trim(); }
    if (stepIdx === 0 && cfgType === 'cfg-standard') return empty('efCfgVariantSelect') ? 'Choose your size' : '';
    if (stepIdx === 0 && cfgType === 'cfg-simple') {
      return empty('efCfgSimpleWidth') ? 'Choose your width' : empty('efCfgSimpleHeight') ? 'Choose your height' : '';
    }
    if (stepIdx === 1 && cfgType !== 'cfg-standard' && cfgType !== 'cfg-simple') {
      if (groupData && groupData.standard_size) return empty('efCfgStdWidth') ? 'Choose your width' : empty('efCfgStdHeight') ? 'Choose your height' : '';
      if (matchedGroup === 'Fireplace Doors - Brookfield Deluxe') {
        var measurements = [['efCfgDeluxeOverallW','overall width'],['efCfgDeluxeOverallH','overall height'],['efCfgDeluxeOpeningW','opening width'],['efCfgDeluxeOpeningH','opening height'],['efCfgDeluxeTopOffset','top offset'],['efCfgDeluxeBottomOffset','bottom offset']];
        for (var d = 0; d < measurements.length; d++) if (empty(measurements[d][0])) return 'Enter your ' + measurements[d][1];
        return '';
      }
      if(trifoldRule && !empty('efCfgWidth') && !empty('efCfgHeight') && !trifoldDimensionsReady())return 'Enter valid panel dimensions';
      if (trifoldRule && !trifoldWingsReady() && !empty('efCfgWidth') && !empty('efCfgHeight')) return 'Choose each side width';
      return empty('efCfgWidth') ? 'Enter your width' : empty('efCfgHeight') ? (isArch ? 'Enter your peak height' : 'Enter your height') : '';
    }
    if (stepIdx === 3 && cfgType !== 'cfg-standard' && cfgType !== 'cfg-simple' && !selections.finish) return 'Choose your finish';
    var step = document.getElementById('efCfgStep' + stepIdx);
    if (!step) return '';
    var labels = {fireplace_type:'fireplace type',firebox_type:'firebox type',fit_type:'fit',frame_width:'frame width',door_type:cfgType === 'cfg-screen' ? 'screen style' : 'door style',side_panel:'side panel',feet:'feet',handle:'handle',pattern:'pattern',glass:'glass',mesh:'mesh',draft_control:'draft control',finish:'finish'};
    var groups = step.querySelectorAll('.ef-cfg-group');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i], name = group.dataset.group || '';
      if (group.style.display === 'none' || group.classList.contains('ef-cfg-group--disabled') || name === 'extras') continue;
      var grid = group.querySelector('.ef-cfg-group__grid');
      if (grid && grid.children.length && !grid.querySelector('[aria-checked="true"]')) return 'Choose your ' + (labels[name] || formatFieldLabel(name).toLowerCase());
      if ((name === 'finish' || group.querySelector('.ef-cfg-swatch-grid')) && !selections.finish) return 'Choose your finish';
    }
    return '';
  }

  function updateStepCTA() {
    var next = document.getElementById('efCfgNext'), single = cfgType === 'cfg-standard' || cfgType === 'cfg-simple';
    var target = single ? document.getElementById('efCfgATC') : next;
    if (!target || (!single && curStep === totalSteps - 1)) return;
    if (target.getAttribute('aria-busy') === 'true' || /\b(adding|processing|sold\s*out|unavailable|added)\b/i.test(target.textContent)) return;
    var missing = missingStepLabel(curStep), label = missing;
    if (!label && !single) label = 'Next: ' + (stepNames[nextVisibleStep(curStep, 1)] || 'Review');
    var old = target.getAttribute('data-ef-next-label') || '';
    if (label) {
      if (old !== label) target.setAttribute('data-ef-next-label', label);
      if (target.getAttribute('aria-label') !== label) target.setAttribute('aria-label', label);
      var expected = document.createElement('span'); expected.textContent = label;
      var html = expected.outerHTML + (single ? '' : ' <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"></polyline></svg>');
      if (target.innerHTML !== html) target.innerHTML = html;
    } else {
      target.removeAttribute('data-ef-next-label');
      target.removeAttribute('aria-label');
    }
    if (old !== label) window.dispatchEvent(new CustomEvent('ef-cfg:cta-changed'));
  }
  var stepCTAScheduled = false;
  function scheduleStepCTA() {
    if (stepCTAScheduled) return;
    stepCTAScheduled = true;
    requestAnimationFrame(function() { stepCTAScheduled = false; updateStepCTA(); });
  }
  root.addEventListener('input', scheduleStepCTA);
  root.addEventListener('change', scheduleStepCTA);

  function validateStep(stepIdx) {
    if(isOldWorldSlim){var message=missingStepLabel(stepIdx);if(message){var err=document.getElementById('efOwsWizardError');if(err){err.textContent=message;err.hidden=false;}return false;}var error=document.getElementById('efOwsWizardError');if(error)error.hidden=true;if(stepIdx===1||stepIdx===3||stepIdx===4)return true;}
    sanitizeTrifold();
    if(trifoldRule && stepIdx===1 && !trifoldDimensionsReady()){document.getElementById('efCfgWidth').focus();return false;}
    if (trifoldRule && stepIdx === 1 && !trifoldWingsReady()) { showTrifoldWingError(); return false; }
    /* Step 0: Fireplace Type — need fireplace_type + firebox_type (or variant for cfg-standard) */
    if (stepIdx === 0) {
      if (cfgType === 'cfg-standard') {
        var sel = document.getElementById('efCfgVariantSelect');
        if (sel && !sel.value) {
          sel.style.borderColor = '#C0533A';
          sel.focus();
          return false;
        }
        return true;
      }
      if (cfgType === 'cfg-simple') {
        var wSel = document.getElementById('efCfgSimpleWidth');
        var hSel = document.getElementById('efCfgSimpleHeight');
        if (wSel && !wSel.value) {
          wSel.style.borderColor = '#C0533A';
          wSel.focus();
          return false;
        }
        if (hSel && !hSel.value) {
          hSel.style.borderColor = '#C0533A';
          hSel.focus();
          return false;
        }
        return true;
      }
      /* For custom types: validate card groups in step 0 (falls through to generic card validation below) */
    }

    /* Measurements validation — Step 1 for custom types */
    var isMeasureStep = (stepIdx === 1 && cfgType !== 'cfg-standard' && cfgType !== 'cfg-simple');
    if (isMeasureStep) {
      /* Standard-size mode (Columbia + future width-tier products): validate
         the two dropdowns, not the hidden W/H text inputs. */
      if (groupData && groupData.standard_size) {
        var stdWSel = document.getElementById('efCfgStdWidth');
        var stdHSel = document.getElementById('efCfgStdHeight');
        if (stdWSel && !stdWSel.value) {
          stdWSel.style.borderColor = '#C0533A';
          stdWSel.focus();
          return false;
        }
        if (stdHSel && !stdHSel.value) {
          stdHSel.style.borderColor = '#C0533A';
          stdHSel.focus();
          return false;
        }
        return true;
      }
      /* Brookfield Deluxe — validate the 6 measurement inputs instead of the
         hidden default width/height. */
      if (matchedGroup === 'Fireplace Doors - Brookfield Deluxe') {
        var deluxeIds = ['efCfgDeluxeOverallW', 'efCfgDeluxeOverallH', 'efCfgDeluxeOpeningW',
                         'efCfgDeluxeOpeningH', 'efCfgDeluxeTopOffset', 'efCfgDeluxeBottomOffset'];
        for (var di = 0; di < deluxeIds.length; di++) {
          var dEl = document.getElementById(deluxeIds[di]);
          if (dEl && !String(dEl.value || '').trim()) {
            dEl.style.borderColor = '#C0533A';
            dEl.focus();
            return false;
          }
        }
        return true;
      }
      var wEl = document.getElementById('efCfgWidth');
      var hEl = document.getElementById('efCfgHeight');
      if (wEl && hEl && (!wEl.value.trim() || !hEl.value.trim())) {
        if (!wEl.value.trim()) { wEl.style.borderColor = '#C0533A'; wEl.focus(); }
        else { hEl.style.borderColor = '#C0533A'; hEl.focus(); }
        return false;
      }
      return true;
    }

    /* 2026-05-06 — Step 3 Finish: swatch grid is NOT wrapped in .ef-cfg-group,
       so the generic loop below skips it. Explicit selections.finish check here
       prevents user from advancing without picking a finish swatch. */
    if (stepIdx === 3 && cfgType !== 'cfg-standard' && cfgType !== 'cfg-simple') {
      if (!selections.finish) {
        var swatchGridEl = document.getElementById('efCfgSwatchGrid');
        if (swatchGridEl) {
          swatchGridEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          swatchGridEl.style.outline = '2px solid #C0533A';
          swatchGridEl.style.outlineOffset = '4px';
          swatchGridEl.style.borderRadius = '8px';
          setTimeout(function() {
            swatchGridEl.style.outline = '';
            swatchGridEl.style.outlineOffset = '';
          }, 3000);
          /* Show "Please make a selection" near the title */
          var subtitle = document.querySelector('#efCfgStep3 .ef-cfg-step__subtitle');
          var errId = 'efCfgErr_finish';
          if (subtitle && !document.getElementById(errId)) {
            var err = document.createElement('div');
            err.id = errId;
            err.style.cssText = 'color:#C0533A;font-size:12px;margin-top:6px;font-weight:500;';
            err.textContent = 'Please make a selection';
            subtitle.after(err);
            setTimeout(function() { var e = document.getElementById(errId); if (e) e.remove(); }, 4000);
          }
        }
        return false;
      }
    }

    /* Steps 1-4: check required card/swatch selections */
    var stepEl = document.getElementById('efCfgStep' + stepIdx);
    if (!stepEl) return true;

    var groups = stepEl.querySelectorAll('.ef-cfg-group');
    for (var i = 0; i < groups.length; i++) {
      var grp = groups[i];
      /* Skip hidden groups */
      if (grp.style.display === 'none') continue;
      /* Skip disabled groups (e.g. mesh dimmed when glass = Replace with Mesh) — no selection required */
      if (grp.classList.contains('ef-cfg-group--disabled')) continue;
      /* Extras (EF_STOLL_EXTRAS_20260829) are an optional multi-select — never required,
         so they must never block Next / Add to Cart. */
      if (grp.dataset.group === 'extras') continue;
      var groupName = grp.dataset.group || '';

      /* Check if group has any rendered options */
      var grid = grp.querySelector('.ef-cfg-group__grid');
      var hasCards = grid && grid.children.length > 0;
      var hasSwatches = grp.querySelector('.ef-cfg-swatch-grid');

      if (hasCards) {
        var selected = grid.querySelector('[aria-checked="true"]');
        if (!selected) {
          /* Scroll to this group and highlight */
          grp.scrollIntoView({ behavior: 'smooth', block: 'center' });
          grid.style.outline = '2px solid #C0533A';
          grid.style.outlineOffset = '4px';
          grid.style.borderRadius = '8px';
          setTimeout(function() { grid.style.outline = ''; grid.style.outlineOffset = ''; }, 3000);

          /* Show error message */
          var label = grp.querySelector('.ef-cfg-group__label');
          var errId = 'efCfgErr_' + groupName;
          var existing = document.getElementById(errId);
          if (!existing) {
            var err = document.createElement('div');
            err.id = errId;
            err.style.cssText = 'color:#C0533A;font-size:12px;margin-top:6px;font-weight:500;';
            err.textContent = 'Please make a selection';
            if (label) label.after(err);
          }
          setTimeout(function() { var e = document.getElementById(errId); if (e) e.remove(); }, 4000);
          return false;
        }
      }

      /* Finish step: check if swatch selected */
      if (groupName === 'finish' || hasSwatches) {
        if (!selections.finish) {
          grp.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var swatchGrid = grp.querySelector('.ef-cfg-swatch-grid');
          if (swatchGrid) {
            swatchGrid.style.outline = '2px solid #C0533A';
            swatchGrid.style.outlineOffset = '4px';
            setTimeout(function() { swatchGrid.style.outline = ''; }, 3000);
          }
          return false;
        }
      }
    }
    return true;
  }

  /* Clear error styling on input */
  var wInput = document.getElementById('efCfgWidth');
  var hInput = document.getElementById('efCfgHeight');
  if (wInput) wInput.addEventListener('input', function() { wInput.style.borderColor = ''; });
  if (hInput) hInput.addEventListener('input', function() { hInput.style.borderColor = ''; });

  document.getElementById('efCfgBack').addEventListener('click', function() {
    if (curStep > 0) showStep(nextVisibleStep(curStep, -1));
  });

  /* ────────────────────────────────────
     FILE UPLOAD
     ──────────────────────────────────── */
  (function() {
    var zone = document.getElementById('efCfgUpload'), input = document.getElementById('efCfgFileInput');
    if (!zone || !input) return;
    // Explicit extensions keep HEIC selectable when the OS has no MIME mapping.
    zone.querySelectorAll('input[type="file"]').forEach(function(field) {
      field.setAttribute('accept', 'image/jpeg,image/png,image/webp,image/heic,image/heif,.jpg,.jpeg,.png,.webp,.heic,.heif');
    });
    input.addEventListener('change', function() {
      var mirrored = !!window.__efCfgMirroring;
      Array.prototype.slice.call(input.files || []).slice(0, mirrored ? 1 : 3).forEach(function(file) { uploadPhoto(file, mirrored ? 0 : efNextPhotoSlot()); });
      input.value = '';
    });
    zone.querySelectorAll('[data-ef-photo-slot]').forEach(function(card) {
      var slot = Number(card.getAttribute('data-ef-photo-slot')), picker = card.querySelector('[data-photo-input]'), camera = card.querySelector('[data-photo-camera-input]');
      card.querySelector('[data-photo-browse]').addEventListener('click', function() { picker.click(); });
      card.querySelector('[data-photo-camera]').addEventListener('click', function() { camera.click(); });
      [picker, camera].forEach(function(field) { field.addEventListener('change', function() {
          var chosen = Array.prototype.slice.call(field.files || []);
          if (slot === 0 && field.multiple) chosen.slice(0, EF_PHOTO_SLOTS).forEach(function(file, index){ uploadPhoto(file, index); });
          else if (chosen[0]) uploadPhoto(chosen[0], slot);
          field.value = '';
        }); });
      card.querySelector('[data-photo-remove]').addEventListener('click', function() { removePhoto(slot); });
      card.addEventListener('dragover', function(e) { e.preventDefault(); card.classList.add('is-dragover'); });
      card.addEventListener('dragleave', function() { card.classList.remove('is-dragover'); });
      card.addEventListener('drop', function(e) { e.preventDefault(); card.classList.remove('is-dragover'); if (e.dataTransfer.files[0]) uploadPhoto(e.dataTransfer.files[0], slot); });
    });
  })();


  /* ────────────────────────────────────
     SIDEBAR TOGGLE (mobile)
     ──────────────────────────────────── */
  (function() {
    var sidebar = document.getElementById('efCfgSidebar');
    var toggle = document.getElementById('efCfgSidebarToggle');
    if (!toggle) return;
    toggle.addEventListener('click', function() {
      sidebar.classList.toggle('is-collapsed');
    });
  })();

  /* ────────────────────────────────────
     ADD TO CART
     ──────────────────────────────────── */
  document.getElementById('efCfgATC').addEventListener('click', function() {
    if(isOldWorldSlim){var payload=owsBuildCart();if(payload.error){alert(payload.error);return;}}
    sanitizeTrifold();
    if (trifoldRule && (!trifoldWingsReady() || !trifoldDimensionsReady())) { goToStep(1); showTrifoldWingError(); return; }
    var atc = this;
    if(syncDoorMSRP()){alert(msrpError);return;}
    if(ceramicAreaSelected() && ceramicAreaCents()===null){alert('Please enter valid fireplace opening width and height to calculate ceramic glass.');return;}
    if (atc.disabled || atc.dataset.photoWait === '1') return;
    if (photoErrors.some(Boolean)) { alert('A photo could not be attached. Please retry or remove it before continuing.'); return; }
    if (_photoUploading) {
      atc.dataset.photoWait = '1'; atc.disabled = true;
      atc.innerHTML = '<span class="ef-cfg-spinner"></span> Processing photos...';
      var _waitPhoto = setInterval(function() {
        if (_photoUploading) return;
        clearInterval(_waitPhoto); delete atc.dataset.photoWait; atc.disabled = false;
        atc.textContent = 'Add to Cart — ' + money(calcTotal());
        if (photoErrors.some(Boolean)) { alert('A photo could not be attached. Please retry or remove it before continuing.'); return; }
        atc.click();
      }, 200);
      return;
    }
    /* 2026-05-11 — Required-measurement gate BEFORE ATC.
       Order received without Width/Height (config_id: mp1wetqv) — those props
       are only added if `selections._width/_height` are set. Without explicit
       blocking, the configurator allowed ATC submit with empty measurements.
       Custom Made products MUST have W+H. Standard/Simple have their own
       size selectors and are exempted.

       Brookfield Deluxe has its own 6-measurement gate later (line ~3420). */
    if (!efValidateMainPhoto()) return;

    var skipWHGate = (cfgType === 'cfg-standard') ||
                     (cfgType === 'cfg-simple') ||
                     (matchedGroup === 'Fireplace Doors - Brookfield Deluxe');
    if (!skipWHGate) {
      var needsWidth = !selections._width && !selections.simple_width && !selections.size;
      var needsHeight = !selections._height && !selections.simple_height && !selections.size;
      if (needsWidth || needsHeight) {
        var missingM = [];
        if (needsWidth) missingM.push('Width');
        if (needsHeight) missingM.push(isArch ? 'Center Peak Height' : 'Height');
        atc.disabled = false;
        atc.textContent = 'Add to Cart — ' + money(calcTotal());
        alert((cfgType === 'cfg-screen' ? 'Please enter your finished screen dimensions before adding to cart:' : 'Please enter your fireplace opening measurements before adding to cart:') + '\n\n• ' + missingM.join('\n• '));
        /* Jump back to Measurements step so user sees the fields */
        try { goToStep(1); } catch(e) {}
        return;
      }
    }

    atc.disabled = true;
    atc.innerHTML = '<span class="ef-cfg-spinner"></span> Adding...';

    var items = [];
    var props = {};

    // Build line item properties
    if (selections._width) props['Width'] = selections._width + '"';
    if (selections._height) props[isArch ? 'Center Peak Height' : 'Height'] = selections._height + '"';
    if (isArch && selections._side_height) props['Side Height'] = selections._side_height + '"';
    if (selections.size) props['Opening Size'] = selections.size;
    if (selections.simple_width) props['Opening Width'] = selections.simple_width;
    if (selections.simple_height) props['Opening Height'] = selections.simple_height;
    if (selections._frame_left) props['Frame Left'] = selections._frame_left;
    if (selections._frame_right) props['Frame Right'] = selections._frame_right;
    if (selections._frame_top) props['Frame Top'] = selections._frame_top;
    if (selections._frame_bottom) props['Frame Bottom'] = selections._frame_bottom;

    var fieldOrder = ['fireplace_type','firebox_type','fit_type','frame_width','door_fit','door_type','side_panel','feet','handle','pattern','style_finish','finish','door_finish','hardware_finish','glass','mesh','draft_control','glass_protection'];
    fieldOrder.forEach(function(field) {
      if (selections[field]) {
        props[formatFieldLabel(field)] = selValDisplay(field, selections[field]);
      }
    });

    /* Extras (EF_STOLL_EXTRAS_20260829) — one readable property for the packing slip;
       each extra still rides in as its own surcharge line item below. */
    var _extras = efSelectedExtras();
    if (_extras.length) {
      props['Extras'] = _extras.map(function (e) { return e.label; }).join(', ');
    }

    Object.assign(props, efPhotoProperties());

    // Order notes
    var notes = document.getElementById('efCfgNotes');
    if (notes && notes.value.trim()) {
      props['_Notes'] = notes.value.trim();
    }

    /* Brookfield Deluxe Magnetic — capture the 6 measurement inputs as line
       item properties. These are required fields; if any is empty, block ATC. */
    if (matchedGroup === 'Fireplace Doors - Brookfield Deluxe') {
      var deluxeFields = [
        ['efCfgDeluxeOverallW',     'Overall Width'],
        ['efCfgDeluxeOverallH',     'Overall Height'],
        ['efCfgDeluxeOpeningW',     'Opening Width'],
        ['efCfgDeluxeOpeningH',     'Opening Height'],
        ['efCfgDeluxeTopOffset',    'Top of opening to top of fireplace'],
        ['efCfgDeluxeBottomOffset', 'Bottom of opening to bottom of fireplace']
      ];
      var missing = [];
      deluxeFields.forEach(function (f) {
        var el = document.getElementById(f[0]);
        var v = el ? String(el.value || '').trim() : '';
        if (!v) { missing.push(f[1]); return; }
        props['_' + f[1]] = v + '"';
      });
      if (missing.length) {
        atc.disabled = false;
        atc.textContent = 'Add to Cart — ' + money(calcTotal());
        alert('Please fill in all 6 measurements before adding to cart:\n\n• ' + missing.join('\n• '));
        return;
      }
    }

    // Configured total price (for cart display)
    props['_Configured Price'] = money(calcTotal());

    // Unique config ID (to match surcharges to specific config, not just product title)
    var configId = Date.now().toString(36);
    props['_config_id'] = configId;

    /* EF FUNNEL: add to cart (P-007) — additive emission only */
    try {
      var _efSumParts = [];
      ['size', 'fit_type', 'door_type', 'finish', 'glass', 'mesh'].forEach(function (k) {
        if (selections[k]) _efSumParts.push(k + ':' + String(selections[k]).slice(0, 40));
      });
      efTrack('ef_cfg_atc', {
        total: Math.round(calcTotal()) / 100,
        config_summary: _efSumParts.join(' | ').slice(0, 200)
      });
    } catch (e) {}

    // Main product item
    var mainVid = variantId;
    // For cfg-standard, use the selected variant
    if (cfgType === 'cfg-standard') {
      var sel = document.getElementById('efCfgVariantSelect');
      if (sel && sel.value) mainVid = sel.value;
    }

    items.push({
      id: parseInt(mainVid, 10),
      quantity: 1,
      properties: props
    });

    /* Expose latest props + items + total for Express Checkout (worker path).
       Same object identity so when ATC re-runs after each click the values
       update for any subsequent Express Checkout. 2026-05-03. */
    window._efOrderSnapshot = {
      mainVariantId: parseInt(mainVid, 10),
      properties: Object.assign({}, props),
      totalCents: calcTotal(),
      productTitle: prodTitle
    };

    // Surcharge variant items
    Object.keys(surcharges).forEach(function(k) {
      var s = surcharges[k];
      if (s.variantId && s.amount > 0) {
        items.push({
          id: parseInt(s.variantId, 10),
          quantity: s.qty || 1,
          properties: {
            '_parent_product': prodTitle,
            '_option_type': formatFieldLabel(k.replace(/_balance_\d+$/, '')),
            '_config_id': configId
          }
        });
      }
    });

    if(isOldWorldSlim){var nativePayload=owsBuildCart();if(nativePayload.error){atc.disabled=false;alert(nativePayload.error);return;}items=nativePayload.items;window._efOrderSnapshot={mainVariantId:items[0].id,properties:items[0].properties,totalCents:nativePayload.totalCents,productTitle:prodTitle};}
    /* DEBUG: log full ATC payload so we can verify variant IDs match expected surcharges. */
    console.group('[EF-CFG] Add to Cart payload');
    console.log('Selections:', JSON.parse(JSON.stringify(selections)));
    console.log('Surcharges:', JSON.parse(JSON.stringify(surcharges)));
    console.log('Items being added:');
    items.forEach(function(it, i) {
      console.log('  [' + i + ']', 'variantId=' + it.id, 'qty=' + it.quantity, 'props=', it.properties);
    });
    console.groupEnd();

    Promise.resolve().then(function() {
      if (!window.EFOptionIntegrity) throw new Error('Cart verification is unavailable. Please reload and try again.');
      return window.EFOptionIntegrity.add(items);
    })
    .then(function() {
      if(isOldWorldSlim){try{localStorage.removeItem('ef-cfg-state-'+prodHandle);localStorage.removeItem('ef-saved-design:'+prodHandle);}catch(e){}}
      atc.innerHTML = 'Added to Cart \u2713';
      atc.style.background = 'var(--ef-green)';

      setTimeout(function() {
        var openCart = function() { if (window.EFCartDrawer) window.EFCartDrawer.open(); else window.location.href = '/cart'; };
        // "Complete Your Hearth" cross-sell \u2014 DOORS only, behind the draft flag (?hearth=1).
        // The door is already banked above, so this can never cost the sale. (2026-06-30)
        if (window.EFHearth && window.EFHearth.enabled() && cfgType !== 'cfg-screen') {
          window.EFHearth.show(openCart);
        } else {
          openCart();
        }
      }, 800);
    })
    .catch(function(err) {
      console.error('ATC error:', err);
      if(window.EFOptionIntegrity) window.EFOptionIntegrity.show(err.message);
      atc.disabled = false;
      atc.textContent = 'Error \u2014 Try Again';
      atc.style.background = '';
      setTimeout(function() {
        atc.textContent = 'Add to Cart \u2014 ' + money(calcTotal());
      }, 2000);
    });
  });

  function calcTotal() {
    syncDoorMSRP();
    syncCeramicArea();
    if (window.EFHammeredArch && groupData && groupData.heaPriceIds) window.EFHammeredArch.sync(root,selections,surcharges,parseMeasurement,groupData.heaPriceIds,groupData);

    syncGlassProtection();
    if(isOldWorldSlim){var input=owsInput();input.finish=input.finish||'Matte Black';input.mesh=input.mesh||'Perforated Mesh';var q=window.EFOldWorldSlim&&window.EFOldWorldSlim.quote(input);return q&&!q.error?q.totalCents:165500;}
    sanitizeTrifold();
    /* Only sum surcharges that will actually be added as cart variants
       (matches the filter at /cart/add.js: s.variantId && s.amount > 0).
       Without this, "Configured Price" shown in cart drifts above the
       real Shopify subtotal whenever a priced option lacks a variantId. */
    var total = basePrice;
    Object.keys(surcharges).forEach(function(k) {
      var s = surcharges[k];
      if (s && s.variantId && s.amount > 0) total += s.amount;
    });
    return total;
  }

  /* Three stable slots: full opening, width tape, height tape. */
  var EF_PHOTO_SLOTS = 3;
  var photoURL = '';
  var photoURLs = [];
  var photoNames = [];
  var photoPending = [];
  var photoErrors = [];
  var photoVersions = [0, 0, 0];
  var _photoUploading = false;
  function efValidateMainPhoto() {
    var zone = document.getElementById('efCfgUpload');
    if (!zone || zone.dataset.mainRequired !== 'true' || photoURLs[0]) return true;
    var error = document.getElementById('efCfgPhotoError');
    if (error) error.hidden = false;
    var button = zone.querySelector('[data-ef-photo-slot="0"] [data-photo-browse]');
    if (button) { button.setAttribute('aria-invalid', 'true'); button.setAttribute('aria-describedby', 'efCfgPhotoError'); button.focus(); button.scrollIntoView({block:'center', behavior:'auto'}); }
    return false;
  }

  function efNextPhotoSlot() {
    for (var i = 0; i < EF_PHOTO_SLOTS; i++) if (!photoNames[i]) return i;
    return -1;
  }
  function efPhotoProperties() {
    var props = {}, labels = ['Photo 1 - Full fireplace', 'Photo 2 - Smallest width', isArch ? 'Photo 3 - Center peak height' : 'Photo 3 - Smallest height'];
    photoURLs.forEach(function(url, index) {
      if (url) props[labels[index]] = url;
    });
    /* Preserve old integrations while named public properties remain visible in the order. */
    var available = photoURLs.filter(Boolean);
    available.forEach(function(url, index) { props[index ? '_Photo URL ' + (index + 1) : '_Photo URL'] = url; });
    return props;
  }
  function efPaintPhotoNames() {
    photoURL = photoURLs.filter(Boolean)[0] || '';
    _photoUploading = photoPending.some(Boolean);
    var el = document.getElementById('efCfgUploadName');
    if (el) {
      var count = photoURLs.filter(Boolean).length;
      el.hidden = !count && !_photoUploading;
      el.style.display = el.hidden ? 'none' : 'block';
      el.textContent = _photoUploading ? 'Uploading photos…' : count + (count === 1 ? ' photo attached' : ' photos attached');
    }
    document.querySelectorAll('[data-photo-thumbnail]').forEach(function(figure){
      var slot = Number(figure.dataset.photoThumbnail), img = figure.querySelector('img');
      figure.hidden = !photoURLs[slot];
      if (photoURLs[slot] && img.getAttribute('src') !== photoURLs[slot]) img.src = photoURLs[slot];
      else if (!photoURLs[slot]) img.removeAttribute('src');
    });
    if (photoURLs[0]) {
      var error = document.getElementById('efCfgPhotoError'), button = document.querySelector('#efCfgUpload [data-ef-photo-slot="0"] [data-photo-browse]');
      if (error) error.hidden = true;
      if (button) { button.removeAttribute('aria-invalid'); button.removeAttribute('aria-describedby'); }
    }
    document.querySelectorAll('[data-ef-photo-slot]').forEach(function(card) {
      var i = Number(card.getAttribute('data-ef-photo-slot')), image = card.querySelector('img'), status = card.querySelector('[data-photo-status]'), remove = card.querySelector('[data-photo-remove]'), browse = card.querySelector('[data-photo-browse]');
      card.setAttribute('aria-busy', photoPending[i] ? 'true' : 'false');
      if (image) { image.hidden = !photoURLs[i]; if (photoURLs[i] && image.getAttribute('src') !== photoURLs[i]) image.src = photoURLs[i]; else if (!photoURLs[i]) image.removeAttribute('src'); }
      if (status) status.textContent = photoPending[i] ? 'Uploading…' : photoErrors[i] || (photoURLs[i] ? 'Attached' : (i === 0 ? 'Full fireplace first · Up to 3 photos total' : 'Optional'));
      if (remove) remove.hidden = !photoNames[i] && !photoErrors[i];
      if (browse) browse.textContent = photoNames[i] ? 'Replace photo' : 'Upload photo';
    });
    document.dispatchEvent(new CustomEvent('ef:photos:change'));
  }
  function removePhoto(slot) {
    photoVersions[slot]++; photoURLs[slot] = ''; photoNames[slot] = ''; photoErrors[slot] = ''; photoPending[slot] = false; efPaintPhotoNames();
  }
  // EF_HEIC_UPLOAD_FIX_20261026: browsers may report HEIC with an empty/generic MIME type.
  function efPhotoFileSupported(file) {
    if (!file) return false;
    var type = (file.type || '').toLowerCase();
    return /^image\/(jpeg|jpg|png|webp|heic|heif|heic-sequence|heif-sequence)$/.test(type) ||
      ((!type || type === 'application/octet-stream') && /\.(jpe?g|png|webp|heic|heif)$/i.test(file.name || ''));
  }
  function efPhotoDeliveryURL(data) {
    var url = data.secure_url;
    if (!url || !/^https:\/\/res\.cloudinary\.com\/dcz6x0ccy\/image\/upload\//.test(url)) throw new Error('Upload failed');
    // Keep the original asset, but attach a JPEG rendition that browsers and the fit team can open.
    if (/^(heic|heif)$/i.test(data.format || '') || /\.(heic|heif)(?:$|\?)/i.test(url)) {
      url = url.replace('/image/upload/', '/image/upload/f_jpg/');
    }
    return url;
  }
  function uploadPhoto(file, slot) {
    var idx = typeof slot === 'number' ? slot : efNextPhotoSlot();
    if (idx < 0 || idx >= EF_PHOTO_SLOTS) { alert('All three photos are attached. Use Replace photo to change one.'); return Promise.resolve(null); }
    if (!efPhotoFileSupported(file)) { photoErrors[idx] = 'Choose a JPG, PNG, WebP or HEIC photo.'; efPaintPhotoNames(); return Promise.resolve(null); }
    if (file.size > 10 * 1024 * 1024) { photoErrors[idx] = 'Maximum file size is 10MB.'; efPaintPhotoNames(); return Promise.resolve(null); }
    var version = ++photoVersions[idx];
    photoNames[idx] = file.name; photoURLs[idx] = ''; photoErrors[idx] = ''; photoPending[idx] = true; efPaintPhotoNames();
    var formData = new FormData(); formData.append('file', file); formData.append('upload_preset', 'ef_fireplace'); formData.append('folder', 'fireplace-photos');
    var controller = new AbortController(), timeout = setTimeout(function() { controller.abort(); }, 60000);
    return fetch('https://api.cloudinary.com/v1_1/dcz6x0ccy/image/upload', { method: 'POST', body: formData, signal: controller.signal })
      .then(function(r) { if (!r.ok) throw new Error('Upload failed'); return r.json(); })
      .then(function(data) { var url = efPhotoDeliveryURL(data); if (photoVersions[idx] !== version) return null; photoURLs[idx] = url; return url; })
      .catch(function() { if (photoVersions[idx] !== version) return null; photoURLs[idx] = ''; photoNames[idx] = ''; photoErrors[idx] = 'Upload failed. Please try again.'; return null; })
      .finally(function() { clearTimeout(timeout); if (photoVersions[idx] !== version) return; photoPending[idx] = false; efPaintPhotoNames(); });
  }


  /* ────────────────────────────────────
     HTML ESCAPE UTILITY
     ──────────────────────────────────── */
  function escHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ────────────────────────────────────
     EMAIL THIS CONFIGURATION
     ──────────────────────────────────── */
  var emailBtn = document.getElementById('efCfgEmailConfig');
  if (emailBtn) {
    emailBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var lines = [prodTitle, ''];
      if (selections._width) lines.push('Width: ' + selections._width + '"');
      if (selections._height) lines.push((isArch ? 'Center Peak Height: ' : 'Height: ') + selections._height + '"');
      if (isArch && selections._side_height) lines.push('Side Height: ' + selections._side_height + '"');
      if (selections._frame_left) lines.push('Custom Frame: L:' + selections._frame_left + ' R:' + selections._frame_right + ' T:' + selections._frame_top + ' B:' + selections._frame_bottom);
      if (selections.size) lines.push('Opening Size: ' + selections.size);
      var fieldOrder = ['fireplace_type','firebox_type','fit_type','frame_width','door_fit','door_type','side_panel','feet','handle','pattern','style_finish','finish','door_finish','hardware_finish','glass','mesh','draft_control','glass_protection'];
      fieldOrder.forEach(function(field) {
        if (selections[field]) lines.push(formatFieldLabel(field) + ': ' + selValDisplay(field, selections[field]));
      });
      lines.push('');
      lines.push('Total: ' + money(calcTotal()));
      lines.push('');
      lines.push('View product: ' + window.location.href);
      var subject = encodeURIComponent('My ' + prodTitle + ' Configuration');
      var body = encodeURIComponent(lines.join('\n'));
      window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
    });
  }

  /* ────────────────────────────────────
     REVIEW "EDIT" LINK DELEGATION
     ──────────────────────────────────── */
  var reviewGrid = document.getElementById('efCfgReviewGrid');
  if (reviewGrid) {
    reviewGrid.addEventListener('click', function(e) {
      var link = e.target.closest('.ef-cfg-review-item__edit');
      if (!link) return;
      e.preventDefault();
      var stepIdx = parseInt(link.getAttribute('data-edit-step'), 10);
      if (!isNaN(stepIdx)) goToStep(stepIdx);
    });
  }

  /* ────────────────────────────────────
     INIT
     ──────────────────────────────────── */
  /* Listen for cart changes (e.g. item removed from drawer) — reset ATC button */
  document.addEventListener('cart:change', function() {
    var atc = document.getElementById('efCfgATC');
    if (atc && atc.disabled) {
      atc.disabled = false;
      atc.style.background = '';
      atc.textContent = 'Add to Cart \u2014 ' + money(calcTotal());
    }
  });
  document.addEventListener('cart:refresh', function() {
    var atc = document.getElementById('efCfgATC');
    if (atc && atc.disabled) {
      atc.disabled = false;
      atc.style.background = '';
      atc.textContent = 'Add to Cart \u2014 ' + money(calcTotal());
    }
  });

  var trifoldRule = window.EFTrifoldPolicy.rule(prodHandle, cfgType);
  function sanitizeTrifold() {
    /* Also sanitize this exact model after restore and before review/price/cart paths. */
    if (isOldWorldScreen) { delete selections.handle; delete surcharges.handle; }
    window.EFTrifoldPolicy.sanitize(trifoldRule, groupData, selections, surcharges);
  }

  function trifoldDimensionsReady() { if(!trifoldRule)return true;var w=parseMeasurement(document.getElementById('efCfgWidth').value),h=parseMeasurement(document.getElementById('efCfgHeight').value);var sh=document.getElementById('efCfgSideHeight');var s=sh?parseMeasurement(sh.value):NaN;return isFinite(w)&&w>0&&isFinite(h)&&h>0&&(!isArch||(isFinite(s)&&s>0&&s<=h)); }
  function trifoldWingsReady() { return !trifoldRule || !!((groupData.side_panel || []).find(function(o){return o.label===selections.side_panel;})); }
  function showTrifoldWingError() { var g=root.querySelector('[data-group="side_panel"]'); if(g){g.scrollIntoView({block:'center',behavior:'smooth'});var b=g.querySelector('button');if(b)b.focus();} }
  function refreshTrifoldDiagram() {
    if(!trifoldRule)return;
    var figure=document.getElementById('efTfDimensions');if(!figure)return;
    var w=document.getElementById('efCfgWidth').value.trim(),h=document.getElementById('efCfgHeight').value.trim();
    var wing=parseFloat(selections.side_panel)||0;
    figure.querySelector('[data-tf-center]').textContent=w&&h ? w+' × '+h+' in' : 'Width × height';
    figure.querySelectorAll('[data-tf-side]').forEach(function(el){el.textContent=wing ? wing+' in' : 'Side';});
    var width=parseMeasurement(w);
    figure.querySelector('figcaption').textContent=(width&&wing ? 'Unfolded total width: '+(width+2*wing)+' in. ' : '')+'Center panel plus two equal sides. Folded footprint depends on angle; diagram not to scale.';
  }
  function refineTrifoldForm() {
    if (!trifoldRule) return;
    var accessories=root.querySelector('[data-efx-uac]');if(accessories){var details=document.createElement('details');details.className='ef-tf-accessories';var heading=document.createElement('summary');heading.textContent='Optional hearth accessories';details.appendChild(heading);accessories.before(details);details.appendChild(accessories);}
    var summary=document.getElementById('efCfgSidebar'),nav=document.getElementById('efCfgNav');if(summary&&nav)nav.before(summary);
    function copy(selector,value){var e=root.querySelector(selector);if(e)e.textContent=value;}
    copy('#efCfgStep1 .ef-cfg-step__title.ef-cfg-arch-hide','Size your three panels');
    copy('#efCfgStep1 .ef-cfg-step__subtitle.ef-cfg-arch-hide','Enter finished dimensions for the center panel, then choose the width of each hinged side panel.');
    copy('#efCfgStep1 .ef-cfg-step__title.ef-cfg-arch-show','Size your arched center panel');
    copy('#efCfgStep1 .ef-cfg-step__subtitle.ef-cfg-arch-show','Enter center-panel width, shoulder height and peak height. Choose each side-panel width below.');
    copy('[data-group="side_panel"] .ef-cfg-group__hint','Select the width of each side panel. Both sides use the same width; the installed footprint depends on the fold angle.');
    copy('#efCfgStep2 .ef-cfg-step__title','Optional screen details');
    copy('#efCfgStep2 .ef-cfg-step__subtitle','Choose only the additional hardware you want for this screen.');
    copy('#efCfgStepReview .ef-cfg-step__subtitle','Check your panel dimensions, hardware and finish before adding your screen to the cart.');
    copy('[data-group="handle"] .ef-cfg-group__hint','Choose No Handle or Simplicity in your selected frame finish.');
    /* Owner 2026-10-21: dark Simplicity preview; actual finish follows frame. */
    var simplicityPreview=root.querySelector('[data-field="handle"][data-value="Simplicity"] img');
    if(simplicityPreview)simplicityPreview.style.filter='brightness(0.55)';
    copy('[data-group="feet"] .ef-cfg-group__hint','Additional feet are optional for this folding screen. Choose None to use no additional feet.');
    if(trifoldRule.family==='ds' && groupData.feet){
      selections.feet=selections.feet||'None (Tri-Fold)';
      var none=root.querySelector('[data-field="feet"][data-value="None (Tri-Fold)"]');if(none)none.setAttribute('aria-checked','true');
    }
    var wing=root.querySelector('[data-group="side_panel"]');
    if(wing && !document.getElementById('efTfDimensions')){
      var diagram=document.createElement('figure');diagram.id='efTfDimensions';diagram.className='ef-tf-dimensions';
      diagram.innerHTML='<svg viewBox="0 0 440 155" role="img" aria-labelledby="efTfDimTitle"><title id="efTfDimTitle">Center panel and two equal side panels shown unfolded; not to scale</title><g fill="#ece9e4" stroke="#716554" stroke-width="3"><path d="M35 35h80v90H35zM125 20h190v105H125zM325 35h80v90h-80z"/></g><g fill="#121212" font-size="15" text-anchor="middle"><text data-tf-side x="75" y="82">Side</text><text x="220" y="67">Center panel</text><text data-tf-center x="220" y="90">Width × height</text><text data-tf-side x="365" y="82">Side</text></g></svg><figcaption>Panels shown unfolded · diagram not to scale. The width you enter is the center panel only.</figcaption>';
      wing.before(diagram);
    }
    root.addEventListener('input',refreshTrifoldDiagram);root.addEventListener('click',function(){requestAnimationFrame(refreshTrifoldDiagram);});
    if(trifoldRule.family==='ds'){var nh=root.querySelector('[data-field="handle"][data-value="No Handle"]');if(nh&&!selections.handle)selectCard(nh,'handle');}
    var oldHint=document.getElementById('efCfgScreenSizeHint');if(oldHint)oldHint.textContent='Check the folded screen footprint on your hearth before ordering. Finished panel dimensions are not the firebox opening dimensions.';
  }

  function init() {
    if (isOldWorldScreen && groupData) {
      groupData = Object.assign({}, groupData);
      delete groupData.handle;
      sanitizeTrifold();
    }
    if (trifoldRule) { groupData = window.EFTrifoldPolicy.data(trifoldRule, groupData); sanitizeTrifold(); root.classList.add('ef-trifold-order'); }
    buildProgress();
    try { populateSteps(); } catch(e) { console.error('[EF-CFG] populateSteps error:', e); }
    refineTrifoldForm();
    if(isOldWorldSlim){
      var title=root.querySelector('#efCfgStep3 .ef-cfg-step__title');if(title)title.textContent='Screen finish';
      var label=document.getElementById('efCfgFrameFinishLabel');if(label){label.textContent='Screen finish';label.style.display='block';}
      var subtitle=root.querySelector('#efCfgStep3 .ef-cfg-step__subtitle');if(subtitle)subtitle.textContent='Choose one finish for your entire screen. Premium finishes add $410.';
      var hint=document.getElementById('efCfgScreenSizeHint');if(hint)hint.style.display='none';
      var review=root.querySelector('#efCfgStepReview .ef-cfg-step__subtitle');if(review)review.textContent='Review your finished screen size, finish and mesh before adding to cart.';
    }
    handleMeasurements();
    handleStandardSize();
    handleBrookfieldDeluxe();
    handleVariantSelect();
    handleSimpleRanges();
    updatePrice();
    showStep(_skipStep0 ? 1 : 0, { skipScroll: true });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Video modal (cfg-simple "Watch Installation Video") removed 2026-05-01 —
     the Installation Guide tab below the gallery is the single source for
     install instructions. */

  /* Arch kit: native Shopify contact submission; success is server rendered. */
  (function() {
    var openBtn=document.getElementById('efCfgTemplateOpen'),modal=document.getElementById('efCfgTemplateModal');
    if(!openBtn||!modal)return;
    var form=document.getElementById('efCfgTemplateForm'),priorFocus,priorOverflow='',draftKey='ef-template-kit:'+location.pathname;
    function updateDimensions(){
      var noun=cfgType==='cfg-screen'?'Requested finished screen dimensions':'Fireplace opening dimensions';
      var values=[['Width',selections._width],['Side height',selections._side_height],['Center peak height',selections._height]].filter(function(v){return v[1]}).map(function(v){return v[0]+': '+v[1]+' in'});
      var text=values.length?noun+' — '+values.join('; ')+'. Arch shape subject to template review.':'Measurements not supplied yet.';
      var hidden=document.getElementById('efTplDimensions'),summary=document.getElementById('efTplDimensionSummary');
      if(hidden)hidden.value=text;if(summary)summary.textContent=values.length?text:'You can request a kit before measuring.';
    }
    function openModal(){priorFocus=document.activeElement;priorOverflow=document.body.style.overflow;modal.setAttribute('data-open','true');document.body.style.overflow='hidden';updateDimensions();var target=modal.querySelector('[data-template-confirmed],.ef-arch-form-errors,#efTplName');if(target){if(target.tagName!=='INPUT')target.setAttribute('tabindex','-1');target.focus();}}
    function closeModal(){modal.removeAttribute('data-open');document.body.style.overflow=priorOverflow;openBtn.focus({preventScroll:true});}
    openBtn.addEventListener('click',openModal);document.getElementById('efCfgTemplateClose').addEventListener('click',closeModal);
    modal.addEventListener('click',function(e){if(e.target===modal)closeModal();});
    modal.addEventListener('keydown',function(e){
      if(e.key==='Escape'){e.preventDefault();closeModal();return;}
      if(e.key!=='Tab')return;
      var items=Array.prototype.filter.call(modal.querySelectorAll('button,input:not([type="hidden"]),select,textarea,a[href]'),function(el){return !el.disabled&&el.getClientRects().length}),first=items[0],last=items[items.length-1];
      if(!items.length)return;
      if(items.indexOf(document.activeElement)<0){e.preventDefault();(e.shiftKey?last:first).focus();}else if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    });
    if(form)form.addEventListener('submit',function(e){
      if(!form.checkValidity()){e.preventDefault();form.reportValidity();return;}
      updateDimensions();
      // Short-lived, tab-local draft preserves address details across Shopify errors/challenges.
      var values={};Array.prototype.forEach.call(form.querySelectorAll('input:not([type="hidden"]),textarea'),function(el){if(el.id)values[el.id]=el.value;});try{sessionStorage.setItem(draftKey,JSON.stringify({at:Date.now(),values:values}));}catch(err){}
      var ret=document.getElementById('efTplReturn'),url=new URL(location.href);url.searchParams.delete('contact_posted');url.searchParams.set('ef_template_kit','1');url.hash='efCfgTemplateModal';if(ret)ret.value=url.pathname+url.search+url.hash;
      // Keep the native POST and Shopify challenge/error handling intact.
    });
    var returning=new URLSearchParams(location.search).get('ef_template_kit')==='1',draft=null;
    try{draft=JSON.parse(sessionStorage.getItem(draftKey));if(draft&&Date.now()-draft.at>1800000){sessionStorage.removeItem(draftKey);draft=null;}}catch(err){}
    if(returning&&modal.querySelector('[data-template-confirmed]')){try{sessionStorage.removeItem(draftKey);}catch(err){}openModal();}
    else if(returning&&(draft||modal.querySelector('.ef-arch-form-errors'))){
      if(draft)Object.keys(draft.values).forEach(function(id){var el=document.getElementById(id);if(el&&form.contains(el))el.value=draft.values[id];});
      if(!modal.querySelector('.ef-arch-form-errors')){var notice=document.createElement('p');notice.className='ef-arch-form-errors';notice.setAttribute('role','alert');notice.textContent='Your request has not been confirmed. Review your details and try again.';form.prepend(notice);}openModal();
    }
  })();

})();


/* ─── Block 2 (was line ~3812) ─── */

/* ── Sticky ATC bar click ── */
(function() {
  var stickyBtn = document.getElementById('efStickyBtn');
  var mainATC = document.getElementById('efCfgATC');
  if (stickyBtn && mainATC) {
    stickyBtn.addEventListener('click', function() { mainATC.click(); });
  }
})();

document.querySelectorAll('.ef-info-trigger').forEach(function(btn){
  btn.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    document.querySelectorAll('.ef-tooltip').forEach(function(t){ t.style.display = 'none'; });
    var tip = btn.querySelector('.ef-tooltip');
    if(!tip){
      tip = document.createElement('span');
      tip.className = 'ef-tooltip';
      tip.textContent = btn.getAttribute('data-ef-tooltip');
      btn.appendChild(tip);
    }
    tip.style.display = tip.style.display === 'block' ? 'none' : 'block';
  });
});
document.addEventListener('click', function(){ document.querySelectorAll('.ef-tooltip').forEach(function(t){ t.style.display = 'none'; }); });


/* ─── Block 3 (was line ~3840) ─── */

/* ── AI Configurator Assist ── */
(function() {
  var aiBtn = document.getElementById('efCfgAiBtn');
  var aiPanel = document.getElementById('efCfgAiPanel');
  var aiUpload = document.getElementById('efCfgAiUpload');
  var aiFile = document.getElementById('efCfgAiFile');
  var aiAnalyzing = document.getElementById('efCfgAiAnalyzing');
  var aiResult = document.getElementById('efCfgAiResult');
  var aiCard = document.getElementById('efCfgAiCard');
  var aiManualLink = document.getElementById('efCfgAiManualLink');
  if (!aiPanel) return;

  /* 2026-05-14 — unified card redesign removed the standalone aiUpload label
     element. The legacy AI handler still calls aiUpload.style.display = 'none'
     /'flex' to toggle between upload + analyzing states. Provide a no-op
     sentinel so those calls don't throw, AND wire data-state on the card root
     so the idle layout returns when the legacy code "shows the upload" again. */
  if (!aiUpload) {
    aiUpload = {
      _state: { display: '' },
      get style() {
        var s = this._state, card = aiCard;
        return {
          set display(v) {
            s.display = v;
            // 'none' = handler is moving to analyzing/result; CSS handles via data-state
            // 'flex' / '' = handler is restoring the idle upload — reset card state
            if (card && (v === 'flex' || v === 'block' || v === '')) card.dataset.state = 'idle';
          },
          get display() { return s.display; }
        };
      }
    };
  }


  /* EF_PHOTO_ASSIST_HELPERS_START — pure contract decisions also exercised in fixture tests. */
  function aiPhotoDecision(data) {
    var status = ['ready','needs_review','needs_retake','incompatible'].indexOf(data.analysis_status) >= 0 ? data.analysis_status : data.analysis_status ? 'needs_review' : '';
    var confidence = Number(data.confidence);
    var sufficient = data.confidence !== null && data.confidence !== '' && Number.isFinite(confidence) && confidence >= 80 && confidence <= 100 && data.photo_quality !== 'poor';
    if (!status) status = data.photo_quality === 'poor' ? 'needs_retake' : sufficient ? 'ready' : 'needs_review';
    return { status: status, apply: status === 'ready' && sufficient && (data.analysis_status ? data.auto_apply === true : data.auto_apply !== false),
      structural: sufficient && status !== 'needs_retake' && status !== 'incompatible' && (typeof data.structural_advice_allowed === 'boolean' ? data.structural_advice_allowed : !(data.review_reasons || []).includes('compatibility_unverified')) };
  }
  /* EF_PHOTO_FIELD_SELECTION_V10: identification and opening can be applied independently.
     Only the server can allow partial application; unrelated fit review is not a veto. */
  function aiPhotoFieldAllowed(data, decision, field) {
    if (decision.status === 'needs_retake' || decision.status === 'incompatible' || data.photo_quality === 'poor') return false;
    if (data.door_application_status && data.door_application_status !== 'open_fireplace') return false;
    var a = data.application_assessment;
    if (a && (a.appliance_class !== 'open_fireplace' || a.front_obstruction !== 'none')) return false;
    var allowed = data.selection_allowed;
    if (allowed && typeof allowed === 'object') return allowed[field] === true;
    return decision.apply === true;
  }
  function aiPhotoChoiceKey(value, field) {
    var key = String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    if (field === 'fireplace_type') {
      if (/^masonry/.test(key)) return 'masonry';
      if (/^(factorybuilt|prefab)/.test(key)) return 'prefab';
    }
    if (field === 'firebox_type') {
      if (/^flushhearth/.test(key)) return 'flush_hearth';
      if (/^holein(?:the)?wall/.test(key)) return 'hole_in_wall';
    }
    return key;
  }
  function aiPhotoSelectionPlan(allowed, expected, before, current, touched, field) {
    if (!allowed || !expected) return 'confirm';
    if (current && aiPhotoChoiceKey(current, field) === aiPhotoChoiceKey(expected, field)) return 'selected';
    if (touched || before || current) return 'kept';
    return 'apply';
  }
  function aiOptionKey(value, field) {
    var key = String(value || '').toLowerCase().replace(/\(\s*\+?\$[\d,.]+\s*\)/g, '').replace(/[^a-z0-9]/g, '');
    if (/^glass/.test(field)) key = key.replace(/glass/g, '');
    return key;
  }
  function aiMatchOption(value, labels, field) {
    var key = aiOptionKey(value, field);
    if (!key) return '';
    return labels.filter(function(label) { return aiOptionKey(label, field) === key; })[0] || '';
  }
  function aiPhotoError(data) {
    var code = typeof data.error === 'string' ? data.error : data.error && data.error.code || data.code || '';
    /* Worker public-code aliases; never expose provider errors. */
    var publicCodes = { analysis_timeout:'service_timeout', analysis_truncated:'truncated_response', analysis_invalid_response:'invalid_response', analysis_empty_response:'invalid_response', analysis_refused:'invalid_response', analysis_unavailable:'service_unavailable', analysis_busy:'rate_limited', analysis_rate_limited:'rate_limited', analysis_network_error:'service_unavailable', unknown_product:'unsupported_product', invalid_product:'invalid_request', product_group_mismatch:'unsupported_product', unsupported_content_type:'invalid_request', invalid_json:'invalid_request', body_too_large:'image_too_large', origin_not_allowed:'service_unavailable', method_not_allowed:'invalid_request' };
    code = publicCodes[code] || code;
    var messages = {
      request_cancelled: 'This photo request was cancelled. You can try again or choose your options manually below.',
      service_timeout: 'Photo recommendations took too long. Please try again, or choose your options manually below.',
      truncated_response: 'We could not finish these recommendations. Please try again, or choose your options manually below.',
      invalid_response: 'We could not prepare reliable recommendations from this photo. Try another photo, or choose your options manually below.',
      invalid_image: 'We could not read this photo. Please try another JPEG, PNG or HEIC image.',
      unsupported_media_type: 'Please choose a JPEG, PNG or HEIC photo.',
      image_too_large: 'This photo is too large. Please choose a photo under 10 MB.',
      unsupported_product: 'Photo recommendations are not available for this door yet. You can choose your options manually below.',
      invalid_request: 'We could not prepare this photo request. Please upload the photo again.',
      rate_limited: 'Our photo service is busy. Please try again in a moment, or choose your options manually below.',
      service_unavailable: 'Our photo service is temporarily unavailable. Please try again, or choose your options manually below.'
    };
    var message = messages[code] || (data.overloaded ? messages.rate_limited : messages.invalid_response);
    if (typeof data.request_id === 'string' && /^[a-zA-Z0-9_-]{6,80}$/.test(data.request_id)) message += ' Reference: ' + data.request_id + '.';
    return message;
  }
  function aiFullCoverTips(dims, handle, selectedType) {
    if (handle !== 'brookfield-deluxe-magnetic-prefab-fireplace-glass-doors' || !/prefab|factory|zero.clearance/i.test(selectedType || '')) return null;
    if (!dims || !dims.louvers || dims.louvers.visible !== true || !Array.isArray(dims.tips) || dims.tips.length !== 6) return null;
    return dims.tips.every(function(tip) { return typeof tip === 'string' && tip.trim().length > 0 && tip.length <= 1000; }) ? dims.tips.slice() : null;
  }
  /* EF_PHOTO_ASSIST_HELPERS_END */
  function aiCurrentOption(field, value, host) {
    var fields = field === 'glass' ? ['glass','glass_color','glass_type'] : field === 'mesh' ? ['mesh','mesh_screen','mesh_type'] : [field];
    var labels = [];
    fields.forEach(function(name) {
      if (typeof window.efCfgPhotoOptions === 'function') labels = labels.concat(window.efCfgPhotoOptions(name));
    });
    var scope = host || document.getElementById('efCfg');
    if (scope) scope.querySelectorAll(field === 'finish' ? '#efCfgSwatchGrid [data-label]' : fields.map(function(name) { return '[data-field="' + name + '"][data-value]'; }).join(',')).forEach(function(node) {
      if (!node.disabled && node.getAttribute('aria-disabled') !== 'true') labels.push(node.dataset.label || node.dataset.value || '');
    });
    return aiMatchOption(value, labels, field);
  }
  function aiPhotoNotice(data, decision) {
    if (aiResult) aiResult.dataset.analysisStatus = decision.status;
    var notice = document.getElementById('efCfgAiNotice');
    if (!notice) return;
    var messages = {
      ready: '',
      needs_review: 'Review the photo suggestions below. Any choices still needing confirmation are marked separately.',
      needs_retake: 'We need a clearer photo to identify your fireplace. Try a straight-on photo showing the full opening with the fire off. Your selections are unchanged.',
      incompatible: 'This photo may not match the fireplace types supported by this door. Confirm your fireplace type or contact us before choosing this model. Your selections are unchanged.'
    };
    var quality = typeof data.photo_quality_note === 'string' && (data.photo_quality !== 'good' || (decision.status === 'needs_review' && !data.identification_reason)) ? data.photo_quality_note.slice(0, 600) : '';
    var action = data.next_action;
    var specific = action && typeof action.title === 'string' && typeof action.detail === 'string' ? action.title + '. ' + action.detail : '';
    notice.textContent = decision.status === 'ready' ? '' : specific || [messages[decision.status], quality].filter(Boolean).join(' ');
    notice.hidden = !notice.textContent;
  }

  var WORKER_URL = 'https://configurator-assistant.danielzajacus.workers.dev';
  var aiRequest = null;
  var aiManualFields = {}, aiApplyingChoice = false;
  function aiSelectedValue(field) {
    var host = document.getElementById('efCfg');
    var card = host && host.querySelector('[data-field="' + field + '"][aria-checked="true"]');
    return card ? card.dataset.value || '' : '';
  }
  function aiRememberManualChoice(event) {
    if (aiApplyingChoice || (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ')) return;
    var target = event.target;
    if (!target || !target.closest || target.closest('[data-cfg-zoom]')) return;
    var card = target.closest('#efCfg [data-field]');
    if (card && ['fireplace_type','firebox_type'].indexOf(card.dataset.field) >= 0) aiManualFields[card.dataset.field] = true;
  }
  document.addEventListener('click', aiRememberManualChoice, true);
  document.addEventListener('keydown', aiRememberManualChoice, true);
  function aiApplyPhotoChoice(data, decision, run, field, expected) {
    var plan = aiPhotoSelectionPlan(aiPhotoFieldAllowed(data, decision, field), expected,
      run.selectionBefore[field], aiSelectedValue(field), aiManualFields[field] === true, field);
    if (plan !== 'apply') return plan;
    aiApplyingChoice = true;
    try { return autoSelectCard(field, expected) ? 'selected' : 'unavailable'; }
    finally { aiApplyingChoice = false; }
  }
  function aiSelectionFeedback(fpType, fbType, applied) {
    var host = document.getElementById('efCfgAiSelectionStatus');
    if (!host) {
      host = document.createElement('p'); host.id = 'efCfgAiSelectionStatus';
      host.className = 'ef-cfg-ai-picks-note'; host.setAttribute('role', 'status'); host.setAttribute('aria-live', 'polite');
      var specs = document.getElementById('efCfgAiSpecs');
      if (specs && specs.parentNode) specs.parentNode.insertBefore(host, specs.nextSibling);
    }
    var messages = [];
    [['fireplace_type',fpType,'fireplace type'],['firebox_type',fbType,'hearth arrangement']].forEach(function(item) {
      var status = applied[item[0]], name = item[1];
      if (status === 'selected' && name) messages.push(name + ' is selected below.');
      else if (status === 'kept') messages.push('Your ' + item[2] + ' choice is kept' + (name ? '; the photo suggests ' + name + '.' : '.'));
      else if (status === 'unavailable') messages.push(name + ' is not available for this door. Please check the model with our team.');
      else if (name) messages.push(name + ' is a suggestion; please confirm it below.');
    });
    host.textContent = messages.join(' '); host.hidden = !host.textContent;
  }
  /* EF_PHOTO_REAL_TIME_20261017: monotonic wall time from file selection, including HEIC preparation. */
  function aiTimeText(milliseconds) {
    var seconds = Math.floor(Math.max(0, milliseconds) / 1000);
    return Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
  }
  function aiClockTick(run) {
    if (aiRequest !== run) return;
    var elapsed = document.getElementById('efCfgAiElapsed');
    if (elapsed) elapsed.textContent = aiTimeText(run.elapsedMs == null ? performance.now() - run.startedAt : run.elapsedMs);
  }
  function aiResultTime(run) {
    var timing = document.getElementById('efCfgAiTiming');
    if (!timing) {
      timing = document.createElement('p'); timing.id = 'efCfgAiTiming';
      timing.style.cssText = 'font-size:13px;line-height:1.5;color:#5c564c;margin:8px 0 14px;text-align:center';
      aiResult.insertBefore(timing, aiResult.firstChild.nextSibling);
    }
    var preparation = Math.min(run.preparedMs || 0, run.elapsedMs);
    timing.textContent = 'Completed in ' + aiTimeText(run.elapsedMs) + ' · photo preparation ' + aiTimeText(preparation) + ' · analysis ' + aiTimeText(run.elapsedMs - preparation);
  }


  var aiError = document.createElement('p');
  aiError.className = 'ef-cfg-ai-error';
  aiError.setAttribute('role', 'alert');
  aiError.hidden = true;
  if (aiCard) {
    if (aiPanel.parentNode === aiCard) aiCard.insertBefore(aiError, aiPanel);
    else aiCard.appendChild(aiError);
  }
  function aiState(state) {
    if (aiCard) { aiCard.dataset.state = state; aiCard.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false'); }
    aiPanel.style.display = state === 'idle' ? 'none' : 'block';
    aiAnalyzing.style.display = state === 'loading' ? 'block' : 'none';
    aiResult.style.display = state === 'result' ? 'block' : 'none';
  }
  function aiFail(run, message) {
    if (aiRequest !== run) return;
    run.stop();
    aiState('idle');
    aiError.textContent = message;
    aiError.hidden = false;
    aiFile.value = '';
  }
  function aiRevealResult() {
    var step = aiCard && aiCard.closest('.ef-cfg-step');
    if (aiCard && aiCard.offsetParent !== null && (!step || step.classList.contains('is-visible'))) {
      aiResult.setAttribute('tabindex', '-1');
      aiResult.focus({ preventScroll: true });
      aiResult.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  /* Unified card: card IS the upload trigger via native <label for=efCfgAiFile>.
     No more toggle — panel is always present; the data-state attribute on the
     card root switches between idle / loading / result. 2026-05-14.

     THREE display modes (mutually exclusive), detected at runtime:
       A. Card always visible (v6 sandbox): aiBtn is hidden empty placeholder.
       B. Button reveals card (LIVE main): aiBtn visible, aiCard initially
          display:none. Click button → show card + manual link, hide button.
       C. Legacy fallback (older LIVE without aiCard): button toggles old panel. */

  /* T-CFG7 2026-09-01 — Mode B is now a TWO-WAY disclosure. Owner: "jak otwieram w
     konfiguratorze ai opcje do zweryfikowania opcji to nie mam mozliwosci tego
     zminimalizowac z powrotem". The bar no longer hides itself; it stays in place and
     IS the collapse control, so nothing above the fold moves and the trigger never
     leaves the cursor. aria-expanded is the single source of truth, read by the CSS
     for the caret and the word, and mirrored into sessionStorage so a step change or
     a later page load does not spring the panel open again.
     The || below keeps the old detection AND accepts the pre-paint restore in the
     snippet, which sets display:'' before this deferred file runs. */
  var btnRevealMode = aiBtn && aiCard && !aiBtn.hasAttribute('hidden') &&
                      (aiCard.style.display === 'none' || aiBtn.hasAttribute('aria-expanded'));

  if (btnRevealMode && typeof IntersectionObserver === 'function' && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var photoIntroObserver = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) { return entry.isIntersecting && entry.intersectionRatio >= 0.5; })) {
        aiBtn.classList.add('ef-photo-assist-seen');
        photoIntroObserver.disconnect();
      }
    }, { threshold: 0.5 });
    photoIntroObserver.observe(aiBtn);
  }
  var aiRetry = document.getElementById('efCfgAiRetry');
  if (aiRetry) aiRetry.addEventListener('click', function(event) {
    event.stopPropagation();
    aiState('idle');
    aiError.hidden = true;
    var uploadButton = aiCard.querySelector('[data-ef-lib="efCfgAiFile"]');
    if (uploadButton) uploadButton.focus();
  });
  if (btnRevealMode) {
    var AI_OPEN_KEY = 'efCfgAiOpen';
    var aiSetOpen = function (open, moveFocus) {
      aiCard.style.display = open ? '' : 'none';
      if (aiManualLink) aiManualLink.style.display = '';
      aiBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      try { sessionStorage.setItem(AI_OPEN_KEY, open ? '1' : '0'); } catch (err) {}
      if (!open && moveFocus) {
        try { aiBtn.focus({ preventScroll: true }); } catch (err) { aiBtn.focus(); }
      }
    };
    if (aiManualLink) aiManualLink.style.display = '';
    if (!aiBtn.hasAttribute('aria-expanded')) {
      aiBtn.setAttribute('aria-expanded', aiCard.style.display === 'none' ? 'false' : 'true');
    }
    if (!aiBtn.hasAttribute('aria-controls')) aiBtn.setAttribute('aria-controls', 'efCfgAiCard');
    aiBtn.addEventListener('click', function (e) {
      e.preventDefault();
      aiSetOpen(aiBtn.getAttribute('aria-expanded') !== 'true', true);
    });
    /* Escape is scoped to focus inside the panel: the card is inline content, not an
       overlay, so a document-wide Escape would steal the key from the rest of the form.
       The example-photo lightbox has its own Escape handler further down — if it is
       open it owns the key and we stand down. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (aiBtn.getAttribute('aria-expanded') !== 'true') return;
      var lb = document.getElementById('efCfgAiLightbox');
      if (lb && lb.getAttribute('aria-hidden') === 'false') return;
      if (!aiCard.contains(document.activeElement) && document.activeElement !== aiBtn) return;
      aiSetOpen(false, true);
    });
  } else if (!aiCard && aiBtn) {
    /* Mode C — legacy fallback */
    aiBtn.addEventListener('click', function () {
      var open = aiPanel.style.display !== 'none';
      aiPanel.style.display = open ? 'none' : 'block';
      if (!open) aiBtn.style.display = 'none';
    });
  }
  /* Mode A — no extra wiring; card is already visible. */

  /* "Or pick manually" — un-fades the type selector below so user can manually
     choose Factory-Built / Masonry without uploading. Also hides the manual
     link itself once clicked (one-shot reveal). */
  if (aiManualLink) {
    aiManualLink.addEventListener('click', function (e) {
      e.preventDefault();
      var groups = document.querySelectorAll('.ef-cfg-group--deprio');
      groups.forEach(function (g) { g.classList.add('is-active'); });
      aiManualLink.style.display = 'none';
      var typeGroup = document.querySelector('.ef-cfg-group[data-group="fireplace_type"]');
      if (typeGroup && typeof typeGroup.scrollIntoView === 'function') {
        typeGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  /* Card-as-button: trigger file picker on click + space/enter (since we use
     <div role="button"> instead of <label> — label cannot legally contain
     <div> children, browsers auto-close the label and the idle layout escapes).
     Don't fire while in loading/result state to avoid re-opening picker.
     Skip clicks originating inside thumbnails (they have their own lightbox). */
  if (aiCard && aiFile) {
    aiCard.addEventListener('click', function (e) {
      if (aiCard.dataset.state !== 'idle') return;
      if (e.target.closest('.ef-cfg-ai-card__thumb')) return;
      aiFile.click();
    });
    aiCard.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (aiCard.dataset.state !== 'idle') return;
        if (e.target.closest('.ef-cfg-ai-card__thumb')) return;
        e.preventDefault();
        aiFile.click();
      }
    });
  }

  /* Example thumbnail lightbox — open full-size on click, close on overlay
     click / X button / Escape. Stops propagation so card click doesn't fire. */
  var aiLightbox = document.getElementById('efCfgAiLightbox');
  var aiLightboxImg = document.getElementById('efCfgAiLightboxImg');
  var aiLightboxClose = document.getElementById('efCfgAiLightboxClose');
  if (aiLightbox && aiLightboxImg) {
    document.querySelectorAll('.ef-cfg-ai-card__thumb').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var src = btn.getAttribute('data-full');
        if (!src) return;
        aiLightboxImg.src = src;
        aiLightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
    function closeLightbox() {
      aiLightbox.setAttribute('aria-hidden', 'true');
      aiLightboxImg.src = '';
      document.body.style.overflow = '';
    }
    aiLightbox.addEventListener('click', function (e) {
      if (e.target === aiLightbox || e.target === aiLightboxImg) closeLightbox();
    });
    if (aiLightboxClose) aiLightboxClose.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && aiLightbox.getAttribute('aria-hidden') === 'false') closeLightbox();
    });
  }

  /* Drag-and-drop on the card. dragover MUST preventDefault for drop to fire. */
  if (aiCard && aiFile) {
    var dragLeaveTimer = null;
    function onDragOver(e) {
      e.preventDefault(); e.stopPropagation();
      if (dragLeaveTimer) { clearTimeout(dragLeaveTimer); dragLeaveTimer = null; }
      aiCard.classList.add('is-dragover');
    }
    function onDragLeave(e) {
      // dragleave fires for child elements too — debounce by 60ms so a
      // dragover on the next child doesn't make the highlight flicker
      dragLeaveTimer = setTimeout(function () { aiCard.classList.remove('is-dragover'); }, 60);
    }
    function onDrop(e) {
      e.preventDefault(); e.stopPropagation();
      aiCard.classList.remove('is-dragover');
      var files = e.dataTransfer && e.dataTransfer.files;
      if (!files || !files.length) return;
      // Set on the file input + dispatch change so existing handler picks it up
      try {
        var dt = new DataTransfer();
        dt.items.add(files[0]);
        aiFile.files = dt.files;
        aiFile.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (err) {
        console.warn('[EF-CFG] drop fallback', err);
      }
    }
    aiCard.addEventListener('dragover', onDragOver);
    aiCard.addEventListener('dragenter', onDragOver);
    aiCard.addEventListener('dragleave', onDragLeave);
    aiCard.addEventListener('drop', onDrop);
  }

  /* When file is selected (via tap or drop), flip card to loading state.
     The downstream handler sets aiAnalyzing display='block' / aiResult on success;
     here we just keep data-state in sync so CSS can hide the idle layout. */
  if (aiFile && aiCard) {
    aiFile.addEventListener('change', function () {
      if (aiFile.files && aiFile.files.length) aiCard.dataset.state = 'loading';
    });
  }
  /* MutationObserver on aiResult: when it becomes visible (display:block),
     bump card state to 'result' AND un-fade the type cards (AI gave us values
     to populate them, so manual selection is now also relevant). */
  if (aiResult && aiCard) {
    var ro = new MutationObserver(function () {
      if (aiResult.style.display && aiResult.style.display !== 'none') {
        aiCard.dataset.state = 'result';
        document.querySelectorAll('.ef-cfg-group--deprio').forEach(function (g) {
          g.classList.add('is-active');
        });
        if (aiManualLink) aiManualLink.style.display = 'none';
      }
    });
    ro.observe(aiResult, { attributes: true, attributeFilter: ['style'] });
  }

  /* Step 2 measurement help is now native <details>/<summary> — no JS needed.
     Removed the old jump-to-step-1 + AI-panel handler 2026-05-03. */

  /* Upload click handled by native <label for="efCfgAiFile"> — no JS proxy.
     Removed `aiFile.click()` 2026-05-04 because iOS Safari throttles
     programmatic file-input clicks (~7s delay before picker opens).
     Native label fires picker immediately on user tap. */

  /* HEIC support — lazy-load converter only when iPhone HEIC photo is uploaded */
  var heic2anyLoaded = null;
  function loadHeic2Any() {
    if (typeof window.heic2any === 'function') return Promise.resolve(window.heic2any);
    if (heic2anyLoaded) return heic2anyLoaded;
    heic2anyLoaded = new Promise(function (resolve, reject) {
      var source = window.EF_HEIC2ANY_URL || 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
      if (!source) return reject(new Error('HEIC converter URL unavailable'));
      var script = document.createElement('script'), settled = false;
      var timer = setTimeout(function () { finish(new Error('HEIC converter loading timed out. Please try again.')); }, 15000);
      function finish(error) {
        if (settled) return;
        settled = true; clearTimeout(timer); script.onload = script.onerror = null;
        if (error) { script.remove(); reject(error); } else resolve(window.heic2any);
      }
      script.src = source;
      script.onload = function () { finish(typeof window.heic2any === 'function' ? null : new Error('HEIC converter API unavailable')); };
      script.onerror = function () { finish(new Error('HEIC converter could not load. Please check your connection and try again.')); };
      document.head.appendChild(script);
    }).catch(function (error) { heic2anyLoaded = null; throw error; });
    return heic2anyLoaded;
  }
  function isHeic(file) {
    var name = (file.name || '').toLowerCase();
    var type = (file.type || '').toLowerCase();
    return /^image\/(heic|heif)(-sequence)?$/.test(type) ||
           /\.(heic|heif)$/i.test(name);
  }
  function probeNativeHeic(file) {
    return new Promise(function (resolve) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      var settled = false;
      var timer = setTimeout(function () { done(false); }, 4000);
      function done(ok) { if (settled) return; settled = true; clearTimeout(timer); img.onload = img.onerror = null; URL.revokeObjectURL(url); resolve(ok); }
      img.onload = function () { done(img.naturalWidth > 0); };
      img.onerror = function () { done(false); };
      img.src = url;
    });
  }
  /* Safari/iOS decode HEIC natively in <img> — no wasm needed there; downstream canvas re-encode outputs JPEG. */
  function convertHeicToJpeg(file) {
    return probeNativeHeic(file).then(function (nativeOk) {
      if (nativeOk) return file;
      return wasmConvertHeic(file);
    });
  }
  var efHeifLoaded = null;
  function loadEfHeif() {
    if (typeof window.EFConvertHeic === 'function') return Promise.resolve(window.EFConvertHeic);
    if (efHeifLoaded) return efHeifLoaded;
    efHeifLoaded = new Promise(function (resolve, reject) {
      var source = window.EF_HEIF_URL;
      if (!source) return reject(new Error('HEIC converter URL unavailable'));
      var script = document.createElement('script'), settled = false;
      var timer = setTimeout(function () { finish(new Error('HEIC converter loading timed out. Please try again.')); }, 20000);
      function finish(error) {
        if (settled) return;
        settled = true; clearTimeout(timer); script.onload = script.onerror = null;
        if (error) { script.remove(); reject(error); } else resolve(window.EFConvertHeic);
      }
      script.src = source;
      script.onload = function () { finish(typeof window.EFConvertHeic === 'function' ? null : new Error('HEIC converter API unavailable')); };
      script.onerror = function () { finish(new Error('HEIC converter could not load. Please check your connection and try again.')); };
      document.head.appendChild(script);
    }).catch(function (error) { efHeifLoaded = null; throw error; });
    return efHeifLoaded;
  }
  /* Decoder ladder: modern libheif first (handles iPhone 15/16 HDR HEIC), legacy heic2any as fallback. */
  function wasmConvertHeic(file) {
    return loadEfHeif().then(function () { return window.EFConvertHeic(file); })
      .catch(function (err) { if (window.console) console.warn('[ef-heic] libheif path failed, trying heic2any:', err && err.message); return legacyConvertHeic(file); });
  }
  function legacyConvertHeic(file) {
    return loadHeic2Any().then(function (heic2any) {
      return heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 });
    }).then(function (blob) {
      if (Array.isArray(blob)) blob = blob[0];
      return new File([blob], (file.name || 'photo').replace(/\.(heic|heif)$/i, '.jpg'), { type: 'image/jpeg' });
    });
  }

  /* File selected → analyze */
  /* Resize image to max 1600px before sending. Promise-based so img-decode
     errors (some malformed PNGs, oversized phone shots) propagate to .catch
     instead of silently never invoking the callback. JPEG re-encode at q=0.85
     keeps everything under Anthropic's 5MB image limit. */
  function resizeImage(file, maxDim) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image(), canvas = null, settled = false;
      var timer = setTimeout(function () { finish(new Error('Image preparation timed out. Please try again.')); }, 15000);
      function finish(error, data) {
        if (settled) return;
        settled = true; clearTimeout(timer); img.onload = img.onerror = null;
        URL.revokeObjectURL(url);
        if (canvas) { canvas.width = 0; canvas.height = 0; canvas = null; }
        if (error) reject(error); else resolve(data);
      }
      img.onload = function () {
        if (settled) return;
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          if (!w || !h) throw new Error('Image dimensions are unavailable');
          if (w > maxDim || h > maxDim) {
            var ratio = Math.min(maxDim / w, maxDim / h);
            w = Math.max(1, Math.round(w * ratio));
            h = Math.max(1, Math.round(h * ratio));
          }
          canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          var context = canvas.getContext('2d');
          if (!context) throw new Error('Image canvas unavailable');
          context.drawImage(img, 0, 0, w, h);
          var data = canvas.toDataURL('image/jpeg', 0.85);
          if (!/^data:image\/jpeg;base64,.+/.test(data)) throw new Error('Image encoding failed');
          finish(null, data);
        } catch (error) { finish(error); }
      };
      img.onerror = function () {
        finish(new Error('Image decode failed'));
      };
      img.src = url;
    });
  }

  aiFile.addEventListener('change', function(e) {
    var file = e.target.files[0];
    if (!file) return;
    if (aiRequest) aiRequest.stop();
    var run = { controller: new AbortController(), timers: [], startedAt: performance.now(), elapsedMs: null };
    run.stop = function () { if (run.elapsedMs == null) run.elapsedMs = performance.now() - run.startedAt; aiClockTick(run); run.controller.abort(); run.timers.forEach(clearTimeout); run.timers.forEach(clearInterval); run.timers = []; };
    run.selectionBefore = { fireplace_type: aiSelectedValue('fireplace_type'), firebox_type: aiSelectedValue('firebox_type') };
    aiRequest = run;
    aiError.hidden = true;
    window._efAiRecs = null;
    window._efAiDims = null;
    aiMeasurementPhoto = null;
    refreshMeasurementPhotoHelp();
    renderAiTips();
    applyAiFitInfoToCards();
    var oldMeasurementAdvice = document.getElementById('efCfgAiEstimated');
    if (oldMeasurementAdvice) oldMeasurementAdvice.style.display = 'none';
    var oldFitSummary = document.getElementById('efCfgAiFitAdvice');
    if (oldFitSummary) oldFitSummary.style.display = 'none';
    if (file.size > 10 * 1024 * 1024) { aiFail(run, 'This photo is larger than 10 MB. Please choose a smaller photo.'); return; }
    aiState('loading');
    aiClockTick(run);
    run.timers.push(setInterval(function () { aiClockTick(run); }, 250));
    var initialStatus = document.getElementById('efCfgAiStatus');
    if (initialStatus) { initialStatus.textContent = 'Preparing your photo…'; initialStatus.style.opacity = '1'; }
    /* Clear stale preview from any previous photo so old image doesn't flash. */
    var prevImg = document.getElementById('efCfgAiPreview');
    if (prevImg) prevImg.removeAttribute('src');

    /* Show analyzing state immediately */
    aiUpload.style.display = 'none';
    aiAnalyzing.style.display = 'block';

    /* iPhone HEIC handling — convert client-side first. Errors propagate to the
       outer chain's .catch so we don't double-alert. */
    var processFile;
    if (isHeic(file)) {
      var s0 = document.getElementById('efCfgAiStatus');
      if (s0) s0.textContent = 'Converting iPhone photo (HEIC → JPEG)…';
      processFile = convertHeicToJpeg(file).catch(function (err) {
        throw new Error('heic_conversion_failed: ' + (err && err.message || err));
      });
    } else {
      processFile = Promise.resolve(file);
    }

    processFile.then(function (finalFile) {
      if (aiRequest !== run) return null;
      var statusEl = document.getElementById('efCfgAiStatus');
      if (statusEl) statusEl.textContent = 'Preparing image…';

      /* Mirror the photo into the Step 6 (Review) upload widget so the customer
         doesn't have to re-upload. Uses DataTransfer + dispatch change so the
         existing efCfgUpload handler's handleFile() runs naturally — that sets
         uploadedFile, filename, preview, and triggers Shopify upload. 2026-05-14. */
      try {
        var reviewInput = document.getElementById('efCfgFileInput');
        if (reviewInput && finalFile) {
          var dt = new DataTransfer();
          dt.items.add(finalFile);
          /* T-CFG8 — tell handleFile() this is the identification photo so it takes
             slot 0 and can never displace a tape shot. dispatchEvent is synchronous,
             so the flag is exact; the finally-style reset runs either way. */
          reviewInput.files = dt.files;
          window.__efCfgMirroring = true;
          try { reviewInput.dispatchEvent(new Event('change', { bubbles: true })); }
          finally { window.__efCfgMirroring = false; }
          var zone = document.getElementById('efCfgUpload');
          if (zone) zone.classList.add('has-file');
        }
      } catch (mirrorErr) {
        console.warn('[EF-CFG] mirror to review step failed:', mirrorErr);
      }

      return resizeImage(finalFile, 1600);
    }).then(function (dataUrl) {
      if (aiRequest !== run || !dataUrl) return;
      document.getElementById('efCfgAiPreview').src = dataUrl;

      run.preparedMs = performance.now() - run.startedAt;
      var statusEl = document.getElementById('efCfgAiStatus');
      if (statusEl) statusEl.textContent = 'Sending your photo and analyzing your fireplace…';

      run.timers.push(setTimeout(function () { run.timedOut = true; run.controller.abort(); }, 75000));

      /* Get product handle from page */
      var root = document.getElementById('efCfg');
      var handle = root ? root.dataset.productHandle : '';

      return fetch(WORKER_URL, {
        signal: run.controller.signal,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          image: dataUrl,
          product_handle: handle,
          cfg_group: window.efCfgMatchedGroup || null
        })
      })
      .then(function(r) { return r.json().then(function(data) { if (!r.ok && !data.error) data.error = 'service_unavailable'; return data; }); })
      .then(function(data) {
        if (aiRequest !== run) return;
        run.stop();

        /* A review/retake result can retain grounded aesthetic suggestions without selecting structural options. */
        if (!data || typeof data !== 'object' || Array.isArray(data) || data.error || (!data.analysis_status && !data.fireplace_type)) {
          aiFail(run, aiPhotoError(data && typeof data === 'object' ? data : { error: 'invalid_response' }));
          return;
        }
        var photoDecision = aiPhotoDecision(data);
        aiState('result');
        aiResultTime(run);
        aiPhotoNotice(data, photoDecision);

        /* Build specs display */
        var specs = document.getElementById('efCfgAiSpecs');
        var html = '';
        var fpRaw = String(data.fireplace_type || '').toLowerCase();
        var fbRaw = String(data.firebox_type || '').toLowerCase();
        var fpType = /masonry/.test(fpRaw) ? 'Masonry' : /prefab|factory|zero.clearance/.test(fpRaw) ? 'Factory-Built' : '';
        var fbType = /flush/.test(fbRaw) ? 'Flush Hearth' : /hole|raised|elevated/.test(fbRaw) ? 'Hole in Wall' : '';
        html += aiSpec('Type', fpType || 'Please confirm manually');
        html += aiSpec('Firebox', fbType || 'Please confirm manually');
        if (Number.isFinite(data.estimated_width) && data.estimated_width > 0 && Number.isFinite(data.estimated_height) && data.estimated_height > 0) {
          html += aiSpec('Est. Size', data.estimated_width + '" x ' + data.estimated_height + '"');
        }
        if (photoDecision.structural && data.lintel_bar && data.lintel_bar.visible === true) {
          html += aiSpec('Lintel Bar', data.lintel_bar.position === 'flush' ? 'Flush' : data.lintel_bar.position === 'recessed' ? 'Recessed' : 'Detected');
        }
        html += aiSpec('Photo assessment', data.identification_status === 'identified' ? 'Type identified' : 'Type needs confirmation');
        specs.innerHTML = html;
        aiRecommendationOverview(data, photoDecision);
        aiMeasurementPhoto = data;
        refreshMeasurementPhotoHelp();

        var lintelNote = document.getElementById('efCfgAiLintelNote');
        if (lintelNote) lintelNote.style.display = 'none';

        /* Step-1 finish tip removed — finish recommendation now shown in
           the Finish step itself in the same green-bordered Fit-Advice style
           (see renderAiTips below). Keeps Step 1 panel focused on type/size. */

        /* ── AUTO-FILL CONFIGURATOR ── */

        /* 1. Auto-select fireplace_type card */
        var fpApplied = aiApplyPhotoChoice(data, photoDecision, run, 'fireplace_type', fpType);

        /* 2. Auto-select firebox_type card */
        var fbApplied = aiApplyPhotoChoice(data, photoDecision, run, 'firebox_type', fbType);
        aiSelectionFeedback(fpType, fbType, { fireplace_type: fpApplied, firebox_type: fbApplied });

        /* 3. Store estimated dimensions + tips for Step 2 */
        window._efAiDims = null;
        if (photoDecision.structural && fpType) {
          window._efAiDims = {
            w: data.estimated_width,
            h: data.estimated_height,
            tips: data.measuring_tips || [],
            lintel: data.lintel_bar || null,
            louvers: data.louvers || null,
            method: data.size_estimation_method || ''
          };
        }

        /* 4. Store finish/glass/fit/mesh/draft recommendations + reasoning for later steps */
        window._efAiRecs = {
          finish: data.recommended_finish || '',
          finish_reason: data.finish_reason || '',
          finish_premium: data.recommended_finish_premium || '',
          finish_premium_reason: data.finish_premium_reason || '',
          glass: data.recommended_glass || '',
          glass_reason: data.glass_reason || '',
          mesh: data.recommended_mesh || '',
          mesh_reason: data.mesh_reason || '',
          draft: typeof data.recommended_draft_for_masonry === 'boolean' ? data.recommended_draft_for_masonry : null,
          draft_label: data.recommended_draft_control || '',
          draft_reason: data.draft_reason || '',
          fireplace_type: photoDecision.structural ? fpType.toLowerCase() : '',
          analysis_status: photoDecision.status,
          fit: photoDecision.structural ? data.recommended_fit || '' : '',
          frame: data.recommended_frame_size || '',
          fit_options: photoDecision.structural ? data.fit_options || null : null,
          product_variant: data.product_variant || null,
          available_variants: data.available_variants || []
        };
        renderAiTips();
        aiFile.value = '';
        aiRevealResult();
      })
      .catch(function(err) {
        if (aiRequest !== run) return;
        aiFail(run, run.timedOut
          ? aiPhotoError({ error: 'service_timeout' })
          : 'We could not reach photo recommendations. Check your connection and upload the photo again.');
      });
    }).catch(function (err) {
      if (aiRequest !== run) return;
      aiFail(run, err && /heic|heif/i.test(String(err.message || ''))
        ? 'We could not convert this HEIC photo. Please try again, or upload a JPEG or PNG copy.'
        : 'We could not read this photo. Please try another JPEG, PNG or HEIC image.');
    });
  });

  /* Show the actual recommendations now, and retain all contextual tips in later steps. */
  function aiRecommendationOverview(data, decision) {
    var host = document.getElementById('efCfgAiRecommendations');
    var evidence = document.getElementById('efCfgAiEvidence');
    if (evidence) { evidence.textContent = typeof data.identification_reason === 'string' ? data.identification_reason : ''; evidence.hidden = !evidence.textContent; }
    if (!host) return;
    if (decision.status === 'needs_retake') { host.innerHTML = ''; host.hidden = true; return; }
    var rows = [];
    function add(label, field, value, reason) {
      var actual = aiCurrentOption(field, value);
      if (!actual) return;
      rows.push('<div class="ef-cfg-ai-pick"><dt>' + _aiEsc(label) + '</dt><dd><strong>' + _aiEsc(actual) + '</strong>' + (reason ? '<p>' + efAiAdviceSummary(reason) + '</p>' : '') + '</dd></div>');
    }
    add('Included finish', 'finish', data.recommended_finish, data.finish_reason);
    add('Premium finish option', 'finish', data.recommended_finish_premium, data.finish_premium_reason);
    add('Glass', 'glass', data.recommended_glass, data.glass_reason);
    add('Mesh', 'mesh', data.recommended_mesh, data.mesh_reason);
    if (!data.recommended_mesh && data.mesh_guidance) rows.push('<div class="ef-cfg-ai-pick"><dt>Mesh</dt><dd><strong>' + _aiEsc(data.mesh_guidance.title) + '</strong><p>' + _aiEsc(data.mesh_guidance.detail) + '</p></dd></div>');
    if (decision.structural) {
      add('Fit', 'fit_type', data.recommended_fit, data.fit_reason);
      add('Frame', 'frame_size', data.recommended_frame_size, data.frame_reason);
      if (!aiCurrentOption('frame_size', data.recommended_frame_size)) add('Frame width', 'frame_width', data.recommended_frame_size, data.frame_reason);
      add('Draft control', 'draft_control', data.recommended_draft_control, data.draft_reason);
    }
    host.innerHTML = rows.length ? '<h4>' + (decision.status === 'incompatible' ? 'Style ideas for a compatible door' : 'Suggested for your fireplace') + '</h4><dl>' + rows.join('') + '</dl><p class="ef-cfg-ai-picks-note">Review these suggestions beside the options in each step. Premium options may add to your price.</p>' : '';
    if (rows.length && decision.status === 'needs_review' && !data.recommended_fit) host.innerHTML += '<p class="ef-cfg-ai-picks-note">Fit and frame options need the mounting and measurement check described above.</p>';
    if (rows.length && data.product_variant && data.product_variant.required_hardware) host.innerHTML += '<p class="ef-cfg-ai-picks-note">' + _aiEsc(data.product_variant.required_hardware) + '</p>';
    host.hidden = !rows.length;
  }

  function aiSpec(label, value) {
    return '<div class="ef-cfg-ai-panel__spec">' +
      '<div class="ef-cfg-ai-panel__spec-label">' + label + '</div>' +
      '<div class="ef-cfg-ai-panel__spec-val">' + _aiEsc(value) + '</div></div>';
  }

  /* Renders contextual AI tips inside steps (Finish, Glass, Mesh, Draft Control)
     once analysis completes. Each tip is gated on whether its container exists
     in the rendered configurator (some tags hide certain steps). */
  function efAiTipCard(opts) {
    var icon = opts.icon || 'sparkle';
    var iconSvg = icon === 'sparkle'
      ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8A6A43" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px;"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>'
      : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8A6A43" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px;"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>';
    var rows = (opts.rows || []).map(function (r) {
      return '<p style="margin:0 0 6px;font-family:Inter,sans-serif;font-size:12.5px;line-height:1.5;color:#3A3732;">' +
        (r.label ? '<strong style="color:#1E1E1B;font-weight:600;">' + r.label + ':</strong> ' : '') +
        r.text + '</p>';
    }).join('');
    if (rows) rows = rows.replace(/margin:0 0 6px;/, 'margin:0 0 6px;').replace(/<\/p>$/, '</p>');
    return '<div class="ef-cfg-ai-tip" style="display:flex;gap:10px;align-items:flex-start;padding:12px 14px;background:#FEF8EE;border:1px solid #F2E5C8;border-left:3px solid #8A6A43;border-radius:6px;margin:14px 0;">' +
      iconSvg +
      '<div style="flex:1;">' +
        '<p style="margin:0 0 6px;font-family:Inter,sans-serif;font-size:10px;font-weight:700;color:#8A6A43;letter-spacing:0.12em;text-transform:uppercase;">' + (opts.eyebrow || 'AI Recommendation') + '</p>' +
        rows +
      '</div>' +
    '</div>';
  }

  /* Renders an inline "AI recommends X — text" advice card matching the Fit Type
     advice style (.ef-cfg-ai-advice). Used for finish, glass, and mesh tips. */
  function efAiAdviceSummary(text) {
    /* Input contains only _aiEsc output plus our optional <em> finish wrapper.
       Decode once before shortening so an entity cannot be cut in half. Strip
       only our wrapper first, then escape again for the visible HTML output. */
    var entities = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'" };
    var plain = String(text || '').replace(/<\/?em>/g, '').replace(/&(?:amp|lt|gt|quot|#39);/g, function(entity) {
      return entities[entity];
    }).replace(/\s+/g, ' ').trim();
    var sentence = plain.match(/^(.+?[.!?])(?:\s|$)/);
    var summary = sentence && sentence[1].length <= 150 ? sentence[1] : plain;
    if (summary.length > 150) {
      var excerpt = summary.slice(0, 140);
      var boundary = excerpt.lastIndexOf(' ');
      summary = (boundary > 0 ? excerpt.slice(0, boundary) : excerpt) + '…';
    }
    return _aiEsc(summary);
  }

  function efAiAdviceHtml(recommendation, text) {
    /* Keep the choice visible beside its options, with the complete explanation
       available on demand. Callers escape all model-generated text before this
       helper; the optional finish emphasis below is our own trusted markup. */
    return '<div class="ef-cfg-ai-advice__heading"><span class="ef-cfg-ai-advice__eyebrow">' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.85 5.55L19.5 10l-5.65 1.45L12 17l-1.85-5.55L4.5 10l5.65-1.45z"/><path d="M19 15l.7 2.1L22 18l-2.3.9L19 21l-.7-2.1L16 18l2.3-.9z"/></svg>' +
        'AI suggestion</span>' +
      '<span class="ef-cfg-ai-advice__rec">' + recommendation + '</span>' +
      '<span class="ef-cfg-ai-advice__summary">' + efAiAdviceSummary(text) + '</span></div>' +
      '<details class="ef-cfg-ai-advice__details"><summary>Why this suggestion</summary>' +
        '<p class="ef-cfg-ai-advice__text">' + text + '</p>' +
      '</details>';
  }

  function renderAiTips() {
    var r = window._efAiRecs || {};
    var finishChoice = aiCurrentOption('finish', r.finish);
    var premiumChoice = aiCurrentOption('finish', r.finish_premium);
    var oldFinish = document.getElementById('efCfgAiFinishTip');
    if (oldFinish) oldFinish.remove();

    /* Finish — primary recommendation, premium upgrade appended as one sentence */
    var finishHost = document.getElementById('efCfgSwatchGrid');
    if (finishHost && (finishChoice || premiumChoice)) {
      var existingFinish = document.getElementById('efCfgAiFinishTip');
      if (existingFinish) existingFinish.remove();
      var primary = finishChoice || premiumChoice;
      var text = _aiEsc((finishChoice ? r.finish_reason : r.finish_premium_reason) || 'Complements your fireplace.');
      if (finishChoice && premiumChoice && finishChoice !== premiumChoice) {
        text += ' Another finish to consider: <em>' + _aiEsc(premiumChoice) + '</em>. See the finish options for current pricing.';
      }
      var fwrap = document.createElement('div');
      fwrap.id = 'efCfgAiFinishTip';
      fwrap.className = 'ef-cfg-ai-advice';
      fwrap.innerHTML = efAiAdviceHtml(_aiEsc(primary), text);
      finishHost.parentNode.insertBefore(fwrap, finishHost.nextSibling);
    }

    /* Glass — Clear/Tinted based on interior */
    var glassGroups = document.querySelectorAll('[data-group="glass_color"], [data-group="glass"], [data-group="glass_type"]');
    glassGroups.forEach(function (g) {
      var existing = g.querySelector('.ef-cfg-ai-glass-tip');
      if (existing) existing.remove();
      var glassChoice = aiCurrentOption('glass', r.glass, g);
      if (!glassChoice) return;
      var wrap = document.createElement('div');
      wrap.className = 'ef-cfg-ai-glass-tip ef-cfg-ai-advice';
      wrap.innerHTML = efAiAdviceHtml(_aiEsc(glassChoice), _aiEsc(r.glass_reason || 'Best match for your firebox interior.'));
      g.appendChild(wrap);
    });

    /* Mesh — preserve the product-aware recommendation, never invent an unavailable option. */
    var meshGroups = document.querySelectorAll('[data-group="mesh"], [data-group="mesh_screen"], [data-group="mesh_type"]');
    meshGroups.forEach(function (g) {
      var existing = g.querySelector('.ef-cfg-ai-mesh-tip');
      if (existing) existing.remove();
      var meshChoice = aiCurrentOption('mesh', r.mesh, g);
      if (!meshChoice) return;
      var wrap = document.createElement('div');
      wrap.className = 'ef-cfg-ai-mesh-tip ef-cfg-ai-advice';
      wrap.innerHTML = efAiAdviceHtml(_aiEsc(meshChoice), _aiEsc(r.mesh_reason) || 'Review this mesh option for your door.');
      g.appendChild(wrap);
    });

    /* Draft control — masonry doors only */
    document.querySelectorAll('.ef-cfg-ai-draft-tip').forEach(function(node) { node.remove(); });
    if (r.fireplace_type && r.fireplace_type.indexOf('masonry') !== -1 && (r.draft_label || typeof r.draft === 'boolean')) {
      var draftGroups = document.querySelectorAll('[data-group="draft_control"], [data-group="draft"]');
      draftGroups.forEach(function (g) {
        var existing = g.querySelector('.ef-cfg-ai-draft-tip');
        if (existing) existing.remove();
        var wrap = document.createElement('div');
        wrap.className = 'ef-cfg-ai-draft-tip ef-cfg-ai-advice';
        var draftChoice = aiCurrentOption('draft_control', r.draft_label || (r.draft === true ? 'Yes' : r.draft === false ? 'No Thank You' : ''), g);
        if (!draftChoice) return;
        wrap.innerHTML = efAiAdviceHtml(_aiEsc(draftChoice), _aiEsc(r.draft_reason) || 'Review the available draft-control option and follow the fireplace operating instructions.');
        g.appendChild(wrap);
      });
    }
  }

  /* Re-render tips when user navigates to a step (in case step content was rebuilt) */
  document.addEventListener('click', function (e) {
    var navBtn = e.target.closest('[data-step-nav], .ef-cfg-nav__next, .ef-cfg-nav__prev');
    if (navBtn && window._efAiRecs) {
      setTimeout(renderAiTips, 100);
    }
  });

  function autoSelectCard(field, expected) {
    var host = document.getElementById('efCfg');
    if (!host) return false;
    var cards = host.querySelectorAll('[data-field="' + field + '"]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (aiPhotoChoiceKey(card.dataset.value, field) !== aiPhotoChoiceKey(expected, field)) continue;
      if (card.disabled || card.getAttribute('aria-disabled') === 'true' || card.hidden || card.closest('[hidden]') || !card.getClientRects().length) continue;
      /* Clicking a selected radio currently toggles it off; preserve the selection. */
      if (card.getAttribute('aria-checked') !== 'true') card.click();
      return card.getAttribute('aria-checked') === 'true';
    }
    return false;
  }

  /* Measurement help uses manual readings, never dimensions inferred from a photo. */
  var aiMeasurementPhoto = null;
  function aiLintelPhotoText(photo) {
    if (!photo || photo.fireplace_type !== 'masonry') return '';
    var bar = photo.lintel_bar;
    if (bar && bar.visible === true) return 'A steel support bar appears at the top of your fireplace. Check where the frame will sit before choosing the height measuring point.';
    return 'The steel support bar is not clear in this photo. With the fireplace cold, look up just inside the top edge. It may be hidden behind the front trim.';
  }
  function refreshMeasurementPhotoHelp() {
    var note = document.getElementById('efCfgLintelPhotoHelp');
    if (!note) return;
    var copy = aiLintelPhotoText(aiMeasurementPhoto);
    note.textContent = copy;
    note.hidden = !copy;
  }
  function aiMeasurementRules(isMasonry) {
    return isMasonry ? [
      ['Find the narrowest width', 'Measure across the front opening at the top, middle and bottom, then check between those points and at any projecting brick or stone. Keep the tape level. Enter the smallest width you find anywhere along the opening.'],
      ['Find the lowest opening height', 'Measure vertically from the hearth at the left, center and right, then check between those points for a low edge or raised hearth. Enter the smallest height at the correct top edge; see Where to measure at the top below.'],
      ['Use your tape measurements', 'Measure at the front opening where the frame will fit. Record to the nearest 1/8 inch. Enter your actual readings in the width and height fields; do not subtract a fitting allowance.']
    ] : [
      ['Opening', 'Measure the front metal opening where the new door frame will install. Follow this fireplace and door model’s measuring guide.'],
      ['Find the narrowest width', 'Measure across the opening at the top, middle and bottom, then check between those points and around any projections. Keep the tape level and enter the smallest opening width.'],
      ['Find the lowest opening height', 'Measure vertically at the left, center and right, then check between those points. Enter the smallest opening height.'],
      ['What to avoid', 'Do not include surrounding trim or measure deep inside the firebox, behind logs, mesh curtains or vents. Follow the fireplace manufacturer’s instructions before moving any existing components.'],
      ['Use your tape measurements', 'Record to the nearest 1/8 inch. Enter your actual readings in the width and height fields; do not subtract a fitting allowance.']
    ];
  }

  /* Show manual measurement guidance when entering the Measure step. */
  var observer = new MutationObserver(function() {
    var step1 = document.getElementById('efCfgStep1');
    if (step1 && step1.classList.contains('is-visible') && window._efAiDims) {
      var dims = window._efAiDims;
      /* Width/Height inputs intentionally left empty — customer must measure
         the opening with a tape measure and enter exact dimensions. AI estimate
         is surfaced as a badge + tips below, never written into the fields.
         Reason: per customer feedback, prefilled estimates were being submitted
         without verification, causing fit issues during production. */

      /* Show estimated badge with tips */
      var estEl = document.getElementById('efCfgAiEstimated');
      if (estEl) {
        var measurementRoot = document.getElementById('efCfg');
        var specialMeasurements = measurementRoot && (measurementRoot.dataset.arch === 'true' || measurementRoot.dataset.cfgType === 'cfg-screen');
        estEl.style.display = specialMeasurements ? 'none' : 'block';

        /* Populate measuring tips with STATIC general rules per fireplace type.
           2026-05-13 — switched from per-photo AI tips (inconsistent) to canned
           rules. AI is only used to detect masonry vs prefab; rules are
           hardcoded so they cannot drift. */
        var tipsUl = document.getElementById('efCfgAiTips');
        if (tipsUl) {
          var selectedType = document.querySelector('#efCfg [data-field="fireplace_type"][aria-checked="true"]');
          var fpType = String(selectedType && selectedType.dataset.value || '').toLowerCase();
          var isMasonry = fpType.indexOf('masonry') !== -1;
          var measuringRules = aiMeasurementRules(isMasonry);
          var rules = measuringRules.map(function(rule) { return rule[1]; });
          var ruleTitles = measuringRules.map(function(rule) { return rule[0]; });
          var photoRoot = document.getElementById('efCfg');
          var fullCoverTips = aiFullCoverTips(dims, photoRoot && photoRoot.dataset.productHandle, fpType);
          if (fullCoverTips) {
            rules = fullCoverTips;
            ruleTitles = ['Overall width','Overall height','Opening width','Opening height','Top offset','Bottom offset'];
          }
          tipsUl.innerHTML = rules.map(function(t, i) {
            return '<li><span class="ef-cfg-ai-estimated__step" aria-hidden="true">' + (i + 1) + '</span>' +
              '<div class="ef-cfg-ai-estimated__rule"><strong class="ef-cfg-ai-estimated__rule-title">' + ruleTitles[i] + '</strong>' +
              '<span class="ef-cfg-ai-estimated__rule-text">' + _aiEsc(t) + '</span></div></li>';
          }).join('');
        }

        /* The masonry-only top-edge disclosure lives beside the measurement inputs. */
        refreshMeasurementPhotoHelp();
        var lintelEl = document.getElementById('efCfgAiLintel');
        if (lintelEl) lintelEl.style.display = 'none';

        /* Fit type info now embeds DIRECTLY into the existing Overlap/Inside Fit
           radio cards in Step 3 (see applyAiFitInfoToCards). Step 1 only shows
           a tiny banner pointing the customer to where the details live. */
        var fitEl = document.getElementById('efCfgAiFitAdvice');
        if (fitEl) {
          if (window._efAiRecs && (window._efAiRecs.fit_options || window._efAiRecs.fit)) {
            fitEl.querySelector('span').innerHTML =
              '<strong>Fit guidance available</strong> — review the Overlap/Inside Fit suggestions and follow this product’s measuring guide.';
            fitEl.style.display = 'flex';
          }
          /* Try injecting now in case Step 3 cards already rendered; otherwise
             the MutationObserver below will catch them when they appear. */
          applyAiFitInfoToCards();
        }
      }

      window._efAiDims = null; /* only auto-fill once */
    }
  });
  var step1El = document.getElementById('efCfgStep1');
  if (step1El) observer.observe(step1El, { attributes: true, attributeFilter: ['class'] });

  /* When Step 2 (Door Style) becomes visible, inject AI fit info into the
     existing Overlap/Inside Fit radio cards. The observer also catches the
     case where AI completes before the customer reaches Step 2. */
  var fitObserver = new MutationObserver(function() {
    var step2 = document.getElementById('efCfgStep2');
    if (!step2 || !step2.classList.contains('is-visible')) return;
    if (!window._efAiRecs) return;
    /* Hide the legacy advice banner inside fit_type group — info is in a standalone card below the grid */
    var adviceEl = document.getElementById('efCfgFitAdvice');
    if (adviceEl) adviceEl.style.display = 'none';
    applyAiFitInfoToCards();
  });
  var step2El = document.getElementById('efCfgStep2');
  if (step2El) fitObserver.observe(step2El, { attributes: true, attributeFilter: ['class'] });

  function _aiEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Keep the choice cards compact. Reuse the same standalone AI suggestion
     component as Finish below the complete fit grid, never inside a radio. */
  function applyAiFitInfoToCards() {
    var group = document.querySelector('[data-group="fit_type"]');
    if (!group) return;
    var previous = group.querySelector('#efCfgAiFitTip');
    var wasOpen = previous && previous.querySelector('details[open]');
    if (previous) previous.remove();
    var cards = group.querySelectorAll('.ef-cfg-card');
    var entries = [];
    var recs = window._efAiRecs;
    var rec = String(recs && recs.fit || '').toLowerCase();
    cards.forEach(function(card) {
      var old = card.querySelector('.ef-cfg-card__ai-info');
      if (old) old.remove();
      card.classList.remove('ef-cfg-card--ai-recommended', 'ef-cfg-card--ai-unavailable');
      card.removeAttribute('data-ai-disabled');
      card.removeEventListener('click', _blockAiDisabledClick, { capture: true });
      var label = String(card.dataset.value || '');
      var mode = /inside/i.test(label) ? 'inside' : /overlap/i.test(label) ? 'overlap' : '';
      if (!mode || !recs) return;
      var option = recs.fit_options && recs.fit_options[mode];
      if (option || rec.indexOf(mode) !== -1) entries.push({label: label, mode: mode, option: option || {}, recommended: rec.indexOf(mode) !== -1});
    });
    if (!entries.length) return;
    var primary = entries.filter(function(entry) { return entry.recommended && entry.option.viable !== false; })[0];
    var title = primary ? primary.label : 'Compare your fit options';
    var reason = primary && primary.option.reason || 'Review the fit details below and confirm your opening measurements before choosing.';
    var wrap = document.createElement('div');
    wrap.id = 'efCfgAiFitTip';
    wrap.className = 'ef-cfg-ai-advice';
    wrap.innerHTML = efAiAdviceHtml(_aiEsc(title), _aiEsc(reason));
    var details = wrap.querySelector('details');
    entries.forEach(function(entry) {
      var option = entry.option;
      if (option.viable === false) {
        var warning = document.createElement('div');
        warning.className = 'ef-cfg-ai-advice__text';
        warning.innerHTML = '<strong>' + _aiEsc(entry.label) + ': not recommended for your fireplace</strong>' + (option.reason ? '<br>' + _aiEsc(option.reason) : '');
        wrap.insertBefore(warning, details);
      } else if (option.tolerance || option.overlap_depth) {
        var metric = document.createElement('div');
        metric.className = 'ef-cfg-ai-advice__text';
        metric.innerHTML = '<strong>' + _aiEsc(entry.label) + '</strong>' + (option.tolerance ? ' · Tolerance ' + _aiEsc(option.tolerance) : '') + (option.overlap_depth ? ' · Overlap ' + _aiEsc(option.overlap_depth) : '');
        wrap.insertBefore(metric, details);
      }
      if (entry !== primary && option.reason && option.viable !== false) {
        details.insertAdjacentHTML('beforeend', '<p class="ef-cfg-ai-advice__text"><strong>' + _aiEsc(entry.label) + '</strong><br>' + _aiEsc(option.reason) + '</p>');
      }
    });
    if (wasOpen) details.open = true;
    var grid = group.querySelector('.ef-cfg-group__grid');
    if (grid) grid.insertAdjacentElement('afterend', wrap);
    else group.appendChild(wrap);
  }
  function _blockAiDisabledClick(e) {
    if (this.dataset.aiDisabled === 'true') {
      e.stopPropagation();
      e.preventDefault();
    }
  }
  // Expose for callers in other IIFEs
  window.efApplyAiFitInfoToCards = applyAiFitInfoToCards;
})();

/* ────────────────────────────────────
   CARD ZOOM MODAL — mobile tap-to-zoom on option cards.
   Uses event delegation: single listener handles all current
   AND future cards (rendered dynamically when steps change).
   ──────────────────────────────────── */
(function efCfgZoomModalInit() {
  function init() {
    var modal = document.getElementById('efCfgZoom');
    if (!modal) return;
    var img      = document.getElementById('efCfgZoomImg');
    var titleEl  = document.getElementById('efCfgZoomTitle');
    var descEl   = document.getElementById('efCfgZoomDesc');
    var priceEl  = document.getElementById('efCfgZoomPrice');
    var chooseBtn = document.getElementById('efCfgZoomChoose');
    var sourceCard = null;
    var lastFocus = null;

    function open(card) {
      if (!card) return;
      sourceCard = card;
      /* REVIEW-9 §3 / T-CFG4 2026-08-31 — measured focusAfterClose:"BODY.efx". Clicking a
         <span role="button"> does not focus it, so lastFocus was <body> and Escape dropped
         the buyer at the top of the document. Now that this modal is the zoom affordance on
         desktop as well, focus must return to the card that opened it. */
      lastFocus = (document.activeElement && document.activeElement !== document.body)
        ? document.activeElement : card;
      var imgSrc = card.dataset.imgFull || (card.querySelector('.ef-cfg-card__img img') || {}).src || '';
      var title = (card.querySelector('.ef-cfg-card__title') || {}).textContent || '';
      var desc  = card.dataset.fullDesc || (card.querySelector('.ef-cfg-card__desc') || {}).textContent || '';
      var price = (card.querySelector('.ef-cfg-card__price') || {}).textContent || '';
      img.src = imgSrc;
      img.alt = title;
      titleEl.textContent = title;
      descEl.textContent = desc;
      priceEl.textContent = price;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { chooseBtn && chooseBtn.focus(); }, 60);
    }
    function close() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      sourceCard = null;
      if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch(e) {}
    }

    /* Open via delegation — works for cards rendered later */
    document.addEventListener('click', function(e) {
      var z = e.target.closest && e.target.closest('[data-cfg-zoom]');
      if (!z) return;
      var card = z.closest('.ef-cfg-card') || (z.parentElement && z.parentElement.querySelector('.ef-cfg-card'));
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      open(card);
    });
    /* Keyboard support — span[role=button] doesn't natively trigger click on
       Enter/Space, so we forward the keydown to the same delegate. (a11y rec) */
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var z = e.target.closest && e.target.closest('[data-cfg-zoom]');
      if (!z || z.tagName === 'BUTTON') return;
      var card = z.closest('.ef-cfg-card') || (z.parentElement && z.parentElement.querySelector('.ef-cfg-card'));
      if (!card) return;
      e.preventDefault();
      open(card);
    });

    /* Strzałki w grupie opcji wybierają poprzednią/następną dostępną pozycję. */
    document.addEventListener('keydown', function(e) {
      var current = e.target.closest && e.target.closest('.ef-cfg-card[role="radio"], .ef-cfg-swatch[role="radio"]');
      if (!current || !/^(ArrowRight|ArrowLeft|ArrowDown|ArrowUp|Home|End)$/.test(e.key)) return;
      var group = current.closest('[role="radiogroup"], .ef-cfg-group__grid, .ef-cfg-swatch-grid');
      if (!group) return;
      var radios = Array.prototype.filter.call(group.querySelectorAll('[role="radio"]'), function(el){ return !el.disabled && el.getClientRects().length; });
      var at = radios.indexOf(current); if (at < 0 || !radios.length) return;
      var next = e.key === 'Home' ? 0 : e.key === 'End' ? radios.length - 1 : (at + (/Right|Down/.test(e.key) ? 1 : -1) + radios.length) % radios.length;
      e.preventDefault(); radios[next].focus();
      if (radios[next].getAttribute('aria-checked') !== 'true') radios[next].click();
    });

    /* Close handlers */
    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-zoom-close]')) close();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
    });

    /* Choose this — select if not already selected.
       If already selected, no-op (don't toggle off — user pressed "Choose this", they want IT). */
    chooseBtn && chooseBtn.addEventListener('click', function() {
      if (sourceCard && sourceCard.getAttribute('aria-checked') !== 'true') {
        try { sourceCard.click(); } catch(e) {}
      }
      close();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ════════════════════════════════════════════════════════════
     REVIEW-STEP CHECKOUT EXTRAS — native dynamic wallet button
     2026-05-03 (rewrite — option A: native dynamic Shopify button)
     ──────────────────────────────────────────────────────────────
     The Liquid {{ form | payment_button }} filter renders a wallet
     button that auto-detects the buyer's preferred wallet (Shop Pay
     purple, PayPal yellow, Apple Pay black, Google Pay). We intercept
     the click in capture phase BEFORE Shopify's wallet popup opens,
     silently ATC base + surcharges to honor the configured price,
     then redirect to /checkout where the same accelerated wallet
     appears at the top of the page. No worker / draft order needed —
     cart contents drive the checkout total exactly.

     More payment options — same handler, no wallet branding, for
     buyers who want card / other payment methods.
     ════════════════════════════════════════════════════════════ */

  function efBuildAtcItems() {
    /* Mirrors the ATC handler payload (assets/ef-configurator-v2.js ~line 3150)
       so the resulting order shows every customer-entered config. Returns
       null if state isn't ready or required fields are missing. */
    var state = window._efCfgState;
    if (!state) return { error: 'Configuration not ready. Try Add to Cart.' };
    if (state.msrpReady && !state.msrpReady())return {error:'This size or finish requires a quote from our team.'};
    if (state.ceramicAreaReady && !state.ceramicAreaReady())return {error:'Please enter valid fireplace opening width and height to calculate ceramic glass.'};
    if (state.syncGlassProtection) state.syncGlassProtection();
    if (state.sanitizeTrifold) state.sanitizeTrifold();
    if(state.trifoldDimensionsReady && !state.trifoldDimensionsReady()) return {error:"Enter valid positive panel dimensions."};
    if (state.trifoldWingsReady && !state.trifoldWingsReady()) return {error: "Choose the width of each side panel."};
    if (state.photoUploading) return { error: 'Please wait for your photos to finish uploading.' };
    if (state.photoError) return { error: 'A photo could not be attached. Please retry or remove it before continuing.' };
    if (!state.validateMainPhoto()) return { error: 'Add a full fireplace photo before continuing. Width and height photos are optional.' };

    if(state.isOldWorldSlim)return state.owsBuildCart();
    var sel = state.selections;
    var surch = state.surcharges || {};
    var props = {};

    if (sel._width) props['Width'] = sel._width + '"';
    if (sel._height) props[state.isArch ? 'Center Peak Height' : 'Height'] = sel._height + '"';
    if (state.isArch && sel._side_height) props['Side Height'] = sel._side_height + '"';
    if (sel.size) props['Opening Size'] = sel.size;
    if (sel.simple_width) props['Opening Width'] = sel.simple_width;
    if (sel.simple_height) props['Opening Height'] = sel.simple_height;
    if (sel._frame_left) props['Frame Left'] = sel._frame_left;
    if (sel._frame_right) props['Frame Right'] = sel._frame_right;
    if (sel._frame_top) props['Frame Top'] = sel._frame_top;
    if (sel._frame_bottom) props['Frame Bottom'] = sel._frame_bottom;

    var fieldOrder = ['fireplace_type','firebox_type','fit_type','frame_width','door_fit','door_type','side_panel','feet','handle','pattern','style_finish','finish','door_finish','hardware_finish','glass','mesh','draft_control','glass_protection'];
    fieldOrder.forEach(function (field) {
      if (sel[field]) props[state.formatFieldLabel(field)] = (field === 'hardware_finish' && sel[field] === '__match__') ? 'Match Frame' : sel[field];
    });

    Object.assign(props, state.photoProperties());
    var notesEl = document.getElementById('efCfgNotes');
    if (notesEl && notesEl.value.trim()) props['_Notes'] = notesEl.value.trim();

    if (state.matchedGroup === 'Fireplace Doors - Brookfield Deluxe') {
      var deluxe = [
        ['efCfgDeluxeOverallW','_Overall Width'],
        ['efCfgDeluxeOverallH','_Overall Height'],
        ['efCfgDeluxeOpeningW','_Opening Width'],
        ['efCfgDeluxeOpeningH','_Opening Height'],
        ['efCfgDeluxeTopOffset','_Top of opening to top of fireplace'],
        ['efCfgDeluxeBottomOffset','_Bottom of opening to bottom of fireplace']
      ];
      var missing = [];
      deluxe.forEach(function (f) {
        var el = document.getElementById(f[0]);
        var v = el ? String(el.value || '').trim() : '';
        if (!v) missing.push(f[1].replace(/^_/, ''));
        else props[f[1]] = v + '"';
      });
      if (missing.length) {
        return { error: 'Please fill in all 6 measurements before checkout:\n\n• ' + missing.join('\n• ') };
      }
    }

    var totalCents = state.calcTotal();
    if (!totalCents || totalCents < 1000) {
      return { error: 'Could not calculate price. Please try Add to Cart instead.' };
    }

    var configId = 'cfg-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    props['_Configured Price'] = (totalCents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    props['_config_id'] = configId;

    var mainVariantId = state.variantId;
    if (state.cfgType === 'cfg-standard') {
      var v = document.getElementById('efCfgVariantSelect');
      if (v && v.value) mainVariantId = v.value;
    }

    var items = [{
      id: parseInt(mainVariantId, 10),
      quantity: 1,
      properties: props
    }];

    Object.keys(surch).forEach(function (key) {
      var s = surch[key];
      if (s && s.variantId && s.amount > 0) {
        items.push({
          id: parseInt(s.variantId, 10),
          quantity: s.qty || 1,
          properties: {
            '_parent_product': state.prodTitle,
            '_option_type': state.formatFieldLabel(key.replace(/_balance_\d+$/, '')),
            '_config_id': configId
          }
        });
      }
    });

    return { items: items };
  }

  function efBuyWithWalletHandler(triggerEl, e) {
    /* Intercepts BOTH the native Shopify dynamic-checkout-button click and
       the More Payment Options click. Validates configuration, builds the
       same multi-line ATC payload as the regular Add-to-Cart handler,
       silently POSTs /cart/add.js, then HARD-redirects to /checkout. */
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }

    var built = efBuildAtcItems();
    if (built.error) {
      alert(built.error);
      return;
    }

    /* EF FUNNEL: express-checkout ATC (P-007) — additive emission only */
    try {
      efTrack('ef_cfg_atc', {
        total: Math.round(calcTotal()) / 100,
        config_summary: 'express_checkout'
      });
    } catch (e) {}

    var origLabel = triggerEl ? triggerEl.textContent : '';
    if (triggerEl && !triggerEl.dataset.cfgWalletBusy) {
      triggerEl.dataset.cfgWalletBusy = '1';
      triggerEl.style.pointerEvents = 'none';
      triggerEl.style.opacity = '0.7';
    }

    Promise.resolve().then(function() {
      if (!window.EFOptionIntegrity) throw new Error('Cart verification is unavailable. Please reload and try again.');
      return window.EFOptionIntegrity.add(built.items);
    })
    .then(function () { return window.EFOptionIntegrity.checkout(); })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function (err) {
      console.error('[EF-CFG buy-with-wallet] Cart error:', err);
      if (triggerEl) {
        triggerEl.style.pointerEvents = '';
        triggerEl.style.opacity = '';
        delete triggerEl.dataset.cfgWalletBusy;
      }
      alert('Could not start checkout: ' + err.message + '\n\nPlease use Add to Cart instead.');
    });
  }

  /* Capture-phase listener on the dynamic button container. The native
     Shopify wallet button renders inside #efCfgShopPayWrap. We capture
     ANY click on that subtree, prevent the wallet popup from opening,
     and route through /checkout instead. Capture phase runs BEFORE
     Shopify's own listeners. */
  var shopPayWrap = document.getElementById('efCfgShopPayWrap');
  if (shopPayWrap) {
    shopPayWrap.addEventListener('click', function (e) {
      var inner = e.target.closest('button, [role="button"], a');
      efBuyWithWalletHandler(inner || shopPayWrap, e);
    }, true);
  }

  var moreBtn = document.getElementById('efCfgMorePay');
  if (moreBtn) {
    moreBtn.addEventListener('click', function (e) {
      efBuyWithWalletHandler(moreBtn, e);
    });
    /* Dynamic Shop Pay height-sync removed 2026-05-03 — Shop Pay button hidden
       entirely (display:none). More-Pay now uses static 56px height matching
       ATC + BACK via CSS. */
  }

  /* ═══════════════════════════════════════════════════════════════════
     LOCALSTORAGE AUTO-SAVE + RESUME (2026-05-03)
     Saves selections + curStep on every change. On return visit shows a
     "Continue where you left off?" banner. Clear on successful add-to-cart.
     Per-product key (handle-scoped). 30-day expiry.
     ═══════════════════════════════════════════════════════════════════ */
  (function efCfgPersist() {
    /* 2026-05-11 — Define root locally. This IIFE lives in efCfgZoomModalInit
       (line 4405 IIFE), NOT in the main configurator IIFE (line 20). The outer
       `root` from line 64 is out of scope here. Was throwing
       Uncaught ReferenceError: root is not defined, which on screens PDP (no
       #efCfg element) was halting page JS init. */
    var root = document.getElementById('efCfg');
    if (!root) return;
    var handle = root.dataset.productHandle || '';
    if (!handle) return;
    // Slim uses the shared Save/share module and its native-model restore hook.
    var slimState=window._efCfgState;
    if(slimState && slimState.isOldWorldSlim)return;
    var KEY = 'ef-cfg-state-' + handle;
    var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

    function save() {
      try {
        if (!Object.keys(selections).length && curStep === 0) return;
        var data = {
          selections: JSON.parse(JSON.stringify(selections)),
          curStep: curStep,
          ts: Date.now()
        };
        localStorage.setItem(KEY, JSON.stringify(data));
      } catch (e) {}
    }

    function loadSaved() {
      try {
        var raw = localStorage.getItem(KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || (Date.now() - (data.ts || 0)) > MAX_AGE_MS) {
          localStorage.removeItem(KEY);
          return null;
        }
        return data;
      } catch (e) { return null; }
    }

    function clearSaved() {
      try { localStorage.removeItem(KEY); } catch (e) {}
    }

    /* Debounced save on any state-changed event + click on option buttons */
    var saveTimer;
    function debouncedSave() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(save, 300);
    }
    window.addEventListener('ef-cfg:state-changed', debouncedSave);

    document.addEventListener('click', function (e) {
      var target = e.target.closest('[data-field][data-value]');
      if (target && root.contains(target)) debouncedSave();
    });

    /* Clear on successful ATC — listen to cart drawer open or page nav to /cart */
    document.addEventListener('click', function (e) {
      var atcBtn = e.target.closest('#efCfgATC');
      if (atcBtn) setTimeout(clearSaved, 1500); /* clear after ATC fetch settles */
    });

    /* Replay saved state — clicks each saved selection's button to re-trigger
       handlers (sets selections + surcharges + UI), then jumps to last step. */
    function restoreFrom(data) {
      if (!data || !data.selections) return;

      Object.keys(data.selections).forEach(function (field) {
        var value = data.selections[field];
        var btn = document.querySelector('[data-field="' + field + '"][data-value="' + CSS.escape(value) + '"]');
        if (btn) try { btn.click(); } catch (e) {}
      });
      if (typeof data.curStep === 'number' && data.curStep > 0) {
        setTimeout(function () { try { goToStep(data.curStep); } catch (e) {} }, 250);
      }
    }

    /* Banner UI — bronze checkmark + 2 buttons, matches store palette */
    function showResumeBanner(data) {
      var hasSelections = data.selections && Object.keys(data.selections).length > 0;
      if (!hasSelections) return;
      var banner = document.createElement('div');
      banner.className = 'ef-cfg-resume-banner';
      banner.innerHTML =
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8A6A43" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<polyline points="3 12 8 17 21 4"/>' +
        '</svg>' +
        '<div class="ef-cfg-resume-banner__text">' +
          '<strong>Continue where you left off?</strong>' +
          '<span>We saved your last configuration.</span>' +
        '</div>' +
        '<button type="button" class="ef-cfg-resume-banner__yes">Restore</button>' +
        '<button type="button" class="ef-cfg-resume-banner__no" aria-label="Dismiss">&times;</button>';
      var insertBefore = root.querySelector('.ef-cfg-section-header') || root.firstChild;
      if (insertBefore && insertBefore.parentNode) {
        insertBefore.parentNode.insertBefore(banner, insertBefore);
      } else {
        root.insertBefore(banner, root.firstChild);
      }
      banner.querySelector('.ef-cfg-resume-banner__yes').addEventListener('click', function () {
        restoreFrom(data);
        banner.remove();
      });
      banner.querySelector('.ef-cfg-resume-banner__no').addEventListener('click', function () {
        clearSaved();
        banner.remove();
      });
    }

    var saved = loadSaved();
    if (saved) {
      /* Show banner after a tick so initial DOM is settled */
      setTimeout(function () { showResumeBanner(saved); }, 600);
    }
  })();
})();



/* Link the screen diagram and measurement labels without changing dimensions or prices. */
(function(){function boot(){var r=document.getElementById('efCfg');if(!r||r.dataset.arch!=='true')return;
[['efCfgWidth','efCfgWidthDescArch'],['efCfgHeight','efCfgHeightDescArch']].forEach(function(pair){var e=document.getElementById(pair[0]);if(e)e.setAttribute('aria-describedby',pair[1]);});
var isScreen=r.dataset.cfgType==='cfg-screen';
[['efCfgWidth','A · Finished screen width'],['efCfgSideHeight','B · Side height'],['efCfgHeight','C · Center peak height']].forEach(function(pair){var input=document.getElementById(pair[0]),label=r.querySelector('label[for="'+pair[0]+'"]'),text=label&&(label.querySelector('.ef-cfg-arch-show')||label);if(isScreen&&text)text.textContent=pair[1];if(input){input.addEventListener('focus',function(){r.querySelectorAll('[data-arch-cue]').forEach(function(g){g.classList.toggle('is-active',g.dataset.archCue===pair[0]);});});input.addEventListener('blur',function(){r.querySelectorAll('[data-arch-cue]').forEach(function(g){g.classList.remove('is-active');});});}});
}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();})();
